export default {
      "type": "Feature",
      "properties": {
        "gid": 282268,
        "name": "Баруун бүс",
        "location": [46.76458982251159, 95.01866203279478]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [90.073841, 47.7758],
              [90.073732749999976, 47.77591445600001],
              [90.073527, 47.776132],
              [90.072078, 47.77765],
              [90.071118, 47.779308],
              [90.070453013000019, 47.780372168999975],
              [90.07042, 47.780425],
              [90.070001, 47.78135],
              [90.069844, 47.781978],
              [90.069809, 47.782677],
              [90.069773, 47.782966],
              [90.069791, 47.783148],
              [90.069828697999981, 47.783242798],
              [90.069859, 47.783319],
              [90.07005, 47.783726],
              [90.070348, 47.784496],
              [90.070563, 47.784889],
              [90.070824, 47.785332],
              [90.071151, 47.785688],
              [90.071192, 47.785825],
              [90.07119, 47.785963],
              [90.071081, 47.78614],
              [90.070969, 47.78628],
              [90.070861, 47.786479],
              [90.070633, 47.786827],
              [90.070451, 47.787121],
              [90.070298, 47.787365],
              [90.070196871, 47.787480949999974],
              [90.070182, 47.787498],
              [90.070021, 47.787589],
              [90.069876, 47.787667],
              [90.069764, 47.787738],
              [90.069648, 47.787903],
              [90.069632, 47.788101],
              [90.069635, 47.788212],
              [90.069683, 47.788497],
              [90.069573, 47.788653],
              [90.069449, 47.788727],
              [90.069259, 47.788827],
              [90.069031, 47.789025],
              [90.068733, 47.789328],
              [90.068555, 47.78968],
              [90.068369, 47.790069],
              [90.068145, 47.790267],
              [90.067934, 47.790425],
              [90.067607, 47.790619],
              [90.067131, 47.790839],
              [90.066671, 47.791112],
              [90.066236, 47.791418],
              [90.06586, 47.791791],
              [90.06569, 47.791932],
              [90.065603, 47.791994],
              [90.065578, 47.792081],
              [90.065599, 47.792147],
              [90.065685, 47.792199],
              [90.065831, 47.792205],
              [90.065942, 47.79223],
              [90.066282, 47.792358],
              [90.066431572999988, 47.792451732000018],
              [90.066957, 47.792781],
              [90.067512, 47.793112],
              [90.068004, 47.793406],
              [90.068679, 47.793799],
              [90.069458, 47.794358],
              [90.070083, 47.794851],
              [90.070824, 47.795286],
              [90.071069, 47.795536],
              [90.071395, 47.795869],
              [90.072103, 47.796499],
              [90.072405, 47.796892],
              [90.072861, 47.79743],
              [90.073345, 47.798018],
              [90.074157, 47.798813],
              [90.074289, 47.799024],
              [90.074293, 47.799136],
              [90.074153, 47.799285],
              [90.073987, 47.799397],
              [90.073619, 47.799596],
              [90.073118, 47.799852],
              [90.072380537000015, 47.800069688],
              [90.071685, 47.800275],
              [90.069785, 47.800825],
              [90.069142, 47.801024],
              [90.068526, 47.801214],
              [90.067979, 47.801479],
              [90.06776, 47.801699],
              [90.067702, 47.80196],
              [90.06759, 47.802212],
              [90.067425, 47.80239],
              [90.067267, 47.802506],
              [90.066994, 47.802713],
              [90.066725, 47.803028],
              [90.066673, 47.80326],
              [90.066645, 47.803426],
              [90.066572, 47.803562],
              [90.066506, 47.803686],
              [90.066381, 47.803806],
              [90.066241, 47.803947],
              [90.066104, 47.804179],
              [90.06606, 47.80438],
              [90.065988, 47.804651],
              [90.065918, 47.805119],
              [90.065893, 47.805458],
              [90.065918, 47.805771],
              [90.065982118000022, 47.805860766000023],
              [90.066038, 47.805939],
              [90.066154, 47.806096],
              [90.066303, 47.806241],
              [90.066497, 47.806522],
              [90.066721, 47.806758],
              [90.067242, 47.807247],
              [90.067847, 47.807636],
              [90.068344, 47.808005],
              [90.068598, 47.80832],
              [90.068721, 47.808472],
              [90.069122, 47.809044],
              [90.069271, 47.809363],
              [90.069321, 47.80947],
              [90.069304, 47.809594],
              [90.069234, 47.809818],
              [90.06901, 47.810236],
              [90.06862, 47.810899],
              [90.068572083, 47.810981143999982],
              [90.068543, 47.811031],
              [90.06805, 47.811963],
              [90.067677, 47.812646],
              [90.067421, 47.813047],
              [90.067085, 47.813329],
              [90.066932, 47.813561],
              [90.066891, 47.813772],
              [90.066896, 47.813928],
              [90.067044, 47.814169],
              [90.067077, 47.814393],
              [90.067019, 47.814538],
              [90.066862, 47.814687],
              [90.066667, 47.814882],
              [90.066323, 47.815217],
              [90.066062, 47.815643],
              [90.065981, 47.816015],
              [90.065905, 47.816563],
              [90.065864, 47.81701],
              [90.06569, 47.817304],
              [90.065578, 47.817602],
              [90.065555, 47.818059],
              [90.065544, 47.818404],
              [90.065545, 47.818724],
              [90.065479, 47.818997],
              [90.065367, 47.819266],
              [90.065295, 47.819583],
              [90.065281, 47.819829],
              [90.065315, 47.82004],
              [90.065369049000026, 47.820178783000017],
              [90.06547, 47.820438],
              [90.065698, 47.820997],
              [90.065784, 47.821305],
              [90.065789, 47.821398],
              [90.065735, 47.821477],
              [90.065462, 47.82168],
              [90.065266437999981, 47.821840005000013],
              [90.065143, 47.821941],
              [90.065123, 47.822048],
              [90.065178, 47.822134],
              [90.065243656, 47.822208838999984],
              [90.065321, 47.822297],
              [90.06547, 47.822446],
              [90.065599, 47.822793],
              [90.065651, 47.823016],
              [90.065628, 47.823286],
              [90.065603, 47.823539],
              [90.065565, 47.823878],
              [90.065615, 47.824065],
              [90.065727, 47.824255],
              [90.065901, 47.824408],
              [90.066257, 47.824582],
              [90.066626, 47.82481],
              [90.066911, 47.825121],
              [90.067234, 47.825626],
              [90.067284, 47.825853],
              [90.067274, 47.826081],
              [90.067147, 47.826218],
              [90.066886, 47.826425],
              [90.066633895999985, 47.826674239],
              [90.066534, 47.826773],
              [90.066245, 47.827033],
              [90.066013, 47.827245],
              [90.065686, 47.827538],
              [90.065496, 47.827875],
              [90.065387, 47.828174],
              [90.065329626999983, 47.828529915999979],
              [90.065274, 47.828875],
              [90.065408, 47.829323],
              [90.065702, 47.82977],
              [90.0661, 47.830234],
              [90.066795, 47.830809],
              [90.067478, 47.831368],
              [90.067888, 47.831683],
              [90.068331, 47.831931],
              [90.068803, 47.832128],
              [90.068849, 47.832147],
              [90.069056, 47.832267],
              [90.069275, 47.832511],
              [90.069429, 47.832768],
              [90.06959, 47.833008],
              [90.069888, 47.833612],
              [90.069988, 47.833923],
              [90.070281, 47.834213],
              [90.0707, 47.834523],
              [90.070898, 47.834809],
              [90.071018, 47.83507],
              [90.071047, 47.835463],
              [90.071139, 47.836076],
              [90.071333, 47.836448],
              [90.071389411999974, 47.836810023999988],
              [90.071436, 47.837109],
              [90.071594789000017, 47.83743933300002],
              [90.071797, 47.83786],
              [90.072087, 47.838063],
              [90.072451, 47.838353],
              [90.072931, 47.838643],
              [90.073246, 47.838949],
              [90.073345, 47.839156],
              [90.073296, 47.839516],
              [90.073118, 47.839752],
              [90.072766, 47.840001],
              [90.072145, 47.840514],
              [90.071702, 47.840908],
              [90.071424, 47.841189],
              [90.071389431, 47.841216654999982],
              [90.071374, 47.841229],
              [90.07118, 47.841384],
              [90.07106, 47.841624],
              [90.071031, 47.84185],
              [90.071027206999986, 47.841875766999976],
              [90.071002, 47.842047],
              [90.070861, 47.842333],
              [90.07019, 47.842833],
              [90.069843, 47.843247],
              [90.069702527, 47.843451933999972],
              [90.069466, 47.843797],
              [90.069437, 47.843963],
              [90.06947, 47.844075],
              [90.069544083999972, 47.84414908399998],
              [90.069578, 47.844183],
              [90.069706, 47.844282],
              [90.069826, 47.844361],
              [90.070012, 47.844472],
              [90.070389, 47.844659],
              [90.070782, 47.84482],
              [90.071068, 47.844944],
              [90.071283, 47.845118],
              [90.071428, 47.845313],
              [90.071573, 47.845491],
              [90.071751, 47.845752],
              [90.071761, 47.845972],
              [90.071764, 47.846096],
              [90.071756, 47.846231],
              [90.071663, 47.846895],
              [90.071613314999979, 47.847392453],
              [90.07158, 47.847726],
              [90.071544, 47.84791],
              [90.071573, 47.848091],
              [90.071644, 47.848165],
              [90.071697, 47.848236],
              [90.071847, 47.848315],
              [90.072074, 47.848393],
              [90.072352, 47.848509],
              [90.07253, 47.848637],
              [90.072658, 47.848712],
              [90.072803, 47.848832],
              [90.072985, 47.849023],
              [90.073097, 47.849209],
              [90.073242, 47.849374],
              [90.073424, 47.849577],
              [90.073614, 47.849788],
              [90.073747, 47.849929],
              [90.073879, 47.850087],
              [90.073941, 47.850219],
              [90.073863, 47.850364],
              [90.073739, 47.850439],
              [90.073619, 47.85053],
              [90.07354, 47.850658],
              [90.073532, 47.850753],
              [90.073602, 47.850799],
              [90.073759, 47.850882],
              [90.074005, 47.851018],
              [90.074282, 47.851166],
              [90.074767, 47.851305],
              [90.07548, 47.851463],
              [90.075788, 47.851552],
              [90.075895, 47.851582],
              [90.076311, 47.851602],
              [90.076677, 47.851503],
              [90.076782701000013, 47.851457129999972],
              [90.076836, 47.851434],
              [90.077073, 47.851325],
              [90.077331, 47.851156],
              [90.077548, 47.851087],
              [90.077766, 47.851018],
              [90.078073, 47.851067],
              [90.078518, 47.851186],
              [90.07931, 47.851453],
              [90.079964, 47.851671],
              [90.080171, 47.8518],
              [90.080251, 47.851889],
              [90.080211, 47.851988],
              [90.080102, 47.852107],
              [90.080013, 47.852235],
              [90.079894, 47.852423],
              [90.079895717, 47.852463247],
              [90.079903, 47.852634],
              [90.079854, 47.852843],
              [90.079824, 47.853045],
              [90.079768, 47.853229],
              [90.079627, 47.853493],
              [90.079508, 47.853839],
              [90.07938, 47.854166],
              [90.079271, 47.854403],
              [90.079202, 47.854659],
              [90.079135, 47.854867],
              [90.07918, 47.855053],
              [90.079261, 47.855246],
              [90.079381, 47.855558],
              [90.079474, 47.85585],
              [90.079573, 47.856211],
              [90.079633, 47.856613],
              [90.079629, 47.857008],
              [90.079637, 47.857234],
              [90.079756, 47.857501],
              [90.079875, 47.85763],
              [90.080033, 47.857699],
              [90.08036, 47.857878],
              [90.080775, 47.858076],
              [90.081181, 47.858264],
              [90.081636, 47.858422],
              [90.082032, 47.85858],
              [90.082359, 47.85863],
              [90.082597, 47.85865],
              [90.082834, 47.8586],
              [90.082953, 47.858561],
              [90.082993, 47.858382],
              [90.082967, 47.858136],
              [90.082928, 47.857691],
              [90.082979960999978, 47.857349289000013],
              [90.082987, 47.857303],
              [90.083022, 47.857115],
              [90.08322, 47.857026],
              [90.083389, 47.857036],
              [90.083676, 47.857076],
              [90.08426, 47.857274],
              [90.084695, 47.857482],
              [90.085147802, 47.857769467000026],
              [90.08524, 47.857828],
              [90.085843, 47.858363],
              [90.086368, 47.858778],
              [90.086764, 47.859155],
              [90.08715, 47.859471],
              [90.087308, 47.859679],
              [90.087294, 47.859763],
              [90.087101, 47.859857],
              [90.086843, 47.860016],
              [90.08613, 47.860481],
              [90.085457, 47.861115],
              [90.085061, 47.861501],
              [90.084871, 47.86196],
              [90.084279, 47.863045],
              [90.084101, 47.863302],
              [90.083913, 47.86353],
              [90.083735, 47.863777],
              [90.083577, 47.864045],
              [90.083534, 47.864216],
              [90.083487, 47.864393],
              [90.083476, 47.864584],
              [90.083464, 47.864806],
              [90.083496, 47.865048],
              [90.083547, 47.86545],
              [90.08362, 47.865785],
              [90.083724, 47.866059],
              [90.083903, 47.866465],
              [90.084131, 47.866816],
              [90.084309, 47.867271],
              [90.084398, 47.867499],
              [90.084331, 47.86777],
              [90.084131, 47.867964],
              [90.083725, 47.868133],
              [90.083379, 47.868271],
              [90.082765, 47.86843],
              [90.081785, 47.868727],
              [90.081303, 47.868893],
              [90.080736248, 47.869089427],
              [90.080498, 47.869172],
              [90.079083, 47.869756],
              [90.079037219999975, 47.869779289],
              [90.078222, 47.870194],
              [90.077717, 47.870112],
              [90.077202, 47.870221],
              [90.076737, 47.87037],
              [90.076331, 47.87032],
              [90.075945, 47.870112],
              [90.07541, 47.869924],
              [90.075174913000012, 47.869808700000021],
              [90.074886, 47.869667],
              [90.074658, 47.869716],
              [90.074361, 47.869865],
              [90.074141199999985, 47.869943708999983],
              [90.073836, 47.870053],
              [90.072787, 47.870578],
              [90.071886, 47.871013],
              [90.070985, 47.871508],
              [90.070669270999986, 47.871655144999977],
              [90.069689, 47.872112],
              [90.068352, 47.872736],
              [90.067521, 47.873221],
              [90.067194, 47.873498],
              [90.067026, 47.873785],
              [90.066838, 47.874042],
              [90.066709, 47.874369],
              [90.066422, 47.874913],
              [90.066096, 47.875567],
              [90.065799, 47.876131],
              [90.065531, 47.876527],
              [90.065056, 47.876883],
              [90.0647, 47.877071],
              [90.064264, 47.877329],
              [90.063581, 47.877715],
              [90.063027, 47.878111],
              [90.062859, 47.878219],
              [90.062699, 47.878505],
              [90.062479, 47.878839],
              [90.062336, 47.879088],
              [90.062146, 47.87938],
              [90.061917, 47.879689],
              [90.061564, 47.88026],
              [90.061126, 47.880813],
              [90.06079, 47.881248],
              [90.060513, 47.881595],
              [90.060226, 47.881961],
              [90.05983, 47.882248],
              [90.059275, 47.882604],
              [90.058879, 47.882921],
              [90.058424, 47.883327],
              [90.058147, 47.883739],
              [90.05795, 47.884147],
              [90.057747, 47.884648],
              [90.057622, 47.884693],
              [90.057486, 47.884645],
              [90.057365, 47.884436],
              [90.057177, 47.884297],
              [90.056821, 47.883951],
              [90.056494, 47.883792],
              [90.05588, 47.883495],
              [90.055237, 47.883169],
              [90.054673, 47.88304],
              [90.05394, 47.882713],
              [90.053240011000014, 47.882391870999982],
              [90.05297, 47.882268],
              [90.051812, 47.881634],
              [90.051475, 47.881387],
              [90.051158, 47.88112],
              [90.050931, 47.880882],
              [90.050673, 47.880744],
              [90.050577, 47.880551],
              [90.050721, 47.880123],
              [90.050878, 47.879442],
              [90.050938, 47.879162],
              [90.051017, 47.878786],
              [90.051049, 47.878213],
              [90.051106, 47.877542],
              [90.051092, 47.877134],
              [90.051076, 47.876443],
              [90.051068, 47.875949],
              [90.051128, 47.875531],
              [90.05121, 47.874897],
              [90.051226180000015, 47.874395417000017],
              [90.051228, 47.874339],
              [90.051248, 47.874092],
              [90.051168, 47.873963],
              [90.051079, 47.873874],
              [90.050743, 47.873755],
              [90.050208, 47.873537],
              [90.049753, 47.873349],
              [90.049208, 47.873211],
              [90.048397, 47.873032],
              [90.047476, 47.872904],
              [90.046664, 47.872825],
              [90.045665, 47.872637],
              [90.044685, 47.872498],
              [90.044121, 47.872429],
              [90.043507, 47.872221],
              [90.042873, 47.872092],
              [90.042319, 47.872062],
              [90.041883, 47.872003],
              [90.041398, 47.871894],
              [90.040913, 47.871785],
              [90.040527, 47.871716],
              [90.040082, 47.871518],
              [90.039627, 47.871419],
              [90.03931, 47.87136],
              [90.038904, 47.871172],
              [90.038597, 47.871043],
              [90.03829, 47.871013],
              [90.037766, 47.871162],
              [90.037122, 47.87129],
              [90.036241, 47.871637],
              [90.035192, 47.872053],
              [90.034568, 47.87234],
              [90.033935, 47.872577],
              [90.033351, 47.872933],
              [90.032806, 47.873329],
              [90.032311, 47.873686],
              [90.031708, 47.87422],
              [90.031054, 47.874814],
              [90.030609, 47.87521],
              [90.030342, 47.875438],
              [90.030064, 47.875567],
              [90.029708, 47.875626],
              [90.029243, 47.875784],
              [90.028857, 47.875972],
              [90.02856, 47.87619],
              [90.028204, 47.876438],
              [90.027907, 47.876665],
              [90.027619, 47.876843],
              [90.027323, 47.876952],
              [90.027075, 47.876962],
              [90.026847, 47.876873],
              [90.02659, 47.876744],
              [90.026392, 47.876685],
              [90.026135, 47.876547],
              [90.025838, 47.876418],
              [90.025481, 47.8762],
              [90.025095, 47.876052],
              [90.024798, 47.875903],
              [90.024353, 47.875527],
              [90.023888, 47.87519],
              [90.023383, 47.874705],
              [90.022878, 47.874309],
              [90.022324, 47.873933],
              [90.021839, 47.873686],
              [90.021294, 47.873428],
              [90.021047, 47.87332],
              [90.020869, 47.8733],
              [90.0207, 47.873389],
              [90.020532, 47.873567],
              [90.020225, 47.873814],
              [90.019819, 47.87427],
              [90.019394, 47.874745],
              [90.01873, 47.875339],
              [90.018305, 47.875735],
              [90.017889, 47.876071],
              [90.017256, 47.876754],
              [90.016889, 47.877081],
              [90.016632, 47.8772],
              [90.016335, 47.877378],
              [90.01587, 47.877625],
              [90.015335, 47.877922],
              [90.014576, 47.87839],
              [90.014563, 47.878398],
              [90.014266, 47.878748],
              [90.014127, 47.878942],
              [90.013955, 47.879209],
              [90.01355, 47.879846],
              [90.013306, 47.88008],
              [90.013181558999975, 47.880161831],
              [90.013049, 47.880249],
              [90.01288, 47.880308],
              [90.012762268000017, 47.880312409],
              [90.012613, 47.880318],
              [90.012296, 47.880219],
              [90.012088, 47.880169],
              [90.011504, 47.879991],
              [90.010841, 47.879892],
              [90.010049, 47.879793],
              [90.009158, 47.879764],
              [90.007446, 47.879714],
              [90.00611, 47.879625],
              [90.005239, 47.879595],
              [90.004717, 47.879583],
              [90.004427, 47.879575],
              [90.003774, 47.879655],
              [90.002942, 47.879764],
              [90.001655, 47.879863],
              [90.000854, 47.879932],
              [89.999834, 47.879952],
              [89.998725, 47.880021],
              [89.997795, 47.879991],
              [89.99729, 47.880011],
              [89.996983, 47.88012],
              [89.996557, 47.880357],
              [89.996152, 47.880605],
              [89.996126, 47.880622],
              [89.995647, 47.880942],
              [89.995241, 47.881189],
              [89.994815, 47.881367],
              [89.994578, 47.881466],
              [89.994281, 47.881526],
              [89.994053, 47.881466],
              [89.993786, 47.881347],
              [89.993489, 47.881209],
              [89.993321, 47.881159],
              [89.993073, 47.881179],
              [89.992786, 47.881278],
              [89.992093, 47.881516],
              [89.991331, 47.881912],
              [89.990361, 47.882397],
              [89.989599, 47.882892],
              [89.989446778, 47.882966762000024],
              [89.989035, 47.883169],
              [89.988777, 47.883288],
              [89.988569, 47.883327],
              [89.988391, 47.883208],
              [89.988294832, 47.883123598999987],
              [89.988154, 47.883],
              [89.988005, 47.882793],
              [89.987866, 47.882684],
              [89.98752, 47.882387],
              [89.987075, 47.882169],
              [89.98655, 47.881951],
              [89.986085, 47.881842],
              [89.986068, 47.881839],
              [89.985431, 47.881714],
              [89.984748, 47.881654],
              [89.983303, 47.881506],
              [89.982472, 47.881516],
              [89.981861, 47.881722],
              [89.981716, 47.881716],
              [89.981581, 47.881669],
              [89.981492, 47.881535],
              [89.981462, 47.881377],
              [89.981403, 47.881209],
              [89.981314, 47.880922],
              [89.981185, 47.880605],
              [89.980749, 47.880308],
              [89.980383, 47.880189],
              [89.979987, 47.880011],
              [89.979492, 47.879833],
              [89.979067, 47.879714],
              [89.97869, 47.879665],
              [89.977908, 47.879595],
              [89.976928, 47.879595],
              [89.976602, 47.879585],
              [89.976018, 47.879694],
              [89.975374, 47.879734],
              [89.974889, 47.879783],
              [89.974246, 47.879971],
              [89.973414, 47.88008],
              [89.97285, 47.880239],
              [89.972326, 47.880447],
              [89.971682, 47.880674],
              [89.971257, 47.880793],
              [89.97091, 47.880872],
              [89.970633, 47.880882],
              [89.970257, 47.880823],
              [89.96996, 47.880753],
              [89.969643, 47.880763],
              [89.969376, 47.880912],
              [89.96899, 47.88109],
              [89.968623, 47.881159],
              [89.968198, 47.881268],
              [89.967693, 47.881446],
              [89.967366, 47.881585],
              [89.96705, 47.881803],
              [89.966763, 47.88206],
              [89.966594, 47.882308],
              [89.966584, 47.882323],
              [89.966347, 47.882674],
              [89.965931, 47.88306],
              [89.965535, 47.883406],
              [89.964902, 47.883792],
              [89.964337, 47.884069],
              [89.963803, 47.884277],
              [89.963001, 47.884386],
              [89.961981, 47.884654],
              [89.961091, 47.884822],
              [89.960813, 47.885],
              [89.960536, 47.885218],
              [89.959833, 47.885782],
              [89.959388, 47.886099],
              [89.958913, 47.886465],
              [89.958438, 47.886841],
              [89.958299, 47.886873],
              [89.958229, 47.886881],
              [89.95815, 47.886867],
              [89.958074, 47.886828],
              [89.957966, 47.886674],
              [89.957876, 47.886394],
              [89.957625, 47.886128],
              [89.957382, 47.88594],
              [89.957052, 47.885775],
              [89.956393, 47.885492],
              [89.955695, 47.885171],
              [89.955264, 47.88489],
              [89.954903, 47.884612],
              [89.954433, 47.884136],
              [89.953876, 47.883783],
              [89.953146, 47.883516],
              [89.952823, 47.883316],
              [89.952722, 47.882987],
              [89.952636, 47.882512],
              [89.952566, 47.882034],
              [89.952570560000026, 47.882002746000012],
              [89.952621, 47.881657],
              [89.952644, 47.881045],
              [89.952764, 47.880542],
              [89.952817, 47.880175],
              [89.953021, 47.87983],
              [89.953233, 47.879437],
              [89.953405, 47.879006],
              [89.953633, 47.878677],
              [89.954048, 47.878465],
              [89.954425, 47.878253],
              [89.95477, 47.877979],
              [89.955123, 47.877524],
              [89.955514, 47.877165],
              [89.955579, 47.877031],
              [89.955661, 47.876863],
              [89.955618, 47.876388],
              [89.95552, 47.875816],
              [89.95553, 47.875429],
              [89.955431, 47.874845],
              [89.955179, 47.874252],
              [89.955128, 47.874134],
              [89.954933, 47.87331],
              [89.954906, 47.872835],
              [89.954909535000013, 47.872623378000014],
              [89.954913, 47.872416],
              [89.954914, 47.872393],
              [89.955062, 47.872101],
              [89.955264, 47.871775],
              [89.955452, 47.871547],
              [89.955448, 47.871311],
              [89.955342, 47.871131],
              [89.954982, 47.87088],
              [89.954715, 47.870628],
              [89.954697, 47.870308],
              [89.954661, 47.869966],
              [89.954618, 47.869503],
              [89.954559, 47.869339],
              [89.954446, 47.869173],
              [89.954417, 47.869131],
              [89.954095, 47.868974],
              [89.953832696, 47.868910095999979],
              [89.953742, 47.868888],
              [89.953546, 47.868716],
              [89.953441, 47.86845],
              [89.953425, 47.868174],
              [89.953387, 47.867799],
              [89.953291, 47.867259],
              [89.953163, 47.866754],
              [89.95304, 47.866315],
              [89.953017, 47.865917],
              [89.953166, 47.86536],
              [89.953323, 47.864936],
              [89.953601, 47.864559],
              [89.953762, 47.864433],
              [89.954001, 47.864245],
              [89.954393, 47.863923],
              [89.954872, 47.86339],
              [89.955099, 47.86317],
              [89.955335, 47.862865],
              [89.955538, 47.862535],
              [89.95561, 47.862102],
              [89.955697, 47.861613],
              [89.955787002000022, 47.861251078],
              [89.955791, 47.861235],
              [89.955732, 47.861059],
              [89.95567539000001, 47.86099267100002],
              [89.955499, 47.860786],
              [89.954997, 47.860472],
              [89.954417, 47.860096],
              [89.95437595300001, 47.860061477999977],
              [89.953876, 47.859641],
              [89.953233, 47.859288],
              [89.952998, 47.859143],
              [89.952613, 47.858904],
              [89.952072, 47.858668],
              [89.951248, 47.858355],
              [89.950417, 47.858064],
              [89.949938, 47.857939],
              [89.949538, 47.857955],
              [89.949374, 47.857908],
              [89.949236, 47.857787],
              [89.949148, 47.857391],
              [89.949047, 47.856775],
              [89.949024561999977, 47.856378592999988],
              [89.949002, 47.85598],
              [89.94899, 47.855471],
              [89.949083, 47.855093],
              [89.949389, 47.854637],
              [89.949829, 47.854206],
              [89.950236, 47.853758],
              [89.950699, 47.853351],
              [89.951264, 47.852958],
              [89.951585, 47.852676],
              [89.951891, 47.852237],
              [89.951992, 47.852167],
              [89.952299, 47.851955],
              [89.952644, 47.851751],
              [89.953342, 47.851366],
              [89.953962, 47.851045],
              [89.954417, 47.850739],
              [89.954571260000023, 47.85062904900002],
              [89.954605, 47.850605],
              [89.954635, 47.850383],
              [89.954583, 47.850108],
              [89.954508, 47.849657],
              [89.954459, 47.84937],
              [89.954409, 47.849209],
              [89.954291, 47.848966],
              [89.954087, 47.848692],
              [89.953899, 47.848511],
              [89.953601, 47.848307],
              [89.953193, 47.848064],
              [89.952715, 47.847696],
              [89.952393, 47.847335],
              [89.952203162999979, 47.847110488999988],
              [89.952174, 47.847076],
              [89.951797, 47.846535],
              [89.951452, 47.846221],
              [89.951217, 47.845962],
              [89.951185, 47.845728],
              [89.951303, 47.845581],
              [89.951439, 47.845368],
              [89.951519, 47.845034],
              [89.951451, 47.844715],
              [89.951295, 47.844277],
              [89.951222, 47.843869],
              [89.951308, 47.843348],
              [89.951342, 47.842794],
              [89.95126926, 47.842369399],
              [89.951256, 47.842292],
              [89.95106, 47.841805],
              [89.950829773, 47.84154748200001],
              [89.950731, 47.841437],
              [89.950362, 47.841037],
              [89.94986, 47.840511],
              [89.949672, 47.840009],
              [89.949585, 47.839578],
              [89.94969, 47.839154],
              [89.949912, 47.838728],
              [89.950344, 47.837943],
              [89.95067, 47.837326],
              [89.950903, 47.83688],
              [89.951318, 47.836292],
              [89.951832, 47.835505],
              [89.952055, 47.834803],
              [89.952071, 47.834227],
              [89.95186, 47.833468],
              [89.951703, 47.833217],
              [89.951468, 47.833217],
              [89.951209, 47.833288],
              [89.950958, 47.833248],
              [89.950621, 47.833131],
              [89.950134, 47.832935],
              [89.949531, 47.832825],
              [89.948244, 47.832448],
              [89.947694361, 47.832279412999981],
              [89.94753, 47.832229],
              [89.947123, 47.83215],
              [89.946025, 47.831852],
              [89.945036, 47.831656],
              [89.944362, 47.83164],
              [89.943985, 47.831554],
              [89.943648, 47.831272],
              [89.943217, 47.831076],
              [89.942621, 47.830966],
              [89.941923, 47.830935],
              [89.941358, 47.830958],
              [89.940691, 47.831138],
              [89.940017, 47.831272],
              [89.939483, 47.831366],
              [89.938887, 47.831374],
              [89.938158, 47.831531],
              [89.937099, 47.831703],
              [89.935828, 47.831884],
              [89.935075, 47.831993],
              [89.934291, 47.832189],
              [89.933679, 47.832276],
              [89.933565595, 47.832305683000016],
              [89.933232, 47.832393],
              [89.932769, 47.832495],
              [89.932314, 47.832409],
              [89.931687, 47.832111],
              [89.931114, 47.831836],
              [89.930824, 47.831742],
              [89.930189, 47.831593],
              [89.928989, 47.831374],
              [89.92882405, 47.831340484],
              [89.927985, 47.83117],
              [89.927507, 47.831068],
              [89.927201, 47.830958],
              [89.926918, 47.830942],
              [89.926463, 47.831146],
              [89.926032, 47.83124],
              [89.925475, 47.831319],
              [89.924887, 47.83146],
              [89.924432, 47.831719],
              [89.923961, 47.831931],
              [89.923632, 47.831931],
              [89.923255, 47.832048],
              [89.922855, 47.832197],
              [89.922557, 47.832331],
              [89.922275, 47.83237],
              [89.921993, 47.832386],
              [89.921765, 47.832472],
              [89.921318, 47.83255],
              [89.920777, 47.832691],
              [89.920299, 47.832801],
              [89.91971, 47.83306],
              [89.919326, 47.833193],
              [89.918863, 47.83324],
              [89.918377, 47.833288],
              [89.917953, 47.83335],
              [89.917616, 47.833476],
              [89.91724, 47.83368],
              [89.916934, 47.833797],
              [89.916628, 47.833923],
              [89.916361, 47.834166],
              [89.916266, 47.834231],
              [89.91611, 47.834338],
              [89.915726, 47.834448],
              [89.915349, 47.834519],
              [89.914996, 47.834644],
              [89.913961, 47.834911],
              [89.912479, 47.835303],
              [89.910847, 47.83579],
              [89.909995318000028, 47.836069107000014],
              [89.909483, 47.836237],
              [89.909012, 47.836456],
              [89.908557, 47.836519],
              [89.908126, 47.836488],
              [89.907687, 47.836331],
              [89.907028, 47.836174],
              [89.906369, 47.836088],
              [89.906151417, 47.836057047999986],
              [89.905659, 47.835987],
              [89.904859, 47.835886],
              [89.904839, 47.835884],
              [89.904173, 47.835727],
              [89.90353, 47.835609],
              [89.902879, 47.835609],
              [89.901639, 47.835899],
              [89.900314, 47.836119],
              [89.899949597999978, 47.836159244999976],
              [89.899318, 47.836229],
              [89.898329, 47.836409],
              [89.896871, 47.836793],
              [89.895387, 47.83726],
              [89.895051, 47.837366],
              [89.894133, 47.837672],
              [89.893139712, 47.838082351000025],
              [89.893051, 47.838119],
              [89.892078, 47.83855],
              [89.891263, 47.838801],
              [89.89051, 47.839044],
              [89.89011, 47.839209],
              [89.88971, 47.83917],
              [89.889051, 47.83895],
              [89.8884, 47.838746],
              [89.887804, 47.838527],
              [89.88738, 47.83848],
              [89.886776, 47.838401],
              [89.886321, 47.838339],
              [89.885757, 47.838221],
              [89.885184, 47.838182],
              [89.884855, 47.838229],
              [89.884266, 47.838205],
              [89.883426961, 47.838136583],
              [89.882917, 47.838095],
              [89.881749, 47.838001],
              [89.881145, 47.837915],
              [89.880729, 47.837868],
              [89.880329, 47.837648],
              [89.87978, 47.837319],
              [89.879648567, 47.837256425000021],
              [89.878776, 47.836841],
              [89.876917, 47.836095],
              [89.875294, 47.835389],
              [89.873749, 47.834786],
              [89.873558920999983, 47.834705180000014],
              [89.872439, 47.834229],
              [89.871702, 47.833805],
              [89.871105, 47.833374],
              [89.870494, 47.832903],
              [89.870221, 47.83268],
              [89.870149, 47.832621],
              [89.87, 47.8325],
              [89.869686, 47.832244],
              [89.869286, 47.832182],
              [89.867913, 47.831938],
              [89.866494, 47.831695],
              [89.865364, 47.831523],
              [89.863246, 47.831217],
              [89.861442, 47.83084],
              [89.859168, 47.830385],
              [89.858416330000011, 47.830250606],
              [89.858042372, 47.83018374400001],
              [89.857725, 47.830127],
              [89.856901, 47.829993],
              [89.856368, 47.829836],
              [89.855795, 47.829507],
              [89.855223, 47.829185],
              [89.854862, 47.829044],
              [89.853685, 47.828582],
              [89.85214, 47.828072],
              [89.850810326999976, 47.8276424],
              [89.850611, 47.827578],
              [89.84989237000002, 47.827362017999974],
              [89.849513, 47.827248],
              [89.849306083999977, 47.82721197799998],
              [89.849019, 47.827162],
              [89.848627, 47.827311],
              [89.847764, 47.827766],
              [89.846964, 47.828174],
              [89.846274, 47.828464],
              [89.845654, 47.828731],
              [89.845387, 47.828911],
              [89.845223, 47.829131],
              [89.845045, 47.829479],
              [89.844932, 47.829782],
              [89.844746, 47.830315],
              [89.844399, 47.830801],
              [89.843834, 47.83117],
              [89.843238, 47.831582],
              [89.843223, 47.831593],
              [89.842807, 47.831946],
              [89.842717960000016, 47.831983416000014],
              [89.842619, 47.832025],
              [89.842281, 47.832048],
              [89.841607, 47.832048],
              [89.841541881000012, 47.832034731000022],
              [89.840493, 47.831821],
              [89.839959, 47.831683],
              [89.838728, 47.831366],
              [89.836893, 47.830935],
              [89.836473564000016, 47.830853902],
              [89.839128494000022, 47.831666945999984],
              [89.836473464999983, 47.830854416000022],
              [89.836470484000017, 47.830853306999984],
              [89.835269, 47.830621],
              [89.834124, 47.830393],
              [89.833662, 47.830291],
              [89.833371, 47.830244],
              [89.833034, 47.830378],
              [89.83265, 47.830621],
              [89.831983, 47.830856],
              [89.831003, 47.831264],
              [89.830968746999986, 47.831275882999989],
              [89.82985, 47.831664],
              [89.829065, 47.831884],
              [89.828579, 47.831946],
              [89.828210474, 47.831937612],
              [89.82792, 47.831931],
              [89.827395, 47.83197],
              [89.826995, 47.831836],
              [89.826712, 47.831593],
              [89.82632, 47.831327],
              [89.825897, 47.83106],
              [89.825622, 47.830958],
              [89.82505, 47.830754],
              [89.824815730000012, 47.83067244199998],
              [89.824352, 47.830511],
              [89.823756405999973, 47.830414866000012],
              [89.823528, 47.830378],
              [89.822493, 47.830213],
              [89.821442, 47.830064],
              [89.821314359999974, 47.830048705000024],
              [89.820524, 47.829954],
              [89.820148, 47.83008],
              [89.819981185000017, 47.830189889],
              [89.819685, 47.830385],
              [89.819081, 47.830864],
              [89.818602, 47.831264],
              [89.818116, 47.831538],
              [89.817787, 47.831687],
              [89.817465, 47.831711],
              [89.817183, 47.831938],
              [89.817137, 47.831979],
              [89.816916, 47.832174],
              [89.816422, 47.83255],
              [89.815732, 47.833201],
              [89.814877, 47.833876],
              [89.814618, 47.834166],
              [89.814383, 47.834291],
              [89.8141, 47.834307],
              [89.813606, 47.834244],
              [89.8129, 47.834237],
              [89.812367, 47.834197],
              [89.811685, 47.834189],
              [89.811316, 47.834119],
              [89.811057, 47.834088],
              [89.810594, 47.834056],
              [89.810226, 47.834072],
              [89.809747, 47.834182],
              [89.809269, 47.834338],
              [89.808869, 47.834409],
              [89.808406, 47.83444],
              [89.808069, 47.834574],
              [89.807685, 47.834684],
              [89.807292, 47.834613],
              [89.806837, 47.834574],
              [89.806249, 47.834668],
              [89.805716, 47.834942],
              [89.805049, 47.835288],
              [89.804516, 47.835476],
              [89.804077, 47.835507],
              [89.803606, 47.83535],
              [89.803081290000023, 47.835150732999978],
              [89.802924, 47.835091],
              [89.802382, 47.834982],
              [89.801473, 47.834888],
              [89.800563, 47.834762],
              [89.799849, 47.834652],
              [89.798382, 47.834244],
              [89.797473, 47.834103],
              [89.796555, 47.83415],
              [89.795739, 47.834315],
              [89.795237039000028, 47.83446901100001],
              [89.794947, 47.834558],
              [89.794437, 47.834691],
              [89.794116, 47.834715],
              [89.793708, 47.834605],
              [89.793298823999976, 47.834440230999974],
              [89.793261, 47.834425],
              [89.792727, 47.834189],
              [89.792163, 47.834009],
              [89.791567, 47.833782],
              [89.791339, 47.833703],
              [89.791167, 47.833546],
              [89.79101, 47.833327],
              [89.790688, 47.83284],
              [89.790411, 47.832394],
              [89.790123, 47.831891],
              [89.789833, 47.831476],
              [89.789696, 47.83117],
              [89.789512, 47.830911],
              [89.789308, 47.830817],
              [89.789002, 47.830785],
              [89.788665, 47.83077],
              [89.788429, 47.830754],
              [89.787833, 47.830613],
              [89.787457, 47.830417],
              [89.787266, 47.830304],
              [89.786766, 47.830009],
              [89.786139, 47.82964],
              [89.785331, 47.829225],
              [89.784413, 47.828809],
              [89.783245, 47.828401],
              [89.782437, 47.82815],
              [89.781471107000016, 47.827987034999978],
              [89.780813, 47.827876],
              [89.779347, 47.827507],
              [89.778727412000023, 47.827298467999981],
              [89.778625, 47.827264],
              [89.778304, 47.827146],
              [89.777846, 47.82699],
              [89.777496, 47.82684],
              [89.777135, 47.826817],
              [89.776688, 47.826911],
              [89.776194, 47.827021],
              [89.775676, 47.827068],
              [89.775496, 47.827068],
              [89.7749, 47.827052],
              [89.774537123000016, 47.827082991],
              [89.774256, 47.827107],
              [89.773812446000022, 47.827054572],
              [89.773723, 47.827044],
              [89.77368063199998, 47.827049403],
              [89.773229, 47.827107],
              [89.772868, 47.827185],
              [89.772343, 47.827264],
              [89.77177, 47.827232],
              [89.771064, 47.82724],
              [89.77046, 47.827256],
              [89.76937, 47.827311],
              [89.768884, 47.827444],
              [89.768272, 47.827617],
              [89.767699, 47.827742],
              [89.767001, 47.827727],
              [89.766217, 47.827805],
              [89.765754, 47.827985],
              [89.765158, 47.828095],
              [89.764664, 47.82808],
              [89.763644, 47.82786],
              [89.763460488000021, 47.827799361000018],
              [89.762954, 47.827632],
              [89.762162, 47.827374],
              [89.761488, 47.827029],
              [89.761103, 47.826919],
              [89.760829, 47.826911],
              [89.760562, 47.826966],
              [89.760209, 47.827123],
              [89.760084958, 47.827196898000011],
              [89.75988, 47.827319],
              [89.759448, 47.827452],
              [89.759111, 47.827656],
              [89.758962, 47.827931],
              [89.758915, 47.828362],
              [89.758907, 47.828801],
              [89.759013, 47.82949],
              [89.75908, 47.830174],
              [89.75915, 47.831115],
              [89.759213, 47.831986],
              [89.759244, 47.832786],
              [89.759291, 47.833366],
              [89.759428, 47.833914],
              [89.759621, 47.834299],
              [89.759911, 47.834707],
              [89.760248, 47.835099],
              [89.760584, 47.835567],
              [89.760719, 47.835742],
              [89.760907, 47.83597],
              [89.760844, 47.836111],
              [89.760672, 47.836252],
              [89.760499, 47.836378],
              [89.760068, 47.836786],
              [89.759707, 47.83706],
              [89.759346, 47.837209],
              [89.758829, 47.837295],
              [89.758303, 47.837484],
              [89.757582, 47.837719],
              [89.756993, 47.838064],
              [89.756436, 47.838464],
              [89.755864, 47.838668],
              [89.755346, 47.838872],
              [89.754656, 47.839107],
              [89.754115, 47.839335],
              [89.753527, 47.839727],
              [89.752836, 47.840299],
              [89.752546, 47.840684],
              [89.752508, 47.840936],
              [89.752525, 47.841257],
              [89.752566, 47.841709],
              [89.752684, 47.842093],
              [89.752905, 47.842541],
              [89.753287, 47.84293],
              [89.753444, 47.843096],
              [89.753757, 47.843428],
              [89.754052, 47.844029],
              [89.754199, 47.844644],
              [89.754435, 47.84538],
              [89.75454, 47.845808],
              [89.754509, 47.846152],
              [89.754381, 47.846531],
              [89.754232, 47.846684],
              [89.754005, 47.846888],
              [89.753511, 47.847366],
              [89.753009, 47.847892],
              [89.752695, 47.848292],
              [89.752515, 47.848629],
              [89.752295, 47.849005],
              [89.752052, 47.849358],
              [89.751832, 47.849672],
              [89.751636, 47.849837],
              [89.751495, 47.849915],
              [89.751378, 47.849954],
              [89.75132, 47.84997],
              [89.751142, 47.850017],
              [89.75104, 47.850174],
              [89.75097, 47.850441],
              [89.750962, 47.850841],
              [89.751007, 47.850985],
              [89.751064, 47.85117],
              [89.751205, 47.851429],
              [89.751357, 47.851779],
              [89.751377, 47.852154],
              [89.751276, 47.852504],
              [89.751189, 47.852951],
              [89.751064, 47.853617],
              [89.751072, 47.854152],
              [89.751066, 47.85465],
              [89.751171, 47.855078],
              [89.751354, 47.855406],
              [89.751534, 47.855649],
              [89.75177, 47.855884],
              [89.752076, 47.856057],
              [89.752366, 47.856253],
              [89.75257, 47.856441],
              [89.752533, 47.856605],
              [89.752405, 47.856692],
              [89.752115, 47.85688],
              [89.751832, 47.857115],
              [89.751629, 47.857249],
              [89.751378, 47.857374],
              [89.751142, 47.857429],
              [89.750844, 47.857594],
              [89.75053, 47.857774],
              [89.750225, 47.857908],
              [89.74984, 47.857955],
              [89.749354, 47.85797],
              [89.749032, 47.858088],
              [89.748891, 47.858308],
              [89.748805, 47.858504],
              [89.748635, 47.858661],
              [89.748601, 47.858692],
              [89.748311, 47.858841],
              [89.748021, 47.859013],
              [89.747675, 47.859249],
              [89.747323, 47.85957],
              [89.746946, 47.859829],
              [89.746468, 47.860096],
              [89.745464, 47.860535],
              [89.744523, 47.861053],
              [89.743534, 47.861625],
              [89.742993, 47.862096],
              [89.742185, 47.862692],
              [89.741393, 47.86321],
              [89.740977, 47.863516],
              [89.740742, 47.863743],
              [89.74053, 47.863955],
              [89.740271, 47.864127],
              [89.740036, 47.864512],
              [89.739868, 47.864759],
              [89.739785, 47.865037],
              [89.739729, 47.865547],
              [89.739668, 47.865798],
              [89.739511, 47.866072],
              [89.739409, 47.866198],
              [89.739315, 47.866457],
              [89.739302, 47.866807],
              [89.739318, 47.867105],
              [89.739495, 47.867374],
              [89.739597, 47.8675],
              [89.739824, 47.867673],
              [89.740138, 47.867806],
              [89.740444, 47.868002],
              [89.740781, 47.868229],
              [89.741087, 47.868378],
              [89.741322, 47.86841],
              [89.741628, 47.86848],
              [89.74195, 47.86859],
              [89.742389, 47.868684],
              [89.742664, 47.868739],
              [89.743911, 47.868935],
              [89.744601, 47.869171],
              [89.745296, 47.869466],
              [89.745377, 47.8695],
              [89.746625, 47.870088],
              [89.747903, 47.870637],
              [89.748758, 47.871163],
              [89.749425, 47.871563],
              [89.74951, 47.871815],
              [89.749541, 47.872102],
              [89.749674, 47.87274],
              [89.74978, 47.873191],
              [89.750014, 47.873893],
              [89.750279, 47.87455],
              [89.750734, 47.87532],
              [89.751307, 47.876324],
              [89.751762, 47.877194],
              [89.75177, 47.877414],
              [89.751706, 47.87759],
              [89.751574, 47.877681],
              [89.751268, 47.8779],
              [89.750499, 47.878347],
              [89.749683, 47.878708],
              [89.748797, 47.878967],
              [89.747801, 47.879273],
              [89.746585, 47.879602],
              [89.745754, 47.879853],
              [89.745119, 47.880206],
              [89.744358, 47.880786],
              [89.743558, 47.881351],
              [89.743173, 47.881681],
              [89.742922, 47.881994],
              [89.742679, 47.882269],
              [89.742436, 47.882481],
              [89.742193, 47.882669],
              [89.742044, 47.882802],
              [89.741754, 47.883038],
              [89.741652, 47.883293],
              [89.741503, 47.883461],
              [89.741236, 47.883728],
              [89.740911, 47.883845],
              [89.740632, 47.8839],
              [89.740405, 47.884057],
              [89.740185, 47.884339],
              [89.739973, 47.884575],
              [89.73973, 47.884802],
              [89.738875, 47.885516],
              [89.737918, 47.886316],
              [89.737897873, 47.88633238],
              [89.737456, 47.886692],
              [89.737103, 47.887053],
              [89.736452, 47.887798],
              [89.73621523700001, 47.888073713999972],
              [89.735832, 47.88852],
              [89.735056, 47.889367],
              [89.734334, 47.890112],
              [89.733291, 47.8911],
              [89.732467, 47.892042],
              [89.731714, 47.892967],
              [89.731589, 47.893108],
              [89.731393, 47.893234],
              [89.731134, 47.893328],
              [89.73075, 47.893446],
              [89.730303, 47.893602],
              [89.729848, 47.893712],
              [89.729652, 47.893853],
              [89.729456, 47.894089],
              [89.729283, 47.89434],
              [89.729023, 47.894796],
              [89.728687, 47.895304],
              [89.728279, 47.895953],
              [89.727832, 47.89674],
              [89.727377, 47.897438],
              [89.727153, 47.897852],
              [89.727013, 47.898161],
              [89.726915, 47.898783],
              [89.726883, 47.899436],
              [89.726833, 47.899833],
              [89.726585, 47.899759],
              [89.72642, 47.899759],
              [89.72624, 47.899728],
              [89.725785, 47.899657],
              [89.725197, 47.899485],
              [89.724459, 47.899352],
              [89.724146039, 47.899300098000026],
              [89.723651, 47.899218],
              [89.722616, 47.899069],
              [89.721824, 47.898904],
              [89.720922, 47.89873],
              [89.720218, 47.898431],
              [89.719565, 47.898222],
              [89.719126, 47.89805],
              [89.718679, 47.897971],
              [89.718075, 47.897924],
              [89.717408, 47.897838],
              [89.716781, 47.897814],
              [89.716153, 47.897814],
              [89.715338, 47.89794],
              [89.715008, 47.897964],
              [89.71471, 47.897987],
              [89.713675, 47.898026],
              [89.71249, 47.898081],
              [89.712059, 47.898206],
              [89.711683, 47.89845],
              [89.711351, 47.898875],
              [89.710965, 47.8994],
              [89.710768, 47.899669],
              [89.710462327000016, 47.900077838000016],
              [89.710128, 47.900525],
              [89.709989, 47.900708],
              [89.709816, 47.900834],
              [89.709557, 47.900842],
              [89.709024, 47.900756],
              [89.70845, 47.900643],
              [89.708064977999982, 47.900569024999982],
              [89.707357, 47.900433],
              [89.70687, 47.900297],
              [89.706295, 47.900257],
              [89.706239, 47.900253],
              [89.705775, 47.900217],
              [89.704601, 47.900097],
              [89.703411, 47.900002],
              [89.702604, 47.900081],
              [89.701949, 47.900121],
              [89.701881895999975, 47.900138894],
              [89.701469, 47.900249],
              [89.701006, 47.900409],
              [89.700678, 47.900505],
              [89.700479, 47.900537],
              [89.699815, 47.900553],
              [89.698753, 47.900641],
              [89.698114, 47.90076],
              [89.697451, 47.900792],
              [89.696436, 47.900864],
              [89.695805, 47.900976],
              [89.695214, 47.901192],
              [89.694702, 47.901368],
              [89.694047, 47.901647],
              [89.692945, 47.902175],
              [89.69213, 47.902478],
              [89.691227, 47.902798],
              [89.690453, 47.903102],
              [89.690292, 47.903165],
              [89.689861, 47.903389],
              [89.689485, 47.903525],
              [89.688973066000017, 47.903559648999988],
              [89.688894, 47.903565],
              [89.688503, 47.903589],
              [89.688167, 47.903756],
              [89.687839643000018, 47.903964318000021],
              [89.687815, 47.90398],
              [89.68752, 47.904196],
              [89.687001, 47.904316],
              [89.686285124999984, 47.904385370999989],
              [89.686258, 47.904388],
              [89.685347, 47.904436],
              [89.684356, 47.904444],
              [89.683238, 47.904436],
              [89.683098, 47.90443],
              [89.682135, 47.904388],
              [89.680897, 47.904388],
              [89.68001, 47.904444],
              [89.679115, 47.904539],
              [89.67858, 47.904619],
              [89.677909, 47.904939],
              [89.677462956, 47.905159133999973],
              [89.677214, 47.905282],
              [89.67687, 47.905386],
              [89.676551, 47.905402],
              [89.676380143000017, 47.905396481000025],
              [89.675808, 47.905378],
              [89.674889, 47.905219],
              [89.674345, 47.905123],
              [89.674042, 47.904947],
              [89.673762, 47.904883],
              [89.673443, 47.904763],
              [89.673027, 47.904731],
              [89.672029, 47.904787],
              [89.671557, 47.904715],
              [89.671373, 47.904627],
              [89.671166, 47.904492],
              [89.67079, 47.904476],
              [89.670551, 47.904563],
              [89.669959, 47.904667],
              [89.6698, 47.904667],
              [89.669592, 47.904563],
              [89.669216, 47.904539],
              [89.668529, 47.904515],
              [89.667618, 47.904539],
              [89.666724, 47.904484],
              [89.665861, 47.904523],
              [89.665645, 47.904531],
              [89.665294, 47.904531],
              [89.66507, 47.904412],
              [89.664774, 47.904372],
              [89.664359, 47.904356],
              [89.663831, 47.904356],
              [89.66328, 47.904476],
              [89.662761, 47.904468],
              [89.662266, 47.904468],
              [89.661794, 47.90446],
              [89.661227, 47.9045],
              [89.660788, 47.904603],
              [89.660532, 47.904627],
              [89.660428, 47.904563],
              [89.660244, 47.904476],
              [89.660037, 47.904468],
              [89.659925, 47.90446],
              [89.659693, 47.90446],
              [89.659445, 47.904476],
              [89.659182, 47.904603],
              [89.65899, 47.904611],
              [89.65879, 47.904579],
              [89.658559, 47.904563],
              [89.658303, 47.904579],
              [89.658175, 47.904691],
              [89.658047, 47.904803],
              [89.657919, 47.904875],
              [89.657648, 47.904883],
              [89.657192, 47.904947],
              [89.656521, 47.905131],
              [89.655626, 47.905266],
              [89.654875, 47.90537],
              [89.654061, 47.905698],
              [89.653286, 47.906121],
              [89.652391, 47.906784],
              [89.651744, 47.9072],
              [89.651057, 47.907759],
              [89.650369, 47.908318],
              [89.649642, 47.909037],
              [89.649003, 47.909717],
              [89.648404, 47.910603],
              [89.648045, 47.911147],
              [89.647477, 47.912057],
              [89.647414235999975, 47.912168216999987],
              [89.64667, 47.913487],
              [89.646431, 47.913887],
              [89.646047, 47.914654],
              [89.645656, 47.915493],
              [89.645081, 47.916707],
              [89.644817, 47.917266],
              [89.644537, 47.917962],
              [89.644338, 47.918649],
              [89.644114, 47.919352],
              [89.643866, 47.919879],
              [89.643658, 47.920542],
              [89.643626, 47.920798],
              [89.643634, 47.921005],
              [89.64369, 47.921181],
              [89.643826, 47.921341],
              [89.64421, 47.921852],
              [89.644593, 47.922412],
              [89.644873, 47.922811],
              [89.644985, 47.923035],
              [89.645049, 47.923139],
              [89.645049, 47.92325],
              [89.644961, 47.923338],
              [89.644769, 47.923482],
              [89.644617, 47.923626],
              [89.64433, 47.92385],
              [89.644202, 47.924137],
              [89.644034, 47.924521],
              [89.643898, 47.924928],
              [89.64365, 47.925767],
              [89.643587, 47.926097],
              [89.643563, 47.926222],
              [89.643403, 47.926918],
              [89.643259, 47.927573],
              [89.643051, 47.92822],
              [89.642772, 47.928771],
              [89.64246, 47.929306],
              [89.642101, 47.92993],
              [89.641949, 47.930185],
              [89.641701, 47.930441],
              [89.641389, 47.930752],
              [89.64111, 47.931088],
              [89.640638, 47.931559],
              [89.640383, 47.931759],
              [89.640015, 47.932121],
              [89.639927, 47.932206],
              [89.639504, 47.93279],
              [89.639336, 47.933117],
              [89.639232, 47.933397],
              [89.639232, 47.93344],
              [89.639232, 47.933724],
              [89.639256, 47.934204],
              [89.639304, 47.934851],
              [89.639352, 47.935346],
              [89.639504, 47.93593],
              [89.639672, 47.936505],
              [89.63984, 47.937088],
              [89.640015, 47.937599],
              [89.640311, 47.938294],
              [89.64063, 47.938806],
              [89.640894, 47.939141],
              [89.64135, 47.939708],
              [89.641741, 47.940324],
              [89.641861, 47.940611],
              [89.641813, 47.94173],
              [89.641837, 47.942513],
              [89.641845, 47.943224],
              [89.641829, 47.943408],
              [89.641821, 47.943479],
              [89.641589, 47.943639],
              [89.641525, 47.943743],
              [89.641405, 47.943863],
              [89.641278, 47.944055],
              [89.641182, 47.94439],
              [89.641022, 47.944582],
              [89.640918, 47.944894],
              [89.64079, 47.945189],
              [89.640575, 47.945501],
              [89.640295, 47.945764],
              [89.639959, 47.946068],
              [89.639576, 47.946356],
              [89.639097, 47.946611],
              [89.639071845999979, 47.946624289],
              [89.638673, 47.946835],
              [89.638282, 47.947027],
              [89.63797, 47.947091],
              [89.637626, 47.947099],
              [89.637275, 47.947218],
              [89.636316, 47.947322],
              [89.635469, 47.947314],
              [89.634678, 47.947338],
              [89.634303, 47.94741],
              [89.634023, 47.94745],
              [89.633672, 47.947562],
              [89.633288, 47.947754],
              [89.632969, 47.947882],
              [89.632793, 47.94793],
              [89.63229, 47.948065],
              [89.63185, 47.948153],
              [89.631139, 47.948145],
              [89.630604, 47.948257],
              [89.630069, 47.948361],
              [89.629645, 47.948417],
              [89.629254, 47.948537],
              [89.628255, 47.948657],
              [89.627288, 47.94872],
              [89.626457, 47.94876],
              [89.625339, 47.948864],
              [89.62527, 47.948869],
              [89.62458, 47.94892],
              [89.624276, 47.948928],
              [89.623837, 47.949088],
              [89.62319, 47.949224],
              [89.622615, 47.949384],
              [89.622151, 47.949671],
              [89.621824, 47.949767],
              [89.621152, 47.949831],
              [89.620401, 47.949799],
              [89.619395, 47.949927],
              [89.618364, 47.949887],
              [89.617653, 47.949783],
              [89.617374, 47.949751],
              [89.617182, 47.949847],
              [89.617014, 47.950079],
              [89.616934, 47.950302],
              [89.616862, 47.950702],
              [89.616742, 47.951285],
              [89.616623, 47.95178],
              [89.616431, 47.952659],
              [89.616335, 47.952955],
              [89.616215, 47.953306],
              [89.616183, 47.953586],
              [89.616007, 47.953922],
              [89.615784, 47.954265],
              [89.615424, 47.954736],
              [89.615073, 47.95524],
              [89.614809, 47.955695],
              [89.614537, 47.956015],
              [89.61429, 47.95639],
              [89.613954, 47.956838],
              [89.613722, 47.957141],
              [89.613443, 47.957525],
              [89.613027, 47.957932],
              [89.612804, 47.958028],
              [89.612596, 47.958108],
              [89.612476, 47.958244],
              [89.61246, 47.958348],
              [89.612468, 47.958459],
              [89.612538, 47.95853],
              [89.612548, 47.958539],
              [89.612628, 47.958603],
              [89.612732, 47.958771],
              [89.612764, 47.958947],
              [89.612764, 47.959067],
              [89.612764, 47.959226],
              [89.612652, 47.959426],
              [89.612452, 47.959594],
              [89.61226, 47.959698],
              [89.611893, 47.959937],
              [89.611088, 47.960361],
              [89.609161, 47.961162],
              [89.607545, 47.961666],
              [89.607233, 47.961763],
              [89.605506, 47.962238],
              [89.605055, 47.962288],
              [89.60468, 47.962288],
              [89.604304, 47.962288],
              [89.603653, 47.962338],
              [89.602777, 47.962639],
              [89.60115, 47.963265],
              [89.599348, 47.964066],
              [89.598472, 47.964291],
              [89.597195, 47.964641],
              [89.596419, 47.965092],
              [89.594892, 47.965918],
              [89.593637, 47.966459],
              [89.593312, 47.966637],
              [89.592956, 47.966962],
              [89.59282, 47.96713],
              [89.592715, 47.967224],
              [89.592747, 47.967381],
              [89.592862, 47.967497],
              [89.593061, 47.96756],
              [89.593312, 47.96778],
              [89.593339547000028, 47.967799237],
              [89.593491, 47.967905],
              [89.593637, 47.968031],
              [89.59369, 47.968157],
              [89.59369, 47.968262],
              [89.593574, 47.968398],
              [89.593449, 47.968524],
              [89.593333, 47.968608],
              [89.593302, 47.968649],
              [89.593302, 47.968838],
              [89.59347, 47.969121],
              [89.593595, 47.969373],
              [89.593748, 47.969571],
              [89.59391, 47.969781],
              [89.594381, 47.970452],
              [89.594528, 47.970861],
              [89.594717, 47.971112],
              [89.594853, 47.971343],
              [89.594863, 47.9715],
              [89.59479, 47.971636],
              [89.594685, 47.971762],
              [89.594549, 47.971835],
              [89.594245, 47.972097],
              [89.594015, 47.972244],
              [89.593826, 47.972485],
              [89.593737762999979, 47.972668611000017],
              [89.59369, 47.972768],
              [89.593627, 47.973124],
              [89.593491, 47.973837],
              [89.593354, 47.974225],
              [89.593176, 47.974738],
              [89.592978, 47.975361],
              [89.592893, 47.975629],
              [89.59261, 47.976551],
              [89.592474, 47.977096],
              [89.5925, 47.977417],
              [89.59238, 47.978637],
              [89.592294004, 47.978906051000024],
              [89.592139, 47.979391],
              [89.591856, 47.979978],
              [89.591353, 47.981015],
              [89.590913, 47.981822],
              [89.59078615300001, 47.982000283],
              [89.590294, 47.982692],
              [89.590011, 47.983007],
              [89.589655, 47.983331],
              [89.589341, 47.983583],
              [89.589037, 47.984013],
              [89.588932, 47.984316],
              [89.588869, 47.984641],
              [89.588743, 47.984914],
              [89.588701, 47.98526],
              [89.588785, 47.985794],
              [89.588785, 47.986108],
              [89.588555, 47.986486],
              [89.588377, 47.986758],
              [89.588188, 47.986978],
              [89.587957, 47.987094],
              [89.587601, 47.987251],
              [89.58736, 47.987335],
              [89.58715, 47.98746],
              [89.587014, 47.987607],
              [89.58692, 47.987806],
              [89.58692, 47.988026],
              [89.58692, 47.988173],
              [89.586847, 47.988362],
              [89.586752, 47.988519],
              [89.58671, 47.988613],
              [89.586595, 47.988634],
              [89.58648, 47.988665],
              [89.586291, 47.988707],
              [89.586144, 47.988833],
              [89.586071, 47.988938],
              [89.585893, 47.989095],
              [89.58561, 47.989231],
              [89.585264, 47.989368],
              [89.585002, 47.989525],
              [89.584709, 47.989682],
              [89.584531, 47.98985],
              [89.584394, 47.989965],
              [89.584321, 47.990101],
              [89.584363, 47.990227],
              [89.584478, 47.990363],
              [89.584709, 47.990416],
              [89.585034, 47.990562],
              [89.585288939, 47.99065336000001],
              [89.58562, 47.990772],
              [89.585882, 47.99094],
              [89.586092, 47.991107],
              [89.586228, 47.991306],
              [89.586312, 47.991505],
              [89.586396, 47.991663],
              [89.586406, 47.99183],
              [89.586427, 47.992082],
              [89.586396, 47.992176],
              [89.586354, 47.992354],
              [89.586239, 47.99248],
              [89.586183240000025, 47.992570850999982],
              [89.586123, 47.992669],
              [89.586061, 47.992815],
              [89.586061, 47.993056],
              [89.586123, 47.993329],
              [89.586146612999983, 47.993618590999972],
              [89.586176, 47.993979],
              [89.58626, 47.994974],
              [89.586176, 47.995362],
              [89.585987, 47.995854],
              [89.585861, 47.996326],
              [89.585778763, 47.99660472],
              [89.585694, 47.996892],
              [89.585683, 47.997395],
              [89.585683, 47.997751],
              [89.585767988999976, 47.997946070000012],
              [89.585819233, 47.998063688],
              [89.585893, 47.998233],
              [89.58594924800002, 47.99828435],
              [89.586249, 47.998558],
              [89.586647, 47.99881],
              [89.58757, 47.999187],
              [89.588439, 47.99948],
              [89.589121, 47.999648],
              [89.589728, 47.999815],
              [89.59042, 48.000004],
              [89.591793, 48.000319],
              [89.592872, 48.000665],
              [89.593407, 48.000864],
              [89.593742, 48.001115],
              [89.593994, 48.001367],
              [89.594434, 48.001807],
              [89.594811, 48.002205],
              [89.595628, 48.003054],
              [89.596446, 48.003871],
              [89.597001, 48.004427],
              [89.597724, 48.005097],
              [89.598605, 48.005821],
              [89.599464, 48.006554],
              [89.600313, 48.007288],
              [89.600816, 48.007644],
              [89.600879, 48.007833],
              [89.600858, 48.007958],
              [89.600722, 48.008074],
              [89.600491, 48.008252],
              [89.600051, 48.008472],
              [89.598982, 48.009258],
              [89.598385, 48.009646],
              [89.597724, 48.010222],
              [89.597169, 48.010976],
              [89.59676, 48.011731],
              [89.596352, 48.012454],
              [89.595964, 48.01345],
              [89.595754, 48.014204],
              [89.595366, 48.01498],
              [89.595188, 48.015378],
              [89.595031, 48.015839],
              [89.594916, 48.016573],
              [89.594884, 48.017495],
              [89.594905, 48.018333],
              [89.595, 48.018868],
              [89.595084, 48.019245],
              [89.594979, 48.019371],
              [89.59478, 48.019507],
              [89.594308, 48.019716],
              [89.593826, 48.019758],
              [89.592925, 48.019842],
              [89.591416, 48.019926],
              [89.590871218000018, 48.019949008000026],
              [89.590682, 48.019957],
              [89.589823, 48.02001],
              [89.588712, 48.020094],
              [89.587329, 48.020335],
              [89.586427, 48.020607],
              [89.585463, 48.020964],
              [89.584751, 48.021414],
              [89.584576094, 48.021558880999976],
              [89.584384, 48.021718],
              [89.584017, 48.022326],
              [89.58365, 48.023311],
              [89.583451, 48.024065],
              [89.583325, 48.025302],
              [89.583063, 48.026245],
              [89.58277, 48.027367],
              [89.582403, 48.028373],
              [89.582016, 48.029075],
              [89.581764, 48.029714],
              [89.581554, 48.030186],
              [89.581345, 48.030437],
              [89.581114, 48.030699],
              [89.580884, 48.030846],
              [89.580685, 48.030877],
              [89.580234, 48.030825],
              [89.579752, 48.030531],
              [89.579417, 48.030332],
              [89.57905, 48.030259],
              [89.578693, 48.030259],
              [89.578524388, 48.030259],
              [89.578285, 48.030259],
              [89.577928, 48.030385],
              [89.577635, 48.030469],
              [89.577258, 48.03072],
              [89.576765, 48.031034],
              [89.576331945999982, 48.03132789],
              [89.575791, 48.031695],
              [89.574659, 48.032407],
              [89.573946, 48.0329],
              [89.573674, 48.033026],
              [89.573328, 48.033078],
              [89.572746419999987, 48.032973277999986],
              [89.572395, 48.03291],
              [89.571389, 48.032805],
              [89.570792, 48.032543],
              [89.569922, 48.032229],
              [89.569634, 48.032038],
              [89.569178, 48.031737],
              [89.568172, 48.031496],
              [89.567124, 48.031443],
              [89.566432, 48.031433],
              [89.565992, 48.031516],
              [89.565489, 48.031695],
              [89.565474099000028, 48.031696737],
              [89.564777, 48.031778],
              [89.564305, 48.031726],
              [89.563613, 48.031579],
              [89.563079, 48.031632],
              [89.562492, 48.031674],
              [89.561507, 48.031621],
              [89.561313254000027, 48.031619272],
              [89.560386, 48.031611],
              [89.559589, 48.031894],
              [89.558887, 48.032198],
              [89.558216, 48.032617],
              [89.557441, 48.03291],
              [89.556037, 48.033466],
              [89.555235, 48.033751],
              [89.554769, 48.033916],
              [89.553417, 48.034335],
              [89.552107, 48.034786],
              [89.550608, 48.035142],
              [89.549623, 48.035289],
              [89.548994, 48.035331],
              [89.548439, 48.0353],
              [89.54802, 48.035247],
              [89.547234, 48.035059],
              [89.546238, 48.03488],
              [89.545985, 48.034851],
              [89.544813, 48.034713],
              [89.54344, 48.034597],
              [89.542392, 48.034545],
              [89.541774, 48.03465],
              [89.54082, 48.034765],
              [89.539998032000028, 48.034863076000022],
              [89.53994, 48.03487],
              [89.53883, 48.035036],
              [89.538682, 48.035059],
              [89.537435, 48.035268],
              [89.536419, 48.03552],
              [89.535643, 48.035719],
              [89.534742, 48.035897],
              [89.533946, 48.035907],
              [89.532929, 48.035886],
              [89.532680067, 48.035858467000025],
              [89.531609, 48.03574],
              [89.530288, 48.035677],
              [89.528936, 48.035624],
              [89.527574, 48.03552],
              [89.526432, 48.035383],
              [89.52552, 48.035237],
              [89.524923, 48.03508],
              [89.524001, 48.034755],
              [89.522733, 48.034409],
              [89.521968, 48.034168],
              [89.521234, 48.034063],
              [89.519704, 48.033916],
              [89.518174, 48.033791],
              [89.51771899900001, 48.033752836000019],
              [89.516791, 48.033675],
              [89.515923088000022, 48.033571736],
              [89.515732, 48.033549],
              [89.515418663, 48.033538218999979],
              [89.515078189, 48.033526505],
              [89.514831, 48.033518],
              [89.513919, 48.033497],
              [89.513416, 48.033487],
              [89.512892, 48.033623],
              [89.512022, 48.033811],
              [89.511373, 48.033937],
              [89.510859, 48.033958],
              [89.510157, 48.033728],
              [89.509382, 48.033434],
              [89.509190263999983, 48.033374713],
              [89.508774, 48.033246],
              [89.508585, 48.033151],
              [89.508501, 48.032805],
              [89.50852215499998, 48.032583531],
              [89.508533, 48.03247],
              [89.508491, 48.031936],
              [89.508061, 48.031317],
              [89.507642, 48.030827],
              [89.507631, 48.030814],
              [89.507233, 48.030563],
              [89.506604, 48.030259],
              [89.505777, 48.029913],
              [89.505116, 48.029745],
              [89.504226, 48.029536],
              [89.503303, 48.029274],
              [89.502622, 48.02898],
              [89.501962, 48.028603],
              [89.501428, 48.028257],
              [89.500704, 48.027964],
              [89.499929, 48.027566],
              [89.499101, 48.027314],
              [89.498409, 48.027094],
              [89.497623, 48.026874],
              [89.496963, 48.026685],
              [89.496649, 48.026643],
              [89.495716, 48.026319],
              [89.494836, 48.026109],
              [89.494312, 48.025795],
              [89.494008, 48.025375],
              [89.493432, 48.025061],
              [89.49275, 48.024768],
              [89.49208, 48.024631],
              [89.49142, 48.024516],
              [89.490689895, 48.024608363000027],
              [89.490424, 48.024642],
              [89.488873, 48.024904],
              [89.487437, 48.025166],
              [89.486224871, 48.025375594000025],
              [89.485436, 48.025512],
              [89.484335, 48.025679],
              [89.482868, 48.025952],
              [89.481223, 48.026266],
              [89.480573, 48.02635],
              [89.479724, 48.026402],
              [89.477628, 48.026612],
              [89.47737392, 48.02663019],
              [89.475868, 48.026738],
              [89.474086, 48.026895],
              [89.471529, 48.027126],
              [89.470282, 48.02722],
              [89.469035, 48.027325],
              [89.468218, 48.027398],
              [89.467379, 48.027555],
              [89.466279, 48.027807],
              [89.465378, 48.027974],
              [89.463806, 48.02832],
              [89.462265, 48.028687],
              [89.460687, 48.028983],
              [89.460589, 48.029001],
              [89.459195, 48.029305],
              [89.458545, 48.0294],
              [89.457508, 48.02962],
              [89.456669, 48.029819],
              [89.456124, 48.029924],
              [89.45537, 48.029934],
              [89.455286731, 48.029942936999987],
              [89.454783, 48.029997],
              [89.454344833, 48.030120676000024],
              [89.454039, 48.030207],
              [89.453284, 48.030458],
              [89.452656, 48.030552],
              [89.45187, 48.030689],
              [89.451283, 48.030699],
              [89.450214, 48.03072],
              [89.449344, 48.030741],
              [89.44861, 48.030793],
              [89.448045, 48.030888],
              [89.446609, 48.03116],
              [89.444859, 48.031485],
              [89.444345, 48.031611],
              [89.444031, 48.031632],
              [89.44358, 48.031726],
              [89.442993, 48.031883],
              [89.442648, 48.031894],
              [89.44227, 48.031841],
              [89.441778, 48.03181],
              [89.441243, 48.031726],
              [89.440604, 48.031632],
              [89.439766, 48.031695],
              [89.439367, 48.031726],
              [89.438382, 48.031768],
              [89.43768, 48.031726],
              [89.437177, 48.031852],
              [89.43658, 48.032009],
              [89.436349, 48.032009],
              [89.436024, 48.031841],
              [89.435626, 48.031632],
              [89.435312, 48.031569],
              [89.435029, 48.031495],
              [89.434704, 48.031537],
              [89.434149, 48.031579],
              [89.433572, 48.031611],
              [89.433259, 48.031673],
              [89.432538, 48.031562],
              [89.431867, 48.031549],
              [89.431035, 48.031537],
              [89.430587, 48.031537],
              [89.430102, 48.031636],
              [89.429804, 48.031773],
              [89.429531, 48.03191],
              [89.429369, 48.03191],
              [89.429034, 48.031736],
              [89.428126, 48.031524],
              [89.426386, 48.031139],
              [89.424696, 48.03089],
              [89.423776, 48.030754],
              [89.423006, 48.030841],
              [89.422397, 48.030965],
              [89.421639, 48.031288],
              [89.419936, 48.031934],
              [89.419352, 48.032171],
              [89.418929, 48.032171],
              [89.417935, 48.032084],
              [89.417065, 48.032046],
              [89.415909, 48.032171],
              [89.414604, 48.032133],
              [89.413573, 48.031959],
              [89.411746, 48.031922],
              [89.410615, 48.03186],
              [89.41008, 48.031736],
              [89.409173, 48.031462],
              [89.408851, 48.031332],
              [89.408403, 48.031151],
              [89.408213305, 48.031091898999989],
              [89.407607, 48.030903],
              [89.406837, 48.030679],
              [89.406253, 48.03053],
              [89.405432, 48.030455],
              [89.404459230999976, 48.030483326000024],
              [89.404127, 48.030493],
              [89.402412, 48.030269],
              [89.401157, 48.030219],
              [89.40015, 48.030344],
              [89.399641, 48.03048],
              [89.399007, 48.030754],
              [89.398336, 48.031127],
              [89.397801, 48.031549],
              [89.397466, 48.032021],
              [89.397437, 48.032052],
              [89.397081, 48.032432],
              [89.396807, 48.033078],
              [89.396409, 48.033674],
              [89.395999, 48.034184],
              [89.395403, 48.034706],
              [89.395216, 48.034868],
              [89.394955, 48.034992],
              [89.39457, 48.035315],
              [89.394185, 48.035613],
              [89.393949, 48.035986],
              [89.393849, 48.03621],
              [89.393663, 48.036334],
              [89.39329, 48.03657],
              [89.39288, 48.036856],
              [89.392321, 48.037477],
              [89.391923, 48.037937],
              [89.391736, 48.038347],
              [89.391438, 48.038944],
              [89.391264, 48.03913],
              [89.390953, 48.039329],
              [89.390456, 48.039541],
              [89.390071, 48.03969],
              [89.389872, 48.039727],
              [89.389599, 48.039938],
              [89.389251, 48.040212],
              [89.389002, 48.040299],
              [89.388381, 48.040373],
              [89.387983, 48.040411],
              [89.387598, 48.040647],
              [89.387063, 48.041032],
              [89.386715, 48.041193],
              [89.386243, 48.041367],
              [89.385299, 48.042088],
              [89.384329, 48.042834],
              [89.383521, 48.043629],
              [89.383012, 48.044139],
              [89.382885271000021, 48.044230578],
              [89.382875, 48.044238],
              [89.382515, 48.044263],
              [89.382056106999983, 48.044176891],
              [89.381657, 48.044102],
              [89.38099, 48.043897],
              [89.380563, 48.043766],
              [89.379345, 48.043393],
              [89.378003, 48.042971],
              [89.376313, 48.042387],
              [89.375107, 48.041653],
              [89.374548, 48.040957],
              [89.374101, 48.040224],
              [89.373815, 48.039491],
              [89.37374, 48.038956],
              [89.373616, 48.038472],
              [89.373554, 48.037813],
              [89.373666, 48.037229],
              [89.373914, 48.036645],
              [89.374101, 48.03611],
              [89.374374, 48.035327],
              [89.374585, 48.034743],
              [89.374612, 48.034658],
              [89.374797, 48.034072],
              [89.374859, 48.03355],
              [89.374867, 48.033475],
              [89.374921, 48.032966],
              [89.374921, 48.032767],
              [89.374809, 48.032655],
              [89.374387, 48.032581],
              [89.373902, 48.032494],
              [89.373318, 48.032208],
              [89.372760797000012, 48.031957035],
              [89.372572, 48.031872],
              [89.372038, 48.031475],
              [89.371557063000012, 48.030741616],
              [89.371516, 48.030679],
              [89.371056, 48.030033],
              [89.370546, 48.029337],
              [89.370136, 48.028467],
              [89.369825, 48.027721],
              [89.369241, 48.026826],
              [89.368583, 48.025596],
              [89.368309, 48.024925],
              [89.368185, 48.024453],
              [89.36816, 48.024117],
              [89.368222, 48.023608],
              [89.368222, 48.023235],
              [89.36811, 48.022924],
              [89.367899, 48.022675],
              [89.367464, 48.022464],
              [89.366917, 48.022066],
              [89.36591, 48.02152],
              [89.365016, 48.020973],
              [89.364245, 48.020737],
              [89.363723, 48.020674],
              [89.363139, 48.020674],
              [89.362766, 48.020575],
              [89.362406, 48.020339],
              [89.36161, 48.019978],
              [89.360392, 48.019332],
              [89.359696, 48.018872],
              [89.358155, 48.017978],
              [89.357298, 48.017543],
              [89.356552, 48.017219],
              [89.356216, 48.016946],
              [89.355931, 48.016722],
              [89.355632, 48.016424],
              [89.354998, 48.016163],
              [89.354278, 48.015827],
              [89.353979, 48.01574],
              [89.353718, 48.01574],
              [89.353284003999988, 48.015887125],
              [89.352836, 48.016039],
              [89.351481, 48.016486],
              [89.349977, 48.016921],
              [89.348958, 48.017145],
              [89.34779, 48.017505],
              [89.347069, 48.017667],
              [89.346125, 48.018077],
              [89.345311, 48.018524],
              [89.345283, 48.018539],
              [89.344513, 48.019108],
              [89.344068, 48.019511],
              [89.343751, 48.019891],
              [89.343266, 48.020538],
              [89.343117, 48.020768],
              [89.343024, 48.020917],
              [89.342977, 48.021124],
              [89.342955, 48.021395],
              [89.342905, 48.021568],
              [89.342819, 48.021718],
              [89.342471, 48.021843],
              [89.341713, 48.021992],
              [89.340892, 48.022054],
              [89.340097, 48.022066],
              [89.338879, 48.022029],
              [89.337688343000025, 48.021888768999986],
              [89.337512, 48.021868],
              [89.336468, 48.021793],
              [89.335556, 48.021635],
              [89.334765, 48.021408],
              [89.333411, 48.02106],
              [89.332255, 48.020998],
              [89.33044, 48.020824],
              [89.329769, 48.020761],
              [89.329222, 48.020824],
              [89.328942996000023, 48.020948777],
              [89.328862, 48.020985],
              [89.328501, 48.021134],
              [89.328216, 48.021122],
              [89.327818, 48.020985],
              [89.327234, 48.020774],
              [89.327217395, 48.020764429999986],
              [89.3265, 48.020351],
              [89.325456, 48.019755],
              [89.324736, 48.019432],
              [89.323766, 48.019034],
              [89.323356, 48.018897],
              [89.322685, 48.018723],
              [89.322148594, 48.0185854],
              [89.321765, 48.018487],
              [89.320435, 48.01804],
              [89.320075, 48.017891],
              [89.319876, 48.017654],
              [89.31971874300001, 48.017261559000019],
              [89.319652, 48.017095],
              [89.319466, 48.016784],
              [89.319043, 48.016598],
              [89.31836, 48.016511],
              [89.317698, 48.016391],
              [89.317676, 48.016387],
              [89.317207, 48.016188],
              [89.316744, 48.015778],
              [89.316309, 48.015492],
              [89.315601, 48.015181],
              [89.315066, 48.014995],
              [89.314259, 48.014821],
              [89.313637, 48.014585],
              [89.312494, 48.014131],
              [89.311817, 48.013888],
              [89.311233, 48.013697],
              [89.310567, 48.013553],
              [89.309747, 48.013503],
              [89.30925, 48.013516],
              [89.309022, 48.013517],
              [89.308720618, 48.013519702999986],
              [89.308576, 48.013521],
              [89.30838, 48.01359],
              [89.30792, 48.014025],
              [89.307597, 48.014373],
              [89.307411, 48.014411],
              [89.307274, 48.014336],
              [89.30705, 48.013889],
              [89.306615, 48.013404],
              [89.306118, 48.013093],
              [89.305405717999975, 48.012872696999978],
              [89.305397, 48.01287],
              [89.304043, 48.012708],
              [89.303297, 48.012633],
              [89.303262852999978, 48.012636074],
              [89.302464, 48.012708],
              [89.301582, 48.012783],
              [89.300762, 48.012882],
              [89.300053, 48.012919],
              [89.299394, 48.012944],
              [89.298947, 48.013106],
              [89.298301, 48.013404],
              [89.297654, 48.01369],
              [89.297319, 48.013814],
              [89.29707, 48.013814],
              [89.296698, 48.013677],
              [89.296337, 48.013677],
              [89.295803, 48.013764],
              [89.295318, 48.013764],
              [89.295007, 48.013615],
              [89.294540467, 48.013423292000027],
              [89.294311, 48.013329],
              [89.293814, 48.012969],
              [89.293429, 48.012435],
              [89.293255, 48.012223],
              [89.293118, 48.012136],
              [89.292447, 48.012012],
              [89.291403, 48.011739],
              [89.291005, 48.011515],
              [89.290521, 48.011092],
              [89.290297, 48.010719],
              [89.290297, 48.010334],
              [89.290359, 48.009638],
              [89.290309, 48.009029],
              [89.290297, 48.008743],
              [89.290173, 48.008557],
              [89.289775, 48.008296],
              [89.289228, 48.007998],
              [89.289104, 48.007662],
              [89.28898, 48.006941],
              [89.28888, 48.005723],
              [89.28883, 48.005164],
              [89.288656, 48.004692],
              [89.28847, 48.004269],
              [89.287936, 48.00361],
              [89.287575, 48.003064],
              [89.287252, 48.002194],
              [89.286805, 48.001286],
              [89.286581, 48.000615],
              [89.286506, 48.000155],
              [89.286512, 47.999804],
              [89.286544, 47.999546],
              [89.286593, 47.999149],
              [89.286581, 47.99885],
              [89.286307, 47.998266],
              [89.286071, 47.997943],
              [89.28581, 47.997632],
              [89.285388, 47.997347],
              [89.28494, 47.996936],
              [89.284568, 47.996564],
              [89.284344, 47.995992],
              [89.284331, 47.995632],
              [89.284319, 47.995321],
              [89.284418, 47.994898],
              [89.284592, 47.994575],
              [89.284642, 47.994215],
              [89.284655, 47.99373],
              [89.284443, 47.993357],
              [89.284033, 47.993009],
              [89.283859, 47.992736],
              [89.283623, 47.99235],
              [89.283188, 47.991866],
              [89.282666, 47.991344],
              [89.281995, 47.990958],
              [89.281767, 47.990842],
              [89.281674, 47.990692],
              [89.281622, 47.990461],
              [89.28151, 47.990126],
              [89.281274, 47.989716],
              [89.280814, 47.989032],
              [89.280541, 47.988485],
              [89.280143, 47.987764],
              [89.279907, 47.986919],
              [89.279783, 47.986708],
              [89.279484, 47.986633],
              [89.278826, 47.986596],
              [89.277744, 47.986683],
              [89.277640513, 47.986695278000013],
              [89.2768, 47.986795],
              [89.275905, 47.986807],
              [89.275147, 47.986807],
              [89.27455, 47.986783],
              [89.273777, 47.986774],
              [89.273457, 47.986683],
              [89.273134, 47.986484],
              [89.273104768, 47.986470387],
              [89.272857, 47.986355],
              [89.272355, 47.986273],
              [89.271742, 47.986223],
              [89.271319, 47.986261],
              [89.270930408000027, 47.986437288],
              [89.270909, 47.986447],
              [89.2703, 47.986845],
              [89.269405, 47.98728],
              [89.26897, 47.987441],
              [89.268634, 47.987516],
              [89.268125, 47.987541],
              [89.267417, 47.987541],
              [89.266634, 47.987603],
              [89.265577, 47.987653],
              [89.264533, 47.98769],
              [89.263825, 47.987827],
              [89.262917, 47.9881],
              [89.261911, 47.988336],
              [89.261066, 47.98846],
              [89.260233, 47.988634],
              [89.259949, 47.988733],
              [89.259301, 47.988958],
              [89.258406, 47.989492],
              [89.257529487999989, 47.990032209999981],
              [89.257499, 47.990051],
              [89.256915, 47.990461],
              [89.256306, 47.991033],
              [89.256194, 47.991108],
              [89.256045, 47.991108],
              [89.255846, 47.990896],
              [89.255461, 47.990548],
              [89.254702, 47.990002],
              [89.253944, 47.989442],
              [89.253273, 47.989057],
              [89.252739, 47.988622],
              [89.251906, 47.987764],
              [89.251546, 47.987317],
              [89.251223, 47.987031],
              [89.250464, 47.986646],
              [89.24952, 47.986335],
              [89.249364289000027, 47.98629415],
              [89.248811, 47.986149],
              [89.247917, 47.985962],
              [89.247196, 47.985763],
              [89.246549, 47.985652],
              [89.246214, 47.985366],
              [89.246129849999988, 47.98525380000001],
              [89.245953, 47.985018],
              [89.245916, 47.984695],
              [89.245926, 47.984328],
              [89.245928, 47.984272],
              [89.245916, 47.983986],
              [89.245836, 47.983745],
              [89.245617, 47.983452],
              [89.245232, 47.983129],
              [89.244844, 47.98266],
              [89.244362, 47.982072],
              [89.243681, 47.981109],
              [89.242933, 47.979823],
              [89.242507, 47.979083],
              [89.24228, 47.978758],
              [89.242013, 47.978481],
              [89.241628, 47.97822],
              [89.241365, 47.978065],
              [89.241029, 47.977956],
              [89.240378, 47.977755],
              [89.239577, 47.977561],
              [89.239528515000018, 47.97754949199998],
              [89.238372, 47.977275],
              [89.238068576999979, 47.977164663999986],
              [89.237415, 47.976927],
              [89.237017, 47.976691],
              [89.236408, 47.976343],
              [89.235712, 47.976082],
              [89.235004, 47.975833],
              [89.234357, 47.975634],
              [89.233736, 47.97556],
              [89.233177, 47.97551],
              [89.232854, 47.975523],
              [89.232543, 47.975659],
              [89.231909, 47.975895],
              [89.230819511999982, 47.976282352999988],
              [89.230753, 47.976306],
              [89.230032, 47.976579],
              [89.229493, 47.97669],
              [89.228926, 47.976803],
              [89.228268, 47.97689],
              [89.226789, 47.977026],
              [89.225943, 47.977064],
              [89.224875, 47.977188],
              [89.223706, 47.977287],
              [89.223371, 47.977287],
              [89.22311, 47.977163],
              [89.222847097999988, 47.976984533],
              [89.222836, 47.976977],
              [89.222352, 47.976865],
              [89.221681, 47.976753],
              [89.220724, 47.976678],
              [89.219729, 47.976616],
              [89.218735, 47.976616],
              [89.218114, 47.976678],
              [89.217517, 47.976765],
              [89.21677982, 47.976938608000012],
              [89.216672, 47.976964],
              [89.216287, 47.977014],
              [89.215802, 47.977064],
              [89.215255, 47.977064],
              [89.21487, 47.976977],
              [89.214853769, 47.976971844],
              [89.21436, 47.976815],
              [89.213801, 47.976778],
              [89.213068, 47.97679],
              [89.212496, 47.97679],
              [89.211949, 47.976852],
              [89.211663, 47.976815],
              [89.211278, 47.976691],
              [89.210806, 47.976616],
              [89.210097, 47.976703],
              [89.209053, 47.976753],
              [89.208196, 47.976828],
              [89.207612, 47.97679],
              [89.207065, 47.976865],
              [89.206232, 47.977039],
              [89.205735, 47.977138],
              [89.205553209000016, 47.977217122000013],
              [89.204878, 47.977511],
              [89.20407, 47.977909],
              [89.203287, 47.978257],
              [89.202653, 47.978443],
              [89.201907, 47.978592],
              [89.2013614, 47.978629835999982],
              [89.201186, 47.978642],
              [89.200313919999985, 47.978860618],
              [89.200093, 47.978916],
              [89.199459, 47.979027],
              [89.198924, 47.979077],
              [89.198365, 47.979139],
              [89.197806, 47.979288],
              [89.197172, 47.97935],
              [89.196476, 47.979524],
              [89.195345, 47.979624],
              [89.194251, 47.979798],
              [89.193655, 47.97981],
              [89.192996, 47.979959],
              [89.192176, 47.980171],
              [89.191194, 47.980581],
              [89.190722, 47.980718],
              [89.190162, 47.980805],
              [89.189541, 47.980817],
              [89.18882, 47.981028],
              [89.187913, 47.981476],
              [89.186931, 47.981923],
              [89.18621, 47.982371],
              [89.185576, 47.982942],
              [89.184831, 47.983589],
              [89.184334, 47.984235],
              [89.183986, 47.984844],
              [89.18371, 47.985324],
              [89.183551, 47.985602],
              [89.183302, 47.985826],
              [89.182619, 47.98641],
              [89.181923, 47.986807],
              [89.181906, 47.986813],
              [89.180765, 47.987203],
              [89.180058, 47.987466],
              [89.179623, 47.987727],
              [89.178865, 47.988349],
              [89.177983, 47.988895],
              [89.177448, 47.98933],
              [89.177138, 47.989741],
              [89.176914, 47.989964],
              [89.176554, 47.990026],
              [89.175684, 47.98989],
              [89.175389318999976, 47.989839250999978],
              [89.174453, 47.989678],
              [89.173148, 47.989529],
              [89.171881, 47.989554],
              [89.170414, 47.989964],
              [89.168836, 47.990499],
              [89.167916, 47.990997],
              [89.167471594, 47.991363853],
              [89.167406, 47.991418],
              [89.167042, 47.991906],
              [89.166913, 47.992128],
              [89.166856, 47.992263],
              [89.16683, 47.992382],
              [89.166665, 47.992563],
              [89.166512, 47.992677],
              [89.166348, 47.99272],
              [89.16614, 47.992711],
              [89.165829, 47.992625],
              [89.165215, 47.992487],
              [89.164471, 47.992409],
              [89.163789128000019, 47.992319098],
              [89.163485, 47.992279],
              [89.162819, 47.99221],
              [89.161911, 47.992201],
              [89.161401, 47.992244],
              [89.160959, 47.992365],
              [89.160743, 47.99253],
              [89.160415, 47.992711],
              [89.160284016, 47.992799785999978],
              [89.159878, 47.993075],
              [89.159333, 47.993438],
              [89.158806, 47.993723],
              [89.157984, 47.994121],
              [89.157457, 47.994372],
              [89.156964, 47.994458],
              [89.156462, 47.994467],
              [89.155880118000027, 47.994378547999986],
              [89.155666, 47.994346],
              [89.155044, 47.994199],
              [89.15404, 47.994043],
              [89.153331, 47.993879],
              [89.152726, 47.993715],
              [89.151947, 47.993559],
              [89.151022, 47.993395],
              [89.150062, 47.993317],
              [89.149084, 47.993239],
              [89.148289, 47.992988],
              [89.14713, 47.992487],
              [89.146256, 47.992097],
              [89.14559, 47.991648],
              [89.144794, 47.991085],
              [89.144172, 47.990636],
              [89.143653, 47.99035],
              [89.14316, 47.990177],
              [89.14239, 47.990048],
              [89.141387, 47.989702],
              [89.140972, 47.989563],
              [89.140617, 47.989555],
              [89.140288, 47.989658],
              [89.139951, 47.989814],
              [89.13932, 47.989978],
              [89.139067855, 47.990004732999978],
              [89.138905, 47.990022],
              [89.138489, 47.989987],
              [89.138440652999975, 47.98997046],
              [89.138109, 47.989857],
              [89.13733, 47.989503],
              [89.136422, 47.98909],
              [89.136379, 47.98907],
              [89.135921, 47.988854],
              [89.135488, 47.988491],
              [89.13503, 47.987954],
              [89.134632, 47.987496],
              [89.134476, 47.987384],
              [89.134122, 47.987314],
              [89.133213, 47.987064],
              [89.132331, 47.986623],
              [89.13183, 47.986285],
              [89.130783, 47.985948],
              [89.129486, 47.985515],
              [89.128777, 47.985351],
              [89.128422, 47.985317],
              [89.128024, 47.98542],
              [89.127514, 47.985481],
              [89.126787, 47.985585],
              [89.125801, 47.985766],
              [89.124746, 47.985896],
              [89.123431, 47.986034],
              [89.122048, 47.985922],
              [89.12088, 47.985654],
              [89.119756, 47.985576],
              [89.118735, 47.985438],
              [89.117602, 47.985265],
              [89.115526, 47.984875],
              [89.114411, 47.984651],
              [89.113952, 47.984625],
              [89.112984, 47.984737],
              [89.111842, 47.984798],
              [89.110579, 47.98504],
              [89.109239, 47.985317],
              [89.108573, 47.98542],
              [89.107621, 47.985498],
              [89.106981, 47.985403],
              [89.106748, 47.985273],
              [89.10641, 47.985282],
              [89.106159, 47.985377],
              [89.105839, 47.985446],
              [89.104853, 47.985654],
              [89.104058, 47.985818],
              [89.102968, 47.986147],
              [89.102025, 47.986432],
              [89.100555, 47.986692],
              [89.099353, 47.986778],
              [89.097952, 47.986899],
              [89.097087, 47.98683],
              [89.096118, 47.986623],
              [89.095564, 47.986519],
              [89.095184, 47.986519],
              [89.094864, 47.986648],
              [89.094284, 47.986778],
              [89.093515, 47.986752],
              [89.092996, 47.986683],
              [89.092269, 47.986467],
              [89.091032, 47.986311],
              [89.090228, 47.986346],
              [89.089441, 47.986605],
              [89.088654, 47.986752],
              [89.08778, 47.986847],
              [89.086959, 47.986873],
              [89.085782, 47.986787],
              [89.084745, 47.986847],
              [89.083741, 47.98709],
              [89.082911, 47.987323],
              [89.08247, 47.987358],
              [89.081743, 47.987332],
              [89.080273, 47.987349],
              [89.078803, 47.987263],
              [89.077575, 47.987288],
              [89.077047, 47.987418],
              [89.076312, 47.987738],
              [89.075585, 47.988093],
              [89.075511684, 47.988127809],
              [89.074911, 47.988413],
              [89.074383, 47.988551],
              [89.074011, 47.988534],
              [89.073492, 47.988387],
              [89.072965098, 47.988238514999978],
              [89.072541, 47.988119],
              [89.071097, 47.987894],
              [89.069816, 47.987617],
              [89.068796, 47.987401],
              [89.067568, 47.987288],
              [89.066158, 47.987202],
              [89.064575, 47.987237],
              [89.063533, 47.987248],
              [89.062765, 47.987439],
              [89.062382, 47.987586],
              [89.06219, 47.987659],
              [89.061851, 47.987988],
              [89.061495, 47.988417],
              [89.061358, 47.988518],
              [89.061047, 47.988628],
              [89.060846, 47.988646],
              [89.060243, 47.988774],
              [89.059767, 47.988884],
              [89.059557, 47.989002],
              [89.05953, 47.989121],
              [89.059472, 47.989361],
              [89.059886, 47.989843],
              [89.059903851, 47.989867835999974],
              [89.059978, 47.989971],
              [89.059758, 47.990154],
              [89.05935617, 47.990080823000028],
              [89.058506, 47.989926],
              [89.057958, 47.990017],
              [89.05846, 47.99041],
              [89.058616825, 47.990453340999977],
              [89.059484, 47.990693],
              [89.059658, 47.990949],
              [89.059703, 47.991187],
              [89.05963, 47.991507],
              [89.059411, 47.991909],
              [89.059274, 47.992174],
              [89.058991, 47.99264],
              [89.058826, 47.992933],
              [89.058616, 47.993801],
              [89.058534, 47.994285],
              [89.058351, 47.994688],
              [89.058172, 47.995138],
              [89.058141, 47.995218],
              [89.057738, 47.99626],
              [89.057428, 47.997018],
              [89.057117, 47.997841],
              [89.056843, 47.998225],
              [89.056532, 47.998682],
              [89.056175, 47.999285],
              [89.055792, 47.999696],
              [89.055261, 48.000016],
              [89.054576, 48.000354],
              [89.054128, 48.000747],
              [89.053909, 48.001104],
              [89.053799, 48.00146],
              [89.0539, 48.001707],
              [89.053918, 48.00199],
              [89.053927, 48.002255],
              [89.05379, 48.002557],
              [89.053616, 48.002822],
              [89.053379, 48.003243],
              [89.053095, 48.003754],
              [89.052656, 48.004157],
              [89.052291, 48.004403],
              [89.051998, 48.004705],
              [89.051806, 48.004897],
              [89.051523, 48.005171],
              [89.051331, 48.005409],
              [89.051244, 48.004793],
              [89.050571, 48.005303],
              [89.050444, 48.005778],
              [89.050771, 48.00574],
              [89.051026, 48.005776],
              [89.051444, 48.006028],
              [89.051372, 48.006177],
              [89.051044, 48.006359],
              [89.050611, 48.006361],
              [89.050334, 48.00625],
              [89.049651, 48.006323],
              [89.048312, 48.006805],
              [89.046919, 48.007361],
              [89.046364, 48.007525],
              [89.044315, 48.008317],
              [89.043413, 48.008672],
              [89.042683, 48.009037],
              [89.04172, 48.009519],
              [89.041, 48.01002],
              [89.040381, 48.010712],
              [89.03998, 48.011395],
              [89.039534, 48.012005],
              [89.03937, 48.01229],
              [89.039124, 48.012715],
              [89.038715, 48.013435],
              [89.038223, 48.013972],
              [89.037777, 48.014327],
              [89.037349, 48.014819],
              [89.037158, 48.015301],
              [89.036975, 48.015802],
              [89.036972, 48.016139],
              [89.036866, 48.01684],
              [89.036711, 48.017396],
              [89.03662, 48.017714],
              [89.03642, 48.017915],
              [89.036092, 48.018179],
              [89.035691, 48.018525],
              [89.0354, 48.019062],
              [89.035245, 48.019827],
              [89.0352, 48.020319],
              [89.035245, 48.020829],
              [89.035382, 48.021348],
              [89.0355, 48.021976],
              [89.035528, 48.022386],
              [89.035528, 48.022641],
              [89.0355, 48.022859],
              [89.035355, 48.023041],
              [89.035054, 48.023269],
              [89.034626, 48.023633],
              [89.034335, 48.023915],
              [89.033925, 48.024471],
              [89.033552, 48.024835],
              [89.032914, 48.025509],
              [89.032705, 48.025773],
              [89.032614, 48.026019],
              [89.032486, 48.026329],
              [89.032322, 48.026629],
              [89.031967, 48.02703],
              [89.03133, 48.027576],
              [89.030756, 48.02805],
              [89.030219, 48.028423],
              [89.030119, 48.028559],
              [89.0301, 48.028714],
              [89.029982, 48.028878],
              [89.02959, 48.029179],
              [89.02898, 48.029561],
              [89.027842, 48.030253],
              [89.027168, 48.030608],
              [89.026859, 48.030681],
              [89.025903, 48.0308],
              [89.025393, 48.030845],
              [89.024773, 48.031],
              [89.024245, 48.031264],
              [89.023289, 48.031829],
              [89.022697, 48.032175],
              [89.021941, 48.032657],
              [89.020794, 48.033449],
              [89.020093, 48.034005],
              [89.019273, 48.034697],
              [89.018791, 48.035207],
              [89.018299, 48.035808],
              [89.01778, 48.0364],
              [89.017252, 48.036828],
              [89.016587, 48.037338],
              [89.01595, 48.037684],
              [89.015467, 48.037848],
              [89.014985, 48.038002],
              [89.013992, 48.038367],
              [89.013227, 48.03854],
              [89.012975, 48.038613],
              [89.012854, 48.038649],
              [89.01269, 48.038722],
              [89.012599, 48.038813],
              [89.012599, 48.038992],
              [89.012599, 48.039059],
              [89.012581, 48.039414],
              [89.012471, 48.039687],
              [89.012316, 48.040033],
              [89.011998, 48.04047],
              [89.011524, 48.041098],
              [89.010996, 48.041599],
              [89.010696, 48.041854],
              [89.010086, 48.042209],
              [89.009211, 48.042747],
              [89.008601, 48.043102],
              [89.00831, 48.043402],
              [89.008128, 48.043666],
              [89.008037, 48.043857],
              [89.007991, 48.044076],
              [89.008009, 48.044304],
              [89.008037, 48.044559],
              [89.008228, 48.045059],
              [89.008592, 48.045952],
              [89.008893, 48.04679],
              [89.009139, 48.047482],
              [89.009211, 48.048092],
              [89.009321, 48.048884],
              [89.009302, 48.049494],
              [89.009202, 48.049785],
              [89.009084, 48.05004],
              [89.008865, 48.050232],
              [89.008492, 48.05035],
              [89.0081, 48.050377],
              [89.007691, 48.050414],
              [89.007299, 48.050478],
              [89.007008, 48.050614],
              [89.006917, 48.050723],
              [89.006826, 48.050896],
              [89.006662, 48.051252],
              [89.006379, 48.05188],
              [89.006124, 48.052335],
              [89.005806, 48.052736],
              [89.005505, 48.053082],
              [89.005278, 48.053309],
              [89.00474, 48.053801],
              [89.004048, 48.054338],
              [89.003611, 48.054621],
              [89.002983, 48.05504],
              [89.002182, 48.055595],
              [89.001626, 48.055923],
              [89.00118, 48.056151],
              [89.000306, 48.056497],
              [88.999768, 48.056724],
              [88.999459, 48.057107],
              [88.999286, 48.057507],
              [88.999195, 48.057935],
              [88.999013, 48.058245],
              [88.998794, 48.058372],
              [88.998448, 48.058372],
              [88.996882, 48.058646],
              [88.995953, 48.058846],
              [88.995106, 48.05911],
              [88.994214, 48.059438],
              [88.993595909000021, 48.059592149000025],
              [88.992975, 48.059747],
              [88.991591, 48.060184],
              [88.990963, 48.060386],
              [88.990544, 48.060521],
              [88.989515, 48.060922],
              [88.988778, 48.061186],
              [88.988204, 48.061532],
              [88.987885, 48.061769],
              [88.987803, 48.061896],
              [88.987785, 48.062188],
              [88.987794, 48.062716],
              [88.987797, 48.062744],
              [88.987885, 48.063608],
              [88.987922, 48.064237],
              [88.987949, 48.065002],
              [88.988031, 48.065757],
              [88.988155579000022, 48.066120603],
              [88.98824, 48.066367],
              [88.98824, 48.066686],
              [88.988113, 48.066932],
              [88.98773, 48.067442],
              [88.987330008000015, 48.067851170999973],
              [88.986902, 48.068289],
              [88.986498305999987, 48.068724342],
              [88.986328, 48.068908],
              [88.986055, 48.068963],
              [88.985888094000018, 48.068947563999984],
              [88.985363, 48.068899],
              [88.984234, 48.068799],
              [88.98285, 48.068726],
              [88.981119, 48.068717],
              [88.979803, 48.068695],
              [88.979471, 48.068689],
              [88.978524, 48.068708],
              [88.977459, 48.068935],
              [88.976621, 48.069117],
              [88.975565, 48.069454],
              [88.974554, 48.069718],
              [88.973807, 48.069964],
              [88.973290307000013, 48.070178216999977],
              [88.972642, 48.070447],
              [88.971831, 48.070911],
              [88.971080085999972, 48.07140427500002],
              [88.971012, 48.071449],
              [88.970465, 48.071877],
              [88.970047, 48.07225],
              [88.969673, 48.072742],
              [88.9693, 48.073406],
              [88.969025854, 48.073992739],
              [88.968972, 48.074108],
              [88.968808, 48.074745],
              [88.968571, 48.075674],
              [88.968417, 48.076329],
              [88.968326, 48.076502],
              [88.968171, 48.076684],
              [88.967752, 48.076939],
              [88.967379, 48.077213],
              [88.96665, 48.077659],
              [88.96543, 48.078515],
              [88.964632607999988, 48.079099698],
              [88.964474, 48.079216],
              [88.963863317, 48.079579841999987],
              [88.963618, 48.079726],
              [88.963053, 48.080017],
              [88.962206, 48.080363],
              [88.961314, 48.080655],
              [88.960731, 48.080782],
              [88.960560029000021, 48.080799809999974],
              [88.960203, 48.080837],
              [88.959238, 48.081165],
              [88.958855, 48.081347],
              [88.958646, 48.081547],
              [88.958455, 48.081875],
              [88.958432843000026, 48.081945217999987],
              [88.958254, 48.082512],
              [88.958054, 48.083314],
              [88.957863, 48.083951],
              [88.957681, 48.084543],
              [88.957663, 48.084871],
              [88.957663, 48.085107],
              [88.957663, 48.085177],
              [88.957663, 48.085262],
              [88.957639, 48.085361],
              [88.957424, 48.085354],
              [88.957389, 48.085353],
              [88.957298, 48.085353],
              [88.956898, 48.085463],
              [88.955841, 48.086064],
              [88.954849, 48.086628],
              [88.954348, 48.087056],
              [88.953893, 48.087439],
              [88.953465, 48.087921],
              [88.953237, 48.088377],
              [88.953189, 48.088507],
              [88.9531, 48.08875],
              [88.952946, 48.089296],
              [88.952873, 48.089779],
              [88.952773, 48.09017],
              [88.952545, 48.090617],
              [88.952299, 48.091108],
              [88.951989, 48.091627],
              [88.951807, 48.091819],
              [88.951616, 48.092046],
              [88.951443, 48.092156],
              [88.95128, 48.092253],
              [88.950562, 48.092766],
              [88.950408, 48.09291],
              [88.950203, 48.093131],
              [88.950115, 48.093346],
              [88.949972, 48.093472],
              [88.949623821999978, 48.093348742999979],
              [88.949585, 48.093335],
              [88.949226, 48.093004],
              [88.948972, 48.092921],
              [88.948713, 48.092987],
              [88.948387, 48.093153],
              [88.947852, 48.093363],
              [88.947789754999974, 48.093404017000012],
              [88.947333, 48.093705],
              [88.947095, 48.093832],
              [88.947, 48.094167],
              [88.9465, 48.094028],
              [88.946417, 48.094111],
              [88.945947, 48.093898],
              [88.945588, 48.093735],
              [88.943917, 48.093417],
              [88.943, 48.093195],
              [88.9427, 48.093147],
              [88.942272, 48.093414],
              [88.94163, 48.093931],
              [88.941083, 48.0945],
              [88.940417, 48.095278],
              [88.940278, 48.095278],
              [88.940029, 48.095273],
              [88.939775, 48.09509],
              [88.939593, 48.094997],
              [88.939414, 48.095005],
              [88.939254, 48.095059],
              [88.939086729999985, 48.095104408],
              [88.938893, 48.095157],
              [88.938558, 48.095188],
              [88.938073, 48.095121],
              [88.937752, 48.095099],
              [88.937399, 48.095237],
              [88.937136, 48.095433],
              [88.936851, 48.095661],
              [88.936664, 48.095857],
              [88.936593, 48.096013],
              [88.936561, 48.096236],
              [88.936553, 48.096508],
              [88.936521, 48.096846],
              [88.936454, 48.097025],
              [88.93637, 48.097181],
              [88.93629, 48.097306],
              [88.936151, 48.097471],
              [88.936089, 48.097667],
              [88.93595338, 48.097883121999985],
              [88.935902, 48.097965],
              [88.935859, 48.098014],
              [88.935804, 48.098077],
              [88.935790442999973, 48.098086038000019],
              [88.93563, 48.098193],
              [88.935175, 48.098442],
              [88.935024, 48.098603],
              [88.934957, 48.098661],
              [88.934957, 48.098741],
              [88.934957, 48.098852],
              [88.935064, 48.09904],
              [88.935189, 48.099258],
              [88.935261, 48.099348],
              [88.935404, 48.099601],
              [88.935602, 48.099623],
              [88.935863206000022, 48.099769276000018],
              [88.936052, 48.099875],
              [88.936316, 48.100007],
              [88.936404, 48.100271],
              [88.936404, 48.1006],
              [88.936437, 48.100864],
              [88.936503, 48.101051],
              [88.93669, 48.101402],
              [88.936799, 48.101556],
              [88.93681, 48.101633],
              [88.936788, 48.101677],
              [88.936744, 48.10171],
              [88.936706867, 48.10170377999998],
              [88.936547, 48.101677],
              [88.936426, 48.101666],
              [88.936294, 48.101633],
              [88.936151, 48.101688],
              [88.936162, 48.101776],
              [88.936173, 48.101952],
              [88.936305, 48.102171],
              [88.936508393999986, 48.102355022999973],
              [88.936536, 48.10238],
              [88.936865, 48.1026],
              [88.937151, 48.102798],
              [88.937228, 48.102886],
              [88.937261, 48.103083],
              [88.937283, 48.103237],
              [88.937272, 48.103358],
              [88.937151, 48.103501],
              [88.93703, 48.103611],
              [88.936942, 48.10372],
              [88.936854, 48.103885],
              [88.936876, 48.104072],
              [88.936964, 48.10427],
              [88.937041, 48.104457],
              [88.937085, 48.104632],
              [88.93714, 48.104852],
              [88.937118, 48.105017],
              [88.937052, 48.105127],
              [88.936898, 48.105281],
              [88.936624, 48.105445],
              [88.936327, 48.105676],
              [88.935953, 48.106006],
              [88.935767, 48.106225],
              [88.935701, 48.106401],
              [88.935712, 48.106599],
              [88.935866, 48.106939],
              [88.935932, 48.107192],
              [88.935921, 48.107379],
              [88.935866, 48.107566],
              [88.935789, 48.107719],
              [88.935701, 48.107763],
              [88.935536, 48.10795],
              [88.935338, 48.108049],
              [88.935141, 48.108203],
              [88.934954, 48.108324],
              [88.934789, 48.108434],
              [88.934657, 48.108565],
              [88.934667, 48.108945],
              [88.934333, 48.108778],
              [88.933646, 48.10828],
              [88.933436772999983, 48.108185057000014],
              [88.930087, 48.106665],
              [88.927186, 48.105324],
              [88.926417, 48.104962],
              [88.92556, 48.104533],
              [88.924868, 48.104215],
              [88.924305, 48.104195],
              [88.923671, 48.104061],
              [88.92266, 48.104116],
              [88.922199, 48.104204],
              [88.921627, 48.104435],
              [88.920639, 48.104852],
              [88.91965, 48.105357],
              [88.91854, 48.105863],
              [88.917584, 48.106357],
              [88.916662, 48.106885],
              [88.915684, 48.10728],
              [88.914552, 48.107687],
              [88.913278, 48.108115],
              [88.911905, 48.108609],
              [88.91152, 48.108774],
              [88.911249, 48.108806],
              [88.910626, 48.108806],
              [88.909917, 48.108861],
              [88.909681, 48.10876],
              [88.907674, 48.108645],
              [88.905875, 48.108553],
              [88.905253, 48.108437],
              [88.904791, 48.108322],
              [88.903569, 48.108137],
              [88.902669, 48.108184],
              [88.901931, 48.108322],
              [88.90117, 48.108506],
              [88.900594, 48.108806],
              [88.900294, 48.108945],
              [88.900132, 48.109037],
              [88.899791, 48.108967],
              [88.899411, 48.108957],
              [88.898788, 48.108893],
              [88.898102, 48.108703],
              [88.896666, 48.108281],
              [88.895356, 48.10789],
              [88.894625, 48.107726],
              [88.894416, 48.107679],
              [88.893698, 48.10752],
              [88.891977, 48.10733],
              [88.889981, 48.107013],
              [88.888207, 48.106781],
              [88.886919, 48.106591],
              [88.885504, 48.106401],
              [88.883856, 48.106137],
              [88.883107, 48.106074],
              [88.8828, 48.106084],
              [88.882019, 48.106243],
              [88.881143, 48.106327],
              [88.880002, 48.106485],
              [88.879337, 48.106559],
              [88.878017, 48.106728],
              [88.877278, 48.106855],
              [88.876359, 48.107077],
              [88.87543, 48.107267],
              [88.874838, 48.107362],
              [88.874426, 48.10739],
              [88.874226, 48.107404],
              [88.873518, 48.107531],
              [88.872473, 48.107689],
              [88.871396, 48.107732],
              [88.870329, 48.107763],
              [88.869178, 48.107742],
              [88.86827, 48.107594],
              [88.867193, 48.107415],
              [88.866074, 48.107235],
              [88.865641, 48.107114],
              [88.864796, 48.106876],
              [88.863444, 48.106559],
              [88.862663, 48.106348],
              [88.86167, 48.106095],
              [88.861174, 48.106],
              [88.860973, 48.105968],
              [88.86072, 48.105799],
              [88.86034, 48.105767],
              [88.859854, 48.105799],
              [88.859136, 48.105862],
              [88.858544, 48.105968],
              [88.858038, 48.106074],
              [88.857605, 48.106179],
              [88.857235, 48.106274],
              [88.856506, 48.106602],
              [88.856126, 48.106776],
              [88.855978, 48.106845],
              [88.855588, 48.107109],
              [88.855324, 48.107362],
              [88.855261682999981, 48.107418931999973],
              [88.855081, 48.107584],
              [88.854785, 48.107795],
              [88.854521, 48.107932],
              [88.854099, 48.108133],
              [88.853074, 48.108587],
              [88.851607, 48.109199],
              [88.850308, 48.109685],
              [88.849489748, 48.10987135],
              [88.849241, 48.109928],
              [88.848185, 48.110118],
              [88.846981, 48.110308],
              [88.84639, 48.110382],
              [88.84526, 48.110583],
              [88.844584, 48.110657],
              [88.84375, 48.110762],
              [88.843127, 48.110731],
              [88.842683, 48.110614],
              [88.842124, 48.110445],
              [88.841068, 48.109886],
              [88.84017, 48.109411],
              [88.839336, 48.108851],
              [88.838628, 48.108397],
              [88.838174, 48.108143],
              [88.837731, 48.107985],
              [88.837224, 48.107753],
              [88.836728, 48.107489],
              [88.836242, 48.107045],
              [88.83599, 48.106707],
              [88.835809, 48.106464],
              [88.835482, 48.105799],
              [88.835165, 48.105113],
              [88.835028, 48.104564],
              [88.834932, 48.103993],
              [88.834774, 48.10355],
              [88.834721, 48.103434],
              [88.834668, 48.10337],
              [88.834415, 48.103318],
              [88.834088, 48.103265],
              [88.833095, 48.103127],
              [88.832102, 48.102927],
              [88.831268, 48.102589],
              [88.830592, 48.10223],
              [88.830033, 48.101734],
              [88.829484, 48.101332],
              [88.828861, 48.100751],
              [88.828428, 48.100361],
              [88.827995, 48.100086],
              [88.827636, 48.099959],
              [88.827245, 48.099843],
              [88.826337, 48.099695],
              [88.825619, 48.099653],
              [88.825207, 48.099569],
              [88.823971, 48.099558],
              [88.822905, 48.099516],
              [88.822377, 48.099569],
              [88.822081, 48.0996],
              [88.821553, 48.099928],
              [88.821152, 48.100266],
              [88.820754104, 48.10055868500001],
              [88.820233, 48.100942],
              [88.819568, 48.10147],
              [88.818765, 48.102166],
              [88.818132, 48.102652],
              [88.817498, 48.103096],
              [88.817012, 48.103529],
              [88.816453, 48.10412],
              [88.816125, 48.104574],
              [88.815946, 48.104954],
              [88.815735, 48.105598],
              [88.815692, 48.105979],
              [88.815629, 48.106306],
              [88.815618, 48.106412],
              [88.815576, 48.106443],
              [88.815397, 48.106475],
              [88.815207, 48.106475],
              [88.81469697, 48.106372833000023],
              [88.814573, 48.106348],
              [88.813771, 48.106211],
              [88.812672, 48.106],
              [88.811088, 48.10582],
              [88.810328, 48.105725],
              [88.809325, 48.105746],
              [88.808617, 48.105789],
              [88.807836, 48.105968],
              [88.807012, 48.106137],
              [88.806199, 48.106485],
              [88.805608, 48.106855],
              [88.805016, 48.107362],
              [88.804827524000018, 48.107610109],
              [88.804583, 48.107932],
              [88.80433, 48.108428],
              [88.80415, 48.108798],
              [88.80396, 48.109178],
              [88.803791, 48.109717],
              [88.803612, 48.110234],
              [88.803485, 48.1109],
              [88.80338, 48.11129],
              [88.803232, 48.111977],
              [88.8032, 48.112642],
              [88.8032, 48.113001],
              [88.803253, 48.113381],
              [88.803369, 48.113972],
              [88.803485, 48.114627],
              [88.803554, 48.115096],
              [88.80358, 48.115271],
              [88.803739, 48.116158],
              [88.803813, 48.116623],
              [88.803813, 48.11675],
              [88.803813, 48.116845],
              [88.803791, 48.116898],
              [88.803707, 48.116961],
              [88.803559, 48.116993],
              [88.80319, 48.117109],
              [88.802429, 48.117352],
              [88.802289987, 48.117389564],
              [88.801415, 48.117626],
              [88.800349, 48.118144],
              [88.79943, 48.118566],
              [88.798543, 48.119041],
              [88.798005, 48.1194],
              [88.797698, 48.119749],
              [88.797424, 48.120213],
              [88.797202, 48.120657],
              [88.797120194, 48.120807598],
              [88.796938, 48.121143],
              [88.796716, 48.121354],
              [88.796546737000028, 48.121523262999972],
              [88.796484, 48.121586],
              [88.795872, 48.121829],
              [88.795185, 48.122082],
              [88.794763, 48.122177],
              [88.794456, 48.122177],
              [88.793907, 48.122209],
              [88.793147, 48.122262],
              [88.792461, 48.122325],
              [88.791922, 48.122526],
              [88.791267, 48.122896],
              [88.790708, 48.123265],
              [88.790254, 48.123698],
              [88.789863, 48.124173],
              [88.789641, 48.124406],
              [88.789525, 48.124617],
              [88.789483, 48.124775],
              [88.789097, 48.124963],
              [88.788696, 48.125019],
              [88.787884, 48.125052],
              [88.787039, 48.125252],
              [88.786283, 48.125564],
              [88.785338911999986, 48.126013848000014],
              [88.785326, 48.12602],
              [88.785102123, 48.126163517],
              [88.784337, 48.126654],
              [88.784124999000028, 48.126815771999986],
              [88.783725, 48.127121],
              [88.783403908000025, 48.127384995],
              [88.782724, 48.127944],
              [88.78266791599998, 48.12802389],
              [88.782201, 48.128689],
              [88.781311, 48.129557],
              [88.780644, 48.13009],
              [88.78001, 48.130724],
              [88.779432, 48.131214],
              [88.779031, 48.131614],
              [88.778776, 48.131759],
              [88.778364, 48.13177],
              [88.777941, 48.13177],
              [88.777443131999974, 48.131554145999985],
              [88.777196, 48.131447],
              [88.776184, 48.131047],
              [88.774749, 48.130402],
              [88.773615, 48.130002],
              [88.772425, 48.129746],
              [88.77199, 48.129641],
              [88.77178, 48.12959],
              [88.770779, 48.129445],
              [88.769989, 48.129334],
              [88.769066, 48.129312],
              [88.768221, 48.129356],
              [88.767442, 48.12939],
              [88.766208, 48.129546],
              [88.765307, 48.129646],
              [88.764873, 48.129657],
              [88.764428, 48.12969],
              [88.764095, 48.129779],
              [88.763627, 48.130102],
              [88.763296993999973, 48.130373320999979],
              [88.763194, 48.130458],
              [88.762816, 48.130825],
              [88.762337, 48.131403],
              [88.761959, 48.131759],
              [88.761803, 48.131826],
              [88.76157, 48.131826],
              [88.761225, 48.131826],
              [88.760691, 48.131848],
              [88.759813, 48.131914],
              [88.759602954, 48.131922863999989],
              [88.759268, 48.131937],
              [88.758778, 48.132048],
              [88.758211, 48.13217],
              [88.757717932999981, 48.132291383],
              [88.757632657999977, 48.132312376000016],
              [88.757622, 48.132315],
              [88.756754, 48.132537],
              [88.75632, 48.132693],
              [88.75572, 48.132993],
              [88.755286, 48.133416],
              [88.754986, 48.133839],
              [88.754619, 48.134428],
              [88.754514497, 48.134693415000015],
              [88.75433, 48.135162],
              [88.753985, 48.135852],
              [88.753874, 48.136297],
              [88.753907, 48.136552],
              [88.754085, 48.136886],
              [88.754196, 48.137298],
              [88.754463, 48.137787],
              [88.75473, 48.138143],
              [88.754886, 48.138376],
              [88.754919, 48.13851],
              [88.754919, 48.138632],
              [88.754908, 48.138721],
              [88.754797, 48.138843],
              [88.754563, 48.139021],
              [88.754438, 48.139187],
              [88.754152, 48.139566],
              [88.753251, 48.140679],
              [88.752439, 48.141557],
              [88.751872, 48.14238],
              [88.75146, 48.14277],
              [88.751304, 48.142892],
              [88.751015, 48.142959],
              [88.750759, 48.142959],
              [88.750537, 48.143092],
              [88.750348, 48.143237],
              [88.750192, 48.143426],
              [88.750003, 48.143559],
              [88.749925, 48.143815],
              [88.749758, 48.143937],
              [88.749044, 48.143941],
              [88.748853611000015, 48.143999608],
              [88.748495, 48.14411],
              [88.748063, 48.144257],
              [88.747673, 48.144471],
              [88.747234, 48.144761],
              [88.746902, 48.1451],
              [88.746516, 48.145521],
              [88.746224, 48.145887],
              [88.746034, 48.146117],
              [88.746002106999981, 48.146160743999985],
              [88.745851, 48.146368],
              [88.745722, 48.146556],
              [88.745661, 48.146687],
              [88.745621, 48.146938],
              [88.745566, 48.147175],
              [88.745566, 48.14746],
              [88.745566, 48.147812],
              [88.745539, 48.148145],
              [88.745505, 48.14845],
              [88.745397, 48.148694],
              [88.745078, 48.149236],
              [88.744671, 48.149718],
              [88.744251, 48.150124],
              [88.744054, 48.150185],
              [88.743654, 48.150158],
              [88.743058, 48.150104],
              [88.742132196999989, 48.149945151999987],
              [88.742108, 48.149941],
              [88.741227, 48.149907],
              [88.740447, 48.149914],
              [88.740386928000021, 48.14992185],
              [88.739146, 48.150084],
              [88.738373, 48.150233],
              [88.737762, 48.15049],
              [88.737242611999989, 48.150739273],
              [88.737139, 48.150789],
              [88.736678, 48.151168],
              [88.736386, 48.15148],
              [88.736334624, 48.151554073],
              [88.736094, 48.151901],
              [88.735667, 48.152491],
              [88.735064, 48.15348],
              [88.734725, 48.153975],
              [88.734277, 48.154748],
              [88.733566, 48.155643],
              [88.73286, 48.156437],
              [88.732454, 48.156891],
              [88.731572, 48.15744],
              [88.730752, 48.157874],
              [88.730169, 48.158023],
              [88.729626, 48.15801],
              [88.729023, 48.157833],
              [88.728433, 48.15761],
              [88.727707, 48.157284],
              [88.727172, 48.157013],
              [88.726853, 48.15683],
              [88.726548, 48.156735],
              [88.725878, 48.156695],
              [88.725863, 48.156694],
              [88.725023, 48.156464],
              [88.724195, 48.156104],
              [88.723728, 48.155732],
              [88.723111, 48.155094],
              [88.722614376000024, 48.154493431999981],
              [88.722595, 48.15447],
              [88.722066, 48.153731],
              [88.721788, 48.153521],
              [88.721531, 48.153392],
              [88.721219, 48.153297],
              [88.720466, 48.153209],
              [88.719002, 48.153297],
              [88.717687, 48.153352],
              [88.715795, 48.153467],
              [88.714778, 48.153474],
              [88.713639, 48.153494],
              [88.713117, 48.153453],
              [88.71294, 48.153474],
              [88.712778, 48.153535],
              [88.712662, 48.153596],
              [88.712473, 48.153697],
              [88.711991, 48.153921],
              [88.711245, 48.154355],
              [88.710133, 48.15504],
              [88.709306, 48.155494],
              [88.70854, 48.155928],
              [88.707604, 48.156565],
              [88.707191, 48.156884],
              [88.706906, 48.157237],
              [88.706669, 48.15765],
              [88.706425, 48.158071],
              [88.70633, 48.15843],
              [88.706235, 48.158776],
              [88.706167, 48.159162],
              [88.706181, 48.159657],
              [88.706221, 48.160132],
              [88.706297842000026, 48.160535042999982],
              [88.706323, 48.160667],
              [88.706432, 48.161189],
              [88.706587, 48.161745],
              [88.706757, 48.162295],
              [88.706994, 48.162918],
              [88.707191, 48.163212],
              [88.707408, 48.163535],
              [88.707957, 48.16403],
              [88.708364, 48.164302],
              [88.708872, 48.164668],
              [88.709327, 48.164986],
              [88.709842, 48.16519],
              [88.710432, 48.165461],
              [88.710906, 48.165637],
              [88.711083, 48.1658],
              [88.711157, 48.166003],
              [88.711212, 48.166146],
              [88.711232, 48.16639],
              [88.711327, 48.16679],
              [88.711503, 48.167203],
              [88.71172, 48.167712],
              [88.711829, 48.168078],
              [88.712045, 48.168695],
              [88.71233, 48.169515],
              [88.712615, 48.170078],
              [88.712805, 48.170519],
              [88.713049, 48.171027],
              [88.713286, 48.17138],
              [88.713574, 48.171872],
              [88.713774, 48.172241],
              [88.714154, 48.172804],
              [88.714357, 48.173102],
              [88.714371, 48.173211],
              [88.714385, 48.173333],
              [88.714385, 48.173448],
              [88.714364, 48.173509],
              [88.714276, 48.17355],
              [88.714086, 48.173584],
              [88.713781, 48.173604],
              [88.713675099, 48.173606604999975],
              [88.712968, 48.173624],
              [88.711808, 48.173685],
              [88.710595, 48.173678],
              [88.70932, 48.173685],
              [88.708459, 48.173773],
              [88.707842, 48.173875],
              [88.707684653, 48.173917913000025],
              [88.707171, 48.174058],
              [88.706506, 48.174228],
              [88.705848, 48.174309],
              [88.704404, 48.174506],
              [88.703726, 48.174587],
              [88.703383846, 48.174662333000015],
              [88.702804, 48.17479],
              [88.702475325000023, 48.174892775999979],
              [88.702174, 48.174987],
              [88.701889, 48.175068],
              [88.701611, 48.175258],
              [88.701414, 48.175407],
              [88.701116, 48.175624],
              [88.700716, 48.175868],
              [88.700316, 48.176065],
              [88.699977, 48.176207],
              [88.699773, 48.176241],
              [88.699068, 48.176248],
              [88.698817, 48.176275],
              [88.698614, 48.17635],
              [88.698241, 48.176587],
              [88.697875, 48.176777],
              [88.697461, 48.176899],
              [88.69715, 48.177001],
              [88.696838, 48.177177],
              [88.696322, 48.177482],
              [88.695902, 48.177658],
              [88.695312, 48.177902],
              [88.694634, 48.178119],
              [88.69418, 48.178302],
              [88.693915, 48.178363],
              [88.693448, 48.178336],
              [88.693390240999975, 48.178322208],
              [88.692824, 48.178187],
              [88.69222, 48.178079],
              [88.69142, 48.177936],
              [88.690932, 48.177821],
              [88.690214, 48.177611],
              [88.689691, 48.177428],
              [88.689074, 48.177224],
              [88.688566, 48.176967],
              [88.688064, 48.17658],
              [88.687698, 48.176228],
              [88.687312, 48.175706],
              [88.686756, 48.175014],
              [88.686362, 48.174546],
              [88.685989, 48.174201],
              [88.685515, 48.173848],
              [88.68504, 48.173543],
              [88.684606, 48.173177],
              [88.684179, 48.172892],
              [88.683542, 48.172472],
              [88.683067, 48.172289],
              [88.682627, 48.17216],
              [88.682152, 48.172085],
              [88.681515, 48.171929],
              [88.681223, 48.171882],
              [88.680498, 48.171963],
              [88.68005, 48.17197],
              [88.679698, 48.171868],
              [88.67946, 48.171766],
              [88.679128, 48.171712],
              [88.678592, 48.171712],
              [88.67824, 48.171658],
              [88.677897, 48.171531],
              [88.677562, 48.171407],
              [88.676572, 48.171055],
              [88.675555, 48.1706],
              [88.674823, 48.170119],
              [88.674084, 48.169583],
              [88.673589, 48.169095],
              [88.673209, 48.168871],
              [88.67247, 48.1686],
              [88.671677, 48.168295],
              [88.671168, 48.167997],
              [88.670741, 48.167651],
              [88.670544, 48.167509],
              [88.670327, 48.167448],
              [88.669731, 48.167427],
              [88.668809, 48.167298],
              [88.667792, 48.167231],
              [88.667378, 48.167251],
              [88.667026, 48.167366],
              [88.666800294999973, 48.167475116],
              [88.666422, 48.167658],
              [88.665907, 48.167841],
              [88.665527, 48.167902],
              [88.665134, 48.167929],
              [88.664815, 48.167956],
              [88.664117, 48.168126],
              [88.663456954000026, 48.168269151],
              [88.663181, 48.168329],
              [88.662117, 48.168566],
              [88.660937, 48.168824],
              [88.660178, 48.169095],
              [88.659554, 48.169346],
              [88.658672, 48.169766],
              [88.657652719, 48.17030573400001],
              [88.657622, 48.170322],
              [88.656903, 48.17077],
              [88.655723, 48.1714],
              [88.654964, 48.171827],
              [88.654645, 48.17197],
              [88.654482, 48.172058],
              [88.654293, 48.172092],
              [88.653899, 48.172133],
              [88.65335, 48.172322],
              [88.652435, 48.172736],
              [88.651764, 48.173014],
              [88.651079, 48.173306],
              [88.65049658800001, 48.173551084],
              [88.649797, 48.173855],
              [88.649384, 48.174051],
              [88.648862, 48.174241],
              [88.648557, 48.174356],
              [88.648224, 48.174601],
              [88.647899, 48.174885],
              [88.647758652, 48.175036224],
              [88.647628, 48.175177],
              [88.647228, 48.175584],
              [88.646895, 48.175882],
              [88.646787, 48.175943],
              [88.646428, 48.175963],
              [88.645817, 48.175902],
              [88.645363, 48.175848],
              [88.645168856999987, 48.175853147999987],
              [88.645099, 48.175855],
              [88.644929, 48.175896],
              [88.64485186600001, 48.175951785],
              [88.644705, 48.176058],
              [88.644156, 48.176255],
              [88.643716, 48.17639],
              [88.643268, 48.176499],
              [88.642871696999975, 48.176551327000027],
              [88.642753, 48.176567],
              [88.642027, 48.176729],
              [88.641424, 48.176838],
              [88.641092, 48.176926],
              [88.640061, 48.177394],
              [88.639613039999972, 48.177535205000027],
              [88.639417, 48.177597],
              [88.638834, 48.177848],
              [88.638610019999987, 48.177946227],
              [88.638061, 48.178187],
              [88.637695, 48.178289],
              [88.637491, 48.178397],
              [88.637356, 48.178486],
              [88.637344770000027, 48.178519391],
              [88.637281, 48.178709],
              [88.637247, 48.179028],
              [88.637227, 48.17934],
              [88.637166, 48.179869],
              [88.637078, 48.180431],
              [88.636868, 48.181062],
              [88.636725, 48.18136],
              [88.63663, 48.181679],
              [88.636413, 48.182032],
              [88.636088, 48.182391],
              [88.635661, 48.182757],
              [88.635227, 48.183137],
              [88.634895, 48.183435],
              [88.634271, 48.183896],
              [88.6336, 48.184323],
              [88.633511594000026, 48.184384024999986],
              [88.632725, 48.184927],
              [88.631959, 48.185428],
              [88.631193, 48.186072],
              [88.630433, 48.186696],
              [88.629796, 48.187205],
              [88.629341936, 48.187617005999982],
              [88.629213, 48.187734],
              [88.628596, 48.188378],
              [88.628074, 48.189029],
              [88.627708, 48.189517],
              [88.627531, 48.189951],
              [88.627457, 48.190276],
              [88.627457, 48.190486],
              [88.627504, 48.190717],
              [88.627721, 48.191164],
              [88.627959, 48.19172],
              [88.628406, 48.1925],
              [88.628737, 48.19303],
              [88.628745, 48.193042],
              [88.62915, 48.193407],
              [88.629362, 48.193714],
              [88.629443, 48.193964],
              [88.629457, 48.194249],
              [88.629376, 48.194527],
              [88.62932, 48.194638],
              [88.629233, 48.194812],
              [88.62903, 48.195076],
              [88.628691, 48.195443],
              [88.628426, 48.195815],
              [88.628135, 48.196385],
              [88.628006, 48.19669],
              [88.627857, 48.19709],
              [88.627809, 48.197504],
              [88.627762, 48.197911],
              [88.627769, 48.19848],
              [88.627803, 48.198772],
              [88.627803, 48.198961],
              [88.627721, 48.199077],
              [88.627498, 48.199239],
              [88.627077, 48.199639],
              [88.626718, 48.199999],
              [88.626399, 48.200324],
              [88.62625, 48.200494],
              [88.626169, 48.200609],
              [88.626135, 48.200833],
              [88.626142, 48.201314],
              [88.626209, 48.201721],
              [88.626291, 48.201924],
              [88.626453, 48.202257],
              [88.626697, 48.202568],
              [88.627138, 48.203274],
              [88.62745, 48.203531],
              [88.627491, 48.203633],
              [88.627491, 48.203707],
              [88.627403, 48.203789],
              [88.627057, 48.203836],
              [88.626779, 48.20385],
              [88.626223, 48.203945],
              [88.625728, 48.20406],
              [88.625002, 48.204257],
              [88.623985, 48.204664],
              [88.623104, 48.205064],
              [88.622528, 48.20547],
              [88.622277, 48.205721],
              [88.622121, 48.205979],
              [88.621945, 48.20625],
              [88.621755, 48.206603],
              [88.621599, 48.206799],
              [88.621355, 48.207023],
              [88.621077, 48.207274],
              [88.620656, 48.207755],
              [88.620433, 48.207979],
              [88.620304, 48.20823],
              [88.620128, 48.208623],
              [88.620019, 48.208989],
              [88.619965, 48.209288],
              [88.619836, 48.209627],
              [88.619782, 48.209837],
              [88.619619, 48.210115],
              [88.619368, 48.210467],
              [88.619178, 48.210644],
              [88.618989, 48.210799],
              [88.618846, 48.210949],
              [88.618772, 48.211132],
              [88.618798, 48.211353],
              [88.618853, 48.211633],
              [88.618778, 48.211796],
              [88.618663, 48.211864],
              [88.618487, 48.211857],
              [88.618311, 48.211864],
              [88.618134, 48.211857],
              [88.617856, 48.211844],
              [88.617578, 48.211823],
              [88.61701295, 48.211770218000026],
              [88.616561, 48.211728],
              [88.616012, 48.211715],
              [88.615212, 48.211694],
              [88.614575, 48.211654],
              [88.614175, 48.211566],
              [88.61389, 48.211545],
              [88.613592, 48.211606],
              [88.613151, 48.211769],
              [88.612744, 48.211939],
              [88.612534, 48.212],
              [88.612160193000022, 48.212181604000023],
              [88.612005, 48.212257],
              [88.6113, 48.212603],
              [88.611056, 48.212725],
              [88.610974, 48.212748],
              [88.610859, 48.212779],
              [88.61071, 48.212786],
              [88.610439, 48.212786],
              [88.609835, 48.212915],
              [88.609293, 48.213044],
              [88.60873, 48.213227],
              [88.608628157, 48.213261194999973],
              [88.608045, 48.213457],
              [88.607721293999987, 48.213629441000023],
              [88.60751, 48.213742],
              [88.606839, 48.214088],
              [88.606452, 48.214291],
              [88.606154, 48.214542],
              [88.605889, 48.2148],
              [88.605706, 48.215023],
              [88.605598, 48.215295],
              [88.605381, 48.21562],
              [88.605205, 48.215817],
              [88.605008, 48.215946],
              [88.604798, 48.21604],
              [88.604249, 48.216244],
              [88.603733, 48.21642],
              [88.603001, 48.216739],
              [88.602215, 48.217139],
              [88.601469, 48.2176],
              [88.600926, 48.217946],
              [88.600594, 48.218095],
              [88.600465, 48.218156],
              [88.600228, 48.218176],
              [88.599964, 48.218176],
              [88.599136, 48.218169],
              [88.59856, 48.218156],
              [88.598052, 48.218156],
              [88.597543, 48.218054],
              [88.597075, 48.21798],
              [88.596017, 48.217864],
              [88.595367, 48.217742],
              [88.594268, 48.2176],
              [88.592465, 48.217295],
              [88.591414, 48.217085],
              [88.590451, 48.216902],
              [88.589726, 48.216657],
              [88.588559, 48.216454],
              [88.587847, 48.216373],
              [88.587176, 48.216393],
              [88.586844, 48.21644],
              [88.58658, 48.216569],
              [88.586376, 48.216766],
              [88.586166, 48.217057],
              [88.585942, 48.217424],
              [88.585813, 48.21781],
              [88.58578, 48.218142],
              [88.585942, 48.218542],
              [88.586213, 48.218997],
              [88.586498, 48.219539],
              [88.586763, 48.220075],
              [88.587034, 48.220719],
              [88.587373, 48.221349],
              [88.587692, 48.221932],
              [88.58778, 48.222149],
              [88.587827, 48.2224],
              [88.587834, 48.222732],
              [88.587854, 48.223166],
              [88.587854, 48.223783],
              [88.587841, 48.224156],
              [88.58778, 48.224604],
              [88.587739, 48.224916],
              [88.587576, 48.225268],
              [88.587481, 48.225444],
              [88.587325, 48.225668],
              [88.587278, 48.225817],
              [88.587264, 48.22598],
              [88.587264, 48.22619],
              [88.587407, 48.226495],
              [88.587576, 48.226841],
              [88.587786, 48.227112],
              [88.588105, 48.227533],
              [88.588208372, 48.227707663999979],
              [88.58825, 48.227778],
              [88.588498, 48.227953],
              [88.588885, 48.228285],
              [88.589671, 48.228807],
              [88.59018, 48.229221],
              [88.590844, 48.229696],
              [88.591075, 48.229858],
              [88.591251, 48.230041],
              [88.591299, 48.230218],
              [88.591299, 48.230414],
              [88.591305, 48.230679],
              [88.591366, 48.231194],
              [88.591495, 48.231818],
              [88.591583, 48.232123],
              [88.591692, 48.23238],
              [88.591888, 48.232726],
              [88.592085, 48.232997],
              [88.592478, 48.233445],
              [88.592763, 48.233804],
              [88.592905, 48.234021],
              [88.593014, 48.234279],
              [88.593055, 48.234489],
              [88.593102, 48.234747],
              [88.593102, 48.235052],
              [88.59315, 48.235628],
              [88.593183, 48.235798],
              [88.593312, 48.235954],
              [88.593685, 48.236225],
              [88.594607, 48.236923],
              [88.594858, 48.237079],
              [88.594885, 48.237127],
              [88.594919, 48.237215],
              [88.594919, 48.237371],
              [88.594912, 48.237547],
              [88.594865, 48.237927],
              [88.594824, 48.238225],
              [88.594797, 48.238964],
              [88.594817, 48.239118],
              [88.594831, 48.239228],
              [88.594784, 48.239364],
              [88.594702, 48.239581],
              [88.594539, 48.239859],
              [88.594458, 48.240083],
              [88.59439, 48.24034],
              [88.594363, 48.240571],
              [88.594363, 48.24072],
              [88.594417, 48.241018],
              [88.594668, 48.241249],
              [88.59498, 48.241608],
              [88.595299, 48.242035],
              [88.595807, 48.242747],
              [88.59597, 48.2431],
              [88.596018, 48.243168],
              [88.596065, 48.243283],
              [88.596085, 48.243425],
              [88.596173, 48.243832],
              [88.596336, 48.244307],
              [88.596431, 48.244653],
              [88.596512, 48.245107],
              [88.596628, 48.245378],
              [88.59679, 48.245636],
              [88.596926, 48.245893],
              [88.596933, 48.24609],
              [88.596851, 48.246354],
              [88.596729, 48.246626],
              [88.596451, 48.246931],
              [88.596079, 48.247148],
              [88.595923, 48.247195],
              [88.595638, 48.247256],
              [88.594682, 48.247378],
              [88.594173, 48.247419],
              [88.593502, 48.247554],
              [88.593116, 48.247649],
              [88.592824, 48.247771],
              [88.592587, 48.247921],
              [88.592356, 48.248158],
              [88.592017, 48.248477],
              [88.591604, 48.248761],
              [88.590722, 48.249222],
              [88.590556, 48.249288],
              [88.590329, 48.249378],
              [88.589997, 48.249588],
              [88.589902, 48.249717],
              [88.589732, 48.249914],
              [88.58917, 48.250653],
              [88.588756, 48.25129],
              [88.588434, 48.251925],
              [88.588197, 48.25257],
              [88.587925, 48.253436],
              [88.587857, 48.253979],
              [88.587755, 48.254522],
              [88.587753, 48.255128],
              [88.587823, 48.255863],
              [88.587861, 48.256034],
              [88.587936, 48.256369],
              [88.588078, 48.256898],
              [88.588298, 48.257424],
              [88.588536, 48.257747],
              [88.588655, 48.257865],
              [88.588655, 48.25795],
              [88.588607, 48.258043],
              [88.588434, 48.258086],
              [88.588146, 48.258086],
              [88.587535, 48.258222],
              [88.586851, 48.25847],
              [88.586774489, 48.258497901999988],
              [88.586415, 48.258629],
              [88.585498, 48.258985],
              [88.584599, 48.25941],
              [88.583546, 48.259868],
              [88.583122, 48.260021],
              [88.582579, 48.260309],
              [88.582426, 48.260428],
              [88.582426, 48.260749203999978],
              [88.582426, 48.260784],
              [88.582426, 48.26126],
              [88.582443, 48.261565],
              [88.582426, 48.261786],
              [88.582308, 48.261905],
              [88.582019, 48.262023],
              [88.58168, 48.262125],
              [88.580984, 48.262651],
              [88.580305, 48.263245],
              [88.579728, 48.263721],
              [88.579524, 48.263907],
              [88.579472, 48.264361],
              [88.5791, 48.264518],
              [88.578777, 48.265027],
              [88.578421, 48.265486],
              [88.578099, 48.265808],
              [88.577522, 48.266113],
              [88.576385, 48.266707],
              [88.575519, 48.267251],
              [88.574965, 48.267603],
              [88.574287, 48.268017],
              [88.573602, 48.2682],
              [88.5726, 48.268591],
              [88.572006, 48.268931],
              [88.571514, 48.269202],
              [88.57108, 48.269454],
              [88.57075, 48.269711],
              [88.570258, 48.270458],
              [88.569817, 48.271103],
              [88.569223, 48.272189],
              [88.568578, 48.273157],
              [88.568001, 48.273971],
              [88.567322, 48.274633],
              [88.566762, 48.275057],
              [88.566371, 48.275295],
              [88.566066, 48.275465],
              [88.565642, 48.275533],
              [88.565541, 48.275563],
              [88.565489, 48.275668],
              [88.565489, 48.275787],
              [88.565625, 48.275855],
              [88.565998, 48.276178],
              [88.56632, 48.276602],
              [88.566694, 48.277028],
              [88.567322, 48.277552],
              [88.567882, 48.278146],
              [88.56834, 48.278808],
              [88.568425, 48.279131],
              [88.568578, 48.279436],
              [88.568968, 48.279809],
              [88.569341, 48.280217],
              [88.569579, 48.280539],
              [88.570037, 48.281014],
              [88.570478, 48.281608],
              [88.570733, 48.28205],
              [88.571106, 48.282847],
              [88.571596, 48.283652],
              [88.572345, 48.284714],
              [88.57333, 48.285817],
              [88.574093, 48.2867],
              [88.575197, 48.287854],
              [88.576028, 48.288465],
              [88.576775, 48.289093],
              [88.577248, 48.28944],
              [88.577674, 48.289941],
              [88.578166, 48.290501],
              [88.578455, 48.291062],
              [88.578537, 48.291504],
              [88.578537, 48.291766],
              [88.578537, 48.291984],
              [88.578542, 48.292309],
              [88.578542, 48.292772],
              [88.578595, 48.293351],
              [88.578722, 48.293639],
              [88.578715, 48.293907],
              [88.5788, 48.294258],
              [88.578889, 48.294534],
              [88.579036, 48.29473],
              [88.579256, 48.294937],
              [88.579527, 48.295147],
              [88.579743, 48.295407],
              [88.579997, 48.295647],
              [88.58026, 48.295932],
              [88.58054, 48.296261],
              [88.58066, 48.296462],
              [88.580763, 48.296648],
              [88.580856, 48.296982],
              [88.581065, 48.297414],
              [88.581301, 48.297944],
              [88.581657, 48.298602],
              [88.582031, 48.299194],
              [88.582271, 48.299564],
              [88.582343, 48.299742],
              [88.582383, 48.299951],
              [88.582404, 48.300125],
              [88.58242313400001, 48.300205156],
              [88.582441, 48.30028],
              [88.582503, 48.300382],
              [88.582614, 48.30052],
              [88.582668, 48.300707],
              [88.582679, 48.300884],
              [88.582699, 48.301063],
              [88.582712, 48.301535],
              [88.582788, 48.30166],
              [88.58297, 48.301811],
              [88.583286, 48.301953],
              [88.583638, 48.302065],
              [88.584123, 48.302256],
              [88.584506001000022, 48.302369178],
              [88.58459, 48.302394],
              [88.584839, 48.302474],
              [88.585062, 48.302577],
              [88.585271, 48.302719],
              [88.585449, 48.302879],
              [88.585747, 48.303169],
              [88.586112, 48.303462],
              [88.586597, 48.30372],
              [88.587114, 48.304027],
              [88.587625, 48.304357],
              [88.588057, 48.304619],
              [88.588413, 48.304895],
              [88.58901, 48.305265],
              [88.589561, 48.305634],
              [88.590139, 48.306053],
              [88.590162, 48.30607],
              [88.590661, 48.306462],
              [88.590995, 48.3068],
              [88.59127, 48.307036],
              [88.591475, 48.30725],
              [88.591769, 48.307655],
              [88.591889, 48.307944],
              [88.592241, 48.308269],
              [88.592886, 48.308981],
              [88.593545, 48.309875],
              [88.593963, 48.310459],
              [88.594551, 48.31122],
              [88.595374, 48.312159],
              [88.595734, 48.312595],
              [88.596081, 48.313],
              [88.596629, 48.313592],
              [88.597141, 48.314188],
              [88.597853, 48.314851],
              [88.598356, 48.315225],
              [88.59901, 48.315608],
              [88.599424, 48.315986],
              [88.600216, 48.316814],
              [88.600741, 48.317401],
              [88.601186, 48.317949],
              [88.60197, 48.318946],
              [88.602468, 48.319756],
              [88.602642, 48.320165],
              [88.602931, 48.32081],
              [88.603407, 48.321616],
              [88.603736, 48.322248],
              [88.604271, 48.323343],
              [88.604947, 48.324496],
              [88.605183, 48.324807],
              [88.60537, 48.325074],
              [88.605579, 48.325475],
              [88.605739, 48.325978],
              [88.605935, 48.326525],
              [88.60606, 48.326926],
              [88.606198, 48.327473],
              [88.606349, 48.328261],
              [88.606411, 48.329271],
              [88.606411, 48.329618],
              [88.606367, 48.329841],
              [88.606296, 48.329996],
              [88.606149, 48.330219],
              [88.605944, 48.330433],
              [88.605601, 48.330775],
              [88.605299, 48.331073],
              [88.604929, 48.33143],
              [88.604689, 48.331683],
              [88.604475, 48.331955],
              [88.604315, 48.332164],
              [88.604173, 48.332444],
              [88.604038, 48.332831],
              [88.603919, 48.333125],
              [88.603772, 48.333339],
              [88.603603, 48.333566],
              [88.603318, 48.333797],
              [88.603113, 48.33398],
              [88.603033, 48.334189],
              [88.603033, 48.334371],
              [88.603096, 48.334549],
              [88.603234, 48.334834],
              [88.603385, 48.33499],
              [88.603501, 48.335204],
              [88.603518, 48.335533],
              [88.603541, 48.335996],
              [88.603461, 48.336472],
              [88.603403, 48.336988],
              [88.603296, 48.337416],
              [88.603211, 48.337709],
              [88.603096, 48.337914],
              [88.602926, 48.338181],
              [88.602633, 48.338488],
              [88.602312, 48.338742],
              [88.601903, 48.338849],
              [88.601391, 48.338951],
              [88.600786, 48.338982],
              [88.600065, 48.339013],
              [88.599493, 48.33906],
              [88.599165942000013, 48.339082780000012],
              [88.59889, 48.339102],
              [88.598454, 48.339178],
              [88.598026, 48.339227],
              [88.597644, 48.339387],
              [88.597374179999974, 48.339501719],
              [88.59735, 48.339512],
              [88.596856, 48.339779],
              [88.596335, 48.339988],
              [88.595881, 48.34017],
              [88.595441, 48.340366],
              [88.595182, 48.340504],
              [88.594844, 48.340767],
              [88.594715, 48.34094],
              [88.594622, 48.341078],
              [88.594493, 48.341212],
              [88.594266, 48.341323],
              [88.593968, 48.34143],
              [88.593598, 48.341595],
              [88.593144, 48.341906],
              [88.592708, 48.342284],
              [88.59218, 48.342687],
              [88.591537, 48.343041],
              [88.59103, 48.34321],
              [88.590443981000021, 48.343334416],
              [88.59038, 48.343348],
              [88.589597, 48.343446],
              [88.588925, 48.343477],
              [88.588502, 48.343455],
              [88.588284, 48.343424],
              [88.587915, 48.343304],
              [88.587612, 48.343161],
              [88.587296, 48.343108],
              [88.586908, 48.343062],
              [88.586878, 48.343059],
              [88.586295, 48.343001],
              [88.585694, 48.342952],
              [88.585218, 48.342796],
              [88.584666, 48.342609],
              [88.584158, 48.342445],
              [88.583495, 48.342204],
              [88.583081, 48.342071],
              [88.582872, 48.342004],
              [88.582636, 48.341977],
              [88.582374, 48.341991],
              [88.582036, 48.342044],
              [88.581711, 48.342151],
              [88.581417, 48.342262],
              [88.580812, 48.342525],
              [88.58018, 48.34281],
              [88.579508, 48.343054],
              [88.579103, 48.343232],
              [88.578724, 48.34341],
              [88.578484, 48.343482],
              [88.578261, 48.343513],
              [88.578088, 48.343544],
              [88.577937, 48.343597],
              [88.577794, 48.34378],
              [88.577638964000016, 48.343959557],
              [88.577598, 48.344007],
              [88.577313, 48.344234],
              [88.577153, 48.34439],
              [88.576833, 48.344563],
              [88.576606, 48.344657],
              [88.57641, 48.344755],
              [88.576174, 48.344964],
              [88.576009, 48.345168],
              [88.575903, 48.345391],
              [88.575876, 48.345591],
              [88.575818, 48.346014],
              [88.575751, 48.346299],
              [88.575729, 48.346851],
              [88.575742, 48.347274],
              [88.575725, 48.34771],
              [88.575662, 48.347968],
              [88.575551, 48.348186],
              [88.575409, 48.348444],
              [88.575297, 48.348647],
              [88.575222, 48.348742],
              [88.57511, 48.348867],
              [88.574857, 48.349076],
              [88.574625, 48.349245],
              [88.574363, 48.349316],
              [88.574105, 48.349316],
              [88.573713, 48.349303],
              [88.573401, 48.349276],
              [88.572988, 48.349281],
              [88.572795069, 48.349286199],
              [88.572654, 48.34929],
              [88.5724, 48.349396],
              [88.572129, 48.349432],
              [88.571595, 48.349472],
              [88.571158, 48.349428],
              [88.570704, 48.349396],
              [88.570077, 48.349276],
              [88.569329, 48.349276],
              [88.568679, 48.349356],
              [88.568074, 48.349392],
              [88.567856, 48.349388],
              [88.567638, 48.349347],
              [88.567384, 48.349343],
              [88.567157, 48.349356],
              [88.56693, 48.349472],
              [88.56677, 48.349655],
              [88.566552, 48.349899],
              [88.566419, 48.3501],
              [88.566263, 48.350327],
              [88.566209227, 48.350456055],
              [88.566178, 48.350531],
              [88.566151, 48.350772],
              [88.566147, 48.35083],
              [88.566151, 48.350976],
              [88.566116, 48.351128],
              [88.566049, 48.351212],
              [88.565836, 48.351448],
              [88.565649, 48.351697],
              [88.565533, 48.35188],
              [88.565444, 48.352036],
              [88.565368, 48.352263],
              [88.565359, 48.352552],
              [88.565359, 48.352641],
              [88.565404, 48.352779],
              [88.565444, 48.352939],
              [88.565497, 48.353135],
              [88.565751, 48.353478],
              [88.566094, 48.353989],
              [88.566494, 48.354737],
              [88.567059, 48.355583],
              [88.56732, 48.35593],
              [88.56758, 48.356277],
              [88.567816, 48.356553],
              [88.567914, 48.356669],
              [88.568025, 48.356864],
              [88.568123, 48.357043],
              [88.568172, 48.357252],
              [88.568177, 48.357519],
              [88.568243, 48.357723],
              [88.568515, 48.358217],
              [88.568777, 48.358805],
              [88.568897, 48.359165],
              [88.569129, 48.359695],
              [88.569463, 48.360296],
              [88.569672, 48.36075],
              [88.569854, 48.361008],
              [88.57005, 48.361271],
              [88.570259, 48.361471],
              [88.570317, 48.361578],
              [88.570397, 48.361689],
              [88.570433, 48.36176],
              [88.57046, 48.36184],
              [88.57046, 48.361916],
              [88.57046, 48.361978],
              [88.570428, 48.362076],
              [88.570411, 48.362134],
              [88.570291, 48.36233],
              [88.570157, 48.362508],
              [88.570117, 48.36261],
              [88.570072, 48.362735],
              [88.570068, 48.36302],
              [88.570108, 48.3633],
              [88.57017, 48.363652],
              [88.570313, 48.363968],
              [88.57062, 48.364435],
              [88.570829, 48.364729],
              [88.570878, 48.364849],
              [88.570878, 48.364938],
              [88.570874, 48.364982],
              [88.570807, 48.365005],
              [88.570682, 48.365],
              [88.570491, 48.364916],
              [88.569997, 48.364724],
              [88.569338, 48.36447],
              [88.568871, 48.364288],
              [88.568301, 48.364226],
              [88.567896, 48.364257],
              [88.567684642000017, 48.364303801],
              [88.567616, 48.364319],
              [88.567255, 48.364435],
              [88.566748, 48.364564],
              [88.566427, 48.364617],
              [88.566027, 48.364626],
              [88.565764, 48.364684],
              [88.565524, 48.364773],
              [88.565333, 48.364831],
              [88.565115, 48.364862],
              [88.56462, 48.364893],
              [88.563953, 48.365],
              [88.563138, 48.365062],
              [88.56252, 48.3652],
              [88.561834, 48.365343],
              [88.561345, 48.365485],
              [88.560833, 48.365628],
              [88.560344, 48.365628],
              [88.559832, 48.365637],
              [88.559449, 48.365708],
              [88.558648, 48.365864],
              [88.55802, 48.366015],
              [88.557175, 48.366064],
              [88.556565, 48.366126],
              [88.556044, 48.366224],
              [88.555595, 48.366429],
              [88.555473082999981, 48.366532010000014],
              [88.555221, 48.366745],
              [88.554829, 48.367132],
              [88.554175, 48.36771],
              [88.553361, 48.368196],
              [88.552484, 48.368694],
              [88.551892, 48.368943],
              [88.551037, 48.369353],
              [88.550205, 48.369842],
              [88.549342, 48.370345],
              [88.548656, 48.370795],
              [88.548087, 48.371004],
              [88.547633, 48.370999],
              [88.547059, 48.37087],
              [88.546387, 48.370741],
              [88.545759, 48.37047],
              [88.54522, 48.370069],
              [88.544771, 48.369669],
              [88.544054, 48.369179],
              [88.5434, 48.368703],
              [88.542862, 48.368231],
              [88.542301, 48.367555],
              [88.542064, 48.367206],
              [88.541838, 48.366874],
              [88.541638, 48.366487],
              [88.54162233400001, 48.366465579000021],
              [88.541491, 48.366286],
              [88.541015, 48.365801],
              [88.540303, 48.365093],
              [88.539973, 48.364826],
              [88.539711, 48.364733],
              [88.539266, 48.364746],
              [88.538798, 48.364706],
              [88.537272, 48.364515],
              [88.53644, 48.364426],
              [88.535977, 48.364413],
              [88.535594, 48.364457],
              [88.535149, 48.364564],
              [88.534161, 48.364849],
              [88.533226, 48.365129],
              [88.53258691100001, 48.365319070999988],
              [88.532029, 48.365485],
              [88.531005, 48.365912],
              [88.530422, 48.366326],
              [88.529902, 48.366847],
              [88.52935, 48.367448],
              [88.528936, 48.36796],
              [88.528593, 48.368552],
              [88.528375, 48.368988],
              [88.528153, 48.369638],
              [88.527845, 48.370305],
              [88.527659, 48.370621],
              [88.527218, 48.371253],
              [88.526857, 48.37164],
              [88.526515, 48.371956],
              [88.525981, 48.372228],
              [88.525433, 48.372455],
              [88.524641, 48.372682],
              [88.524156, 48.372829],
              [88.523359, 48.373078],
              [88.522736, 48.373269],
              [88.521632, 48.373692],
              [88.520894, 48.374079],
              [88.520333, 48.374444],
              [88.520053, 48.37472],
              [88.519683, 48.375276],
              [88.519336, 48.375668],
              [88.519078, 48.375833],
              [88.518797, 48.375886],
              [88.518344, 48.376118],
              [88.517774, 48.376398],
              [88.517342, 48.376701],
              [88.516675, 48.377448],
              [88.516149, 48.377951],
              [88.51566, 48.37841],
              [88.515241, 48.378663],
              [88.514739, 48.37893],
              [88.514334, 48.379064],
              [88.513982, 48.379122],
              [88.513626, 48.379228],
              [88.51335, 48.379424],
              [88.513061, 48.379718],
              [88.512642, 48.380079],
              [88.512188, 48.380519],
              [88.511783, 48.380875],
              [88.511365, 48.381307],
              [88.510853, 48.381939],
              [88.510711, 48.382277],
              [88.510666, 48.382669],
              [88.510635, 48.38302],
              [88.510613, 48.383421],
              [88.510675, 48.383977],
              [88.510884, 48.384471],
              [88.511134, 48.384974],
              [88.511378, 48.385263],
              [88.511726, 48.385459],
              [88.512282, 48.38574],
              [88.512811, 48.38598],
              [88.513279, 48.386251],
              [88.513884, 48.386527],
              [88.514681, 48.38687],
              [88.515246, 48.38707],
              [88.515816, 48.387217],
              [88.516332, 48.387337],
              [88.516384, 48.387345],
              [88.516875, 48.387418],
              [88.517547, 48.387489],
              [88.518357, 48.387631],
              [88.51902, 48.387738],
              [88.519389, 48.38784],
              [88.519599, 48.387992],
              [88.519803, 48.388241],
              [88.520048, 48.388655],
              [88.520124, 48.389011],
              [88.520124, 48.389385],
              [88.520053, 48.389767],
              [88.51991, 48.390159],
              [88.519866, 48.390649],
              [88.519892, 48.391187],
              [88.519923, 48.391441],
              [88.520035, 48.391984],
              [88.520048, 48.392344],
              [88.519964, 48.392611],
              [88.519803, 48.392874],
              [88.519514, 48.393266],
              [88.519269, 48.393533],
              [88.518869, 48.393902],
              [88.518312, 48.394334],
              [88.517569, 48.394832],
              [88.516942, 48.395251],
              [88.516452, 48.39562],
              [88.516038, 48.396052],
              [88.515811, 48.396461],
              [88.515722, 48.396746],
              [88.515642, 48.397066],
              [88.515633, 48.397244],
              [88.515638, 48.397676],
              [88.515727, 48.398299],
              [88.515807, 48.398735],
              [88.515865, 48.399345],
              [88.515847, 48.399643],
              [88.515825, 48.39987],
              [88.515767, 48.399955],
              [88.515682, 48.400013],
              [88.515598, 48.400039],
              [88.515304, 48.400048],
              [88.514378, 48.400102],
              [88.513808, 48.400146],
              [88.512945, 48.400333],
              [88.512442, 48.400453],
              [88.511872, 48.400502],
              [88.511521, 48.400556],
              [88.51116, 48.400662],
              [88.510533, 48.400925],
              [88.510128, 48.401085],
              [88.509576, 48.401397],
              [88.509193, 48.401495],
              [88.508806, 48.401584],
              [88.508272, 48.401882],
              [88.507871, 48.402162],
              [88.507391, 48.402585],
              [88.506821, 48.403075],
              [88.506211, 48.403489],
              [88.505793, 48.403658],
              [88.505526, 48.403707],
              [88.505121, 48.403671],
              [88.504507, 48.403564],
              [88.504137, 48.403462],
              [88.503652, 48.403364],
              [88.503213983000023, 48.403270449],
              [88.502945, 48.403213],
              [88.502322, 48.403039],
              [88.501774, 48.402901],
              [88.501187, 48.402803],
              [88.500314, 48.402772],
              [88.499535, 48.402719],
              [88.498783, 48.402683],
              [88.498053, 48.402723],
              [88.497546, 48.402803],
              [88.497074, 48.402932],
              [88.496304, 48.403208],
              [88.495695, 48.403395],
              [88.495076, 48.403631],
              [88.494654, 48.403851],
              [88.493981, 48.404241],
              [88.493136, 48.404784],
              [88.492981871999973, 48.404883867000024],
              [88.49221, 48.405384],
              [88.49168, 48.405696],
              [88.491177, 48.405887],
              [88.490523, 48.406083],
              [88.489606, 48.406252],
              [88.488574, 48.406444],
              [88.487982, 48.406546],
              [88.487562384, 48.406570326],
              [88.487292, 48.406586],
              [88.48646, 48.406648],
              [88.486315651999973, 48.406658229000016],
              [88.485952, 48.406684],
              [88.485763432, 48.406675609999979],
              [88.485053, 48.406644],
              [88.484444, 48.406657],
              [88.484092, 48.406582],
              [88.483776, 48.406435],
              [88.483344, 48.406101],
              [88.483046, 48.405821],
              [88.482735, 48.405558],
              [88.482307, 48.405322],
              [88.481764, 48.405002],
              [88.481101, 48.404677],
              [88.480661, 48.404396],
              [88.480291, 48.404214],
              [88.479868, 48.404089],
              [88.479299, 48.403911],
              [88.478467, 48.403653],
              [88.47779, 48.403471],
              [88.477483, 48.403346],
              [88.477207, 48.403141],
              [88.477131, 48.402883],
              [88.477127, 48.402616],
              [88.477163, 48.402193],
              [88.47726, 48.401668],
              [88.477358, 48.401321],
              [88.477416, 48.401023],
              [88.477496, 48.400685],
              [88.477616, 48.400275],
              [88.477866, 48.399763],
              [88.478021, 48.39947],
              [88.478035, 48.399296],
              [88.47799, 48.399145],
              [88.477657, 48.398673],
              [88.477269, 48.398099],
              [88.476931, 48.397569],
              [88.476695, 48.397293],
              [88.476299, 48.396822],
              [88.475996, 48.396479],
              [88.475734, 48.396234],
              [88.475431, 48.396065],
              [88.475133, 48.395869],
              [88.474697, 48.395616],
              [88.474234, 48.395473],
              [88.47366, 48.395317],
              [88.472926, 48.395197],
              [88.472708, 48.395148],
              [88.472507, 48.395104],
              [88.47208, 48.395086],
              [88.471265545, 48.395059862999972],
              [88.471114, 48.395055],
              [88.470452, 48.395052],
              [88.469184, 48.39512],
              [88.468902, 48.395121],
              [88.468635, 48.395046],
              [88.468436, 48.394916],
              [88.468006, 48.394463],
              [88.467767, 48.394245],
              [88.467408, 48.394016],
              [88.467054, 48.393874],
              [88.466840497000021, 48.393639985999982],
              [88.466825, 48.393623],
              [88.466604, 48.39339],
              [88.466187, 48.39293],
              [88.465367, 48.39234],
              [88.46449, 48.391894],
              [88.463541, 48.391276],
              [88.462074, 48.390643],
              [88.461197, 48.390269],
              [88.45996, 48.390111],
              [88.457947, 48.389895],
              [88.4551, 48.389651],
              [88.454546583000024, 48.389674741000022],
              [88.454424, 48.38968],
              [88.453978, 48.389938],
              [88.453762, 48.390125],
              [88.453604, 48.390125],
              [88.453072, 48.389608],
              [88.452761797, 48.389321000999985],
              [88.45231, 48.388903],
              [88.451864, 48.38863],
              [88.45103, 48.388285],
              [88.448844, 48.38804],
              [88.447924788000023, 48.387912186999984],
              [88.447607, 48.387868],
              [88.445608, 48.387407],
              [88.444357, 48.387177],
              [88.444007610000028, 48.387000304000026],
              [88.443135, 48.386559],
              [88.442315, 48.386199],
              [88.441841, 48.38607],
              [88.440517, 48.386113],
              [88.439422953000019, 48.386195906000012],
              [88.438432, 48.386271],
              [88.436937, 48.386329],
              [88.436505, 48.386444],
              [88.436031, 48.386631],
              [88.435671, 48.387105],
              [88.435225, 48.387983],
              [88.434736, 48.388687],
              [88.434147, 48.389306],
              [88.433442, 48.389996],
              [88.43314, 48.390672],
              [88.432968, 48.391376],
              [88.432838, 48.391822],
              [88.432579, 48.392067],
              [88.431947, 48.392556],
              [88.431357, 48.393073],
              [88.430767, 48.393605],
              [88.430656, 48.393718],
              [88.429948, 48.39444],
              [88.429387, 48.395072],
              [88.428941, 48.395417],
              [88.428596, 48.395475],
              [88.428294, 48.395734],
              [88.427862, 48.396683],
              [88.427417, 48.39769],
              [88.426956, 48.398179],
              [88.426611, 48.39884],
              [88.426295, 48.399458],
              [88.425849, 48.39989],
              [88.425216, 48.400278],
              [88.424152, 48.400781],
              [88.422412, 48.401429],
              [88.421500998999988, 48.401745193000011],
              [88.420715, 48.402018],
              [88.418112, 48.402637],
              [88.416574, 48.40314],
              [88.415307061000021, 48.40342118],
              [88.414632, 48.403571],
              [88.41167, 48.404218],
              [88.410102, 48.404492],
              [88.409139, 48.404779],
              [88.40829, 48.405211],
              [88.405946, 48.406591],
              [88.404796, 48.407152],
              [88.404336, 48.407569],
              [88.403919, 48.408072],
              [88.403128, 48.408935],
              [88.402351, 48.409597],
              [88.40146, 48.410129],
              [88.399748, 48.410719],
              [88.398368, 48.411035],
              [88.39739, 48.411423],
              [88.395808, 48.412113],
              [88.3946, 48.412459],
              [88.393434, 48.412694],
              [88.392961, 48.412789],
              [88.391853, 48.412876],
              [88.391393, 48.412962],
              [88.390962, 48.413336],
              [88.390444, 48.413753],
              [88.389452, 48.414673],
              [88.388531, 48.415421],
              [88.387453, 48.416054],
              [88.386302, 48.416629],
              [88.385094, 48.417348],
              [88.384275, 48.417909],
              [88.384059, 48.41811],
              [88.383858, 48.418484],
              [88.383627, 48.418729],
              [88.383196, 48.418973],
              [88.382822, 48.419232],
              [88.382744, 48.419418],
              [88.382664, 48.419606],
              [88.382434, 48.420167],
              [88.382161, 48.420699],
              [88.381629, 48.421533],
              [88.381068, 48.42205],
              [88.380665, 48.422295],
              [88.380234, 48.422352],
              [88.379083, 48.422683],
              [88.378321, 48.42287],
              [88.377444, 48.423215],
              [88.376768, 48.423719],
              [88.375689, 48.424495],
              [88.375344, 48.42474],
              [88.375186, 48.425013],
              [88.375085, 48.425286],
              [88.374999, 48.425473],
              [88.374654, 48.425617],
              [88.373863, 48.425789],
              [88.372799, 48.426106],
              [88.372482, 48.426393],
              [88.372353, 48.42671],
              [88.372267, 48.427069],
              [88.372152, 48.427271],
              [88.371993, 48.427371],
              [88.371778, 48.42753],
              [88.371648, 48.427817],
              [88.371505, 48.427975],
              [88.371174, 48.42809],
              [88.370196, 48.428522],
              [88.36969, 48.428735],
              [88.369649, 48.428752],
              [88.369564, 48.428862],
              [88.369304, 48.429198],
              [88.369089, 48.429343],
              [88.368643, 48.429644],
              [88.36719, 48.430391],
              [88.366845, 48.430506],
              [88.365997, 48.430636],
              [88.36535, 48.430837],
              [88.364702, 48.431168],
              [88.364214, 48.431283],
              [88.363552, 48.431297],
              [88.362675, 48.431513],
              [88.362229, 48.431513],
              [88.361194, 48.431297],
              [88.360117254999977, 48.430977007000024],
              [88.359986, 48.430938],
              [88.358893, 48.430808],
              [88.357527, 48.430837],
              [88.356247, 48.431053],
              [88.355484, 48.43134],
              [88.355437689999974, 48.431358249000027],
              [88.354205, 48.431844],
              [88.35314, 48.432218],
              [88.352378, 48.432606],
              [88.35176, 48.433066],
              [88.351271, 48.43367],
              [88.350379, 48.434504],
              [88.349689, 48.435008],
              [88.349459, 48.435194],
              [88.349301, 48.435324],
              [88.349229, 48.435525],
              [88.349243, 48.435813],
              [88.349502, 48.436115],
              [88.349818, 48.436374],
              [88.349847, 48.436618],
              [88.34979, 48.436877],
              [88.34979, 48.437237],
              [88.35002, 48.437423],
              [88.350595, 48.438157],
              [88.350983, 48.43866],
              [88.351041, 48.439005],
              [88.350839, 48.439566],
              [88.350422, 48.440458],
              [88.350235, 48.441062],
              [88.350307, 48.441651],
              [88.350207, 48.441953],
              [88.349876, 48.442241],
              [88.349516, 48.442701],
              [88.348668, 48.443564],
              [88.347546, 48.444341],
              [88.346928, 48.444671],
              [88.346755, 48.445146],
              [88.346497, 48.44539],
              [88.345936, 48.445678],
              [88.345792, 48.445822],
              [88.346065, 48.445966],
              [88.34631, 48.446153],
              [88.34641, 48.44644],
              [88.34641, 48.446713],
              [88.346266, 48.447044],
              [88.346252, 48.447332],
              [88.346396, 48.447663],
              [88.347302, 48.44818],
              [88.348524, 48.448612],
              [88.349258, 48.448727],
              [88.349726, 48.448937],
              [88.35012, 48.449115],
              [88.350581, 48.44946],
              [88.351026, 48.449992],
              [88.351285, 48.450611],
              [88.351731, 48.451056],
              [88.352191, 48.451588],
              [88.352436, 48.452178],
              [88.352623, 48.453127],
              [88.352651, 48.453688],
              [88.352896, 48.45435],
              [88.353054, 48.45491],
              [88.353054, 48.455313],
              [88.353255, 48.456248],
              [88.353572, 48.456622],
              [88.354104, 48.456881],
              [88.354866, 48.457168],
              [88.355398, 48.457542],
              [88.356002, 48.457945],
              [88.356592, 48.458146],
              [88.357383, 48.458362],
              [88.357455, 48.458462],
              [88.35734, 48.458549],
              [88.356865, 48.458664],
              [88.356505, 48.458692],
              [88.355945, 48.459023],
              [88.355398, 48.459584],
              [88.354521, 48.460246],
              [88.353428, 48.461123],
              [88.351861, 48.46213],
              [88.350868, 48.462719],
              [88.350667, 48.462978],
              [88.350624, 48.463309],
              [88.350279, 48.463524],
              [88.349473, 48.463826],
              [88.348783, 48.464387],
              [88.347834, 48.464847],
              [88.347331, 48.464919],
              [88.34536, 48.465034],
              [88.343707, 48.465049],
              [88.342585, 48.465049],
              [88.342130661, 48.465044021999972],
              [88.342126813999982, 48.465044406],
              [88.341089, 48.465034],
              [88.340025, 48.465106],
              [88.339156554999988, 48.465340845000014],
              [88.339119, 48.465351],
              [88.338184, 48.465653],
              [88.33679, 48.466199],
              [88.336128, 48.466386],
              [88.335323, 48.466875],
              [88.334345, 48.467522],
              [88.33387, 48.468069],
              [88.333209, 48.468745],
              [88.332691, 48.469133],
              [88.332188, 48.46942],
              [88.331699, 48.469593],
              [88.33167, 48.469895],
              [88.331972, 48.470427],
              [88.331958, 48.470585],
              [88.331339, 48.470959],
              [88.330707, 48.471463],
              [88.330505, 48.472023],
              [88.33052, 48.472412],
              [88.330318, 48.47244],
              [88.329916, 48.472095],
              [88.328995, 48.471793],
              [88.328740273, 48.47171683],
              [88.328276, 48.471578],
              [88.32737, 48.471606],
              [88.326378, 48.471736],
              [88.3254, 48.472081],
              [88.324854, 48.472282],
              [88.324303215999976, 48.472574741000017],
              [88.323473, 48.473016],
              [88.322538, 48.473605],
              [88.322222, 48.474123],
              [88.321949, 48.474324],
              [88.321345, 48.47431],
              [88.320295, 48.474094],
              [88.318282, 48.473835],
              [88.316779058, 48.473784505000026],
              [88.316139, 48.473763],
              [88.314298, 48.473778],
              [88.313234, 48.473979],
              [88.312917541, 48.474127845999988],
              [88.312745, 48.474209],
              [88.312098, 48.475058],
              [88.311077, 48.476352],
              [88.309941, 48.477804],
              [88.309092, 48.478523],
              [88.30764, 48.479429],
              [88.306044, 48.479947],
              [88.304246, 48.480292],
              [88.303139, 48.480407],
              [88.301514, 48.480307],
              [88.301441355, 48.480302881],
              [88.299486, 48.480192],
              [88.298642, 48.480192],
              [88.298479, 48.480192],
              [88.297343, 48.480494],
              [88.29661, 48.480781],
              [88.296572444999981, 48.480791997999972],
              [88.295186, 48.481198],
              [88.294525, 48.481601],
              [88.294483, 48.481646],
              [88.294021, 48.482147],
              [88.293302, 48.483399],
              [88.292799, 48.484405],
              [88.292612, 48.484549],
              [88.292324, 48.484607],
              [88.291534, 48.484535],
              [88.290715986, 48.48443023599998],
              [88.289621, 48.48429],
              [88.28801, 48.484247],
              [88.286414, 48.484333],
              [88.28597, 48.484349],
              [88.285192, 48.484376],
              [88.283322, 48.484664],
              [88.281884, 48.484966],
              [88.280834, 48.485383],
              [88.280686699, 48.485473302],
              [88.279684, 48.486088],
              [88.279353, 48.486232],
              [88.278922, 48.486289],
              [88.278533, 48.486289],
              [88.277627, 48.486088],
              [88.27698, 48.486102],
              [88.276333, 48.486232],
              [88.275873, 48.486275],
              [88.274794, 48.486375],
              [88.273385, 48.486404],
              [88.272263, 48.486534],
              [88.271703, 48.48662],
              [88.27107, 48.486893],
              [88.270725, 48.486979],
              [88.270236, 48.487094],
              [88.268783, 48.487253],
              [88.267086, 48.487684],
              [88.265677, 48.48823],
              [88.26457, 48.488806],
              [88.263621, 48.48951],
              [88.263017, 48.490359],
              [88.262355, 48.491308],
              [88.262197, 48.491423],
              [88.261895, 48.491509],
              [88.26096, 48.49138],
              [88.260102733, 48.491402158000028],
              [88.259838, 48.491409],
              [88.258875, 48.49148],
              [88.258328, 48.49138],
              [88.257552, 48.491394],
              [88.256617, 48.491725],
              [88.256392538, 48.491849001999981],
              [88.255654, 48.492257],
              [88.25505, 48.492674],
              [88.254345, 48.493408],
              [88.253784, 48.494184],
              [88.253534, 48.494647],
              [88.253396, 48.494903],
              [88.253281, 48.495349],
              [88.25331, 48.495795],
              [88.253382, 48.496212],
              [88.253712, 48.497046],
              [88.253827, 48.497405],
              [88.253827, 48.497779],
              [88.253612, 48.498124],
              [88.253151, 48.498441],
              [88.252835, 48.498656],
              [88.252706, 48.498901],
              [88.25272, 48.499246],
              [88.252662, 48.499318],
              [88.252346, 48.499318],
              [88.251598, 48.499117],
              [88.251080675000026, 48.49903287799998],
              [88.250448, 48.49893],
              [88.249341, 48.498671],
              [88.247902, 48.498642],
              [88.24668, 48.498815],
              [88.245515, 48.499045],
              [88.24425, 48.499663],
              [88.243727471, 48.49997412099998],
              [88.242898, 48.500468],
              [88.242639, 48.500583],
              [88.24238, 48.500512],
              [88.241934, 48.500166],
              [88.241812951999975, 48.500030453000022],
              [88.241575, 48.499764],
              [88.240913, 48.499189],
              [88.23995, 48.498714],
              [88.23903, 48.498326],
              [88.23729, 48.497621],
              [88.236436, 48.497395],
              [88.235176, 48.49706],
              [88.234155, 48.496844],
              [88.233493, 48.496844],
              [88.23299, 48.496859],
              [88.232558, 48.49696],
              [88.231969, 48.497046],
              [88.231365, 48.497377],
              [88.231916427999977, 48.497293472000024],
              [88.231365042, 48.497377275000019],
              [88.230358, 48.497707],
              [88.230085, 48.497837],
              [88.229768, 48.497923],
              [88.22951, 48.498052],
              [88.229136, 48.49811],
              [88.228848, 48.498211],
              [88.228604, 48.498354],
              [88.228345, 48.498599],
              [88.228172, 48.498656],
              [88.227942, 48.498671],
              [88.227243493, 48.498705248000022],
              [88.227065, 48.498714],
              [88.225224, 48.498714],
              [88.223527, 48.498685],
              [88.222276, 48.4988],
              [88.221686, 48.498987],
              [88.220881, 48.499275],
              [88.220641, 48.49938],
              [88.219601, 48.499836],
              [88.21835, 48.500555],
              [88.217372, 48.501216],
              [88.217037893999986, 48.501480378999986],
              [88.217035294000027, 48.501482010000018],
              [88.217027, 48.501489],
              [88.216493, 48.501654],
              [88.216333713999973, 48.501681637],
              [88.215957, 48.501747],
              [88.215255, 48.501871],
              [88.214419, 48.502036],
              [88.213593, 48.502232],
              [88.212747, 48.502325],
              [88.21157, 48.502283],
              [88.210579, 48.502222],
              [88.209754, 48.50217],
              [88.209155, 48.502005],
              [88.208206, 48.50153],
              [88.206957, 48.500777],
              [88.206255, 48.500374],
              [88.20547, 48.500157],
              [88.204779, 48.500044],
              [88.203705, 48.500023],
              [88.203035, 48.499837],
              [88.202429, 48.499629],
              [88.202137, 48.499528],
              [88.201012, 48.49928],
              [88.2003, 48.499115],
              [88.199071, 48.499043],
              [88.19808, 48.499012],
              [88.197038, 48.498929],
              [88.196408, 48.498991],
              [88.196068, 48.498981],
              [88.195934, 48.498888],
              [88.195748, 48.49864],
              [88.195552, 48.498186],
              [88.195356, 48.497711],
              [88.195201, 48.497247],
              [88.195046, 48.496865],
              [88.194809, 48.496473],
              [88.194437, 48.496122],
              [88.193746, 48.495544],
              [88.193033, 48.494966],
              [88.192755, 48.494669],
              [88.192529, 48.494401],
              [88.192388, 48.494331],
              [88.192205, 48.494338],
              [88.191938, 48.494401],
              [88.191728, 48.494527],
              [88.19132, 48.494708],
              [88.190309, 48.495121],
              [88.189153, 48.495616],
              [88.188606, 48.495781],
              [88.188213, 48.495853],
              [88.187728, 48.495853],
              [88.186459, 48.495895],
              [88.184838, 48.495936],
              [88.183961, 48.496008],
              [88.183662, 48.49608],
              [88.183311, 48.496225],
              [88.182754, 48.496431],
              [88.182095666, 48.496714815000018],
              [88.181629, 48.496916],
              [88.1807, 48.497247],
              [88.180101, 48.497422],
              [88.179252, 48.497574],
              [88.179101194, 48.497597929999984],
              [88.178584, 48.49768],
              [88.177469, 48.497907],
              [88.176313, 48.498145],
              [88.175529, 48.498361],
              [88.175164, 48.498475],
              [88.174775, 48.498671],
              [88.174352, 48.499043],
              [88.174306273000013, 48.499090498999976],
              [88.173836, 48.499579],
              [88.173351, 48.50024],
              [88.173052, 48.500663],
              [88.172955, 48.500909],
              [88.172887, 48.501241],
              [88.172804, 48.501489],
              [88.172721, 48.501623],
              [88.172649, 48.501695],
              [88.172412, 48.501788],
              [88.171958, 48.501933],
              [88.171039, 48.502242],
              [88.170580734, 48.50232824699998],
              [88.170327, 48.502376],
              [88.16946, 48.502583],
              [88.168562, 48.502913],
              [88.168022294000025, 48.50317508400002],
              [88.16752, 48.503419],
              [88.166725, 48.503852],
              [88.165992, 48.504399],
              [88.165084, 48.505184],
              [88.164392, 48.506051],
              [88.164227, 48.506278],
              [88.164134, 48.50636],
              [88.164, 48.506412],
              [88.163082, 48.506722],
              [88.16212, 48.507059],
              [88.161409, 48.507405],
              [88.16091, 48.507706],
              [88.160388, 48.508094],
              [88.159665, 48.508631],
              [88.158974, 48.509261],
              [88.158664, 48.509642],
              [88.158416, 48.509993],
              [88.158179, 48.510437],
              [88.157869, 48.510994],
              [88.157601, 48.511242],
              [88.157209, 48.511562],
              [88.156559, 48.511944],
              [88.155826, 48.512439],
              [88.155289, 48.512873],
              [88.154969, 48.513193],
              [88.15467, 48.513616],
              [88.154394, 48.514052],
              [88.154123, 48.514566],
              [88.153803, 48.514989],
              [88.153607, 48.515267],
              [88.153307, 48.515711],
              [88.152967, 48.516134],
              [88.152668, 48.516351],
              [88.152347, 48.516585],
              [88.152121, 48.516852],
              [88.152009, 48.517027],
              [88.151957, 48.517194],
              [88.151939, 48.517424],
              [88.151938, 48.51747],
              [88.151931, 48.517725],
              [88.151931, 48.517845],
              [88.151907, 48.51794],
              [88.151859, 48.517964],
              [88.151685, 48.517972],
              [88.15127, 48.517979],
              [88.150983, 48.517971],
              [88.150716, 48.517964],
              [88.150001, 48.517956],
              [88.149705434999987, 48.51794356],
              [88.149407, 48.517931],
              [88.148727, 48.517897],
              [88.148392, 48.517818],
              [88.148047, 48.517797],
              [88.147853, 48.517822],
              [88.147707, 48.517904],
              [88.147515, 48.51802],
              [88.14729, 48.518191],
              [88.147217925, 48.518245372000024],
              [88.147119, 48.51832],
              [88.146904, 48.518505],
              [88.146657, 48.518686],
              [88.146314, 48.518877],
              [88.146014, 48.51902],
              [88.1456, 48.519266],
              [88.145218, 48.519553],
              [88.144931, 48.519826],
              [88.14472, 48.520068],
              [88.144464, 48.520317],
              [88.144248, 48.520587],
              [88.14401, 48.520918],
              [88.143801, 48.521307],
              [88.143683, 48.521577],
              [88.143441, 48.522125],
              [88.14333, 48.522443],
              [88.143258, 48.522705],
              [88.143171, 48.522959],
              [88.14306, 48.523166],
              [88.142726, 48.523809],
              [88.142385, 48.524563],
              [88.142194, 48.524937],
              [88.142107, 48.525175],
              [88.142035, 48.525747],
              [88.141932, 48.526763],
              [88.14194, 48.527002],
              [88.142075, 48.527224],
              [88.142393, 48.52755],
              [88.142639, 48.527732],
              [88.142647, 48.527796],
              [88.142599, 48.527835],
              [88.142472, 48.527835],
              [88.14225, 48.527828],
              [88.141868, 48.527772],
              [88.141178, 48.527716],
              [88.140224, 48.527621],
              [88.139971458, 48.527610531999983],
              [88.139645, 48.527597],
              [88.138994, 48.527613],
              [88.138596, 48.527677],
              [88.138112, 48.527732],
              [88.137532, 48.527764],
              [88.136952, 48.527716],
              [88.136341, 48.527613],
              [88.135753, 48.527502],
              [88.135142, 48.527438],
              [88.134419, 48.527319],
              [88.134014, 48.527264],
              [88.133712, 48.527256],
              [88.133402, 48.527287],
              [88.132878, 48.527375],
              [88.132624, 48.527422],
              [88.132076, 48.52751],
              [88.131703, 48.527542],
              [88.131465, 48.527542],
              [88.13129, 48.52751],
              [88.131123, 48.527399],
              [88.130805, 48.527232],
              [88.13052, 48.527089],
              [88.130202, 48.526914],
              [88.129916, 48.526787],
              [88.129733, 48.526739],
              [88.129455, 48.526676],
              [88.129138, 48.52662],
              [88.128725, 48.526557],
              [88.128304, 48.526485],
              [88.128141, 48.526436],
              [88.127962, 48.526382],
              [88.127303, 48.526199],
              [88.125373, 48.525707],
              [88.124214, 48.525366],
              [88.123046, 48.524937],
              [88.122227, 48.524462],
              [88.121346, 48.524011],
              [88.119981, 48.523388],
              [88.119342, 48.522956],
              [88.118766, 48.522618],
              [88.118138, 48.522348],
              [88.117558, 48.522189],
              [88.117002, 48.522054],
              [88.116113, 48.521927],
              [88.115764, 48.521943],
              [88.115287, 48.521998],
              [88.114882, 48.522197],
              [88.114387588, 48.522521725],
              [88.114072, 48.522729],
              [88.113643, 48.523046],
              [88.113564, 48.523174],
              [88.113564, 48.523245],
              [88.113548, 48.523412],
              [88.113564, 48.523785],
              [88.113564, 48.524015],
              [88.113516, 48.524079],
              [88.113405, 48.524095],
              [88.113143, 48.524158],
              [88.11296, 48.524174],
              [88.112793, 48.524214],
              [88.112603, 48.524412],
              [88.112507, 48.524627],
              [88.112476, 48.524897],
              [88.112388, 48.525016],
              [88.112269, 48.525095],
              [88.112007, 48.525207],
              [88.111034, 48.525742],
              [88.110228, 48.526144],
              [88.109513, 48.526477],
              [88.109021, 48.526755],
              [88.10891, 48.52689],
              [88.108846, 48.527097],
              [88.108838, 48.527319],
              [88.108822, 48.527573],
              [88.108735, 48.527828],
              [88.108584, 48.528105],
              [88.108481, 48.52836],
              [88.108386, 48.528685],
              [88.108354, 48.529114],
              [88.108378, 48.529503],
              [88.108425, 48.529876],
              [88.108393, 48.530019],
              [88.108322, 48.530139],
              [88.108187, 48.530385],
              [88.10802, 48.530599],
              [88.107766, 48.530885],
              [88.107695, 48.531139],
              [88.107671, 48.531576],
              [88.107639, 48.531663],
              [88.10756, 48.531775],
              [88.107448, 48.531862],
              [88.107242, 48.531965],
              [88.106956, 48.532061],
              [88.106702, 48.532259],
              [88.106551, 48.532458],
              [88.106432, 48.532728],
              [88.10636, 48.533014],
              [88.106289, 48.533268],
              [88.106289, 48.533291],
              [88.106289, 48.533633],
              [88.106313, 48.533927],
              [88.10636, 48.534173],
              [88.106416, 48.534316],
              [88.106503, 48.53457],
              [88.106718, 48.534951],
              [88.1069, 48.535618],
              [88.106972, 48.536063],
              [88.106956, 48.536699],
              [88.1069, 48.537127],
              [88.106821, 48.537437],
              [88.106702, 48.537652],
              [88.106551, 48.537866],
              [88.106408, 48.538065],
              [88.106154, 48.53835],
              [88.105892, 48.538565],
              [88.105487, 48.538891],
              [88.105042, 48.539113],
              [88.104613, 48.53928],
              [88.104176, 48.539446],
              [88.103835, 48.539518],
              [88.103319, 48.539685],
              [88.102445, 48.540066],
              [88.101563, 48.54036],
              [88.100888, 48.540519],
              [88.100619967, 48.540550105000023],
              [88.100483, 48.540566],
              [88.100325, 48.540598],
              [88.100261, 48.54067],
              [88.100251246000028, 48.540732793000018],
              [88.100245, 48.540773],
              [88.100317, 48.541067],
              [88.100372, 48.541432],
              [88.100396, 48.541678],
              [88.100372, 48.541765],
              [88.100309, 48.541813],
              [88.100182, 48.541845],
              [88.100015, 48.541869],
              [88.099816, 48.5419],
              [88.099479, 48.542448],
              [88.099336, 48.542875],
              [88.098984, 48.543077],
              [88.098526, 48.54328],
              [88.097971, 48.543565],
              [88.097322, 48.543926],
              [88.096696, 48.544247],
              [88.096223, 48.544382],
              [88.095781, 48.544448],
              [88.095445356000027, 48.544461214000023],
              [88.095019, 48.544478],
              [88.094288, 48.544465],
              [88.093733, 48.54442],
              [88.093193, 48.544345],
              [88.092673, 48.544244],
              [88.092338, 48.544187],
              [88.092066, 48.54405],
              [88.091828, 48.543887],
              [88.091625, 48.543692],
              [88.091335, 48.543292],
              [88.091145, 48.54304],
              [88.09088, 48.542864],
              [88.090604, 48.542712],
              [88.090232, 48.542602],
              [88.089238, 48.542243],
              [88.088753, 48.542072],
              [88.08822, 48.541832],
              [88.08761, 48.541402],
              [88.08705, 48.541],
              [88.086885, 48.540914],
              [88.086488, 48.540707],
              [88.086143, 48.540542],
              [88.08591, 48.54046],
              [88.085647, 48.54043],
              [88.085293, 48.540546],
              [88.084341, 48.540905],
              [88.083319567999979, 48.541276255000014],
              [88.083279, 48.541291],
              [88.082617, 48.541664],
              [88.08172, 48.542326],
              [88.080754, 48.543195],
              [88.080648, 48.543364],
              [88.080354, 48.54383],
              [88.080078, 48.544616],
              [88.079899, 48.545333],
              [88.079623, 48.546134],
              [88.079388, 48.546837],
              [88.079126, 48.547196],
              [88.07885, 48.547375],
              [88.07834, 48.547486],
              [88.077747, 48.547486],
              [88.076643, 48.547596],
              [88.076032, 48.547638],
              [88.075471, 48.547748],
              [88.074381, 48.547955],
              [88.073622, 48.548037],
              [88.072298, 48.547927],
              [88.071937414999979, 48.547875159],
              [88.070573, 48.547679],
              [88.069428, 48.547389],
              [88.068559, 48.547072],
              [88.06718, 48.546423],
              [88.065924, 48.545596],
              [88.065644, 48.545299],
              [88.065441, 48.545085],
              [88.065028, 48.544244],
              [88.064848, 48.54394],
              [88.064728, 48.543812],
              [88.064563, 48.543827],
              [88.06443, 48.543909],
              [88.064263, 48.54406],
              [88.063978, 48.54427],
              [88.063579, 48.544561],
              [88.062986, 48.544782],
              [88.061744, 48.544892],
              [88.060875, 48.544809],
              [88.060036, 48.544713],
              [88.05968, 48.544667],
              [88.059328, 48.54457],
              [88.058923, 48.544352],
              [88.058539, 48.544114],
              [88.057798, 48.543692],
              [88.056516, 48.543002],
              [88.055357, 48.542395],
              [88.054281, 48.541871],
              [88.053108, 48.541429],
              [88.051881, 48.541057],
              [88.05086, 48.540895],
              [88.05002, 48.540737],
              [88.049457, 48.5407],
              [88.04915, 48.540685],
              [88.048902, 48.540752],
              [88.04868, 48.540891],
              [88.048294, 48.541126],
              [88.047604, 48.541705],
              [88.047312531999978, 48.541928885],
              [88.046418, 48.542616],
              [88.046045, 48.54285],
              [88.045838, 48.542905],
              [88.045631, 48.542905],
              [88.045328, 48.542933],
              [88.045204, 48.543016],
              [88.04508, 48.543181],
              [88.044882, 48.5434],
              [88.044597, 48.543602],
              [88.044222, 48.54385],
              [88.043794, 48.544067],
              [88.043149, 48.544262],
              [88.042445, 48.544478],
              [88.041945893, 48.544636695],
              [88.041838, 48.544671],
              [88.041189, 48.54492],
              [88.040637, 48.545209],
              [88.040003, 48.545582],
              [88.039941011, 48.545628465999982],
              [88.039396, 48.546037],
              [88.038941, 48.546465],
              [88.038209, 48.547058],
              [88.037685, 48.547623],
              [88.037465, 48.547872],
              [88.03723, 48.54801],
              [88.036802, 48.548148],
              [88.036195, 48.548327],
              [88.035480032, 48.548614375999989],
              [88.03465, 48.548948],
              [88.033774, 48.549325],
              [88.033414799000013, 48.549546635000013],
              [88.033022, 48.549789],
              [88.032291, 48.550258],
              [88.032071, 48.550341],
              [88.031919, 48.550341],
              [88.031739, 48.550231],
              [88.031663036999987, 48.550185874000022],
              [88.031436, 48.550051],
              [88.030857, 48.549803],
              [88.029808, 48.549555],
              [88.028663, 48.549265],
              [88.027697, 48.549031],
              [88.026925, 48.548934],
              [88.025945, 48.548948],
              [88.024869, 48.548975],
              [88.024318, 48.548906],
              [88.023614, 48.548534],
              [88.022924, 48.548175],
              [88.022276, 48.547844],
              [88.02189, 48.54772],
              [88.021048, 48.54783],
              [88.020193, 48.548093],
              [88.019448, 48.548451],
              [88.018234, 48.549141],
              [88.017915153999979, 48.549373989],
              [88.017365, 48.549776],
              [88.016772, 48.550189],
              [88.016123, 48.550562],
              [88.015102, 48.55121],
              [88.014261, 48.551914],
              [88.013585, 48.552562],
              [88.013185, 48.55299],
              [88.013157, 48.553252],
              [88.013171, 48.5535],
              [88.013378, 48.553845],
              [88.013875, 48.5543],
              [88.014123, 48.554645],
              [88.014316, 48.555032],
              [88.01434, 48.555438],
              [88.014316, 48.555735],
              [88.014261, 48.556094],
              [88.013999, 48.556452],
              [88.013724, 48.556773],
              [88.01353, 48.557184],
              [88.013254, 48.558149],
              [88.01325, 48.558182],
              [88.013199, 48.558632],
              [88.013212, 48.55888],
              [88.013364, 48.559322],
              [88.013571, 48.559943],
              [88.013668, 48.560384],
              [88.013654, 48.560991],
              [88.013681, 48.561722],
              [88.013695, 48.562081],
              [88.013626, 48.562412],
              [88.013529, 48.562616],
              [88.013309, 48.562743],
              [88.012936, 48.56284],
              [88.011998, 48.562922],
              [88.011419, 48.56295],
              [88.010792, 48.563059],
              [88.010438624000017, 48.563128071999984],
              [88.010219, 48.563171],
              [88.009088, 48.563557],
              [88.007915, 48.564054],
              [88.006535, 48.564606],
              [88.004839, 48.565433],
              [88.003142, 48.566151],
              [88.0019, 48.566813],
              [88.00059, 48.567503],
              [87.999886, 48.567919],
              [87.999183, 48.568427],
              [87.99812, 48.56913],
              [87.997913, 48.569269],
              [87.997688, 48.569374],
              [87.997472, 48.56942],
              [87.997127, 48.569365],
              [87.996603, 48.569227],
              [87.995099, 48.568661],
              [87.99434, 48.568385],
              [87.99332, 48.567958],
              [87.992713, 48.567571],
              [87.992023, 48.567213],
              [87.991154, 48.566827],
              [87.99074, 48.566771],
              [87.990285, 48.56673],
              [87.989553, 48.566689],
              [87.988642, 48.566771],
              [87.988339, 48.566799],
              [87.987043, 48.566909],
              [87.986020638000014, 48.567030122],
              [87.98576, 48.567061],
              [87.984408, 48.567337],
              [87.98267, 48.567778],
              [87.982249, 48.567867],
              [87.981907, 48.568032],
              [87.981487, 48.568339],
              [87.980992, 48.568692],
              [87.980422, 48.569149],
              [87.979558, 48.569847],
              [87.979317, 48.570041],
              [87.978393, 48.5708],
              [87.977804, 48.571332],
              [87.977305, 48.571719],
              [87.976655, 48.571986],
              [87.975965, 48.572179],
              [87.975486, 48.572272],
              [87.974751, 48.572414],
              [87.973551, 48.572552],
              [87.972406, 48.572648],
              [87.971054, 48.572731],
              [87.970521, 48.573012],
              [87.970124, 48.573357],
              [87.969702, 48.573779],
              [87.969351, 48.57425],
              [87.968847, 48.574966],
              [87.968598, 48.57538],
              [87.968516, 48.575766],
              [87.96846, 48.576856],
              [87.968502, 48.577587],
              [87.968488, 48.577794],
              [87.968336, 48.577946],
              [87.968171, 48.57818],
              [87.967964, 48.578622],
              [87.96755, 48.579684],
              [87.967357, 48.580401],
              [87.967246, 48.581312],
              [87.967191, 48.581808],
              [87.967205, 48.582498],
              [87.96715, 48.583491],
              [87.967026, 48.584112],
              [87.966943, 48.584581],
              [87.966791, 48.584926],
              [87.966626, 48.585257],
              [87.96635, 48.585671],
              [87.966005, 48.586085],
              [87.965425, 48.586761],
              [87.964915, 48.587147],
              [87.964377, 48.587506],
              [87.963646, 48.587933],
              [87.963053, 48.588389],
              [87.962432, 48.588775],
              [87.961742, 48.589106],
              [87.960707, 48.589741],
              [87.959769, 48.590403],
              [87.959107, 48.590982],
              [87.958583, 48.591479],
              [87.958086, 48.591975],
              [87.957466, 48.592417],
              [87.957148, 48.59261],
              [87.956665, 48.592789],
              [87.956045, 48.592941],
              [87.955106, 48.593272],
              [87.954955, 48.593396],
              [87.954913, 48.593507],
              [87.954955, 48.593645],
              [87.955106, 48.593714],
              [87.955422, 48.593909],
              [87.955769, 48.594127],
              [87.956225, 48.594426],
              [87.956721, 48.594707],
              [87.957245, 48.594886],
              [87.95759, 48.595135],
              [87.957866, 48.595369],
              [87.958252, 48.595783],
              [87.958486, 48.596183],
              [87.958693, 48.596473],
              [87.958942, 48.596735],
              [87.959162, 48.5969],
              [87.959645, 48.597176],
              [87.960266, 48.597576],
              [87.961425, 48.598238],
              [87.962321, 48.598887],
              [87.962997, 48.599315],
              [87.963535, 48.599687],
              [87.96417, 48.60017],
              [87.964874, 48.600749],
              [87.965605, 48.601315],
              [87.966446, 48.601839],
              [87.967495, 48.602474],
              [87.967978, 48.602819],
              [87.968281, 48.603094],
              [87.968518, 48.603359],
              [87.968871, 48.603667],
              [87.969261, 48.603929],
              [87.969411, 48.604094],
              [87.969494, 48.604177],
              [87.969509, 48.604312],
              [87.969434, 48.604394],
              [87.969281, 48.60464],
              [87.969164, 48.604943],
              [87.969123, 48.605109],
              [87.969095, 48.605412],
              [87.969109, 48.605633],
              [87.969233, 48.605853],
              [87.96944, 48.606185],
              [87.969702, 48.606736],
              [87.96984, 48.607095],
              [87.970088, 48.607343],
              [87.970461, 48.607454],
              [87.970861, 48.607564],
              [87.97133, 48.607743],
              [87.971813, 48.607964],
              [87.97224, 48.60813],
              [87.973234, 48.608337],
              [87.974172, 48.60864],
              [87.975013, 48.608888],
              [87.976144, 48.609275],
              [87.976586, 48.609468],
              [87.976972, 48.609689],
              [87.977345, 48.609937],
              [87.97762, 48.61024],
              [87.977827, 48.61053],
              [87.977993, 48.611082],
              [87.978007, 48.611385],
              [87.978117, 48.611579],
              [87.978269, 48.611648],
              [87.978421, 48.611648],
              [87.978669, 48.611648],
              [87.97951, 48.61162],
              [87.980669, 48.611606],
              [87.981442, 48.611703],
              [87.981952, 48.611785],
              [87.982421, 48.611965],
              [87.982863, 48.612172],
              [87.983718, 48.612641],
              [87.984311, 48.612917],
              [87.985401, 48.613358],
              [87.98656, 48.613882],
              [87.987525, 48.614434],
              [87.98756304, 48.614458502],
              [87.988146, 48.614834],
              [87.988726, 48.615027],
              [87.989374, 48.615207],
              [87.989802, 48.615276],
              [87.989981, 48.615317],
              [87.990478, 48.6154],
              [87.990961, 48.615455],
              [87.99165, 48.615441],
              [87.992202, 48.615441],
              [87.992473175999976, 48.615441],
              [87.992644, 48.615441],
              [87.992921, 48.615477],
              [87.993499, 48.615552],
              [87.994216, 48.615538],
              [87.994975, 48.6154],
              [87.995982, 48.615207],
              [87.996837, 48.615083],
              [87.997017, 48.615069],
              [87.997127, 48.615083],
              [87.997362, 48.615221],
              [87.997872, 48.615469],
              [87.998658, 48.61591],
              [87.999417, 48.616352],
              [87.999996, 48.6166],
              [88.000341, 48.616835],
              [88.000755, 48.617152],
              [88.000948, 48.617414],
              [88.001376, 48.617786],
              [88.001873, 48.618242],
              [88.002011, 48.618338],
              [88.002314, 48.618449],
              [88.002797, 48.618559],
              [88.00328, 48.618683],
              [88.003707, 48.618821],
              [88.004052, 48.618959],
              [88.004232, 48.619056],
              [88.004935, 48.619497],
              [88.005942, 48.620007],
              [88.007198, 48.620808],
              [88.007915, 48.621346],
              [88.009032, 48.622132],
              [88.009247, 48.622336],
              [88.009391, 48.622477],
              [88.009405, 48.622573],
              [88.009446, 48.622711],
              [88.009612, 48.622891],
              [88.009892, 48.623101],
              [88.010274, 48.623318],
              [88.010936, 48.623649],
              [88.011943, 48.624036],
              [88.012826, 48.624519],
              [88.013254, 48.62485],
              [88.013433, 48.625057],
              [88.013557, 48.625291],
              [88.013764, 48.625733],
              [88.014233, 48.626519],
              [88.014716, 48.627429],
              [88.015158, 48.628009],
              [88.015309, 48.628105],
              [88.015461, 48.628119],
              [88.015778, 48.627981],
              [88.016137, 48.627829],
              [88.01702, 48.627636],
              [88.017779, 48.627554],
              [88.01862, 48.627485],
              [88.01971, 48.627429],
              [88.020814, 48.627567],
              [88.021393, 48.627636],
              [88.02229, 48.627802],
              [88.023242, 48.628036],
              [88.024249, 48.628257],
              [88.025256, 48.628505],
              [88.02577, 48.628674],
              [88.026221, 48.628878],
              [88.026911, 48.629223],
              [88.027615, 48.629706],
              [88.027753, 48.629885],
              [88.027808, 48.629968],
              [88.027849, 48.630119],
              [88.027918, 48.630423],
              [88.028084, 48.631154],
              [88.028166, 48.631692],
              [88.028222, 48.632065],
              [88.028235, 48.632409],
              [88.028222, 48.63303],
              [88.028222, 48.633789],
              [88.028194, 48.634134],
              [88.028139, 48.634327],
              [88.028084, 48.634451],
              [88.027932, 48.634631],
              [88.027822, 48.634741],
              [88.027615, 48.634865],
              [88.027438212, 48.634990593999987],
              [88.027356, 48.635049],
              [88.027005, 48.635268],
              [88.026855907000026, 48.635454685000013],
              [88.026771, 48.635561],
              [88.026625, 48.63578],
              [88.026552, 48.636028],
              [88.026391, 48.636218],
              [88.026201, 48.636408],
              [88.025734, 48.636803],
              [88.0255, 48.637124],
              [88.025208, 48.637329],
              [88.024945, 48.637519],
              [88.024623, 48.637651],
              [88.024331, 48.637753],
              [88.024141, 48.637899],
              [88.023951, 48.638162],
              [88.023746, 48.63844],
              [88.023542, 48.638615],
              [88.023235, 48.638761],
              [88.022825, 48.639024],
              [88.022475, 48.639273],
              [88.022139, 48.639565],
              [88.021876, 48.639887],
              [88.021671, 48.640267],
              [88.021525, 48.640632],
              [88.02132, 48.641143],
              [88.02113, 48.641626],
              [88.020923, 48.642209],
              [88.020809, 48.642532],
              [88.020662, 48.642926],
              [88.020429, 48.643248],
              [88.020209, 48.643613],
              [88.019946, 48.644154],
              [88.019596, 48.644826],
              [88.019274, 48.645396],
              [88.019084, 48.645776],
              [88.018748, 48.646113],
              [88.018339, 48.646361],
              [88.01771, 48.646536],
              [88.017126, 48.646741],
              [88.016819, 48.646799],
              [88.016117, 48.646799],
              [88.015372, 48.646799],
              [88.014758, 48.646814],
              [88.014173, 48.646931],
              [88.013647, 48.647092],
              [88.013034, 48.647252],
              [88.012434, 48.647442],
              [88.011338, 48.648012],
              [88.010666, 48.648363],
              [88.01052, 48.648451],
              [88.01052, 48.648553],
              [88.0109, 48.648685],
              [88.011616, 48.648875],
              [88.012127, 48.648992],
              [88.012902, 48.649211],
              [88.013224, 48.649372],
              [88.01413, 48.649649],
              [88.014977, 48.649869],
              [88.015766, 48.650029],
              [88.016775, 48.650278],
              [88.017623, 48.650526],
              [88.018003, 48.650702],
              [88.018207, 48.650892],
              [88.018456, 48.651169],
              [88.018733, 48.651593],
              [88.018938, 48.652017],
              [88.019318, 48.652645],
              [88.019873, 48.653566],
              [88.020122, 48.653917],
              [88.020297, 48.654224],
              [88.020531, 48.654604],
              [88.020896, 48.65494],
              [88.021291, 48.655393],
              [88.021656, 48.655934],
              [88.021817, 48.656211],
              [88.021992, 48.656723],
              [88.022095, 48.657147],
              [88.022226083000021, 48.65732642],
              [88.022255, 48.657366],
              [88.022317760000021, 48.657402371999979],
              [88.022431, 48.657468],
              [88.022679, 48.657556],
              [88.023249, 48.657571],
              [88.024243, 48.657585],
              [88.024945, 48.657687],
              [88.025427, 48.657863],
              [88.025821, 48.658024],
              [88.026201, 48.658228],
              [88.026523, 48.658418],
              [88.02683, 48.658594],
              [88.027268, 48.658944],
              [88.029168, 48.660391],
              [88.029797, 48.660786],
              [88.030177, 48.661151],
              [88.030557, 48.661633],
              [88.031127, 48.662218],
              [88.031609, 48.662598],
              [88.032018, 48.662832],
              [88.03272, 48.663226],
              [88.03345, 48.663636],
              [88.03405, 48.663913],
              [88.034488, 48.664074],
              [88.035745, 48.664483],
              [88.036593, 48.66479],
              [88.037206, 48.665126],
              [88.03735, 48.665185],
              [88.038595, 48.665696],
              [88.040597, 48.666339],
              [88.041986, 48.666661],
              [88.043038, 48.666997],
              [88.044368, 48.667348],
              [88.045128, 48.667567],
              [88.046531, 48.668079],
              [88.049118, 48.668897],
              [88.050184, 48.66935],
              [88.05093, 48.669789],
              [88.051193, 48.670008],
              [88.051295, 48.670183],
              [88.051324, 48.670344],
              [88.051339, 48.670519],
              [88.051281, 48.670651],
              [88.051105, 48.670972],
              [88.050871, 48.67182],
              [88.050608, 48.672814],
              [88.050594, 48.673165],
              [88.050681, 48.673413],
              [88.050857, 48.673588],
              [88.051061, 48.673793],
              [88.051485, 48.673925],
              [88.052216, 48.674246],
              [88.052947, 48.674538],
              [88.053327, 48.674699],
              [88.053721, 48.674933],
              [88.053955, 48.675108],
              [88.054189, 48.675357],
              [88.054452, 48.675781],
              [88.055095, 48.676453],
              [88.055563, 48.676877],
              [88.055643187999976, 48.676935637999975],
              [88.055723, 48.676994],
              [88.055770726999981, 48.677001562999976],
              [88.056089, 48.677052],
              [88.056761, 48.677184],
              [88.057404, 48.677374],
              [88.057901, 48.677607],
              [88.058296, 48.677754],
              [88.05888, 48.677885],
              [88.059465, 48.678046],
              [88.060751, 48.678265],
              [88.061029, 48.678324],
              [88.061306, 48.678397],
              [88.062198, 48.678718],
              [88.063674, 48.679098],
              [88.064902, 48.679507],
              [88.066378, 48.679887],
              [88.067503, 48.680194],
              [88.068482, 48.680545],
              [88.069038, 48.680852],
              [88.069286, 48.681042],
              [88.069783, 48.681539],
              [88.07047, 48.682109],
              [88.071332, 48.68284],
              [88.071464, 48.683103],
              [88.071551, 48.683468],
              [88.071639, 48.68398],
              [88.071712, 48.68493],
              [88.071756, 48.685441],
              [88.071844, 48.685806],
              [88.072004, 48.686011],
              [88.072194, 48.686201],
              [88.072574, 48.686406],
              [88.073071, 48.68661],
              [88.073787, 48.687136],
              [88.074138, 48.687458],
              [88.074182, 48.687589],
              [88.074197, 48.68775],
              [88.074211, 48.687882],
              [88.074182, 48.688057],
              [88.074124, 48.688232],
              [88.07405, 48.68851],
              [88.073831, 48.689051],
              [88.073539, 48.689738],
              [88.073349, 48.690162],
              [88.073203, 48.690527],
              [88.073174, 48.690761],
              [88.073159, 48.691068],
              [88.073188, 48.691258],
              [88.073261, 48.691492],
              [88.073422, 48.691784],
              [88.074094, 48.6925],
              [88.07465, 48.693085],
              [88.075468, 48.693684],
              [88.07633, 48.694093],
              [88.076667, 48.694166],
              [88.077163, 48.694239],
              [88.077456, 48.694385],
              [88.077938, 48.694751],
              [88.07826, 48.695058],
              [88.078581, 48.695452],
              [88.079326, 48.69611],
              [88.080335, 48.696768],
              [88.081402, 48.697396],
              [88.082629, 48.698141],
              [88.083375, 48.698638],
              [88.084705, 48.699194],
              [88.086308, 48.699785],
              [88.086434, 48.701032],
              [88.086394, 48.701354],
              [88.086324, 48.701605],
              [88.086269, 48.701958],
              [88.086151, 48.702272],
              [88.085963, 48.702782],
              [88.085751, 48.7033],
              [88.085633, 48.703865],
              [88.08557, 48.704367],
              [88.085602, 48.704602],
              [88.085688, 48.704798],
              [88.08601, 48.705034],
              [88.086402, 48.705292],
              [88.08692, 48.705583],
              [88.087202, 48.705873],
              [88.087461, 48.706203],
              [88.08765, 48.706626],
              [88.08812, 48.707576],
              [88.088285, 48.708101],
              [88.08845, 48.708548],
              [88.088756, 48.709035],
              [88.089415, 48.710227],
              [88.090066, 48.711161],
              [88.09049, 48.711883],
              [88.090576, 48.712236],
              [88.0906, 48.712605],
              [88.090466, 48.713013],
              [88.090301, 48.713311],
              [88.090121, 48.71353],
              [88.089784, 48.713648],
              [88.089438, 48.713711],
              [88.08896, 48.713931],
              [88.088293, 48.714197],
              [88.087673, 48.714582],
              [88.087375, 48.714754],
              [88.087163, 48.714786],
              [88.086873, 48.714817],
              [88.085876, 48.714841],
              [88.085816067999986, 48.714843136000013],
              [88.085006, 48.714872],
              [88.084229, 48.714911],
              [88.083727, 48.715021],
              [88.08346, 48.715107],
              [88.083044, 48.715327],
              [88.082644, 48.71539],
              [88.082228, 48.715398],
              [88.081805, 48.715492],
              [88.081248, 48.715696],
              [88.080792, 48.715759],
              [88.080455, 48.715751],
              [88.079875, 48.715743],
              [88.079474, 48.715806],
              [88.078737, 48.715994],
              [88.07807, 48.716167],
              [88.077686, 48.716182],
              [88.077395, 48.716151],
              [88.076964, 48.716167],
              [88.076572, 48.716174],
              [88.076179, 48.716261],
              [88.075607, 48.716378],
              [88.074532, 48.716433],
              [88.073755, 48.716457],
              [88.073339, 48.716488],
              [88.07297, 48.716504],
              [88.072233, 48.716622],
              [88.071762, 48.716684],
              [88.071393, 48.716645],
              [88.071064, 48.716512],
              [88.070405, 48.716269],
              [88.070146, 48.716237],
              [88.069934, 48.716237],
              [88.069683, 48.716316],
              [88.069471, 48.716292],
              [88.069173, 48.716143],
              [88.068247, 48.715868],
              [88.067494, 48.715562],
              [88.066945, 48.715209],
              [88.065933, 48.714762],
              [88.065305, 48.714558],
              [88.065015, 48.714472],
              [88.064576, 48.71444],
              [88.063924, 48.71437],
              [88.063917, 48.714369],
              [88.063359, 48.714284],
              [88.062442, 48.714056],
              [88.061312, 48.713742],
              [88.060692, 48.713499],
              [88.059994, 48.713028],
              [88.059554, 48.712683],
              [88.059044, 48.712369],
              [88.058519, 48.71204],
              [88.058126, 48.711953],
              [88.057664, 48.711914],
              [88.056918, 48.711898],
              [88.0564, 48.711796],
              [88.055694, 48.711491],
              [88.055412, 48.711451],
              [88.055239, 48.711522],
              [88.05498, 48.71164],
              [88.054714, 48.711765],
              [88.054376, 48.711946],
              [88.054023, 48.712267],
              [88.054015123999989, 48.712274783],
              [88.053348, 48.712934],
              [88.05276, 48.713515],
              [88.05214, 48.714229],
              [88.051505, 48.715005],
              [88.051309, 48.715147],
              [88.051152, 48.715241],
              [88.050963, 48.715296],
              [88.05061, 48.715492],
              [88.050242, 48.715798],
              [88.050053, 48.71601],
              [88.049888, 48.716261],
              [88.049779, 48.716512],
              [88.049551, 48.717116],
              [88.049426, 48.717406],
              [88.049284, 48.717743],
              [88.049269, 48.718042],
              [88.049299, 48.718388],
              [88.049308, 48.718489],
              [88.04941, 48.718818],
              [88.049473, 48.719509],
              [88.049426, 48.719948],
              [88.049277, 48.720489],
              [88.049041, 48.721211],
              [88.048814, 48.72187],
              [88.04861, 48.722231],
              [88.048366, 48.722537],
              [88.048068, 48.722859],
              [88.047825, 48.723094],
              [88.04737, 48.723706],
              [88.046891, 48.724412],
              [88.046625, 48.724742],
              [88.046452, 48.724914],
              [88.046083, 48.725189],
              [88.045738, 48.725534],
              [88.045495, 48.725887],
              [88.045197, 48.726601],
              [88.044985, 48.727025],
              [88.044867, 48.727637],
              [88.044757, 48.727959],
              [88.044585, 48.728194],
              [88.044373, 48.728429],
              [88.044083, 48.728743],
              [88.043565, 48.72919],
              [88.042937, 48.729763],
              [88.042451, 48.730383],
              [88.041902, 48.731034],
              [88.041227, 48.732038],
              [88.040897, 48.732368],
              [88.040607, 48.732556],
              [88.040199, 48.732744],
              [88.03965, 48.733003],
              [88.038858, 48.733388],
              [88.038253, 48.733843],
              [88.037579, 48.734478],
              [88.036998, 48.735067],
              [88.036206, 48.735741],
              [88.035939, 48.736126],
              [88.03568, 48.736502],
              [88.035523, 48.736824],
              [88.035437, 48.737099],
              [88.035382, 48.737248],
              [88.035256, 48.737342],
              [88.035099, 48.737397],
              [88.034715, 48.737499],
              [88.034338, 48.737617],
              [88.034064, 48.737687],
              [88.033664, 48.737868],
              [88.033224, 48.737915],
              [88.033005, 48.738009],
              [88.03262, 48.738338],
              [88.032236, 48.738613],
              [88.031804, 48.738809],
              [88.031232, 48.739044],
              [88.030808, 48.739264],
              [88.030361, 48.739672],
              [88.029623, 48.740417],
              [88.02905, 48.740967],
              [88.028956, 48.741139],
              [88.028925, 48.74132],
              [88.028925, 48.741641],
              [88.028909, 48.742034],
              [88.028831, 48.742238],
              [88.028674, 48.742387],
              [88.028109, 48.742653],
              [88.027615, 48.74285],
              [88.02716, 48.743054],
              [88.026987, 48.743234],
              [88.026893, 48.743422],
              [88.026877, 48.743681],
              [88.026838, 48.744073],
              [88.026814, 48.744419],
              [88.026681, 48.744678],
              [88.026501, 48.744952],
              [88.026312, 48.745235],
              [88.026155, 48.745423],
              [88.025975, 48.745643],
              [88.025716, 48.745902],
              [88.025402, 48.746302],
              [88.025285, 48.746615],
              [88.025214, 48.74689],
              [88.025206, 48.747369],
              [88.0253, 48.747918],
              [88.025465, 48.748381],
              [88.025591, 48.749448],
              [88.025496, 48.749667],
              [88.025332, 48.749793],
              [88.025049, 48.749903],
              [88.024594, 48.750075],
              [88.023888, 48.750122],
              [88.023425, 48.750075],
              [88.023001, 48.749973],
              [88.022732368999982, 48.749881010000024],
              [88.022452, 48.749785],
              [88.021848, 48.749597],
              [88.021338, 48.749432],
              [88.020977, 48.749369],
              [88.02031, 48.749314],
              [88.019895, 48.74933],
              [88.019651, 48.749393],
              [88.019345, 48.74944],
              [88.018992, 48.749448],
              [88.01831, 48.749463],
              [88.017815, 48.749558],
              [88.016623, 48.749887],
              [88.016042, 48.74995],
              [88.015446, 48.749903],
              [88.014771, 48.749887],
              [88.014097, 48.750091],
              [88.012967, 48.750507],
              [88.011719, 48.750985],
              [88.010635, 48.751368],
              [88.010519, 48.751409],
              [88.009554, 48.751778],
              [88.009069728999975, 48.75202348900001],
              [88.008471, 48.752327],
              [88.007404, 48.7529],
              [88.006706, 48.753355],
              [88.006361, 48.753763],
              [88.006251, 48.753948],
              [88.006212, 48.754014],
              [88.006125, 48.754351],
              [88.006016, 48.754689],
              [88.005851, 48.754995],
              [88.005466, 48.755552],
              [88.005019, 48.75625],
              [88.004792, 48.756603],
              [88.004643, 48.756729],
              [88.004415, 48.756838],
              [88.00407, 48.756885],
              [88.003536, 48.757027],
              [88.002752, 48.757278],
              [88.002093, 48.757584],
              [88.001995419000025, 48.757637369],
              [88.001347, 48.757992],
              [88.00113, 48.758182],
              [88.000883, 48.758355],
              [88.000635, 48.758627],
              [88.000462, 48.759097],
              [88.000448625, 48.759190983],
              [88.000388, 48.759617],
              [88.000437, 48.760112],
              [88.000388, 48.760235],
              [88.00019, 48.760235],
              [87.999967, 48.760112],
              [87.999865, 48.760139],
              [87.999606, 48.760223],
              [87.998973, 48.760365],
              [87.998731091000025, 48.760411509999983],
              [87.998094, 48.760534],
              [87.997008, 48.760818],
              [87.995792, 48.761128],
              [87.995133, 48.761219],
              [87.993931, 48.761335],
              [87.992974, 48.7614],
              [87.992147, 48.761451],
              [87.99141, 48.761568],
              [87.990983, 48.761645],
              [87.990013, 48.76193],
              [87.989432, 48.762188],
              [87.988824, 48.762602],
              [87.988074, 48.763158],
              [87.987479, 48.763572],
              [87.987082427000018, 48.763842115999978],
              [87.986626, 48.764153],
              [87.98607, 48.76449],
              [87.985851, 48.76458],
              [87.985618, 48.764593],
              [87.985264981, 48.764580323000018],
              [87.985256, 48.76458],
              [87.984726, 48.764541],
              [87.983433, 48.764451],
              [87.982787, 48.764503],
              [87.982037, 48.764619],
              [87.981106, 48.764916],
              [87.980434, 48.765097],
              [87.980007, 48.765149],
              [87.979542, 48.765123],
              [87.97896, 48.765162],
              [87.978688, 48.765265],
              [87.978339, 48.765446],
              [87.978171, 48.765537],
              [87.977951, 48.765576],
              [87.97768, 48.765614],
              [87.977163, 48.765679],
              [87.976775, 48.765769],
              [87.976607, 48.765834],
              [87.976506878, 48.765902375999985],
              [87.976361, 48.766002],
              [87.976038, 48.766261],
              [87.975818, 48.766403],
              [87.975521, 48.766455],
              [87.975043, 48.766597],
              [87.97459, 48.766855],
              [87.974293, 48.76714],
              [87.974021, 48.767398],
              [87.973685, 48.767618],
              [87.973052, 48.768032],
              [87.97269, 48.76842],
              [87.971927, 48.769286],
              [87.971552, 48.76979],
              [87.970996, 48.770268],
              [87.970634, 48.770411],
              [87.970182, 48.770527],
              [87.969799132, 48.770569723],
              [87.969483, 48.770605],
              [87.968643, 48.770685],
              [87.967596, 48.77085],
              [87.966394, 48.771057],
              [87.965592, 48.771161],
              [87.965359, 48.771161],
              [87.965088, 48.771057],
              [87.964739, 48.77076],
              [87.96439, 48.77054],
              [87.964015, 48.770411],
              [87.963614, 48.770346],
              [87.962748, 48.770437],
              [87.960977, 48.77054],
              [87.960188, 48.770592],
              [87.959606, 48.770411],
              [87.959193, 48.770062],
              [87.958766, 48.769713],
              [87.958029, 48.769221],
              [87.957396, 48.768846],
              [87.957089, 48.76875],
              [87.956943, 48.768704],
              [87.956374, 48.768497],
              [87.955547, 48.76829],
              [87.954745, 48.768071],
              [87.954267, 48.767851],
              [87.953631, 48.767507],
              [87.952819, 48.767127],
              [87.952095, 48.766855],
              [87.951475, 48.766481],
              [87.950906, 48.76608],
              [87.950381, 48.765794],
              [87.949871, 48.765614],
              [87.94907, 48.765317],
              [87.948398, 48.765201],
              [87.947884, 48.765144],
              [87.94742, 48.764979],
              [87.946911, 48.764787],
              [87.946239, 48.764541],
              [87.945625, 48.764339],
              [87.945325, 48.764288],
              [87.945253, 48.764185],
              [87.945305, 48.764009],
              [87.94536, 48.763895],
              [87.945476, 48.763636],
              [87.945541, 48.763248],
              [87.945463, 48.763003],
              [87.94523, 48.76277],
              [87.944944, 48.762596],
              [87.944687, 48.762512],
              [87.944545, 48.762434],
              [87.944532, 48.762343],
              [87.94461, 48.762253],
              [87.944752, 48.762072],
              [87.944765, 48.761904],
              [87.944713, 48.761762],
              [87.94448, 48.761697],
              [87.943989, 48.761555],
              [87.943252, 48.761464],
              [87.94302, 48.761361],
              [87.942968, 48.761206],
              [87.94302, 48.761051],
              [87.943188, 48.760818],
              [87.943188, 48.760585],
              [87.943032, 48.76034],
              [87.9428, 48.76012],
              [87.942205, 48.759797],
              [87.941649, 48.759461],
              [87.940964, 48.758956],
              [87.940331, 48.758607],
              [87.93993, 48.758349],
              [87.939749, 48.758103],
              [87.939193, 48.757793],
              [87.938689, 48.757651],
              [87.93843, 48.757586],
              [87.938146, 48.757483],
              [87.937835, 48.757276],
              [87.93746, 48.757017],
              [87.936956, 48.75672],
              [87.936646, 48.756552],
              [87.936168, 48.756435],
              [87.935883, 48.756125],
              [87.935586, 48.755763],
              [87.935421, 48.7556],
              [87.935194, 48.755446],
              [87.934812, 48.755559],
              [87.934461, 48.755711],
              [87.93353, 48.756073],
              [87.932719701, 48.756446258999972],
              [87.932069, 48.756746],
              [87.93132, 48.757017],
              [87.930841, 48.757133],
              [87.930195, 48.757263],
              [87.929303, 48.75747],
              [87.928359, 48.757845],
              [87.927519, 48.758245],
              [87.926653, 48.758594],
              [87.925864, 48.759099],
              [87.925463, 48.759486],
              [87.925205, 48.759654],
              [87.924843, 48.759797],
              [87.924558, 48.760016],
              [87.924325, 48.760301],
              [87.924132, 48.760753],
              [87.924106, 48.761102],
              [87.924154, 48.76145],
              [87.924071, 48.761698],
              [87.923844, 48.761897],
              [87.923586, 48.7621],
              [87.923149, 48.762343],
              [87.922309, 48.762744],
              [87.921076740999979, 48.763258297999982],
              [87.920512, 48.763494],
              [87.919077, 48.764296],
              [87.919046169000012, 48.764325319000022],
              [87.918547, 48.7648],
              [87.917836, 48.765459],
              [87.917461, 48.765705],
              [87.917112, 48.765782],
              [87.916672, 48.765847],
              [87.916135456, 48.765988772000014],
              [87.915741, 48.766093],
              [87.915211, 48.766364],
              [87.914435, 48.76692],
              [87.913828218999981, 48.767249669000023],
              [87.913673, 48.767334],
              [87.913233, 48.767463],
              [87.913120446999983, 48.767473527],
              [87.912677, 48.767515],
              [87.912302, 48.767554],
              [87.911798, 48.767735],
              [87.91141, 48.767903],
              [87.911230235, 48.768104470000026],
              [87.911087, 48.768265],
              [87.910751, 48.76873],
              [87.909946, 48.769663],
              [87.909255, 48.770344],
              [87.908333, 48.771329],
              [87.907881, 48.771639],
              [87.907364, 48.772091],
              [87.907329, 48.772122],
              [87.907053, 48.772363],
              [87.906834, 48.772557],
              [87.906653, 48.772608],
              [87.90641, 48.772624],
              [87.906098, 48.772645],
              [87.905427, 48.772862],
              [87.904752, 48.773087],
              [87.904148, 48.773126],
              [87.903621, 48.773126],
              [87.903072, 48.773139],
              [87.90295992199998, 48.773145562000025],
              [87.902645, 48.773164],
              [87.902342, 48.773254],
              [87.901973, 48.773488],
              [87.901714, 48.773604],
              [87.901011, 48.773728],
              [87.900563, 48.773888],
              [87.900124, 48.774043],
              [87.899144, 48.77442],
              [87.898508, 48.77469],
              [87.897577, 48.775129],
              [87.896646, 48.775569],
              [87.895198, 48.776435],
              [87.89344, 48.777314],
              [87.893032265999977, 48.777547027000026],
              [87.891811, 48.778245],
              [87.890402, 48.778892],
              [87.889316, 48.779383],
              [87.888967, 48.779719],
              [87.888764, 48.779971],
              [87.888592, 48.780314],
              [87.888437, 48.780495],
              [87.888176, 48.780672],
              [87.887995, 48.780819],
              [87.887868, 48.781076],
              [87.887842, 48.781348],
              [87.887713, 48.781749],
              [87.887648, 48.782305],
              [87.887506, 48.782951],
              [87.887505, 48.782967],
              [87.887454, 48.783662],
              [87.887364, 48.783908],
              [87.887183, 48.784063],
              [87.886756, 48.784477],
              [87.886291, 48.784851],
              [87.885631, 48.785071],
              [87.884882, 48.785407],
              [87.884468, 48.785756],
              [87.88408, 48.786041],
              [87.883498, 48.786248],
              [87.882619, 48.78648],
              [87.881818, 48.786636],
              [87.881326, 48.786739],
              [87.88099, 48.786946],
              [87.880421, 48.787166],
              [87.880072, 48.787243],
              [87.880034109, 48.787248297000019],
              [87.879607, 48.787308],
              [87.879549, 48.78732],
              [87.879103, 48.787411],
              [87.878573, 48.787605],
              [87.878159, 48.787721],
              [87.877694, 48.787825],
              [87.876633, 48.788083],
              [87.876187064000021, 48.788217756999984],
              [87.875948, 48.78829],
              [87.87578, 48.788394],
              [87.875703, 48.78851],
              [87.875651, 48.788691],
              [87.875641, 48.788744],
              [87.875548, 48.78926],
              [87.875328, 48.790204],
              [87.87503, 48.791328],
              [87.874668, 48.79235],
              [87.874474, 48.792919],
              [87.874216, 48.793319],
              [87.873893, 48.793888],
              [87.87366, 48.794418],
              [87.873479, 48.794819],
              [87.873259, 48.794974],
              [87.872936, 48.795078],
              [87.871928, 48.795362],
              [87.871486485, 48.795480293000026],
              [87.870868, 48.795646],
              [87.869988, 48.795814],
              [87.868954, 48.795905],
              [87.867157, 48.796008],
              [87.866136, 48.796047],
              [87.864662, 48.796357],
              [87.863679, 48.79659],
              [87.862839, 48.79681],
              [87.862019615, 48.797280114999978],
              [87.861171, 48.797767],
              [87.860021, 48.798478],
              [87.859379, 48.798831],
              [87.85909, 48.799069],
              [87.858894, 48.799327],
              [87.85874, 48.79976],
              [87.858554, 48.800039],
              [87.858159, 48.800456],
              [87.857849, 48.800779],
              [87.857264, 48.801122],
              [87.856582, 48.801425],
              [87.856457035, 48.801441601000022],
              [87.855897, 48.801516],
              [87.855289, 48.801451],
              [87.854294, 48.801231],
              [87.853621, 48.800869],
              [87.851915, 48.800288],
              [87.850312, 48.799835],
              [87.84929, 48.799706],
              [87.848295, 48.799693],
              [87.847946, 48.799641],
              [87.847739, 48.799486],
              [87.847649, 48.79924],
              [87.847577, 48.798946],
              [87.847558, 48.798866],
              [87.847411, 48.798501],
              [87.847235, 48.798142],
              [87.847067, 48.797883],
              [87.846756, 48.797508],
              [87.84655, 48.796978],
              [87.846252, 48.796603],
              [87.845761, 48.796357],
              [87.845438, 48.796189],
              [87.845192, 48.795905],
              [87.844908, 48.795621],
              [87.844804, 48.79553],
              [87.844597, 48.795608],
              [87.844261, 48.79584],
              [87.843256538, 48.796347837999974],
              [87.843007, 48.796474],
              [87.840991, 48.797431],
              [87.84037, 48.797715],
              [87.840202, 48.797728],
              [87.839949208, 48.797690335000027],
              [87.839853, 48.797676],
              [87.838909, 48.79765],
              [87.837435, 48.797689],
              [87.835677, 48.797754],
              [87.834307, 48.797767],
              [87.833208, 48.797715],
              [87.83238, 48.79778],
              [87.831993, 48.797961],
              [87.831592, 48.798051],
              [87.830892, 48.798078],
              [87.830263, 48.798171],
              [87.829922, 48.798388],
              [87.829717, 48.798633],
              [87.829280260000019, 48.799057178999988],
              [87.829265, 48.799072],
              [87.829006, 48.799215],
              [87.828722, 48.799292],
              [87.828179, 48.799396],
              [87.827407349, 48.799590901999977],
              [87.827209, 48.799641],
              [87.825684, 48.800158],
              [87.82492047, 48.800588573000027],
              [87.824675, 48.800727],
              [87.8239, 48.801283],
              [87.82315, 48.802007],
              [87.822826, 48.802253],
              [87.822374, 48.802472],
              [87.821262, 48.802912],
              [87.820008, 48.80361],
              [87.818327, 48.804399],
              [87.817138, 48.805045],
              [87.816983, 48.805265],
              [87.81688, 48.805575],
              [87.816802, 48.805911],
              [87.816634, 48.806558],
              [87.816453, 48.807101],
              [87.816479, 48.807502],
              [87.816543, 48.807799],
              [87.81675, 48.808213],
              [87.816974, 48.808809],
              [87.817345, 48.809335],
              [87.817582, 48.809665],
              [87.817591, 48.809893],
              [87.817526, 48.809997],
              [87.817242, 48.810165],
              [87.816724, 48.810333],
              [87.815173, 48.810966],
              [87.81357, 48.811716],
              [87.812936, 48.812156],
              [87.812652, 48.812479],
              [87.812484, 48.812841],
              [87.812303, 48.813293],
              [87.812109, 48.813888],
              [87.811902, 48.814289],
              [87.811876, 48.814638],
              [87.811889, 48.814974],
              [87.811967, 48.81531],
              [87.812277, 48.815918],
              [87.812497, 48.816319],
              [87.812497, 48.816461],
              [87.812471, 48.816577],
              [87.812368, 48.816693],
              [87.812225, 48.816732],
              [87.812019, 48.816758],
              [87.811669, 48.816849],
              [87.811062, 48.817004],
              [87.810558, 48.817185],
              [87.810066, 48.817547],
              [87.809704, 48.817896],
              [87.808877, 48.818516],
              [87.808127, 48.819253],
              [87.807933, 48.819395],
              [87.807675, 48.819434],
              [87.807261, 48.819434],
              [87.806459, 48.819434],
              [87.805361, 48.819357],
              [87.804042, 48.81924],
              [87.803577587, 48.81921709400001],
              [87.803008, 48.819189],
              [87.80262, 48.819292],
              [87.802271, 48.819538],
              [87.802051, 48.819861],
              [87.802041461999977, 48.819876180999984],
              [87.801767, 48.820313],
              [87.801327, 48.820662],
              [87.800693, 48.821024],
              [87.79984, 48.82127],
              [87.798832, 48.821373],
              [87.798404651, 48.821429959],
              [87.797474, 48.821554],
              [87.79613, 48.821632],
              [87.794501, 48.821994],
              [87.793699, 48.822278],
              [87.793169, 48.822589],
              [87.792803600000013, 48.822840792000022],
              [87.792381, 48.823132],
              [87.792342, 48.823222],
              [87.792342, 48.823287],
              [87.792445, 48.823326],
              [87.792898, 48.823455],
              [87.793428, 48.823649],
              [87.794178, 48.823933],
              [87.795044, 48.824321],
              [87.795548, 48.824593],
              [87.796013, 48.824864],
              [87.79644, 48.825006],
              [87.796918, 48.825071],
              [87.797862, 48.825123],
              [87.798496, 48.82511],
              [87.799375, 48.8252],
              [87.800151, 48.825213],
              [87.801159, 48.825213],
              [87.801937751000025, 48.825155728000027],
              [87.802206, 48.825136],
              [87.802814, 48.82498],
              [87.803331, 48.824864],
              [87.804197, 48.824631],
              [87.804986, 48.824463],
              [87.805658, 48.824347],
              [87.806103575, 48.824212239000019],
              [87.80664, 48.82405],
              [87.807111, 48.823898],
              [87.807765, 48.823688],
              [87.808218, 48.823662],
              [87.80911, 48.823701],
              [87.810028, 48.823636],
              [87.811101, 48.823442],
              [87.812665, 48.823326],
              [87.813945, 48.823235],
              [87.815044, 48.823235],
              [87.816091, 48.823235],
              [87.816789, 48.823313],
              [87.817552, 48.823403],
              [87.818689, 48.823662],
              [87.819892, 48.823907],
              [87.820926, 48.824101],
              [87.821301, 48.824269],
              [87.821598, 48.824541],
              [87.821973, 48.824929],
              [87.822322, 48.825136],
              [87.822645, 48.825265],
              [87.822762, 48.825407],
              [87.822775, 48.825769],
              [87.822865, 48.825963],
              [87.823279, 48.826131],
              [87.823667, 48.826338],
              [87.823783, 48.826493],
              [87.823835, 48.826493],
              [87.823861, 48.826635],
              [87.823887, 48.826907],
              [87.823951, 48.827062],
              [87.82421, 48.82732],
              [87.824701, 48.827812],
              [87.824714, 48.82798],
              [87.824533, 48.828096],
              [87.824261, 48.828161],
              [87.823925, 48.828161],
              [87.823538, 48.828264],
              [87.822661923, 48.828606386],
              [87.822645, 48.828613],
              [87.821676, 48.828949],
              [87.820836, 48.82935],
              [87.820383, 48.829751],
              [87.820137, 48.829932],
              [87.819788, 48.830048],
              [87.819051, 48.830203],
              [87.818697, 48.830311],
              [87.818457, 48.830552],
              [87.818289, 48.830863],
              [87.818134, 48.831199],
              [87.818126613, 48.831217429],
              [87.817849, 48.83191],
              [87.817526, 48.832556],
              [87.81719, 48.83288],
              [87.817022, 48.833203],
              [87.816892, 48.8335],
              [87.816699, 48.833733],
              [87.81653, 48.833875],
              [87.816168, 48.834017],
              [87.815936, 48.834146],
              [87.815341, 48.83447],
              [87.814578, 48.834961],
              [87.814268, 48.835194],
              [87.814178, 48.835323],
              [87.814165, 48.83553],
              [87.814048, 48.835724],
              [87.81379, 48.836047],
              [87.813286, 48.83668],
              [87.812471, 48.837482],
              [87.812135, 48.83777],
              [87.811928, 48.838193],
              [87.811799, 48.838684],
              [87.811708, 48.839033],
              [87.811579, 48.839318],
              [87.811385, 48.839654],
              [87.811295, 48.839874],
              [87.81132, 48.840171],
              [87.811553, 48.840533],
              [87.812187, 48.841438],
              [87.812704, 48.842162],
              [87.812743, 48.842343],
              [87.812678, 48.842511],
              [87.812484, 48.842601],
              [87.812225, 48.842666],
              [87.811372, 48.842731],
              [87.810973252999986, 48.842721814000015],
              [87.809679, 48.842692],
              [87.80858, 48.842795],
              [87.807894, 48.842912],
              [87.807664446, 48.842978395999978],
              [87.807002, 48.84317],
              [87.805929, 48.843364],
              [87.804404, 48.843752],
              [87.80293, 48.844127],
              [87.801999, 48.844347],
              [87.801443, 48.844411],
              [87.800926, 48.844437],
              [87.800202, 48.844399],
              [87.799401, 48.84445],
              [87.798289, 48.844489],
              [87.798162248999972, 48.844489],
              [87.797552, 48.844489],
              [87.796259, 48.844321],
              [87.795367, 48.844153],
              [87.794372, 48.843985],
              [87.793742, 48.843949],
              [87.793686, 48.843946],
              [87.793234, 48.844024],
              [87.792885, 48.844205],
              [87.792187, 48.84467],
              [87.791788632000021, 48.844987059],
              [87.791359, 48.845329],
              [87.791075, 48.845704],
              [87.790933, 48.846196],
              [87.790894, 48.846493],
              [87.790829, 48.846764],
              [87.790791, 48.847101],
              [87.790765, 48.847734],
              [87.790713, 48.848186],
              [87.790661, 48.848329],
              [87.790506, 48.848561],
              [87.790248, 48.848872],
              [87.790235, 48.848988],
              [87.790235, 48.849053],
              [87.790248, 48.849104],
              [87.790287, 48.849131],
              [87.790403, 48.849208],
              [87.791036, 48.849518],
              [87.791773, 48.84988],
              [87.792458, 48.850281],
              [87.792665, 48.850475],
              [87.792794, 48.850785],
              [87.792859, 48.851057],
              [87.792924, 48.851535],
              [87.792975, 48.852168],
              [87.792924, 48.852556],
              [87.792898, 48.852828],
              [87.792794, 48.85306],
              [87.792549, 48.853345],
              [87.792045, 48.854043],
              [87.791553, 48.854638],
              [87.791334, 48.855077],
              [87.791243, 48.855362],
              [87.79114, 48.855801],
              [87.790933, 48.856228],
              [87.790506, 48.856797],
              [87.789976, 48.857456],
              [87.789575, 48.858025],
              [87.789407, 48.858245],
              [87.789149, 48.85849],
              [87.788929, 48.858671],
              [87.788593, 48.858878],
              [87.787895, 48.859201],
              [87.787328865, 48.859538326],
              [87.787222, 48.859602],
              [87.786589, 48.860106],
              [87.786382, 48.860365],
              [87.78633, 48.860533],
              [87.78633, 48.860701],
              [87.786343, 48.860869],
              [87.786353369999972, 48.860910213000011],
              [87.786421, 48.861179],
              [87.786498, 48.861464],
              [87.786615, 48.861994],
              [87.786757, 48.862472],
              [87.786783, 48.862653],
              [87.786783, 48.862899],
              [87.786783, 48.863468],
              [87.78677, 48.8637],
              [87.786692, 48.863881],
              [87.786524, 48.864166],
              [87.78624, 48.864502],
              [87.785568, 48.86529],
              [87.784326, 48.86657],
              [87.783176, 48.867837],
              [87.782245, 48.86882],
              [87.781586, 48.869453],
              [87.781211, 48.869725],
              [87.781146, 48.869764],
              [87.780836, 48.869764],
              [87.780263564999984, 48.869717993],
              [87.780189, 48.869712],
              [87.779595, 48.869595],
              [87.779181, 48.869518],
              [87.778767, 48.869492],
              [87.777759, 48.869518],
              [87.777397, 48.869544],
              [87.777242, 48.869479],
              [87.777009, 48.86935],
              [87.776544, 48.869169],
              [87.775768, 48.86882],
              [87.774798, 48.86838],
              [87.774036, 48.868044],
              [87.773454, 48.867708],
              [87.772833, 48.867488],
              [87.771928, 48.867217],
              [87.771166, 48.8671],
              [87.770545, 48.866984],
              [87.770118, 48.866945],
              [87.769472, 48.866932],
              [87.769019, 48.866894],
              [87.768632, 48.866777],
              [87.768205, 48.866687],
              [87.767843, 48.866725],
              [87.767391, 48.866803],
              [87.766912, 48.866855],
              [87.76639998600001, 48.866891727],
              [87.766201, 48.866906],
              [87.765859471, 48.866832407],
              [87.765723, 48.866803],
              [87.765219, 48.866725],
              [87.764624, 48.866596],
              [87.763913, 48.866389],
              [87.763117, 48.866276],
              [87.762736, 48.866221],
              [87.761547, 48.866014],
              [87.760629, 48.865795],
              [87.759931, 48.865549],
              [87.759194, 48.865458],
              [87.758742, 48.865458],
              [87.758147, 48.865484],
              [87.757513, 48.865601],
              [87.756893, 48.865782],
              [87.756565837999972, 48.865918513],
              [87.756337, 48.866014],
              [87.755936, 48.866131],
              [87.755639, 48.866182],
              [87.755148, 48.86617],
              [87.754824, 48.866131],
              [87.754333, 48.866053],
              [87.753674, 48.865872],
              [87.753568154, 48.865808083],
              [87.753053, 48.865497],
              [87.752678, 48.865213],
              [87.75242, 48.865058],
              [87.752122, 48.865019],
              [87.751385, 48.864928],
              [87.750817, 48.864903],
              [87.75061, 48.864903],
              [87.750274, 48.864954],
              [87.75008, 48.86498],
              [87.749187, 48.865016],
              [87.748499, 48.865149],
              [87.748052, 48.865233],
              [87.747473, 48.865306],
              [87.746568, 48.865426],
              [87.746338, 48.865535],
              [87.746182, 48.865728],
              [87.745892, 48.86603],
              [87.745626, 48.866235],
              [87.745252, 48.866356],
              [87.744673, 48.866609],
              [87.74452009700002, 48.86669116600001],
              [87.744178, 48.866875],
              [87.743394, 48.867225],
              [87.742754, 48.867514],
              [87.741873, 48.867925],
              [87.741233, 48.868299],
              [87.740871, 48.868661],
              [87.740401, 48.868987],
              [87.740159, 48.869204],
              [87.739966, 48.869397],
              [87.73987, 48.86953],
              [87.739821, 48.869723],
              [87.739773, 48.86994],
              [87.739737, 48.870073],
              [87.739652, 48.870254],
              [87.739556, 48.870471],
              [87.739459, 48.870616],
              [87.739242, 48.870809],
              [87.739001, 48.871171],
              [87.738904, 48.871388],
              [87.738771, 48.871775],
              [87.738578, 48.872052],
              [87.738433, 48.872282],
              [87.738252, 48.872499],
              [87.737999, 48.872752],
              [87.737914, 48.87303],
              [87.737878, 48.873356],
              [87.73783, 48.873645],
              [87.73777, 48.874056],
              [87.737794, 48.874731],
              [87.737745, 48.875045],
              [87.737649, 48.875371],
              [87.737564, 48.875576],
              [87.737613, 48.875818],
              [87.737697, 48.876107],
              [87.737854, 48.876433],
              [87.737999, 48.876928],
              [87.738035, 48.877218],
              [87.737975, 48.877604],
              [87.737939, 48.877894],
              [87.73789, 48.878304],
              [87.737757, 48.878569],
              [87.737601, 48.878799],
              [87.737287, 48.879016],
              [87.736913, 48.879221],
              [87.736502, 48.879462],
              [87.736056, 48.879704],
              [87.735754, 48.879897],
              [87.735344, 48.880066],
              [87.734909, 48.880199],
              [87.734571, 48.880368],
              [87.734499, 48.880452],
              [87.734463, 48.880621],
              [87.734426, 48.880923],
              [87.734402, 48.881345],
              [87.734487, 48.881756],
              [87.734608, 48.882154],
              [87.734909, 48.882806],
              [87.735163, 48.883518],
              [87.735416, 48.883976],
              [87.735766, 48.884314],
              [87.736104, 48.884918],
              [87.736514, 48.885666],
              [87.73684, 48.886547],
              [87.73713, 48.887452],
              [87.737263, 48.887766],
              [87.73742, 48.887995],
              [87.737806, 48.888442],
              [87.737975, 48.888804],
              [87.738083, 48.889238],
              [87.738397, 48.889793],
              [87.738832, 48.8903],
              [87.739495, 48.890892],
              [87.739906, 48.891278],
              [87.740099, 48.89158],
              [87.740473, 48.892328],
              [87.74063, 48.892871],
              [87.740726, 48.893462],
              [87.740763, 48.894235],
              [87.740799, 48.894717],
              [87.740907, 48.894995],
              [87.741185, 48.895236],
              [87.741728, 48.895985],
              [87.742356, 48.896504],
              [87.74314, 48.897023],
              [87.744009, 48.897602],
              [87.744721, 48.898],
              [87.745445, 48.898435],
              [87.746085, 48.898905],
              [87.746387, 48.899328],
              [87.746556, 48.899581],
              [87.746616, 48.899907],
              [87.74664, 48.900366],
              [87.746857, 48.900812],
              [87.747111, 48.901343],
              [87.747111, 48.901524],
              [87.74705, 48.901645],
              [87.746966, 48.901778],
              [87.746857, 48.901995],
              [87.746604, 48.902321],
              [87.746604, 48.902434917999983],
              [87.746604, 48.902478],
              [87.74664, 48.902562],
              [87.746803149000016, 48.902644056999975],
              [87.746809, 48.902647],
              [87.747256, 48.902924],
              [87.747775, 48.903093],
              [87.748088, 48.903323],
              [87.748487, 48.903745],
              [87.749042, 48.904276],
              [87.749199, 48.904397],
              [87.749476, 48.904566],
              [87.749866, 48.904801],
              [87.750076, 48.90494],
              [87.750871, 48.905495],
              [87.750998, 48.905584],
              [87.751656, 48.906064],
              [87.752385, 48.906506],
              [87.752896, 48.906839],
              [87.753346, 48.907095],
              [87.753656, 48.907228],
              [87.753942, 48.907397],
              [87.754059, 48.907606],
              [87.75409, 48.907831],
              [87.754062, 48.908265],
              [87.754059, 48.908745],
              [87.753997, 48.909466],
              [87.753958, 48.909931],
              [87.753842, 48.910132],
              [87.753663, 48.910396],
              [87.753609, 48.910659],
              [87.753477, 48.910961],
              [87.753214, 48.911449],
              [87.752852, 48.912301],
              [87.752439, 48.91327],
              [87.752137, 48.914185],
              [87.752114, 48.914425],
              [87.752191, 48.914526],
              [87.752362, 48.914626],
              [87.752671, 48.914677],
              [87.753183, 48.914812],
              [87.753624, 48.914956],
              [87.75378, 48.915006],
              [87.754717, 48.915169],
              [87.755515, 48.915223],
              [87.75612, 48.915355],
              [87.756662, 48.91544],
              [87.757034, 48.915587],
              [87.757445, 48.915765],
              [87.757824, 48.915889],
              [87.75822, 48.916075],
              [87.758592, 48.916153],
              [87.758971, 48.91623],
              [87.759374, 48.91637],
              [87.759785, 48.916455],
              [87.760165, 48.916509],
              [87.760436, 48.916587],
              [87.760818, 48.916769],
              [87.761218, 48.916959],
              [87.761614, 48.917176],
              [87.762226, 48.91747],
              [87.762791, 48.917641],
              [87.763551, 48.917749],
              [87.76407, 48.91778],
              [87.764465, 48.91792],
              [87.764789, 48.918078],
              [87.764905, 48.918203],
              [87.764931, 48.918327],
              [87.764884, 48.918524],
              [87.764806, 48.918857],
              [87.764721, 48.919113],
              [87.764481, 48.919469],
              [87.76431, 48.919624],
              [87.763923, 48.919834],
              [87.763236, 48.920111],
              [87.763194, 48.920128],
              [87.762481, 48.920461],
              [87.761807, 48.920833],
              [87.761366, 48.921159],
              [87.760947, 48.921531],
              [87.760746, 48.92181],
              [87.760614, 48.922073],
              [87.760506, 48.922398],
              [87.760413, 48.922701],
              [87.760079, 48.923376],
              [87.759616, 48.924115],
              [87.759072, 48.924863],
              [87.758514, 48.925467],
              [87.75796, 48.925949],
              [87.757221, 48.926439],
              [87.756399, 48.926846],
              [87.755728022000028, 48.927142926999977],
              [87.755529, 48.927231],
              [87.754539, 48.927691],
              [87.75422, 48.927863],
              [87.754024, 48.928086],
              [87.753888, 48.928412],
              [87.753842, 48.928675],
              [87.753847096000015, 48.928711985],
              [87.753873, 48.9289],
              [87.754066, 48.929163],
              [87.754368, 48.929589],
              [87.754593, 48.92993],
              [87.754919, 48.930318],
              [87.755164, 48.930499],
              [87.755449, 48.930508],
              [87.755717, 48.930318],
              [87.756081, 48.929985],
              [87.756623, 48.929558],
              [87.757174, 48.929132],
              [87.757545, 48.928985],
              [87.758057, 48.928923],
              [87.758752, 48.92878],
              [87.759413, 48.928652],
              [87.760284, 48.928495],
              [87.761071, 48.928357],
              [87.762133, 48.928218],
              [87.762846, 48.928102],
              [87.763287, 48.928063],
              [87.763574, 48.928063],
              [87.763876, 48.928071],
              [87.764302, 48.928164],
              [87.765046, 48.928357],
              [87.765537, 48.92846],
              [87.765906, 48.928497],
              [87.76624, 48.928474],
              [87.766836, 48.928396],
              [87.767472, 48.928288],
              [87.768068, 48.92821],
              [87.768471, 48.928148],
              [87.76899, 48.928102],
              [87.770013, 48.928009],
              [87.771262, 48.927917],
              [87.772677, 48.927872],
              [87.773473637, 48.927917521999973],
              [87.774112, 48.927954],
              [87.774903, 48.927962],
              [87.775328160000015, 48.927788959],
              [87.77536, 48.927776],
              [87.775678, 48.92752],
              [87.77605, 48.927032],
              [87.776312, 48.926785],
              [87.77646, 48.926645],
              [87.776817, 48.926374],
              [87.777258, 48.926188],
              [87.777917, 48.92604],
              [87.778467, 48.92604],
              [87.779227, 48.926195],
              [87.780133, 48.926521],
              [87.781071, 48.926846],
              [87.782512, 48.927342],
              [87.78376, 48.92773],
              [87.784813, 48.928133],
              [87.785347, 48.928389],
              [87.785907, 48.928733],
              [87.786766, 48.929225],
              [87.787626, 48.929737],
              [87.788626, 48.930341],
              [87.789345, 48.930828],
              [87.790059, 48.93141],
              [87.790803, 48.932139],
              [87.791508, 48.932921],
              [87.792283, 48.933735],
              [87.792835, 48.934212],
              [87.793316, 48.934505],
              [87.793815, 48.934773],
              [87.794287, 48.935155],
              [87.794741, 48.935645],
              [87.795034, 48.93599],
              [87.795321, 48.936478],
              [87.795328, 48.936489],
              [87.795662, 48.936989],
              [87.795995, 48.937431],
              [87.796243, 48.937826],
              [87.796568, 48.93802],
              [87.797103, 48.93826],
              [87.797568, 48.938353],
              [87.798444, 48.938485],
              [87.799164, 48.938671],
              [87.79959, 48.938779],
              [87.800071, 48.938911],
              [87.800096, 48.938923],
              [87.801016, 48.939337],
              [87.801993, 48.939725],
              [87.803119, 48.9402],
              [87.803132, 48.940205],
              [87.8041, 48.940686],
              [87.805255, 48.941228],
              [87.805774, 48.941491],
              [87.806526, 48.941918],
              [87.807238, 48.942352],
              [87.807703, 48.942739],
              [87.808153, 48.94315],
              [87.808548, 48.943591],
              [87.808742, 48.943932],
              [87.808959, 48.94432],
              [87.809067, 48.944614],
              [87.809168, 48.944994],
              [87.8093, 48.945521],
              [87.809447, 48.945862],
              [87.809703, 48.946226],
              [87.80992, 48.946435],
              [87.810113, 48.946567],
              [87.810415, 48.94673],
              [87.810888, 48.946877],
              [87.811121, 48.94704],
              [87.811283, 48.947226],
              [87.811477, 48.94759],
              [87.811779, 48.948093],
              [87.812174, 48.948613],
              [87.81243, 48.948907],
              [87.81267, 48.94907],
              [87.812756, 48.949256],
              [87.812787, 48.949535],
              [87.812833, 48.949814],
              [87.812806421, 48.949970586],
              [87.812787, 48.950085],
              [87.81281, 48.950162],
              [87.812825, 48.950162],
              [87.812973, 48.950193],
              [87.813166, 48.950062],
              [87.813414, 48.949837],
              [87.813732, 48.949633],
              [87.814142, 48.949508],
              [87.814429, 48.949465],
              [87.814925, 48.949418],
              [87.815258, 48.949349],
              [87.815654, 48.94924],
              [87.816072, 48.949039],
              [87.816545, 48.948915],
              [87.817335, 48.948543],
              [87.818095, 48.94831],
              [87.818769, 48.948093],
              [87.819629, 48.947838],
              [87.82052, 48.947388],
              [87.821713, 48.946978],
              [87.822023, 48.946838],
              [87.822341, 48.946598],
              [87.822566, 48.946435],
              [87.822775, 48.946226],
              [87.822862591999979, 48.946185811000021],
              [87.822945, 48.946148],
              [87.823255, 48.946087],
              [87.823635, 48.946056],
              [87.824696, 48.945947],
              [87.825378, 48.945939],
              [87.8262, 48.946063],
              [87.826372, 48.94607],
              [87.826944, 48.946094],
              [87.827246, 48.946048],
              [87.82761, 48.945823],
              [87.828145, 48.945591],
              [87.828734, 48.945389],
              [87.829137, 48.945273],
              [87.829346, 48.945273],
              [87.82978, 48.945319],
              [87.830152, 48.945397],
              [87.830927, 48.945529],
              [87.831585, 48.945653],
              [87.832019, 48.945676],
              [87.832693, 48.945738],
              [87.833251, 48.945808],
              [87.833949, 48.945862],
              [87.834297, 48.945908],
              [87.834801, 48.946025],
              [87.835086527999977, 48.946176687],
              [87.835281, 48.94628],
              [87.836025, 48.946544],
              [87.836521, 48.946668],
              [87.836971, 48.946768],
              [87.83742, 48.946799],
              [87.837885, 48.946753],
              [87.838528, 48.946575],
              [87.838877, 48.946358],
              [87.839079566, 48.946292782],
              [87.839551, 48.946141],
              [87.840117, 48.945978],
              [87.840597, 48.945986],
              [87.841488, 48.945932],
              [87.842317, 48.946001],
              [87.842813, 48.946056],
              [87.843449, 48.946063],
              [87.84427, 48.946009],
              [87.845169, 48.946071],
              [87.846083, 48.946303],
              [87.846943, 48.946489],
              [87.847641, 48.94652],
              [87.848137, 48.946513],
              [87.848578, 48.946412],
              [87.849097, 48.946296],
              [87.849485, 48.946125],
              [87.849934, 48.945831],
              [87.8505, 48.945505],
              [87.850717, 48.945265],
              [87.850833, 48.945226],
              [87.850942, 48.945288],
              [87.85119, 48.945451],
              [87.8516, 48.945684],
              [87.851933, 48.945916],
              [87.852507, 48.946164],
              [87.853018, 48.946396],
              [87.853754, 48.946768],
              [87.854188, 48.946939],
              [87.854824, 48.947102],
              [87.85532, 48.947148],
              [87.855816, 48.947202],
              [87.856374, 48.947295],
              [87.857086, 48.947326],
              [87.857823, 48.947357],
              [87.858535, 48.947427],
              [87.859039, 48.947443],
              [87.859489, 48.947512],
              [87.860101, 48.947621],
              [87.86086, 48.947582],
              [87.861356, 48.947466],
              [87.861891, 48.947257],
              [87.86203, 48.947233],
              [87.862201, 48.947365],
              [87.862557, 48.947567],
              [87.862975, 48.947629],
              [87.86375, 48.947869],
              [87.864386, 48.948008],
              [87.864998, 48.948148],
              [87.865641, 48.948303],
              [87.866005, 48.948326],
              [87.866416, 48.948334],
              [87.867354, 48.948272],
              [87.868105, 48.948194],
              [87.868268, 48.948217],
              [87.868462, 48.948287],
              [87.86871, 48.948442],
              [87.869027, 48.948659],
              [87.869275, 48.94883],
              [87.86967, 48.94907],
              [87.870221, 48.949395],
              [87.870461, 48.949628],
              [87.870693, 48.950007],
              [87.870941, 48.950449],
              [87.871189, 48.950945],
              [87.871321, 48.95134],
              [87.871321, 48.951565],
              [87.871274, 48.951813],
              [87.871205, 48.952188],
              [87.871081, 48.95265],
              [87.870933, 48.953084],
              [87.870794, 48.953502],
              [87.870616, 48.953913],
              [87.870386, 48.95428],
              [87.870146, 48.954663],
              [87.869818, 48.95499],
              [87.869523, 48.9553],
              [87.869198, 48.955579],
              [87.868888, 48.955827],
              [87.868462, 48.95602],
              [87.868082, 48.956183],
              [87.867478, 48.956408],
              [87.867268, 48.956516],
              [87.867168, 48.956656],
              [87.867129, 48.956842],
              [87.867129, 48.957012],
              [87.867222, 48.9575],
              [87.86723, 48.957857],
              [87.867106, 48.958082],
              [87.866982, 48.958221],
              [87.866796, 48.958454],
              [87.866641, 48.958647],
              [87.866447, 48.958857],
              [87.866292, 48.959104],
              [87.866292, 48.959275],
              [87.866323, 48.959438],
              [87.866377, 48.959647],
              [87.86654, 48.959903],
              [87.86671, 48.960151],
              [87.867098, 48.960546],
              [87.867284, 48.960825],
              [87.867377, 48.961096],
              [87.867416, 48.961305],
              [87.867408, 48.9617],
              [87.867379, 48.962028],
              [87.867346, 48.962405],
              [87.867361, 48.962777],
              [87.86754, 48.963304],
              [87.867811, 48.963777],
              [87.867942, 48.964102],
              [87.867935, 48.964412],
              [87.867911, 48.964715],
              [87.867764, 48.964939],
              [87.867516, 48.965265],
              [87.867245, 48.965699],
              [87.866976, 48.966042],
              [87.866726, 48.966419],
              [87.866679, 48.966706],
              [87.866703, 48.966946],
              [87.866762, 48.967627],
              [87.866887, 48.968108],
              [87.867021, 48.968419],
              [87.867234, 48.968606],
              [87.867462, 48.968728],
              [87.868004, 48.969108],
              [87.868446, 48.969364],
              [87.868779, 48.969449],
              [87.869329, 48.969496],
              [87.870089, 48.969573],
              [87.870562, 48.969651],
              [87.870949, 48.969767],
              [87.871259, 48.969875],
              [87.871685, 48.970023],
              [87.872204, 48.970263],
              [87.872747, 48.97041],
              [87.87301, 48.97048],
              [87.873281, 48.970472],
              [87.873553, 48.970464],
              [87.874048, 48.970565],
              [87.874389, 48.970828],
              [87.874862, 48.971239],
              [87.875304, 48.971665],
              [87.875699, 48.972091],
              [87.876117, 48.972502],
              [87.876505, 48.97275],
              [87.87697, 48.972975],
              [87.877931, 48.973564],
              [87.878892, 48.974191],
              [87.879279, 48.974563],
              [87.87948, 48.974827],
              [87.879759, 48.974966],
              [87.880131, 48.975067],
              [87.880441, 48.975152],
              [87.880462, 48.975162],
              [87.880728, 48.975284],
              [87.880984, 48.975416],
              [87.881177, 48.975485],
              [87.881348, 48.975509],
              [87.881743, 48.975555],
              [87.882161, 48.975532],
              [87.883014, 48.975377],
              [87.884083, 48.975245],
              [87.885067, 48.975121],
              [87.885842, 48.975013],
              [87.886547, 48.974982],
              [87.887059, 48.975013],
              [87.888027, 48.97509],
              [87.88874, 48.975144],
              [87.889097, 48.975175],
              [87.889368, 48.975261],
              [87.889748, 48.975416],
              [87.890298, 48.97564],
              [87.89091, 48.975927],
              [87.891313, 48.976105],
              [87.891987, 48.976229],
              [87.892382, 48.976299],
              [87.893118997999977, 48.976347475000011],
              [87.893203, 48.976353],
              [87.893686058000014, 48.976349395],
              [87.894141, 48.976346],
              [87.89497, 48.976322],
              [87.895443, 48.976369],
              [87.895869, 48.976431],
              [87.896225, 48.976566],
              [87.896543, 48.976756],
              [87.896839, 48.977092],
              [87.897047, 48.977407],
              [87.897318, 48.977895],
              [87.897496, 48.978283],
              [87.897551, 48.978438],
              [87.897605, 48.978507],
              [87.897938, 48.978639],
              [87.898457, 48.978848],
              [87.898842, 48.979095],
              [87.8991, 48.97943],
              [87.899217, 48.979693],
              [87.899279, 48.979856],
              [87.899302, 48.980088],
              [87.899286, 48.980251],
              [87.899271, 48.980468],
              [87.899302, 48.980894],
              [87.89955, 48.981188],
              [87.899844, 48.981343],
              [87.90034, 48.981498],
              [87.900676, 48.981659],
              [87.900899, 48.981926],
              [87.900961, 48.982131],
              [87.900999, 48.982366],
              [87.90089, 48.982552],
              [87.900596, 48.982808],
              [87.900278, 48.98304],
              [87.899774, 48.983498],
              [87.899581, 48.983746],
              [87.899527, 48.983947],
              [87.899565, 48.984195],
              [87.899565, 48.984311],
              [87.899627, 48.984474],
              [87.899627, 48.98459],
              [87.899434, 48.984768],
              [87.899031, 48.984978],
              [87.898318, 48.985427],
              [87.897923, 48.985815],
              [87.897613, 48.986287],
              [87.897496, 48.986535],
              [87.897427, 48.986589],
              [87.897233, 48.986644],
              [87.896977, 48.986644],
              [87.896504, 48.986605],
              [87.895908, 48.98645],
              [87.895858526999973, 48.986438126999985],
              [87.894908, 48.98621],
              [87.893754, 48.986016],
              [87.892684, 48.985985],
              [87.891987, 48.986062],
              [87.891167, 48.986129],
              [87.890181, 48.986248],
              [87.889624, 48.986357],
              [87.889221, 48.986411],
              [87.88867, 48.986427],
              [87.888144, 48.98645],
              [87.887641, 48.986521],
              [87.887437, 48.98661],
              [87.887267, 48.986797],
              [87.88708, 48.987179],
              [87.886787, 48.987402],
              [87.886279, 48.987812],
              [87.886155729, 48.987932179999973],
              [87.885641, 48.988434],
              [87.885005, 48.98879],
              [87.884872, 48.988833],
              [87.884494, 48.988953],
              [87.883905, 48.989092],
              [87.883332, 48.989272],
              [87.882887, 48.989486],
              [87.882504, 48.989664],
              [87.882154, 48.989751],
              [87.881596, 48.989859],
              [87.88117, 48.990038],
              [87.880581, 48.990332],
              [87.880248, 48.990448],
              [87.879504, 48.990572],
              [87.878713, 48.990673],
              [87.877644, 48.990851],
              [87.877617980000025, 48.990857111000025],
              [87.876226, 48.991184],
              [87.874707, 48.991533],
              [87.873669, 48.991843],
              [87.873173, 48.992052],
              [87.872603, 48.992477],
              [87.872078, 48.992878],
              [87.872072275, 48.992883348000021],
              [87.871577, 48.993346],
              [87.87081, 48.994044],
              [87.870484, 48.994237],
              [87.87029, 48.994408],
              [87.870097, 48.994633],
              [87.869934, 48.994834],
              [87.869787, 48.995028],
              [87.869616, 48.995183],
              [87.869515, 48.995369],
              [87.869484, 48.995555],
              [87.869422, 48.995756],
              [87.869384, 48.99602],
              [87.869283, 48.996237],
              [87.869058, 48.996624],
              [87.868934, 48.996996],
              [87.868965, 48.997221],
              [87.869058, 48.997383],
              [87.869322, 48.997484],
              [87.869942, 48.997616],
              [87.870538, 48.997817],
              [87.870933, 48.997965],
              [87.871778, 48.998306],
              [87.872514, 48.998515],
              [87.873243, 48.99874],
              [87.874103, 48.999212],
              [87.874242, 48.99929],
              [87.874273, 48.999406],
              [87.87432, 48.999553],
              [87.874304, 48.999731],
              [87.874234, 48.999871],
              [87.873987, 49.00001],
              [87.873436, 49.000165],
              [87.873219, 49.000212],
              [87.872762, 49.000382],
              [87.872491, 49.000607],
              [87.871995, 49.000963],
              [87.871863319, 49.001040521999983],
              [87.871375, 49.001328],
              [87.870453, 49.001924],
              [87.869686, 49.002513],
              [87.86943, 49.002823],
              [87.86912, 49.003497],
              [87.869035, 49.003892],
              [87.869035, 49.004505],
              [87.869167, 49.005109],
              [87.869226527000023, 49.005363917000011],
              [87.869252, 49.005473],
              [87.869616, 49.005954],
              [87.869957, 49.006481],
              [87.870244, 49.006961],
              [87.870554, 49.007449],
              [87.870988, 49.007868],
              [87.87167, 49.008371],
              [87.872406, 49.008797],
              [87.872894, 49.009162],
              [87.872906, 49.009179],
              [87.873072, 49.009417],
              [87.873243, 49.009727],
              [87.873374, 49.010053],
              [87.873622, 49.010649],
              [87.873994, 49.011293],
              [87.874258, 49.01175],
              [87.87456, 49.012261],
              [87.875157, 49.013082],
              [87.875668, 49.013633],
              [87.876179, 49.014121],
              [87.87666, 49.014431],
              [87.877024, 49.014594],
              [87.877644, 49.014749],
              [87.87821, 49.014872],
              [87.878938, 49.015051],
              [87.87979, 49.015206],
              [87.880248, 49.015322],
              [87.880658, 49.015423],
              [87.881115, 49.015647],
              [87.88165, 49.015981],
              [87.881968, 49.016322],
              [87.882456, 49.016848],
              [87.882735, 49.017306],
              [87.882743, 49.017592],
              [87.882735, 49.017864],
              [87.882642, 49.018197],
              [87.882495, 49.018375],
              [87.882216, 49.018561],
              [87.881805, 49.0187],
              [87.880759, 49.018793],
              [87.880038, 49.01885],
              [87.879457, 49.01901],
              [87.878574, 49.019328],
              [87.877780185, 49.019687189000024],
              [87.877427, 49.019847],
              [87.877037, 49.019998],
              [87.876722, 49.020204],
              [87.876703716, 49.020256491999987],
              [87.87666, 49.020382],
              [87.87666, 49.020645],
              [87.876714, 49.02101],
              [87.876768, 49.021591],
              [87.876745, 49.021839],
              [87.876575, 49.022118],
              [87.876466, 49.022304],
              [87.876195, 49.022606],
              [87.875714, 49.023009],
              [87.874947, 49.023644],
              [87.874186888, 49.024066173999984],
              [87.87418, 49.02407],
              [87.873429, 49.024427],
              [87.872863, 49.024574],
              [87.87215, 49.024613],
              [87.871623, 49.024682],
              [87.870848, 49.024806],
              [87.870143, 49.024977],
              [87.869314, 49.025],
              [87.86857, 49.024992],
              [87.867935, 49.024884],
              [87.867253, 49.024822],
              [87.866865, 49.024868],
              [87.866408, 49.024946],
              [87.865866, 49.024954],
              [87.864099, 49.024915],
              [87.863371, 49.024946],
              [87.863231, 49.025023],
              [87.863099, 49.025109],
              [87.862906, 49.025543],
              [87.862740841, 49.025810416000013],
              [87.862394, 49.026372],
              [87.862046, 49.0271],
              [87.861813, 49.027898],
              [87.861743, 49.028301],
              [87.861743, 49.028572],
              [87.861829, 49.028782],
              [87.86203, 49.02903],
              [87.862162, 49.029231],
              [87.86217, 49.029401],
              [87.862131, 49.029533],
              [87.861929, 49.029742],
              [87.861681, 49.029959],
              [87.861411, 49.030353],
              [87.861193, 49.030688],
              [87.861131704, 49.030802666999989],
              [87.860961, 49.031122],
              [87.860511, 49.031587],
              [87.860225, 49.031842],
              [87.860217, 49.03199],
              [87.860325, 49.032129],
              [87.860496, 49.032323],
              [87.860628, 49.032555],
              [87.860628, 49.032749],
              [87.860619660999987, 49.03284288499998],
              [87.860597, 49.033098],
              [87.860519, 49.033493],
              [87.860364, 49.033803],
              [87.860155, 49.034151],
              [87.860090222, 49.034252007000021],
              [87.859767, 49.034756],
              [87.859341, 49.035229],
              [87.859279, 49.035376],
              [87.859318, 49.035732],
              [87.859357, 49.036096],
              [87.85931, 49.036313],
              [87.859086, 49.036623],
              [87.858528, 49.036949],
              [87.858132, 49.036972],
              [87.857869, 49.036848],
              [87.857528, 49.036763],
              [87.85704, 49.036778],
              [87.85659, 49.036778],
              [87.856102, 49.036864],
              [87.855467, 49.037088],
              [87.854692, 49.03722],
              [87.854103, 49.037243],
              [87.853398, 49.037205],
              [87.852763, 49.037003],
              [87.852189, 49.036701],
              [87.8516, 49.036453],
              [87.850942, 49.036228],
              [87.850914, 49.03622],
              [87.850368, 49.03605],
              [87.849624, 49.035833],
              [87.848888, 49.03574],
              [87.848307, 49.035686],
              [87.84792, 49.035709],
              [87.847315, 49.035841],
              [87.846928, 49.035988],
              [87.846494, 49.03612],
              [87.846129517, 49.036195846],
              [87.845975, 49.036228],
              [87.845409, 49.036259],
              [87.844871373999979, 49.036265091000018],
              [87.843379, 49.036282],
              [87.841899, 49.03636],
              [87.841566, 49.036414],
              [87.840938, 49.036569],
              [87.840581, 49.036701],
              [87.840124, 49.03691],
              [87.839559, 49.037204],
              [87.838536, 49.037786],
              [87.838032, 49.037995],
              [87.837699, 49.038049],
              [87.837389, 49.038049],
              [87.837087, 49.038034],
              [87.836529, 49.037987],
              [87.836157, 49.037925],
              [87.836002, 49.037925],
              [87.835917, 49.037979],
              [87.8357, 49.038142],
              [87.83546, 49.038351],
              [87.835258, 49.038506],
              [87.834809, 49.038824],
              [87.834189, 49.039281],
              [87.833763, 49.039529],
              [87.833336, 49.039769],
              [87.832469, 49.040172],
              [87.831345, 49.040815],
              [87.830772, 49.041211],
              [87.830446, 49.041552],
              [87.830307, 49.0418],
              [87.830200688, 49.042071782999983],
              [87.830183, 49.042117],
              [87.830113, 49.042288],
              [87.829997, 49.042396],
              [87.829857, 49.042551],
              [87.829594, 49.042737],
              [87.829323, 49.042954],
              [87.828974, 49.043396],
              [87.828865, 49.043667],
              [87.828811, 49.043837],
              [87.82878, 49.044054],
              [87.828834, 49.044217],
              [87.828974, 49.044457],
              [87.829051, 49.044674],
              [87.829082, 49.045008],
              [87.829082, 49.045217],
              [87.828958, 49.045457],
              [87.828803, 49.045635],
              [87.828625, 49.045883],
              [87.82847, 49.046178],
              [87.828462, 49.046596],
              [87.828462, 49.046898],
              [87.828462, 49.047255],
              [87.828292, 49.047464],
              [87.82809, 49.04772],
              [87.82785, 49.047867],
              [87.827378, 49.048115],
              [87.826981994999983, 49.048284995000017],
              [87.826471, 49.048587],
              [87.826076, 49.048928],
              [87.826037, 49.049076],
              [87.826037, 49.049176],
              [87.826071576, 49.049258451000014],
              [87.826076, 49.049269],
              [87.826229, 49.049395],
              [87.826466, 49.049601],
              [87.826593, 49.049727],
              [87.826635, 49.04988],
              [87.826821, 49.050284],
              [87.827043, 49.050504],
              [87.827268, 49.05096],
              [87.827366, 49.05108],
              [87.82754, 49.051222],
              [87.827911, 49.051472],
              [87.828326, 49.051756],
              [87.828888, 49.052008],
              [87.829732, 49.052522],
              [87.830188, 49.052702],
              [87.830845, 49.052955],
              [87.83113, 49.053241],
              [87.831227, 49.053337],
              [87.831474, 49.053557],
              [87.83163, 49.053828],
              [87.831761, 49.05411],
              [87.831772, 49.054504],
              [87.831816, 49.054832],
              [87.831794, 49.054995],
              [87.831739, 49.055152],
              [87.831729, 49.055181],
              [87.831607, 49.055313],
              [87.831591, 49.055365],
              [87.831514, 49.055451],
              [87.831395, 49.055635],
              [87.831251, 49.055854],
              [87.831254, 49.056083],
              [87.831381, 49.056391],
              [87.831648, 49.056698],
              [87.831806, 49.056777],
              [87.832059, 49.056832],
              [87.832393, 49.057002],
              [87.832568, 49.057099],
              [87.832797, 49.057228],
              [87.832983, 49.057364],
              [87.833133, 49.057506],
              [87.833171, 49.057688],
              [87.833208, 49.057831],
              [87.83323, 49.058089],
              [87.83332, 49.05826],
              [87.833472, 49.058505],
              [87.833829, 49.059023],
              [87.834068, 49.059284],
              [87.834763, 49.059703],
              [87.835606, 49.060097],
              [87.83658, 49.060542],
              [87.837308, 49.06084],
              [87.837694, 49.061009],
              [87.838161, 49.061315],
              [87.838573, 49.061472],
              [87.839152, 49.061726],
              [87.839851, 49.061875],
              [87.840707, 49.062006],
              [87.84139, 49.062224],
              [87.842079, 49.062311],
              [87.842646, 49.062335],
              [87.843675, 49.062465],
              [87.844939, 49.062519],
              [87.845574, 49.062463],
              [87.846409, 49.062428],
              [87.848038, 49.062427],
              [87.848647, 49.062412],
              [87.849242, 49.062545],
              [87.849575, 49.062651],
              [87.849875, 49.062906],
              [87.850177, 49.063219],
              [87.850547, 49.063519],
              [87.850822, 49.063781],
              [87.851087, 49.064013],
              [87.851159, 49.064121],
              [87.851205, 49.06427],
              [87.851217, 49.06447],
              [87.851185, 49.064636],
              [87.851136, 49.064837],
              [87.851051, 49.064981],
              [87.851031, 49.065324],
              [87.851105, 49.065593],
              [87.851143, 49.065747],
              [87.851084, 49.065862],
              [87.850972, 49.065954],
              [87.850939, 49.066052],
              [87.850862, 49.066104],
              [87.850767, 49.066196],
              [87.850719, 49.066437],
              [87.850729, 49.066517],
              [87.850748, 49.066602],
              [87.850828, 49.066676],
              [87.850838, 49.066779],
              [87.85105, 49.066938],
              [87.851157, 49.067097],
              [87.851168, 49.067195],
              [87.851162, 49.067372],
              [87.851164, 49.067521],
              [87.851175, 49.067612],
              [87.851367, 49.067645],
              [87.85157, 49.067755],
              [87.851633, 49.067853],
              [87.851699, 49.068029],
              [87.851894, 49.068157],
              [87.852145, 49.068315],
              [87.85276, 49.068636],
              [87.85298, 49.068784],
              [87.853069, 49.06888],
              [87.853097, 49.068994],
              [87.853048, 49.069201],
              [87.853051, 49.069338],
              [87.852984, 49.069487],
              [87.852969, 49.069631],
              [87.853023, 49.069739],
              [87.853181, 49.069824],
              [87.85348, 49.069959],
              [87.85388, 49.07009],
              [87.854154, 49.070188],
              [87.854338, 49.070244],
              [87.854435, 49.070312],
              [87.854436, 49.070347],
              [87.854392, 49.07037],
              [87.854245, 49.070434],
              [87.854159, 49.070475],
              [87.853969, 49.07055],
              [87.853634, 49.070839],
              [87.85281, 49.071532],
              [87.852321, 49.072005],
              [87.852169, 49.072292],
              [87.85212, 49.072487],
              [87.852092, 49.072915],
              [87.852067, 49.073449],
              [87.852033, 49.074016],
              [87.851895, 49.074617],
              [87.851839, 49.074868],
              [87.8518, 49.075133],
              [87.851716, 49.075323],
              [87.851571, 49.075496],
              [87.85127, 49.075738],
              [87.850961, 49.076009],
              [87.850591, 49.076252],
              [87.850163, 49.076736],
              [87.8497, 49.07714],
              [87.849381, 49.077337],
              [87.848834, 49.077433],
              [87.848789113, 49.077445247000014],
              [87.848079, 49.077639],
              [87.847335, 49.077907],
              [87.846757, 49.078261],
              [87.846463, 49.078372],
              [87.846106, 49.078403],
              [87.845747, 49.078325],
              [87.845458, 49.078196],
              [87.845053, 49.077964],
              [87.844851, 49.07784],
              [87.844755, 49.077829],
              [87.844685, 49.07783],
              [87.844537, 49.077848],
              [87.84433, 49.077941],
              [87.844103, 49.077943],
              [87.843848, 49.077824],
              [87.843628, 49.077689],
              [87.843366, 49.077628],
              [87.842966, 49.077648],
              [87.842471, 49.07776],
              [87.841838, 49.077936],
              [87.841475, 49.078015],
              [87.841135, 49.078089],
              [87.840579, 49.078196],
              [87.840258, 49.078227],
              [87.840138, 49.078303],
              [87.840083, 49.078415],
              [87.840012, 49.078648],
              [87.839939, 49.07898],
              [87.839821, 49.079239],
              [87.839693687000022, 49.079369288],
              [87.839607, 49.079458],
              [87.839247, 49.079821],
              [87.839016, 49.080034],
              [87.838688, 49.080237],
              [87.838212, 49.080429],
              [87.83752, 49.080686],
              [87.837243, 49.08082],
              [87.836943, 49.081097],
              [87.836617, 49.081425],
              [87.836405, 49.081764],
              [87.8362, 49.082077],
              [87.836146, 49.082295],
              [87.836037, 49.082524],
              [87.835822, 49.082757],
              [87.835677, 49.082949],
              [87.835567, 49.083213],
              [87.835561, 49.083367],
              [87.835588, 49.083459],
              [87.835747, 49.083572],
              [87.835802, 49.083697],
              [87.835856, 49.083806],
              [87.835864, 49.084095],
              [87.835786, 49.08452],
              [87.835764, 49.084913],
              [87.835856, 49.085368],
              [87.835875, 49.085454],
              [87.835929, 49.085585],
              [87.83594, 49.085739],
              [87.836091, 49.085864],
              [87.836188, 49.085967],
              [87.836314, 49.086217],
              [87.836334, 49.086332],
              [87.836337, 49.086549],
              [87.836339, 49.086664],
              [87.836341, 49.086795],
              [87.836157, 49.08705],
              [87.83603, 49.087275],
              [87.835906, 49.087487],
              [87.835742, 49.087639],
              [87.835496, 49.087831],
              [87.835419, 49.087918],
              [87.835256, 49.088079],
              [87.83511, 49.088189],
              [87.834965, 49.088339],
              [87.834948, 49.088408],
              [87.834898, 49.088505],
              [87.834899, 49.088574],
              [87.834936, 49.088728],
              [87.835027, 49.088945],
              [87.835214, 49.089161],
              [87.835547, 49.089313],
              [87.836013, 49.089568],
              [87.836321, 49.089731],
              [87.836719, 49.090077],
              [87.837011, 49.090362],
              [87.837226, 49.09068],
              [87.837403, 49.090879],
              [87.837458, 49.091016],
              [87.837514, 49.091233],
              [87.837622, 49.091422],
              [87.837667, 49.091536],
              [87.837792, 49.091678],
              [87.837995, 49.091825],
              [87.838145, 49.091973],
              [87.838261, 49.092109],
              [87.838343, 49.092315],
              [87.838531, 49.092622],
              [87.838685, 49.092959],
              [87.838734, 49.093285],
              [87.838711, 49.093474],
              [87.838592, 49.093692],
              [87.838551, 49.093813],
              [87.838536, 49.09395],
              [87.838486, 49.094088],
              [87.838367, 49.094272],
              [87.838344, 49.094444],
              [87.838366, 49.094718],
              [87.838501, 49.094981],
              [87.838635, 49.095214],
              [87.838923, 49.095756],
              [87.839005, 49.095933],
              [87.839155, 49.096063],
              [87.839375, 49.09617],
              [87.839954, 49.096418],
              [87.84069, 49.09663],
              [87.841512, 49.096778],
              [87.842236, 49.096865],
              [87.842943, 49.096877],
              [87.843823, 49.096893],
              [87.844555, 49.096882],
              [87.845477, 49.096801],
              [87.845955, 49.096712],
              [87.846484, 49.096576],
              [87.846961, 49.096384],
              [87.847064, 49.09632],
              [87.84722, 49.096239],
              [87.847416, 49.096009],
              [87.847553, 49.095836],
              [87.847724, 49.095691],
              [87.847785, 49.095662],
              [87.847898, 49.095639],
              [87.848003, 49.095667],
              [87.848117, 49.095746],
              [87.848302, 49.095836],
              [87.848645, 49.096034],
              [87.849042, 49.096222],
              [87.849085, 49.096242],
              [87.850103, 49.096664],
              [87.850936, 49.096956],
              [87.851714, 49.097133],
              [87.852134, 49.097239],
              [87.852431, 49.097259],
              [87.852659, 49.097326],
              [87.852801, 49.097463],
              [87.853033, 49.097776],
              [87.853411, 49.098252],
              [87.853761, 49.098577],
              [87.854246, 49.098917],
              [87.854884, 49.099331],
              [87.855574, 49.100126],
              [87.855713, 49.100363],
              [87.855854, 49.100596],
              [87.855898, 49.100695],
              [87.855856, 49.100805],
              [87.855704, 49.101058],
              [87.855545, 49.101443],
              [87.855395, 49.101861],
              [87.8554, 49.102188],
              [87.855402, 49.102296],
              [87.855553, 49.10245],
              [87.855897, 49.102693],
              [87.856373, 49.102999],
              [87.856476, 49.103171],
              [87.856528, 49.103381],
              [87.856478, 49.103496],
              [87.856427, 49.103599],
              [87.856227, 49.103647],
              [87.856151, 49.10375],
              [87.856004, 49.103848],
              [87.855971, 49.103946],
              [87.855972, 49.10402],
              [87.856062, 49.104157],
              [87.856151, 49.104294],
              [87.856216, 49.104499],
              [87.85636, 49.104744],
              [87.856277, 49.10502],
              [87.856332, 49.105151],
              [87.856342, 49.105265],
              [87.856413, 49.105339],
              [87.856615, 49.105412],
              [87.85687, 49.105519],
              [87.857257, 49.105739],
              [87.857723, 49.105936],
              [87.858198, 49.106213],
              [87.858305, 49.106367],
              [87.85858, 49.106651],
              [87.858925, 49.106906],
              [87.859293, 49.107046],
              [87.859898, 49.107225],
              [87.860529, 49.107415],
              [87.860908, 49.107669],
              [87.861181, 49.107862],
              [87.861489, 49.108014],
              [87.861875, 49.10812],
              [87.862268, 49.108203],
              [87.862497, 49.10831],
              [87.862708, 49.108411],
              [87.862953, 49.108467],
              [87.863285, 49.108544],
              [87.863785, 49.108724],
              [87.864122, 49.109024],
              [87.864229, 49.109144],
              [87.86423, 49.109253],
              [87.864206, 49.109373],
              [87.864175, 49.109591],
              [87.864213, 49.109733],
              [87.86424, 49.109808],
              [87.864416, 49.109886],
              [87.864652, 49.109925],
              [87.86516, 49.11007],
              [87.865583, 49.110313],
              [87.865832, 49.110637],
              [87.865977, 49.110922],
              [87.866085, 49.11111],
              [87.866263, 49.111326],
              [87.866363, 49.1116],
              [87.866366, 49.111766],
              [87.866318, 49.111967],
              [87.866269, 49.112167],
              [87.866085, 49.112507],
              [87.865845, 49.113052],
              [87.865703, 49.113488],
              [87.865616, 49.11375],
              [87.865627, 49.113925],
              [87.865717, 49.114043],
              [87.865832, 49.114105],
              [87.866176, 49.114337],
              [87.866442, 49.11461],
              [87.866472, 49.114816],
              [87.866444, 49.115222],
              [87.866335, 49.115486],
              [87.866175, 49.115814],
              [87.865981, 49.116158],
              [87.865771, 49.116658],
              [87.865572, 49.117077],
              [87.865459, 49.117244],
              [87.865261, 49.117377],
              [87.865105, 49.117413],
              [87.864817, 49.11742],
              [87.864660406999974, 49.117413313999975],
              [87.864372, 49.117401],
              [87.86391, 49.117399],
              [87.863152, 49.117456],
              [87.862528, 49.117649],
              [87.862085, 49.117738],
              [87.861691, 49.117673],
              [87.861141, 49.117614],
              [87.859999, 49.117617],
              [87.858936, 49.117648],
              [87.858293, 49.117755],
              [87.857364, 49.118008],
              [87.856113, 49.118247],
              [87.855138, 49.11834],
              [87.853989, 49.118309],
              [87.853509, 49.118255],
              [87.853346, 49.118287],
              [87.853237, 49.118407],
              [87.853259, 49.118604],
              [87.853262, 49.118788],
              [87.853231, 49.118995],
              [87.853086, 49.119225],
              [87.852904, 49.119283],
              [87.852734, 49.11949],
              [87.852398, 49.119773],
              [87.852223251999987, 49.120005470000024],
              [87.852177, 49.120067],
              [87.852014, 49.120246],
              [87.851982, 49.1204],
              [87.851994, 49.120606],
              [87.852007, 49.120875],
              [87.851854, 49.121077],
              [87.851571, 49.121353],
              [87.851099, 49.121797],
              [87.850599, 49.12211],
              [87.850055, 49.122469],
              [87.849763, 49.122723],
              [87.849605, 49.122912],
              [87.849516, 49.123074],
              [87.849467, 49.123252],
              [87.849367, 49.123527],
              [87.849145, 49.123809],
              [87.849009, 49.123993],
              [87.848751, 49.124236],
              [87.848588, 49.124374],
              [87.848071, 49.124721],
              [87.847587, 49.125115],
              [87.847045, 49.125427],
              [87.846845, 49.125536],
              [87.846734, 49.125595],
              [87.846416, 49.125878],
              [87.846022, 49.126287],
              [87.845626, 49.12657],
              [87.845377, 49.126778],
              [87.845334, 49.126864],
              [87.845337, 49.126996],
              [87.84534, 49.127185],
              [87.845432, 49.127453],
              [87.845483, 49.127577],
              [87.845495, 49.127607],
              [87.845605, 49.127887],
              [87.845626, 49.128104],
              [87.845663, 49.128485],
              [87.845653, 49.128688],
              [87.845647, 49.128848],
              [87.84558, 49.128986],
              [87.845363, 49.129085],
              [87.845199, 49.129178],
              [87.845008, 49.129225],
              [87.844322, 49.129401],
              [87.844253, 49.129419],
              [87.843846, 49.129521],
              [87.843399550000015, 49.129623435999974],
              [87.843323, 49.129641],
              [87.842601, 49.129746],
              [87.842071, 49.129853],
              [87.841828, 49.129929],
              [87.841639, 49.130062],
              [87.841398, 49.13027],
              [87.84122, 49.130546],
              [87.84106247699998, 49.130780331999972],
              [87.840978, 49.130906],
              [87.840738, 49.131255],
              [87.840432, 49.131648],
              [87.840093, 49.131979],
              [87.839818, 49.13221],
              [87.839553, 49.132549],
              [87.839177, 49.133021],
              [87.838784, 49.133471],
              [87.838485, 49.133845],
              [87.837952, 49.134306],
              [87.837305, 49.134735],
              [87.836847, 49.135018],
              [87.836379, 49.135205],
              [87.835971, 49.135305],
              [87.835777369000027, 49.135331689999987],
              [87.835601, 49.135356],
              [87.835259, 49.135482],
              [87.834731, 49.135703],
              [87.834575, 49.135782],
              [87.834368, 49.135945],
              [87.834330537000028, 49.136059683999974],
              [87.834319, 49.136095],
              [87.834339, 49.136244],
              [87.834447, 49.136495],
              [87.834617, 49.136746],
              [87.834709, 49.136985],
              [87.834616, 49.137181],
              [87.834471, 49.137376],
              [87.834143, 49.137613],
              [87.833893, 49.137758],
              [87.833425, 49.137922],
              [87.832994, 49.138072],
              [87.83277, 49.138176],
              [87.832558, 49.138312],
              [87.832383, 49.138508],
              [87.832252, 49.138726],
              [87.832099, 49.139043],
              [87.831958, 49.139403],
              [87.831881, 49.139686],
              [87.831838, 49.13997],
              [87.831861, 49.140362],
              [87.831899, 49.1406],
              [87.831969, 49.141061],
              [87.832044, 49.14144],
              [87.832127, 49.141662],
              [87.832209, 49.141868],
              [87.832281, 49.142033],
              [87.832415, 49.142193],
              [87.832575, 49.142397],
              [87.832756, 49.14278],
              [87.832909, 49.143042],
              [87.833116, 49.143469],
              [87.833373, 49.144194],
              [87.833412, 49.144434],
              [87.833397, 49.144589],
              [87.833338, 49.144698],
              [87.833227, 49.144848],
              [87.833005, 49.145124],
              [87.832927, 49.145299],
              [87.83287, 49.145429],
              [87.832493, 49.145843],
              [87.832393, 49.14613],
              [87.83237, 49.146325],
              [87.832287, 49.146526],
              [87.832158, 49.146681],
              [87.831952, 49.146866],
              [87.831789, 49.14701],
              [87.831453, 49.147304],
              [87.830947, 49.147772],
              [87.830448, 49.148216],
              [87.830138, 49.148447],
              [87.829985561, 49.148511647000021],
              [87.829947, 49.148528],
              [87.829713, 49.148627],
              [87.829232, 49.148802],
              [87.82915, 49.148832],
              [87.82862, 49.148956],
              [87.828055, 49.149114],
              [87.827664, 49.149192],
              [87.827071, 49.149247],
              [87.826452, 49.149252],
              [87.825868, 49.14925],
              [87.825159, 49.149146],
              [87.824615, 49.148967],
              [87.823833, 49.148607],
              [87.823288, 49.148387],
              [87.82278, 49.148219],
              [87.822244, 49.148028],
              [87.821595, 49.147821],
              [87.821209, 49.147681],
              [87.820937, 49.147609],
              [87.820578, 49.14752],
              [87.820147, 49.147299],
              [87.819672, 49.147034],
              [87.819221, 49.146682],
              [87.819034, 49.146455],
              [87.818951, 49.146209],
              [87.818949, 49.146049],
              [87.818937, 49.145831],
              [87.818831, 49.145804],
              [87.818753, 49.145839],
              [87.818642, 49.145948],
              [87.818609, 49.146051],
              [87.818423, 49.146436],
              [87.818141, 49.14681],
              [87.818058088999976, 49.146912666999981],
              [87.817885, 49.147127],
              [87.817705, 49.147317],
              [87.817584, 49.147426],
              [87.817369, 49.147577],
              [87.817084, 49.147762],
              [87.816808, 49.14793],
              [87.816461, 49.148104],
              [87.815953, 49.148497],
              [87.81548, 49.148901],
              [87.815076, 49.149287],
              [87.814734, 49.149673],
              [87.814323, 49.150162],
              [87.813427, 49.151382],
              [87.812745, 49.152359],
              [87.812354, 49.152986],
              [87.812313, 49.153158],
              [87.812315, 49.153284],
              [87.812404, 49.153403],
              [87.812476, 49.153517],
              [87.8126, 49.153631],
              [87.812926, 49.153852],
              [87.813367, 49.154117],
              [87.813461053000026, 49.154167380999979],
              [87.814054, 49.154485],
              [87.814856, 49.155005],
              [87.815386, 49.155374],
              [87.815663, 49.155632],
              [87.815805, 49.155861],
              [87.815965, 49.156119],
              [87.816111, 49.156519],
              [87.816239, 49.15689],
              [87.816269, 49.157084],
              [87.816272, 49.157285],
              [87.816275, 49.157491],
              [87.816279, 49.157731],
              [87.816294, 49.158091],
              [87.816303, 49.158646],
              [87.816308, 49.158933],
              [87.816372, 49.159121],
              [87.816443, 49.159218],
              [87.816559, 49.159343],
              [87.816631, 49.159462],
              [87.816809, 49.159679],
              [87.817076, 49.159986],
              [87.817219, 49.160187],
              [87.817254, 49.160236],
              [87.817583, 49.160577],
              [87.817928, 49.160878],
              [87.818461, 49.161447],
              [87.818993, 49.161952],
              [87.819224, 49.162237],
              [87.81927, 49.162328],
              [87.819288, 49.162397],
              [87.819299, 49.1625],
              [87.819292, 49.16262],
              [87.819284, 49.162689],
              [87.819278, 49.162809],
              [87.819245, 49.162969],
              [87.819213, 49.163118],
              [87.819225, 49.163336],
              [87.819228, 49.163524],
              [87.819253, 49.163954],
              [87.819293, 49.164262],
              [87.81934, 49.164485],
              [87.819387, 49.164697],
              [87.819479, 49.164948],
              [87.819552, 49.16517],
              [87.819687, 49.165381],
              [87.819758, 49.165466],
              [87.819883, 49.165654],
              [87.819946, 49.165746],
              [87.820053, 49.165922],
              [87.82009, 49.166002],
              [87.820108, 49.166071],
              [87.820092, 49.166128],
              [87.820075, 49.166197],
              [87.820024, 49.16626],
              [87.819912, 49.166341],
              [87.819775, 49.166427],
              [87.819505, 49.16655],
              [87.81908, 49.166707],
              [87.818646, 49.166859],
              [87.818178, 49.167023],
              [87.817848, 49.167168],
              [87.817624084999977, 49.167314628999975],
              [87.817538, 49.167371],
              [87.817296, 49.16755],
              [87.817072, 49.167723],
              [87.816737, 49.168023],
              [87.816306, 49.168404],
              [87.816014, 49.168675],
              [87.815395, 49.169211],
              [87.815042, 49.16954],
              [87.814914, 49.169701],
              [87.81438, 49.170157],
              [87.81453245, 49.170280833],
              [87.815275, 49.170884],
              [87.819808, 49.174259],
              [87.823308, 49.177939],
              [87.824825, 49.178009],
              [87.827019, 49.177026],
              [87.827157, 49.177022],
              [87.834303, 49.17676],
              [87.843363, 49.177286],
              [87.848074, 49.177359],
              [87.851492, 49.176153],
              [87.855997, 49.176199],
              [87.858144, 49.176953],
              [87.861311, 49.178064],
              [87.864744, 49.176695],
              [87.867852471999981, 49.175453327000014],
              [87.870905, 49.174234],
              [87.873468726999988, 49.172480950000022],
              [87.875032, 49.171412],
              [87.878572, 49.172407],
              [87.88389, 49.172205],
              [87.893259, 49.176321],
              [87.904333, 49.177305],
              [87.906179, 49.176706],
              [87.914633, 49.173685],
              [87.920767, 49.173235],
              [87.926973, 49.174551],
              [87.929369, 49.175661],
              [87.931456, 49.179648],
              [87.934176, 49.180723],
              [87.942457, 49.181246],
              [87.948225, 49.18096],
              [87.950251, 49.182097],
              [87.951517, 49.183439],
              [87.954232, 49.184546],
              [87.954753299, 49.184758912],
              [87.957033, 49.18569],
              [87.957959099, 49.185549505999973],
              [87.96023, 49.185205],
              [87.965815, 49.184355],
              [87.968603, 49.184626],
              [87.976915, 49.186625],
              [87.980558, 49.184527],
              [87.985464, 49.184],
              [87.988527, 49.183203],
              [87.990522, 49.185167],
              [87.993017, 49.188982],
              [87.995401, 49.191568],
              [87.996756, 49.193754],
              [88.003084, 49.200216],
              [88.001768100999982, 49.202114124],
              [88.00046, 49.204001],
              [88.000142, 49.205782],
              [88.000055, 49.206259],
              [88.000389058999986, 49.20824029],
              [88.000475, 49.20875],
              [88.003153, 49.209452],
              [88.003644, 49.209459],
              [88.005407, 49.209486],
              [88.006647, 49.209986],
              [88.008291, 49.211702],
              [88.011026, 49.213842],
              [88.012159, 49.217161],
              [88.012468, 49.217455],
              [88.014082, 49.218996],
              [88.014218, 49.219041],
              [88.019934, 49.220854],
              [88.01813, 49.222581],
              [88.017641, 49.223047],
              [88.017813795, 49.226032471],
              [88.017832, 49.226347],
              [88.018253674999983, 49.226593357000013],
              [88.022272, 49.228941],
              [88.02524, 49.229872],
              [88.027292, 49.231577],
              [88.028505, 49.231969],
              [88.044832, 49.237242],
              [88.053186, 49.239191],
              [88.05514, 49.239969],
              [88.05657, 49.240973],
              [88.057951, 49.242895],
              [88.056184, 49.248734],
              [88.055651, 49.250486],
              [88.052652, 49.252207],
              [88.052256, 49.256346],
              [88.053881, 49.257803],
              [88.056784, 49.259283],
              [88.06106, 49.259806],
              [88.0632, 49.260244],
              [88.074221, 49.259577],
              [88.080669461000014, 49.260708642999987],
              [88.082022, 49.260946],
              [88.081506900000022, 49.259563243],
              [88.081347, 49.259134],
              [88.081862393999984, 49.258680788],
              [88.083502, 49.257239],
              [88.085058890000028, 49.25587063],
              [88.085451, 49.255526],
              [88.088854, 49.254923],
              [88.090937906000022, 49.255371930000024],
              [88.09461, 49.256163],
              [88.099042477000012, 49.255573317000028],
              [88.100458, 49.255385],
              [88.101077953000015, 49.255527939],
              [88.103468, 49.256079],
              [88.107031, 49.256205],
              [88.107679057999974, 49.256967044000021],
              [88.110067, 49.259775],
              [88.111097, 49.261698],
              [88.116644, 49.265726],
              [88.116709, 49.267077],
              [88.11672, 49.267336],
              [88.123735, 49.27276],
              [88.12397088, 49.273820915999977],
              [88.124601, 49.276655],
              [88.125959, 49.278654],
              [88.128775, 49.279619],
              [88.132059, 49.279829],
              [88.132814270999972, 49.279679925999972],
              [88.133356, 49.279573],
              [88.13492, 49.279265],
              [88.137506, 49.281065],
              [88.141176, 49.280115],
              [88.149294, 49.281538],
              [88.153799, 49.286432],
              [88.159654208, 49.288468249],
              [88.161905, 49.289251],
              [88.163202, 49.291235],
              [88.16791241300001, 49.292096650000019],
              [88.168707, 49.292242],
              [88.170668, 49.293772],
              [88.170397, 49.296064],
              [88.167372660000012, 49.29728782799998],
              [88.162714, 49.299173],
              [88.163042, 49.300943],
              [88.165611942999988, 49.304920501000026],
              [88.166281, 49.305956],
              [88.166525, 49.307646],
              [88.163668, 49.311728],
              [88.162523, 49.312857],
              [88.160189, 49.315161],
              [88.159458313000016, 49.315597963000016],
              [88.158072, 49.316427],
              [88.158907, 49.317144],
              [88.1626, 49.317564],
              [88.164442805000022, 49.317772832],
              [88.165865, 49.317934],
              [88.169737, 49.323504],
              [88.170233, 49.325461],
              [88.169764, 49.327234],
              [88.166449, 49.330381],
              [88.165255, 49.332087],
              [88.162855, 49.332964],
              [88.160574, 49.333796],
              [88.156546, 49.335421],
              [88.154444, 49.336977],
              [88.157034, 49.338717],
              [88.162401, 49.340292],
              [88.162699, 49.34038],
              [88.165766, 49.340525],
              [88.164780599999972, 49.343988707],
              [88.164568, 49.344736],
              [88.165012244000025, 49.34570112900002],
              [88.166475, 49.348879],
              [88.16601, 49.351729],
              [88.163219739, 49.353801106999981],
              [88.159708, 49.356409],
              [88.160293919000026, 49.360680796],
              [88.160585, 49.362803],
              [88.154924, 49.364481],
              [88.151876, 49.364245],
              [88.14712, 49.366358],
              [88.144404, 49.366823],
              [88.144293, 49.366842],
              [88.142761625, 49.367453985999987],
              [88.139406, 49.368795],
              [88.138847269999985, 49.369843763],
              [88.13843, 49.370627],
              [88.136727813, 49.370671129000016],
              [88.129751, 49.370852],
              [88.124575, 49.372782],
              [88.122759, 49.374193],
              [88.122661376999986, 49.374558117],
              [88.122305, 49.375891],
              [88.124094, 49.377657],
              [88.121337929999981, 49.378151135999985],
              [88.118628, 49.378637],
              [88.117285806999973, 49.379992351999988],
              [88.117098, 49.380182],
              [88.116663, 49.382765],
              [88.119642, 49.387137],
              [88.119516, 49.388964],
              [88.118738, 49.390852],
              [88.119661, 49.391672],
              [88.124136, 49.393053],
              [88.128843, 49.395666],
              [88.131689, 49.396536],
              [88.135538, 49.398848],
              [88.137686, 49.399336],
              [88.140711, 49.402296],
              [88.141244, 49.402174],
              [88.143705, 49.401613],
              [88.15361328900002, 49.40738501300001],
              [88.153627, 49.407393],
              [88.153865896000013, 49.407415734999972],
              [88.165091, 49.408484],
              [88.168581, 49.409899],
              [88.171218758, 49.413485013000013],
              [88.171499, 49.413866],
              [88.178133, 49.413694],
              [88.178439138999977, 49.413744345],
              [88.18152, 49.414251],
              [88.185488, 49.416964],
              [88.184889, 49.419127],
              [88.180538153999976, 49.422204943],
              [88.180155, 49.422476],
              [88.17885, 49.424746],
              [88.178598, 49.426607],
              [88.178390936000028, 49.428840670999989],
              [88.178377, 49.428991],
              [88.178717, 49.434652],
              [88.176638, 49.436808],
              [88.175234, 49.438715],
              [88.174482, 49.438997],
              [88.1714, 49.440149],
              [88.167938734000018, 49.439823994999983],
              [88.166533, 49.439692],
              [88.16625, 49.441759],
              [88.166506, 49.443903],
              [88.165731, 49.445185],
              [88.169367, 49.448168],
              [88.171473, 49.451826],
              [88.173243, 49.453497],
              [88.177301, 49.454558],
              [88.17936755300002, 49.454203862999975],
              [88.182337, 49.453695],
              [88.184858, 49.455473],
              [88.185109, 49.455511],
              [88.188414, 49.456026],
              [88.190512, 49.457617],
              [88.192675, 49.460947],
              [88.192877, 49.4611],
              [88.198462, 49.465334],
              [88.19964, 49.465967],
              [88.204717, 49.468686],
              [88.20535086000001, 49.469025499999987],
              [88.208059, 49.470476],
              [88.208957236, 49.470663197000022],
              [88.211557, 49.471205],
              [88.212954, 49.472677],
              [88.215242, 49.473269],
              [88.219259, 49.476343],
              [88.221785, 49.479498],
              [88.227711520000014, 49.478529595999987],
              [88.228064, 49.478472],
              [88.232115, 49.477964],
              [88.233313, 49.476782],
              [88.23361, 49.476488],
              [88.2340767, 49.475774866999984],
              [88.234591, 49.474989],
              [88.23757, 49.474524],
              [88.240232, 49.475512],
              [88.243402, 49.47793],
              [88.244009, 49.478914],
              [88.244562, 49.479815],
              [88.245800721000023, 49.480216815],
              [88.247019, 49.480612],
              [88.249356997, 49.479373434000024],
              [88.24959, 49.47925],
              [88.250704, 49.478823],
              [88.256117631999984, 49.481406326000013],
              [88.25614, 49.481417],
              [88.256184514999973, 49.481403354],
              [88.257895, 49.480879],
              [88.261474116999977, 49.481797094],
              [88.263575, 49.482336],
              [88.265226, 49.481711],
              [88.265464998000027, 49.480902125999989],
              [88.26565, 49.480276],
              [88.268034, 49.47933],
              [88.271808619000012, 49.478805529999988],
              [88.274317, 49.478457],
              [88.276884532, 49.477491852000014],
              [88.277854014000013, 49.477127419],
              [88.278185, 49.477003],
              [88.285872, 49.476156],
              [88.288633, 49.475],
              [88.294188, 49.47267],
              [88.29566434100002, 49.471705795999981],
              [88.296572, 49.471113],
              [88.299723, 49.471281],
              [88.303774, 49.472681],
              [88.309313, 49.474436],
              [88.315504, 49.475061],
              [88.318483, 49.475168],
              [88.320879, 49.480196],
              [88.321466, 49.482123],
              [88.322996, 49.484022],
              [88.32585, 49.484987],
              [88.32691, 49.485975],
              [88.327001, 49.486628],
              [88.327158, 49.487799],
              [88.326978340999972, 49.488177409],
              [88.326151, 49.48992],
              [88.328924176999976, 49.490005058],
              [88.330259, 49.490046],
              [88.334383, 49.491999],
              [88.3361, 49.493761],
              [88.338942, 49.494829],
              [88.340726469, 49.494900237000024],
              [88.342474, 49.49497],
              [88.345423, 49.494108],
              [88.346854, 49.492212],
              [88.347867345, 49.490868173000024],
              [88.347872, 49.490862],
              [88.347915783000019, 49.490854618000014],
              [88.35063, 49.490397],
              [88.354605, 49.490621],
              [88.35668, 49.490736],
              [88.359297, 49.489733],
              [88.359312, 49.48966],
              [88.360025, 49.486326],
              [88.361807, 49.483145],
              [88.363555473000019, 49.482620578000024],
              [88.364721, 49.482271],
              [88.367823, 49.482256],
              [88.372179, 49.482901],
              [88.378595, 49.483172],
              [88.380689, 49.485669],
              [88.381083, 49.486139],
              [88.382053053999982, 49.486323017000018],
              [88.383898, 49.486673],
              [88.387589543, 49.486430573],
              [88.387781, 49.486418],
              [88.389929, 49.486277],
              [88.391871, 49.486852],
              [88.392756, 49.487112],
              [88.39494319, 49.489243438000017],
              [88.396326, 49.490591],
              [88.400317707999989, 49.492984399000022],
              [88.401728, 49.49383],
              [88.40225, 49.496851],
              [88.40227073, 49.496836579999979],
              [88.404898, 49.495009],
              [88.406408, 49.491751],
              [88.412878652000018, 49.488347246999979],
              [88.414495, 49.487497],
              [88.417675984000027, 49.486914937999984],
              [88.42137, 49.486239],
              [88.422979, 49.485373],
              [88.42362, 49.482206],
              [88.423826, 49.481176],
              [88.431475, 49.476961],
              [88.434169919999988, 49.471837468],
              [88.434946, 49.470362],
              [88.446480421999979, 49.471274994999987],
              [88.447428, 49.47135],
              [88.449552946999972, 49.471122746],
              [88.458845, 49.470129],
              [88.4648, 49.469847],
              [88.470514, 49.470251],
              [88.47234322700001, 49.470963542999982],
              [88.472845, 49.471159],
              [88.474007810999979, 49.470959231999984],
              [88.475866, 49.47064],
              [88.481245, 49.4709],
              [88.48345562999998, 49.47139882099998],
              [88.484068, 49.471537],
              [88.492849, 49.471815],
              [88.494015527999977, 49.471440143999985],
              [88.495768, 49.470877],
              [88.499655, 49.472879],
              [88.500647, 49.475054],
              [88.501966, 49.476942],
              [88.512758, 49.484442],
              [88.513617, 49.485041],
              [88.514147, 49.485029],
              [88.516249, 49.484984],
              [88.519887, 49.486413],
              [88.521292, 49.486963],
              [88.524012, 49.487101],
              [88.524908, 49.486913],
              [88.532789, 49.485247],
              [88.539763, 49.484381],
              [88.544783, 49.483324],
              [88.551832, 49.482668],
              [88.552401, 49.483767],
              [88.555449, 49.487509],
              [88.560331, 49.490419],
              [88.563383, 49.49069],
              [88.565542, 49.492921],
              [88.56745, 49.49489],
              [88.570639, 49.495249],
              [88.574377, 49.497053],
              [88.579405, 49.497454],
              [88.581503, 49.498423],
              [88.583021, 49.49872],
              [88.584478, 49.500277],
              [88.589087, 49.501059],
              [88.591848, 49.501658],
              [88.595034, 49.503],
              [88.596804, 49.503046],
              [88.597284, 49.502981],
              [88.600073, 49.5026],
              [88.602484, 49.501204],
              [88.603693, 49.497404],
              [88.606058, 49.494642],
              [88.607786, 49.494032],
              [88.613577, 49.494986],
              [88.619387, 49.49716],
              [88.625376, 49.497862],
              [88.627928, 49.496779],
              [88.630262, 49.493174],
              [88.635725, 49.491453],
              [88.641104, 49.490389],
              [88.642641, 49.488909],
              [88.643747, 49.487436],
              [88.653391, 49.482313],
              [88.656084, 49.481875],
              [88.657474508, 49.481323847],
              [88.658617, 49.480871],
              [88.661486, 49.479563],
              [88.663112865000016, 49.478151704000027],
              [88.664669833, 49.476801043000023],
              [88.669863, 49.472296],
              [88.673279286000025, 49.467212793999977],
              [88.673468, 49.466932],
              [88.673449, 49.464872],
              [88.678087510000012, 49.464762619],
              [88.679598, 49.464727],
              [88.682126821999987, 49.462676462],
              [88.682966, 49.461996],
              [88.685375188000023, 49.461703236],
              [88.685764337000023, 49.461655946],
              [88.688677, 49.461302],
              [88.695318, 49.461416],
              [88.698056, 49.460886],
              [88.704337193000015, 49.459668564000026],
              [88.704531, 49.459631],
              [88.704840574, 49.459363521],
              [88.706068, 49.458303],
              [88.707501507000018, 49.457060206],
              [88.708338, 49.456335],
              [88.711558304, 49.454520624999986],
              [88.714811, 49.452688],
              [88.717558, 49.45286],
              [88.719419384, 49.453996887000017],
              [88.721029, 49.45498],
              [88.721132, 49.455042],
              [88.72205, 49.455057],
              [88.724092, 49.455092],
              [88.727658857999984, 49.453909639000017],
              [88.732931, 49.452162],
              [88.735266, 49.450834],
              [88.736433, 49.449217],
              [88.740427, 49.449957],
              [88.742388, 49.452395],
              [88.744661, 49.454435],
              [88.748587, 49.456369],
              [88.748362, 49.457075],
              [88.747774, 49.458918],
              [88.749342, 49.460402],
              [88.751444, 49.461088],
              [88.754277208000019, 49.460436876000017],
              [88.762281157000018, 49.458597420999979],
              [88.763014, 49.458429],
              [88.765667474, 49.458214234000025],
              [88.766214, 49.45817],
              [88.766770668, 49.458015204999981],
              [88.76771, 49.457754],
              [88.778032, 49.454886],
              [88.785246, 49.457369],
              [88.786951, 49.458197],
              [88.787557252, 49.458491508],
              [88.78776, 49.45859],
              [88.788127713999984, 49.458593507999979],
              [88.798872, 49.458696],
              [88.801714, 49.459322],
              [88.807784008, 49.459332712],
              [88.807947, 49.459333],
              [88.812006, 49.458895],
              [88.812545546000024, 49.458631879999984],
              [88.812887765000028, 49.458464989999982],
              [88.813993, 49.457926],
              [88.814466, 49.455278],
              [88.818094, 49.452894],
              [88.821257, 49.451601],
              [88.821294, 49.450072],
              [88.821341, 49.44805],
              [88.822195, 49.446741],
              [88.826819227999977, 49.444273970999973],
              [88.826971, 49.444193],
              [88.827222998000025, 49.444136141],
              [88.829936577000012, 49.443523868],
              [88.831434, 49.443186],
              [88.833124985999973, 49.44344780199998],
              [88.834192, 49.443613],
              [88.83652248300001, 49.442906393999976],
              [88.839502, 49.442003],
              [88.843283, 49.442812],
              [88.846094, 49.44282],
              [88.849539, 49.446238],
              [88.851866, 49.449633],
              [88.852656, 49.450182],
              [88.856925717000024, 49.453142403000015],
              [88.857828, 49.453768],
              [88.859647118999987, 49.454290561999983],
              [88.862169, 49.455015],
              [88.86587, 49.455141],
              [88.865081927, 49.455964986000026],
              [88.86429, 49.456793],
              [88.86154, 49.460291],
              [88.859468, 49.464651],
              [88.85298, 49.465696],
              [88.850756, 49.46707],
              [88.850863, 49.467901],
              [88.858938, 49.465906],
              [88.864904, 49.465315],
              [88.870375, 49.466967],
              [88.874449, 49.469744],
              [88.876978, 49.470739],
              [88.880785, 49.473192],
              [88.885279, 49.47518],
              [88.879427, 49.476267],
              [88.874964, 49.478502],
              [88.872225, 49.480452],
              [88.871065, 49.482164],
              [88.871565549000024, 49.484473155999979],
              [88.87182, 49.485647],
              [88.870434226999976, 49.485864054],
              [88.867376562, 49.486342976],
              [88.865244, 49.486677],
              [88.862297921, 49.486638880999976],
              [88.861998, 49.486635],
              [88.861691434000022, 49.486692716999983],
              [88.856405, 49.487688],
              [88.851019, 49.489618],
              [88.852148, 49.492437],
              [88.85174, 49.494406],
              [88.852843748, 49.495972514000016],
              [88.852861, 49.495997],
              [88.860384, 49.496393],
              [88.864428, 49.497412],
              [88.864540825, 49.497416564],
              [88.867716, 49.497545],
              [88.869208, 49.49809],
              [88.87266, 49.499346],
              [88.873991, 49.501261],
              [88.875628, 49.50308],
              [88.875568534000024, 49.503277159],
              [88.875086, 49.504877],
              [88.8748, 49.506903],
              [88.878309788000024, 49.513086604000023],
              [88.879137, 49.514544],
              [88.879297, 49.516569],
              [88.879828, 49.520289],
              [88.876206431000014, 49.527758647999974],
              [88.875639, 49.528929],
              [88.875522713, 49.529169020999973],
              [88.875155, 49.529928],
              [88.876417, 49.53266],
              [88.876871, 49.533644],
              [88.87745, 49.537614],
              [88.877462, 49.537703],
              [88.87652, 49.541452],
              [88.872091, 49.545591],
              [88.868071, 49.547033],
              [88.886766, 49.557821],
              [88.898859, 49.557592],
              [88.901529444, 49.556393704000016],
              [88.904154, 49.555216],
              [88.905226, 49.554056],
              [88.905725, 49.54925],
              [88.906118, 49.548147],
              [88.906950154000015, 49.545789871000011],
              [88.906984, 49.545694],
              [88.909555, 49.544653],
              [88.914156, 49.544057],
              [88.91538, 49.543898],
              [88.923038609, 49.545131094999988],
              [88.923597, 49.545221],
              [88.929461, 49.54183],
              [88.930928392999988, 49.540242592000027],
              [88.931295, 49.539846],
              [88.93392, 49.534914],
              [88.93395, 49.531153],
              [88.934086337999986, 49.53084216000002],
              [88.935011, 49.528734],
              [88.934336, 49.527174],
              [88.931372, 49.526247],
              [88.928747, 49.525423],
              [88.928473, 49.522265],
              [88.927565, 49.520693],
              [88.92785891, 49.519757562],
              [88.928156, 49.518812],
              [88.928479652000021, 49.518616591000011],
              [88.932035, 49.51647],
              [88.933615, 49.510752],
              [88.934851, 49.51005],
              [88.938916291, 49.509658903],
              [88.940125697999974, 49.509542553000017],
              [88.942148, 49.509348],
              [88.942987, 49.507731],
              [88.945276, 49.505965],
              [88.945791, 49.505568],
              [88.950872, 49.503553],
              [88.956678, 49.502443],
              [88.958929027000011, 49.501703217999989],
              [88.959482458000025, 49.501521337999975],
              [88.95952, 49.501509],
              [88.962366, 49.498491],
              [88.96591, 49.49291],
              [88.961042, 49.490919],
              [88.956995, 49.487165],
              [88.956423, 49.486635],
              [88.955456453000011, 49.48247826],
              [88.955435, 49.482386],
              [88.955504465999979, 49.482266363],
              [88.955772938999985, 49.481803991999982],
              [88.958675562, 49.476805005000017],
              [88.962286, 49.470587],
              [88.965677, 49.466978],
              [88.965948244, 49.463831942000013],
              [88.965971, 49.463568],
              [88.967669, 49.462713],
              [88.977533, 49.461325],
              [88.985338, 49.465235],
              [88.988947, 49.46628],
              [88.997164, 49.469565],
              [88.999674, 49.470133],
              [89.009798, 49.466509],
              [89.010782, 49.469141],
              [89.016855, 49.475573],
              [89.017538, 49.477861],
              [89.018114, 49.479799],
              [89.028368, 49.484247],
              [89.03314, 49.487124],
              [89.035675460999983, 49.487908313999981],
              [89.036085, 49.488035],
              [89.039952, 49.485808],
              [89.040503914, 49.485489503999986],
              [89.040964, 49.485224],
              [89.04130964, 49.485093966000022],
              [89.044331602999989, 49.483957066000016],
              [89.045294, 49.483595],
              [89.067322634, 49.483711496000012],
              [89.076940039000021, 49.483762356999989],
              [89.077818, 49.483767],
              [89.080805, 49.484259],
              [89.084833473, 49.485747747],
              [89.090179221000028, 49.487723300000027],
              [89.092676, 49.488646],
              [89.095449, 49.489443],
              [89.102743, 49.4895],
              [89.108679, 49.491552],
              [89.111452, 49.493971],
              [89.111799, 49.495348],
              [89.112314, 49.497404],
              [89.122122, 49.49864],
              [89.122583, 49.498587],
              [89.128862, 49.49785],
              [89.135321, 49.498396],
              [89.141935, 49.500181],
              [89.145891, 49.502386],
              [89.149485, 49.506128],
              [89.150125, 49.507543],
              [89.150393, 49.508131],
              [89.151396, 49.512213],
              [89.152853, 49.514982],
              [89.154821, 49.516302],
              [89.157492, 49.516966],
              [89.159412944999985, 49.517168045],
              [89.163187, 49.517565],
              [89.173811, 49.517763],
              [89.175798, 49.517168],
              [89.178659, 49.51631],
              [89.180383146, 49.516232613],
              [89.181288, 49.516192],
              [89.186808, 49.517683],
              [89.189737, 49.517431],
              [89.19879, 49.521597],
              [89.201563, 49.522242],
              [89.202078, 49.524096],
              [89.201254, 49.526602],
              [89.201944, 49.529764],
              [89.207499, 49.533796],
              [89.207875468, 49.534123548000025],
              [89.209192, 49.535269],
              [89.210142, 49.537108],
              [89.211939, 49.538698],
              [89.212934683000015, 49.538968921],
              [89.215036348000012, 49.539540773999988],
              [89.217981, 49.540342],
              [89.227556, 49.543497],
              [89.230543, 49.546473],
              [89.231079, 49.548189],
              [89.232096, 49.551443],
              [89.226812, 49.558134],
              [89.226126, 49.562166],
              [89.223837, 49.564234],
              [89.219488, 49.566938],
              [89.218673642999988, 49.567396056],
              [89.218013111, 49.567767590000017],
              [89.21419, 49.569918],
              [89.211725, 49.570578],
              [89.209521022, 49.570471880000014],
              [89.208942, 49.570444],
              [89.205753554000012, 49.571611018],
              [89.204699, 49.571997],
              [89.202753, 49.576151],
              [89.202288, 49.578695],
              [89.19964, 49.582579],
              [89.195195866, 49.584713858999976],
              [89.19274052999998, 49.585893344999988],
              [89.190722, 49.586863],
              [89.189299, 49.588499],
              [89.194853, 49.593256],
              [89.194485332999989, 49.595708962],
              [89.194323, 49.596792],
              [89.194342, 49.596811],
              [89.194760198999973, 49.597201396],
              [89.199381, 49.601515],
              [89.198709, 49.60541],
              [89.190027, 49.611821],
              [89.18976, 49.612017],
              [89.187521, 49.61286],
              [89.183382, 49.617437],
              [89.182192, 49.619921],
              [89.182779, 49.623316],
              [89.185003, 49.626165],
              [89.185778, 49.628878],
              [89.18833, 49.631544],
              [89.197065, 49.634401],
              [89.20301607, 49.635160589],
              [89.206396, 49.635592],
              [89.211439980000023, 49.636081575999981],
              [89.212011, 49.636137],
              [89.212019, 49.636137],
              [89.212214, 49.636221],
              [89.212635767, 49.636404057999982],
              [89.222506, 49.640688],
              [89.225348, 49.642572],
              [89.230307, 49.642607],
              [89.234278, 49.644785],
              [89.24008, 49.644228],
              [89.242467619000024, 49.645124597],
              [89.243366607999974, 49.645462184],
              [89.244173, 49.645765],
              [89.249636, 49.644957],
              [89.254732, 49.640886],
              [89.256626399000027, 49.637227849999988],
              [89.256646, 49.63719],
              [89.256662, 49.637156],
              [89.256773, 49.637132],
              [89.256874682999978, 49.637110506999989],
              [89.265142, 49.635363],
              [89.269865, 49.633089],
              [89.271647, 49.631739],
              [89.276423, 49.630033],
              [89.278567806000012, 49.627254882999978],
              [89.28089, 49.624247],
              [89.281604668, 49.62239381400002],
              [89.282045, 49.621252],
              [89.282343, 49.620478],
              [89.285131, 49.618158],
              [89.28782, 49.617368],
              [89.291189, 49.616373],
              [89.298586, 49.613527],
              [89.301012, 49.611998],
              [89.302179, 49.609953],
              [89.301954, 49.608995],
              [89.304815, 49.60655],
              [89.308599405999985, 49.603313892000017],
              [89.308763, 49.603174],
              [89.309560267999984, 49.603221780000013],
              [89.311049, 49.603311],
              [89.313414, 49.603453],
              [89.316305, 49.604242],
              [89.318693, 49.602667],
              [89.330183, 49.59754],
              [89.336176, 49.596132],
              [89.341285111, 49.594006907999983],
              [89.343275055, 49.593179207999981],
              [89.343302, 49.593168],
              [89.346373, 49.592615],
              [89.343169, 49.590635],
              [89.341764, 49.589766],
              [89.334131, 49.583635],
              [89.337595, 49.583433],
              [89.342962229000022, 49.582614133999982],
              [89.345598, 49.582212],
              [89.346797329000026, 49.582823064000024],
              [89.350122, 49.584517],
              [89.356428, 49.584108],
              [89.358199405999983, 49.58366557],
              [89.360628, 49.583059],
              [89.362528, 49.586901],
              [89.36656, 49.589521],
              [89.370775, 49.592775],
              [89.373522, 49.593588],
              [89.376010040999972, 49.593998688999989],
              [89.376436, 49.594069],
              [89.377842718000011, 49.593932236],
              [89.37982, 49.59374],
              [89.383356, 49.595781],
              [89.385888822000027, 49.595956011],
              [89.387278, 49.596052],
              [89.388245301999973, 49.595893037],
              [89.390783, 49.595476],
              [89.386719087000017, 49.600210998000023],
              [89.385351, 49.601805],
              [89.38434, 49.605612],
              [89.3818, 49.609121],
              [89.381685957, 49.609195183],
              [89.380235, 49.610139],
              [89.379438, 49.610655],
              [89.381948, 49.610602],
              [89.388559, 49.610464],
              [89.391169, 49.611326],
              [89.395044, 49.614038],
              [89.395238, 49.614206],
              [89.398809, 49.617327],
              [89.402922, 49.619287],
              [89.403776317, 49.620524224],
              [89.403868, 49.620657],
              [89.407137, 49.620352],
              [89.410715, 49.619169],
              [89.411837, 49.618795],
              [89.417381746, 49.615843863],
              [89.41818, 49.615419],
              [89.421034, 49.615946],
              [89.427023, 49.621534],
              [89.429914, 49.622908],
              [89.432772, 49.623575],
              [89.434362, 49.625048],
              [89.434847, 49.626863],
              [89.436487, 49.630575],
              [89.435537, 49.633322],
              [89.43149, 49.634943],
              [89.431059, 49.635115],
              [89.439226, 49.641134],
              [89.442404, 49.643473],
              [89.444178, 49.645353],
              [89.444311, 49.645578],
              [89.451914, 49.658491],
              [89.452036435000025, 49.658609747000014],
              [89.456949692000023, 49.663374985000019],
              [89.458254, 49.66464],
              [89.463003, 49.661867],
              [89.464036, 49.66107],
              [89.464849, 49.66044],
              [89.467234, 49.659567],
              [89.469915, 49.659605],
              [89.469969618999983, 49.659620814],
              [89.472761, 49.660429],
              [89.479048, 49.66115],
              [89.486124, 49.66221],
              [89.494442691000017, 49.663456667999981],
              [89.495646, 49.663637],
              [89.499697, 49.664843],
              [89.502638, 49.66847],
              [89.505297, 49.668058],
              [89.51232, 49.670183],
              [89.511666091999984, 49.671281383],
              [89.511171, 49.672113],
              [89.517199, 49.677271],
              [89.519282991000011, 49.677224535999983],
              [89.519621, 49.677217],
              [89.52645714800002, 49.678287431],
              [89.529539, 49.67877],
              [89.530634, 49.678918],
              [89.533857, 49.679349],
              [89.536238825999988, 49.679667655],
              [89.538424, 49.67996],
              [89.545214, 49.683008],
              [89.553061, 49.683981],
              [89.553087, 49.683962],
              [89.565763, 49.681097],
              [89.568616849000023, 49.681135262999987],
              [89.569716, 49.68115],
              [89.570772, 49.680654],
              [89.573542, 49.679346],
              [89.575238055, 49.679729861],
              [89.576222653, 49.679952701],
              [89.579878, 49.68078],
              [89.583105, 49.680826],
              [89.586855405, 49.680282379],
              [89.586996, 49.680262],
              [89.595282, 49.681589],
              [89.601801, 49.683535],
              [89.602137218, 49.683665497999982],
              [89.605404100999976, 49.684933487000023],
              [89.609015, 49.686335],
              [89.61441014899998, 49.687936929999978],
              [89.615527981000014, 49.68826883700001],
              [89.624147, 49.690828],
              [89.628492, 49.692053],
              [89.637049, 49.693583],
              [89.651434, 49.697432],
              [89.658503, 49.700068],
              [89.662661, 49.701197],
              [89.67182, 49.702299],
              [89.67589, 49.703169],
              [89.676859, 49.70389],
              [89.678423, 49.705744],
              [89.680662, 49.71084],
              [89.680143, 49.712667],
              [89.679953, 49.713327],
              [89.69674765000002, 49.721199522],
              [89.697378, 49.721495],
              [89.698107, 49.721628],
              [89.699024436, 49.72179631],
              [89.7031, 49.722544],
              [89.709184602999983, 49.72503795199998],
              [89.709558, 49.725191],
              [89.71637420899998, 49.723896013],
              [89.716948, 49.723787],
              [89.722719, 49.727728],
              [89.721529, 49.729826],
              [89.719278, 49.731054],
              [89.719118, 49.732748],
              [89.717375, 49.733988],
              [89.716372, 49.736856],
              [89.714692, 49.737292],
              [89.714266, 49.737402],
              [89.713026, 49.739286],
              [89.713145987000019, 49.740966501],
              [89.713202, 49.741751],
              [89.713817289000019, 49.742476348000025],
              [89.715673, 49.744664],
              [89.718172, 49.747606],
              [89.719667177000019, 49.748759740000025],
              [89.719677764999972, 49.748767910000026],
              [89.721395, 49.750093],
              [89.720465, 49.752935],
              [89.720429707, 49.752947200999984],
              [89.718853615, 49.753492062000021],
              [89.717474, 49.753969],
              [89.716226, 49.755262],
              [89.713205516000016, 49.758389932],
              [89.712431, 49.759192],
              [89.712286, 49.761805],
              [89.712545608000028, 49.762134824999976],
              [89.713739, 49.763651],
              [89.714319, 49.764391],
              [89.71361, 49.767908],
              [89.717993, 49.770391],
              [89.718889, 49.772135],
              [89.718133679, 49.772765441],
              [89.717390798999986, 49.773385499000028],
              [89.712889, 49.777143],
              [89.714201, 49.784353],
              [89.713831, 49.788099],
              [89.712952912999981, 49.788913372000025],
              [89.711309, 49.790438],
              [89.709995951, 49.790838242],
              [89.708632, 49.791254],
              [89.705609069, 49.790807395],
              [89.703833, 49.790545],
              [89.699793, 49.791014],
              [89.696901, 49.78861],
              [89.69578, 49.786123],
              [89.690374, 49.784941],
              [89.686152, 49.784018],
              [89.679445, 49.784246],
              [89.675158, 49.782862],
              [89.670095, 49.784555],
              [89.664248, 49.785841],
              [89.664060579000022, 49.787087045000021],
              [89.663847, 49.788507],
              [89.662637202999974, 49.789032768000027],
              [89.655215009000017, 49.792258397000012],
              [89.654024, 49.792776],
              [89.653493962000027, 49.792753414],
              [89.650457, 49.792624],
              [89.640266925999981, 49.799571454999978],
              [89.638971, 49.800455],
              [89.636126, 49.801798],
              [89.635628296999982, 49.801856276000024],
              [89.631369, 49.802355],
              [89.625284, 49.801867],
              [89.624660162, 49.802239730999986],
              [89.623323562, 49.80303832200002],
              [89.621237, 49.804285],
              [89.621307148000028, 49.804872349],
              [89.621489, 49.806395],
              [89.624144, 49.806353],
              [89.629648, 49.808393],
              [89.629705, 49.809137],
              [89.629858, 49.811235],
              [89.62932, 49.81201],
              [89.626005, 49.816767],
              [89.626478, 49.81883],
              [89.632218, 49.818399],
              [89.636374, 49.818087],
              [89.642584, 49.818823],
              [89.645342, 49.820139],
              [89.65135, 49.826269],
              [89.651709, 49.828283],
              [89.649103, 49.82976],
              [89.643599, 49.831335],
              [89.640535, 49.834055],
              [89.64007, 49.835714],
              [89.639585, 49.837442],
              [89.640364, 49.838121],
              [89.643713, 49.84104],
              [89.643782, 49.843294],
              [89.643514525, 49.843375198],
              [89.638742, 49.844824],
              [89.634721, 49.844907],
              [89.630003, 49.845003],
              [89.629990358999976, 49.845034484],
              [89.626318, 49.854181],
              [89.625465897000026, 49.854300049000017],
              [89.621866, 49.854803],
              [89.621805832, 49.855081676999987],
              [89.620848, 49.859518],
              [89.620629635, 49.859605351000027],
              [89.612551, 49.862837],
              [89.612583199000028, 49.863392076000025],
              [89.61294, 49.869543],
              [89.616037, 49.870977],
              [89.615650123000023, 49.871801060999985],
              [89.615068, 49.873041],
              [89.615407842000025, 49.874588094999979],
              [89.615984, 49.877211],
              [89.617411, 49.87895],
              [89.623926, 49.883657],
              [89.628088, 49.883963],
              [89.629484, 49.884066],
              [89.632372, 49.884878],
              [89.63302, 49.885653],
              [89.63281867500001, 49.886906830999976],
              [89.632296, 49.890162],
              [89.632466463000014, 49.891906066999979],
              [89.632551, 49.892771],
              [89.632082245999982, 49.893082816],
              [89.631186, 49.893679],
              [89.631603731999974, 49.894854322000015],
              [89.631937, 49.895792],
              [89.631876, 49.89797],
              [89.629148, 49.905058],
              [89.628789504, 49.905132912999989],
              [89.620424, 49.906881],
              [89.619093267999972, 49.90715839500001],
              [89.617987, 49.907389],
              [89.615313, 49.907183],
              [89.614481663, 49.906897468000011],
              [89.609915, 49.905329],
              [89.607201531999976, 49.907093770000017],
              [89.60124, 49.910971],
              [89.595961, 49.912863],
              [89.591933069999982, 49.912781713000015],
              [89.591204, 49.912767],
              [89.591714710000019, 49.912862714000028],
              [89.614164, 49.91707],
              [89.631166, 49.920286],
              [89.635027, 49.921666],
              [89.645636, 49.925455],
              [89.661795, 49.93125],
              [89.672869, 49.935228],
              [89.674471, 49.935808],
              [89.676874, 49.936659],
              [89.684408, 49.939329],
              [89.691938, 49.940779],
              [89.70376, 49.942709],
              [89.707612, 49.942834],
              [89.720991, 49.943266],
              [89.722391, 49.944185],
              [89.723581, 49.944086],
              [89.725565, 49.94533],
              [89.727308, 49.945753],
              [89.72928, 49.945795],
              [89.731188, 49.946646],
              [89.732412, 49.947191],
              [89.734137, 49.947065],
              [89.7349, 49.947008],
              [89.735548, 49.947267],
              [89.736605, 49.947683],
              [89.738134, 49.947633],
              [89.738653, 49.947615],
              [89.740103, 49.947226],
              [89.741842, 49.947577],
              [89.743341, 49.947596],
              [89.744417, 49.947962],
              [89.745646, 49.947596],
              [89.747385, 49.947966],
              [89.749922, 49.947702],
              [89.750853, 49.948072],
              [89.75194, 49.948175],
              [89.752733675, 49.948366863],
              [89.753756, 49.948614],
              [89.755130149000024, 49.948192797],
              [89.755198, 49.948172],
              [89.755320735, 49.948197247],
              [89.757162, 49.948576],
              [89.75844, 49.948294],
              [89.759974, 49.948725],
              [89.761555913999985, 49.948671736999984],
              [89.76235, 49.948645],
              [89.764116, 49.947931],
              [89.766394, 49.948771],
              [89.768332, 49.948984],
              [89.769773, 49.950018],
              [89.771963, 49.949923],
              [89.773985, 49.950902],
              [89.775091, 49.951437],
              [89.777544, 49.951815],
              [89.779566, 49.951765],
              [89.780993, 49.951082],
              [89.781172, 49.950994],
              [89.782537, 49.95112],
              [89.785776, 49.951418],
              [89.786628835999977, 49.951867629999981],
              [89.786768, 49.951941],
              [89.792494, 49.952219],
              [89.794127, 49.953028],
              [89.796492, 49.953058],
              [89.799253, 49.95347],
              [89.800604, 49.953459],
              [89.801725, 49.95302],
              [89.803473, 49.952845],
              [89.803822165999975, 49.952753067],
              [89.8062, 49.952127],
              [89.807780787000013, 49.952157613],
              [89.809195, 49.952185],
              [89.810629, 49.951994],
              [89.811979, 49.952162],
              [89.812086, 49.952143],
              [89.815046, 49.95162],
              [89.816599, 49.951548],
              [89.818377, 49.951471],
              [89.81925, 49.951242],
              [89.820016996, 49.951306702000011],
              [89.820471, 49.951345],
              [89.823915, 49.951937],
              [89.826413845, 49.952722397],
              [89.826998, 49.952906],
              [89.827244751000023, 49.952906287000019],
              [89.82958, 49.952909],
              [89.8318, 49.953234],
              [89.833181, 49.953886],
              [89.834627, 49.953897],
              [89.835798, 49.95447],
              [89.837141, 49.954481],
              [89.837881, 49.954752],
              [89.839216, 49.954672],
              [89.840303, 49.954981],
              [89.841177, 49.954649],
              [89.843512, 49.955099],
              [89.845697, 49.956579],
              [89.847258, 49.95672],
              [89.848242, 49.957094],
              [89.848539, 49.957109],
              [89.849863, 49.957167],
              [89.851248, 49.957888],
              [89.853281, 49.95793],
              [89.854544, 49.958296],
              [89.855910205999976, 49.95886815199998],
              [89.856939, 49.959299],
              [89.860022, 49.959513],
              [89.86244, 49.959677],
              [89.862814787, 49.958986798000012],
              [89.862844, 49.958933],
              [89.865549, 49.958113],
              [89.867361, 49.957865],
              [89.86857, 49.957949],
              [89.871362503, 49.956901883],
              [89.873453, 49.956118],
              [89.874519180999982, 49.955506242000013],
              [89.874605, 49.955457],
              [89.877012, 49.954073],
              [89.879618, 49.953299],
              [89.880359627000018, 49.953306954000027],
              [89.881317301000024, 49.953317226000024],
              [89.882788, 49.953333],
              [89.884054, 49.953768],
              [89.888159, 49.953817],
              [89.889822, 49.954088],
              [89.892527, 49.955042],
              [89.894037, 49.954962],
              [89.899347, 49.956228],
              [89.901014, 49.957529],
              [89.903391, 49.958864],
              [89.906641, 49.959578],
              [89.908201, 49.96036],
              [89.909342, 49.961241],
              [89.910669, 49.961874],
              [89.913046, 49.962717],
              [89.916346, 49.963068],
              [89.920588, 49.962854],
              [89.92359, 49.963324],
              [89.927176, 49.963236],
              [89.929949, 49.964098],
              [89.931139, 49.965002],
              [89.931684, 49.966074],
              [89.932119, 49.96644],
              [89.935278, 49.967382],
              [89.935694, 49.967974],
              [89.936484, 49.968339],
              [89.938265, 49.96916],
              [89.940332, 49.969809],
              [89.94396, 49.969949],
              [89.945108, 49.969992],
              [89.945566, 49.970293],
              [89.946865984999988, 49.971150218],
              [89.947081, 49.971292],
              [89.947614913999985, 49.971292],
              [89.949678, 49.971292],
              [89.950674, 49.971506],
              [89.951089, 49.971483],
              [89.951986, 49.97143],
              [89.953875, 49.971926],
              [89.95645, 49.972033],
              [89.957853, 49.972326],
              [89.960424, 49.972391],
              [89.962267, 49.972692],
              [89.963991, 49.972895],
              [89.965483, 49.973349],
              [89.967812515999981, 49.973206614999981],
              [89.968477, 49.973166],
              [89.969065893, 49.972987045000025],
              [89.969507, 49.972853],
              [89.969956222, 49.972831074999988],
              [89.971392, 49.972761],
              [89.972124, 49.972548],
              [89.972439816000019, 49.972283827000012],
              [89.973078, 49.97175],
              [89.97415, 49.971449],
              [89.97555, 49.971655],
              [89.976629, 49.972235],
              [89.976915, 49.972788],
              [89.977186, 49.973005],
              [89.979082, 49.974157],
              [89.980013, 49.975283],
              [89.982157, 49.976561],
              [89.982965, 49.977381],
              [89.983889, 49.977804],
              [89.984957, 49.979464],
              [89.987108, 49.980318],
              [89.988771, 49.981707],
              [89.990656, 49.982637],
              [89.99262, 49.983263],
              [89.994425, 49.98348],
              [89.996222, 49.983969],
              [89.997919, 49.984102],
              [89.999796, 49.985224],
              [90.002138, 49.987265],
              [90.002504, 49.987585],
              [90.003534, 49.987733],
              [90.006044, 49.988092],
              [90.006259535000027, 49.988241217],
              [90.00659, 49.98847],
              [90.008486, 49.988966],
              [90.009192, 49.989492],
              [90.010881, 49.990751],
              [90.013551, 49.99072],
              [90.014242, 49.990709],
              [90.015059, 49.991143],
              [90.015574, 49.991415],
              [90.01661, 49.991579],
              [90.016669474000025, 49.991588235],
              [90.016932, 49.991629],
              [90.017053, 49.991704],
              [90.017511, 49.991983],
              [90.01771, 49.99254],
              [90.018202, 49.993006],
              [90.018488, 49.993959],
              [90.018026, 49.995188],
              [90.018858, 49.995974],
              [90.019018, 49.996859],
              [90.019705, 49.997774],
              [90.019598, 49.998846],
              [90.021292, 49.999762],
              [90.021338, 50.000757],
              [90.021786308, 50.001286035000021],
              [90.02191, 50.001432],
              [90.023081, 50.001406],
              [90.02424, 50.000952],
              [90.02627, 49.999636],
              [90.02733, 49.99906],
              [90.028936, 49.998877],
              [90.03105, 49.997725],
              [90.031267, 49.998152],
              [90.031374, 49.998362],
              [90.031431, 49.999411],
              [90.032064, 50.000269],
              [90.032061, 50.001516],
              [90.031496, 50.002253],
              [90.031233, 50.003572],
              [90.030714, 50.004026],
              [90.030596, 50.00477],
              [90.031321, 50.006224],
              [90.031069, 50.007559],
              [90.030313, 50.008101],
              [90.030069, 50.008654],
              [90.028776, 50.008581],
              [90.027765, 50.009035],
              [90.027777, 50.009729],
              [90.027422, 50.010122],
              [90.026236, 50.010698],
              [90.026087, 50.011106],
              [90.025755, 50.011248],
              [90.025076, 50.011477],
              [90.02503221500001, 50.011677523],
              [90.025007, 50.011793],
              [90.0245, 50.012033],
              [90.02437, 50.012495],
              [90.023809, 50.012766],
              [90.023302, 50.012892],
              [90.022892, 50.013311],
              [90.022226, 50.013224],
              [90.021820033999973, 50.013365206],
              [90.021513, 50.013472],
              [90.021539040999983, 50.01362207699998],
              [90.021589, 50.01391],
              [90.021318, 50.01412],
              [90.020994361000021, 50.01412],
              [90.020773, 50.01412],
              [90.020361, 50.014494],
              [90.019842, 50.014532],
              [90.019621, 50.014761],
              [90.019808, 50.015097],
              [90.019236, 50.015535],
              [90.019216953000011, 50.015734082],
              [90.019163, 50.016298],
              [90.018682, 50.016539],
              [90.018858, 50.016859],
              [90.01895, 50.017244],
              [90.01861, 50.017408],
              [90.017962, 50.017538],
              [90.017321, 50.017836],
              [90.016912, 50.017836],
              [90.016836, 50.018251],
              [90.016222, 50.018534],
              [90.015963, 50.019255],
              [90.015481277999982, 50.019838049999976],
              [90.015093, 50.020308],
              [90.014273, 50.020967],
              [90.013506, 50.021353],
              [90.01293, 50.022635],
              [90.01203, 50.023706],
              [90.012957, 50.02453],
              [90.01248, 50.024805],
              [90.012392, 50.025991],
              [90.011728, 50.026541],
              [90.011839, 50.026941],
              [90.009951, 50.027575],
              [90.010038, 50.028574],
              [90.009916, 50.029978],
              [90.008791, 50.031481],
              [90.008352, 50.033312],
              [90.009283, 50.034063],
              [90.009344, 50.034716],
              [90.009184, 50.035242],
              [90.008558, 50.035677],
              [90.008444, 50.036428],
              [90.008741, 50.036951],
              [90.008291, 50.037848],
              [90.008394, 50.037976],
              [90.00849593800001, 50.038103021999973],
              [90.008585, 50.038214],
              [90.008371, 50.038664],
              [90.008127, 50.039827],
              [90.00773, 50.040487],
              [90.007658, 50.041422],
              [90.007208, 50.041914],
              [90.007246, 50.042234],
              [90.007292, 50.042589],
              [90.006498, 50.043203],
              [90.006182, 50.043749],
              [90.005499, 50.044077],
              [90.004728, 50.045115],
              [90.004004, 50.045354],
              [90.003984, 50.045359],
              [90.003969, 50.045412],
              [90.003653, 50.046125],
              [90.002207, 50.047308],
              [90.000322, 50.04812],
              [89.999979, 50.049208],
              [90.001196, 50.050924],
              [90.002619, 50.052057],
              [90.003836, 50.052858],
              [90.011164, 50.056738],
              [90.024672, 50.06394],
              [90.028864, 50.065897],
              [90.029966, 50.066412],
              [90.048555, 50.075056],
              [90.0613, 50.080973],
              [90.066259, 50.083178],
              [90.071829, 50.085642],
              [90.083757, 50.091406],
              [90.088118, 50.093515],
              [90.094896, 50.095201],
              [90.112142, 50.09947],
              [90.12052, 50.101542],
              [90.135542, 50.105246],
              [90.139425, 50.10602],
              [90.151804, 50.108458],
              [90.155001, 50.109087],
              [90.165712, 50.111185],
              [90.167029, 50.110685],
              [90.168947, 50.109957],
              [90.1733, 50.110029],
              [90.175627, 50.110983],
              [90.177141, 50.111608],
              [90.178148, 50.112024],
              [90.180489, 50.111349],
              [90.183264, 50.110548],
              [90.1915, 50.108343],
              [90.192363167, 50.108111139000016],
              [90.19868775499998, 50.106412248000026],
              [90.203089, 50.10523],
              [90.207468, 50.10639],
              [90.211885, 50.106691],
              [90.21414, 50.109464],
              [90.214735, 50.110197],
              [90.221533, 50.112215],
              [90.232016, 50.111044],
              [90.233784, 50.110796],
              [90.242849, 50.109529],
              [90.245356, 50.109194],
              [90.248056, 50.109247],
              [90.250036, 50.109568],
              [90.260431, 50.111902],
              [90.266569, 50.114412],
              [90.281584, 50.118765],
              [90.291224, 50.122282],
              [90.296873, 50.128386],
              [90.304636, 50.136652],
              [90.311468, 50.143999],
              [90.31233, 50.144915],
              [90.316885, 50.149755],
              [90.321539, 50.153421],
              [90.324663, 50.154894],
              [90.333355, 50.156644],
              [90.342012, 50.158384],
              [90.349451, 50.159781],
              [90.356252874, 50.169030798],
              [90.358778, 50.17053],
              [90.365680849, 50.179159525999978],
              [90.365934, 50.179476],
              [90.369661695, 50.182249092],
              [90.372221, 50.184153],
              [90.374273, 50.187445],
              [90.376493, 50.191008],
              [90.382608, 50.198244],
              [90.388132, 50.19742],
              [90.391439, 50.198267],
              [90.39414, 50.19821],
              [90.397203, 50.198893],
              [90.40251, 50.198],
              [90.403875, 50.198152],
              [90.407167, 50.198515],
              [90.40888, 50.199408],
              [90.410916064, 50.200472551000018],
              [90.410959, 50.200495],
              [90.414011, 50.20064],
              [90.416861411000014, 50.199989125],
              [90.421434, 50.198945],
              [90.423162, 50.198549],
              [90.424654, 50.198728],
              [90.426718, 50.198973],
              [90.428968, 50.198438],
              [90.429475783999976, 50.198316573999989],
              [90.433836, 50.197275],
              [90.437897, 50.196909],
              [90.442667, 50.196478],
              [90.446493, 50.197042],
              [90.449886908999986, 50.196865806],
              [90.450384, 50.19684],
              [90.46829, 50.200712],
              [90.473764, 50.201891],
              [90.488676, 50.205278],
              [90.483137, 50.208982],
              [90.482748, 50.210791],
              [90.484327, 50.21298],
              [90.486433, 50.216642],
              [90.486357, 50.218592],
              [90.481699, 50.223055],
              [90.482869, 50.224554],
              [90.483271, 50.225069],
              [90.485231, 50.225908],
              [90.486879, 50.226614],
              [90.490127778999977, 50.228005445],
              [90.491056, 50.228403],
              [90.493856, 50.229525],
              [90.495077246999983, 50.229572256999973],
              [90.497965, 50.229684],
              [90.497999, 50.229693],
              [90.499666, 50.230085],
              [90.501494, 50.230661],
              [90.502054, 50.230837],
              [90.502103, 50.230829],
              [90.506399, 50.230116],
              [90.512613, 50.23374],
              [90.516035, 50.235735],
              [90.517561, 50.235109],
              [90.51914, 50.234461],
              [90.525866, 50.236692],
              [90.528997, 50.237005],
              [90.536619, 50.235857],
              [90.540674, 50.238527],
              [90.545652, 50.240564],
              [90.547972, 50.241514],
              [90.549284, 50.242815],
              [90.551168, 50.24407],
              [90.55657259100002, 50.243537748],
              [90.557951, 50.243402],
              [90.561765, 50.240872],
              [90.56341919099998, 50.239772620999986],
              [90.563864, 50.239477],
              [90.56703, 50.239046],
              [90.568418, 50.239533],
              [90.569868, 50.240042],
              [90.573717, 50.24098],
              [90.581087, 50.241644],
              [90.583017, 50.24267],
              [90.58692, 50.240843],
              [90.588923963000013, 50.240704912000012],
              [90.5893, 50.240679],
              [90.59112920299998, 50.239523685],
              [90.595521995000013, 50.236749222000014],
              [90.596029, 50.236429],
              [90.596888603000025, 50.234853145999978],
              [90.597696, 50.233373],
              [90.597975, 50.232859],
              [90.599462, 50.232663],
              [90.600977, 50.232462],
              [90.601034878, 50.232441256000016],
              [90.606203, 50.230589],
              [90.607774, 50.229318],
              [90.608675, 50.228586],
              [90.610298226999987, 50.22479769],
              [90.610754, 50.223734],
              [90.615274188, 50.223663448000025],
              [90.615431, 50.223661],
              [90.615590116000021, 50.223609867],
              [90.619467, 50.222364],
              [90.625347194000028, 50.22200662900002],
              [90.625555, 50.221994],
              [90.628182891999984, 50.220119372],
              [90.62956, 50.219137],
              [90.633444699999984, 50.218726047000018],
              [90.633776, 50.218691],
              [90.634107557, 50.218483137000021],
              [90.637987, 50.216051],
              [90.643141, 50.215555],
              [90.648893, 50.218245],
              [90.649237, 50.218405],
              [90.652475, 50.218752],
              [90.65682, 50.220152],
              [90.65950639, 50.219968568000013],
              [90.660906, 50.219873],
              [90.660921383000016, 50.219606702000021],
              [90.660967, 50.218817],
              [90.663271867999981, 50.218290215000025],
              [90.664091, 50.218103],
              [90.664347, 50.217115],
              [90.66662, 50.213678],
              [90.666864, 50.213308],
              [90.667316606999975, 50.211588431],
              [90.667402, 50.211264],
              [90.668246126999975, 50.210930616999974],
              [90.672860225000022, 50.209108306000019],
              [90.676046, 50.20875],
              [90.691633, 50.215925],
              [90.702822, 50.221106],
              [90.72122, 50.229631],
              [90.735056, 50.23628],
              [90.735083, 50.245096],
              [90.732832, 50.249701],
              [90.728148, 50.263533],
              [90.725176, 50.272348],
              [90.721651, 50.282354],
              [90.720204, 50.286535],
              [90.720201, 50.286551],
              [90.714998, 50.301554],
              [90.716055, 50.303808],
              [90.714876, 50.305342],
              [90.712412, 50.307203],
              [90.709272, 50.310434],
              [90.707861, 50.314363],
              [90.7111, 50.314932],
              [90.714205, 50.315878],
              [90.716368, 50.317945],
              [90.717978, 50.319067],
              [90.719625, 50.319277],
              [90.720213, 50.319712],
              [90.721212, 50.319662],
              [90.721472, 50.319986],
              [90.724123, 50.320074],
              [90.726213, 50.320292],
              [90.729394, 50.319567],
              [90.729509, 50.31954],
              [90.730204910999987, 50.319571522],
              [90.730944, 50.319605],
              [90.731063252000013, 50.319595148000019],
              [90.733389, 50.319403],
              [90.734308, 50.319811],
              [90.735468, 50.319799],
              [90.736006, 50.320162],
              [90.736773, 50.320318],
              [90.737432, 50.320402],
              [90.73816808700002, 50.320722763],
              [90.738623, 50.320921],
              [90.740230709, 50.320985797],
              [90.740335, 50.32099],
              [90.740349286000026, 50.321000917999982],
              [90.741667, 50.322008],
              [90.741745424999976, 50.322006418],
              [90.742609, 50.321989],
              [90.743246, 50.322569],
              [90.743738, 50.322649],
              [90.744104, 50.32308],
              [90.744989, 50.323099],
              [90.747412, 50.324492],
              [90.748022, 50.325602],
              [90.750292, 50.326368],
              [90.751993, 50.327768],
              [90.752192, 50.327932],
              [90.754614, 50.329267],
              [90.755175, 50.330194],
              [90.757433, 50.331785],
              [90.758604, 50.331984],
              [90.761791158, 50.333211235000022],
              [90.762793, 50.333597],
              [90.76344680699998, 50.333456093],
              [90.763605, 50.333422],
              [90.763993619000018, 50.333536962999972],
              [90.764467, 50.333677],
              [90.764702898999985, 50.33364186],
              [90.765333, 50.333548],
              [90.76643522, 50.33398368600001],
              [90.767706, 50.334486],
              [90.768093016000023, 50.334480475000021],
              [90.769037, 50.334467],
              [90.769477151999979, 50.334607507999976],
              [90.770124, 50.334814],
              [90.771097, 50.334768],
              [90.772211, 50.334963],
              [90.773671087000025, 50.334994822],
              [90.773771, 50.334997],
              [90.774958, 50.335466],
              [90.77611, 50.335539],
              [90.777712, 50.336237],
              [90.780848, 50.336313],
              [90.781404452, 50.336075901000015],
              [90.783094, 50.335356],
              [90.784776, 50.333059],
              [90.786505, 50.330694],
              [90.788397, 50.329424],
              [90.792505007999978, 50.328234986999973],
              [90.795725, 50.327303],
              [90.798613, 50.333376],
              [90.802172, 50.335482],
              [90.80649, 50.335882],
              [90.808737, 50.336653],
              [90.811262, 50.340899],
              [90.818563, 50.340857],
              [90.822332, 50.343046],
              [90.822801, 50.344736],
              [90.823462, 50.347128],
              [90.826479, 50.352243],
              [90.82744, 50.353071],
              [90.835722, 50.353697],
              [90.838857809999979, 50.353305361000025],
              [90.839205, 50.353262],
              [90.839463823000017, 50.352837824],
              [90.841963, 50.348742],
              [90.845334, 50.346285],
              [90.847708, 50.344553],
              [90.852053, 50.344419],
              [90.86083, 50.343832],
              [90.864332, 50.346898],
              [90.865179, 50.347639],
              [90.86804, 50.34783],
              [90.869455, 50.347567],
              [90.873491, 50.346819],
              [90.87498545, 50.347833857000012],
              [90.876417, 50.348806],
              [90.876452213, 50.348829905],
              [90.880789, 50.351774],
              [90.883192, 50.352137],
              [90.885736, 50.350462],
              [90.891397, 50.346735],
              [90.895628, 50.347345],
              [90.90003, 50.345995],
              [90.905077, 50.348261],
              [90.91395, 50.350981],
              [90.91506, 50.353407],
              [90.915117, 50.358953],
              [90.913084, 50.360209],
              [90.911432, 50.36183],
              [90.911013, 50.365351],
              [90.916533, 50.370962],
              [90.916761, 50.375872],
              [90.919786, 50.380201],
              [90.918460116, 50.380940405999979],
              [90.915373, 50.382662],
              [90.913065, 50.383947],
              [90.9133769, 50.384442073],
              [90.914606, 50.386393],
              [90.915033, 50.392149],
              [90.912077, 50.395128],
              [90.910246, 50.398397],
              [90.907178784, 50.401668578],
              [90.906794, 50.402079],
              [90.904547, 50.405943],
              [90.905291, 50.409826],
              [90.905399316, 50.409881750000011],
              [90.907774, 50.411104],
              [90.910082, 50.41202],
              [90.920728, 50.412027],
              [90.92507, 50.412027],
              [90.93326, 50.415239],
              [90.947443, 50.417707],
              [90.953569, 50.420473],
              [90.964296, 50.423063],
              [90.974431, 50.427186],
              [90.978075, 50.428667],
              [90.983023, 50.429193],
              [90.991442, 50.428862],
              [90.994562, 50.42964],
              [90.997522, 50.429728],
              [90.998026, 50.429613],
              [90.999597, 50.429316],
              [90.999983, 50.429243],
              [91.006208, 50.429647],
              [91.013266, 50.42853],
              [91.019445, 50.428675],
              [91.022802, 50.428827],
              [91.025145, 50.430716],
              [91.026842, 50.432085],
              [91.028872, 50.431562],
              [91.035295, 50.43128],
              [91.039286, 50.430814],
              [91.044539, 50.430197],
              [91.050619, 50.429632],
              [91.05686, 50.429399],
              [91.06933, 50.429407],
              [91.073271, 50.429457],
              [91.079977, 50.42906],
              [91.084772, 50.430765],
              [91.086839, 50.430806],
              [91.092836, 50.430918],
              [91.094545, 50.430409],
              [91.095175, 50.43022],
              [91.095342, 50.430368],
              [91.096891, 50.431746],
              [91.101004, 50.432013],
              [91.107038, 50.430296],
              [91.109667, 50.430414],
              [91.114717, 50.429369],
              [91.114756, 50.429361],
              [91.114782, 50.429368],
              [91.116861, 50.42977],
              [91.118061, 50.429198],
              [91.119619, 50.428453],
              [91.120753, 50.42906],
              [91.122541, 50.430014],
              [91.126681, 50.42838],
              [91.128339109000024, 50.427724324999986],
              [91.129091, 50.427427],
              [91.130419104, 50.424975002999986],
              [91.130899, 50.424089],
              [91.136679, 50.42507],
              [91.142196486999978, 50.426301248000016],
              [91.142881, 50.426454],
              [91.143225, 50.426531],
              [91.144148, 50.426302],
              [91.146540292, 50.425711327999977],
              [91.149401, 50.425005],
              [91.157873, 50.423948],
              [91.158136, 50.423002],
              [91.1621, 50.422468],
              [91.16361, 50.42243],
              [91.16432, 50.423212],
              [91.165360790000022, 50.423628684999983],
              [91.166578, 50.424116],
              [91.167433, 50.424578],
              [91.167963, 50.424982],
              [91.168711, 50.42531],
              [91.169432, 50.425432],
              [91.169848778000016, 50.425483573],
              [91.170725, 50.425592],
              [91.172243, 50.426172],
              [91.174398, 50.426695],
              [91.175165, 50.426985],
              [91.176104, 50.427267],
              [91.1763398, 50.427493962000028],
              [91.176691, 50.427832],
              [91.177221, 50.428144],
              [91.178915, 50.428507],
              [91.180082, 50.428728],
              [91.18066672499998, 50.42897506700001],
              [91.181147, 50.429178],
              [91.182859, 50.429426],
              [91.184938, 50.430193],
              [91.187155, 50.431242],
              [91.188749, 50.431795],
              [91.192884, 50.433477],
              [91.194639, 50.434484],
              [91.195624198000019, 50.434676576000015],
              [91.196184, 50.434786],
              [91.197315730000014, 50.434616829],
              [91.197435, 50.434599],
              [91.198298, 50.43461],
              [91.19961, 50.434526],
              [91.200602, 50.434839],
              [91.201456, 50.435999],
              [91.203131, 50.43635],
              [91.203539, 50.436636],
              [91.205053, 50.437101],
              [91.205278, 50.438265],
              [91.20558, 50.438738],
              [91.206514, 50.439425],
              [91.206548, 50.43947],
              [91.207266, 50.440447],
              [91.207922, 50.440851],
              [91.208384, 50.440966],
              [91.208803, 50.440935],
              [91.209311, 50.440752],
              [91.20973, 50.440553],
              [91.210135, 50.440359],
              [91.210699, 50.440199],
              [91.211512, 50.440142],
              [91.212114, 50.440229],
              [91.212717, 50.44031],
              [91.213617, 50.44042],
              [91.213949, 50.440672],
              [91.214441, 50.441324],
              [91.216845, 50.442068],
              [91.217508, 50.442858],
              [91.219266256000026, 50.443610445],
              [91.219576, 50.443743],
              [91.221563, 50.443922],
              [91.221878883999977, 50.443801747],
              [91.222464, 50.443579],
              [91.223074, 50.44348],
              [91.223455, 50.443533],
              [91.225092, 50.443766],
              [91.226526, 50.444315],
              [91.226828, 50.44459],
              [91.227045, 50.445078],
              [91.227289, 50.44523],
              [91.227613, 50.445295],
              [91.228556, 50.445265],
              [91.230249, 50.445902],
              [91.230574, 50.446287],
              [91.230791, 50.446898],
              [91.231474, 50.447321],
              [91.233229, 50.447584],
              [91.235239, 50.448095],
              [91.238703, 50.44945],
              [91.240126, 50.449659],
              [91.241941, 50.450441],
              [91.243788, 50.450609],
              [91.244658, 50.450731],
              [91.24542, 50.451113],
              [91.24687, 50.451567],
              [91.24758, 50.452047],
              [91.248323, 50.452188],
              [91.25139, 50.452581],
              [91.252584, 50.453032],
              [91.259554, 50.456957],
              [91.264936, 50.461222],
              [91.267782, 50.462545],
              [91.276484, 50.463709],
              [91.280382, 50.465616],
              [91.283236, 50.466822],
              [91.284532, 50.467542],
              [91.285418, 50.468035],
              [91.287813, 50.468958],
              [91.289961, 50.470716],
              [91.29138, 50.471586],
              [91.294256, 50.471956],
              [91.30485, 50.470873],
              [91.309591, 50.470057],
              [91.313681, 50.469965],
              [91.31686879199998, 50.470554712000023],
              [91.316919, 50.470564],
              [91.318174, 50.47064],
              [91.32725, 50.469667],
              [91.327639, 50.469549],
              [91.328212206999979, 50.469373049000012],
              [91.332884, 50.467939],
              [91.334307, 50.467768],
              [91.339067, 50.467813],
              [91.342634, 50.468137],
              [91.346148, 50.468454],
              [91.347834, 50.468088],
              [91.350851, 50.468096],
              [91.353867, 50.467081],
              [91.356836, 50.466078],
              [91.36109, 50.465216],
              [91.363794, 50.464392],
              [91.367712, 50.463945],
              [91.369905, 50.464224],
              [91.3715, 50.464254],
              [91.372915, 50.464087],
              [91.377028, 50.462866],
              [91.378427, 50.46261],
              [91.37985, 50.462545],
              [91.381552, 50.462751],
              [91.383055, 50.463121],
              [91.384618, 50.463335],
              [91.385, 50.463388],
              [91.387186, 50.463392],
              [91.388575, 50.462786],
              [91.391314, 50.461592],
              [91.392427, 50.460882],
              [91.393541860000028, 50.460019182999986],
              [91.393984, 50.459677],
              [91.395437, 50.45817],
              [91.397270124999977, 50.456866427000023],
              [91.397829, 50.456469],
              [91.400179, 50.455313],
              [91.402014, 50.454767],
              [91.403593, 50.454481],
              [91.406755, 50.454279],
              [91.406748, 50.454447],
              [91.406645, 50.454657],
              [91.406541711999978, 50.454700914999989],
              [91.406351, 50.454782],
              [91.406698, 50.455362],
              [91.406618, 50.456793],
              [91.405916, 50.457594],
              [91.405863, 50.458025],
              [91.405298, 50.458456],
              [91.40523, 50.458887],
              [91.405090535999989, 50.459126081000022],
              [91.404943, 50.459379],
              [91.404898, 50.45994],
              [91.404562, 50.460196],
              [91.404356, 50.460485],
              [91.404036, 50.460772],
              [91.403948, 50.461172],
              [91.403414, 50.461515],
              [91.403372, 50.46192],
              [91.40291, 50.462107],
              [91.402834, 50.462305],
              [91.402266, 50.462473],
              [91.402189, 50.462587],
              [91.4023, 50.462675],
              [91.402597, 50.462751],
              [91.402708, 50.462824],
              [91.402582, 50.462881],
              [91.402056, 50.462961],
              [91.401905165000016, 50.463025464999987],
              [91.401815, 50.463064],
              [91.401716, 50.463213],
              [91.401537, 50.463247],
              [91.401495, 50.463255],
              [91.401064, 50.463308],
              [91.401037, 50.463461],
              [91.401041, 50.463644],
              [91.40159, 50.464258],
              [91.401663, 50.46456],
              [91.401594, 50.464724],
              [91.401209, 50.465178],
              [91.401155139000025, 50.465311277000012],
              [91.401072, 50.465517],
              [91.400946, 50.465647],
              [91.400700237000024, 50.465800847000025],
              [91.400446, 50.46596],
              [91.4, 50.46633],
              [91.400025780000021, 50.466551341000013],
              [91.400099, 50.46718],
              [91.400549, 50.471552],
              [91.400816, 50.474524],
              [91.400526, 50.476133],
              [91.402048, 50.477533],
              [91.402983, 50.477491],
              [91.403921, 50.47716],
              [91.405458, 50.478949],
              [91.40732, 50.480417],
              [91.413271, 50.48118],
              [91.414255, 50.481084],
              [91.415201, 50.480989],
              [91.419466, 50.483267],
              [91.420988, 50.484076],
              [91.421923, 50.485342],
              [91.427141, 50.486353],
              [91.430887, 50.489515],
              [91.435804, 50.489508],
              [91.438574, 50.490141],
              [91.440371, 50.492716],
              [91.442465, 50.494143],
              [91.450129, 50.500929],
              [91.458834, 50.508604],
              [91.458326, 50.520147],
              [91.457933, 50.529547],
              [91.457288, 50.54363],
              [91.457102, 50.547644],
              [91.487608, 50.554026],
              [91.488718, 50.55427],
              [91.495264, 50.555712],
              [91.499884, 50.556524],
              [91.515455, 50.559694],
              [91.524801, 50.561922],
              [91.522604, 50.57041],
              [91.522501, 50.570803],
              [91.523203, 50.570718],
              [91.525785, 50.570398],
              [91.533892, 50.572546],
              [91.533914461999984, 50.573260950000019],
              [91.533968, 50.574965],
              [91.534033291000014, 50.577076071000022],
              [91.534163, 50.58127],
              [91.542036, 50.581305],
              [91.54751, 50.581831],
              [91.556765, 50.583269],
              [91.559332, 50.584299],
              [91.562223, 50.583845],
              [91.56428, 50.585474],
              [91.570734, 50.585306],
              [91.576388, 50.584516],
              [91.58185, 50.58375],
              [91.584971, 50.584356],
              [91.586416, 50.584635],
              [91.589899, 50.584635],
              [91.589998, 50.584764],
              [91.59107, 50.584242],
              [91.598665, 50.580534],
              [91.600622, 50.581396],
              [91.607641, 50.582003],
              [91.610823, 50.583006],
              [91.619074, 50.58346],
              [91.620192, 50.583464],
              [91.621492, 50.584311],
              [91.622727911000027, 50.585118216000012],
              [91.623167, 50.585405],
              [91.624447146000023, 50.584929553],
              [91.625030617999982, 50.584712852],
              [91.625181, 50.584657],
              [91.626092270000015, 50.584318399999972],
              [91.628023, 50.583601],
              [91.632521, 50.583746],
              [91.633055297999988, 50.583959930999981],
              [91.635046, 50.584757],
              [91.636390888999983, 50.584134763],
              [91.63743, 50.583654],
              [91.642240144000027, 50.585890870000014],
              [91.642935, 50.586214],
              [91.644304599, 50.586254258],
              [91.646303, 50.586313],
              [91.649977, 50.58629],
              [91.650141597000015, 50.590012241000011],
              [91.65027, 50.592916],
              [91.650686, 50.602571],
              [91.651053064999985, 50.608388336000019],
              [91.651503, 50.615519],
              [91.651688, 50.61865],
              [91.651754, 50.619795],
              [91.652154957, 50.626503698000022],
              [91.652246, 50.628027],
              [91.653291086000024, 50.633345170999974],
              [91.65388, 50.636342],
              [91.653886, 50.636381],
              [91.65532, 50.6437],
              [91.655394, 50.644083],
              [91.66968, 50.654226],
              [91.673928806999982, 50.65732608899998],
              [91.681045852000011, 50.662518952000028],
              [91.681982, 50.663202],
              [91.687477949000026, 50.668035998],
              [91.688566, 50.668993],
              [91.694849, 50.673567],
              [91.702627, 50.681356],
              [91.711657, 50.689184],
              [91.716932, 50.693766],
              [91.723085, 50.699114],
              [91.731043, 50.69932],
              [91.733618, 50.699396],
              [91.745779, 50.699747],
              [91.749964, 50.7013],
              [91.754129, 50.702951],
              [91.775332, 50.711115],
              [91.786287, 50.715288],
              [91.793497, 50.718046],
              [91.799418, 50.720312],
              [91.802595, 50.720854],
              [91.818567, 50.723574],
              [91.82424, 50.724535],
              [91.828852, 50.725946],
              [91.834486, 50.727571],
              [91.842669, 50.730169],
              [91.847944, 50.731787],
              [91.854959, 50.733938],
              [91.868719, 50.732096],
              [91.881999, 50.730328],
              [91.892946, 50.728865],
              [91.903299, 50.727438],
              [91.913038, 50.726221],
              [91.927992, 50.724272],
              [91.936811, 50.723119],
              [91.971865, 50.718531],
              [91.976152, 50.718134],
              [91.983393, 50.715708],
              [91.984907, 50.715643],
              [91.986483, 50.715574],
              [91.987295, 50.71512],
              [91.987657, 50.714719],
              [91.988386, 50.7139],
              [91.990294, 50.71382],
              [91.993872, 50.712366],
              [91.996077, 50.713137],
              [91.996873, 50.713106],
              [91.999914, 50.712988],
              [92.005068, 50.711267],
              [92.005205, 50.711133],
              [92.006392, 50.709948],
              [92.010244, 50.708735],
              [92.012259, 50.707266],
              [92.013872, 50.706457],
              [92.016558, 50.70624],
              [92.023199, 50.705061],
              [92.03974, 50.702162],
              [92.050097, 50.70035],
              [92.055826, 50.699335],
              [92.067945, 50.697153],
              [92.07173, 50.696486],
              [92.099768, 50.697344],
              [92.11841, 50.699682],
              [92.15106, 50.703768],
              [92.172102, 50.706392],
              [92.189028, 50.711023],
              [92.198629, 50.713648],
              [92.204157, 50.715174],
              [92.229197, 50.721548],
              [92.241781, 50.724749],
              [92.250265, 50.726179],
              [92.270109, 50.729502],
              [92.271711, 50.73097],
              [92.271723, 50.732267],
              [92.278688, 50.738264],
              [92.280012, 50.739541],
              [92.281111, 50.740599],
              [92.282927, 50.741793],
              [92.285616, 50.743433],
              [92.287622, 50.745371],
              [92.288984, 50.746023],
              [92.290434, 50.747431],
              [92.291579, 50.747868],
              [92.291887, 50.747988],
              [92.299345, 50.749769],
              [92.304645838999988, 50.751223902],
              [92.30567, 50.751505],
              [92.307350371999974, 50.751700496000012],
              [92.308687, 50.751856],
              [92.312552, 50.752626],
              [92.314707, 50.753775],
              [92.315996, 50.754873],
              [92.316668, 50.756071],
              [92.316889, 50.758352],
              [92.316584, 50.762396],
              [92.319277, 50.765295],
              [92.320253, 50.769495],
              [92.319925, 50.770597],
              [92.318781, 50.772245],
              [92.316034, 50.775045],
              [92.315519, 50.777452],
              [92.317015, 50.779745],
              [92.317968, 50.781874],
              [92.318205, 50.782633],
              [92.317808, 50.783812],
              [92.317144917, 50.78426441900001],
              [92.316763, 50.784525],
              [92.31558, 50.786451],
              [92.314894, 50.788759],
              [92.313757, 50.790094],
              [92.313674449000018, 50.790868934],
              [92.313646, 50.791136],
              [92.312345, 50.791983],
              [92.310667, 50.793509],
              [92.310778, 50.793634],
              [92.309881, 50.794283],
              [92.307253, 50.796186],
              [92.306826, 50.798124],
              [92.306437, 50.800001],
              [92.304873, 50.801283],
              [92.304621746, 50.801677202],
              [92.303553, 50.803354],
              [92.302683, 50.805498],
              [92.302662719000011, 50.806196245000024],
              [92.302641, 50.806944],
              [92.303549, 50.808596],
              [92.306417, 50.81138],
              [92.308199, 50.811884],
              [92.31069, 50.813749],
              [92.315123, 50.815802],
              [92.318288, 50.817358],
              [92.319613, 50.81801],
              [92.320423329999983, 50.819077371],
              [92.320543, 50.819235],
              [92.322660962999976, 50.820539286999974],
              [92.323008, 50.820753],
              [92.323310099000025, 50.821357197999987],
              [92.323893, 50.822523],
              [92.324890628999981, 50.822960412999976],
              [92.326452, 50.823645],
              [92.327829, 50.82477],
              [92.328657, 50.826693],
              [92.329035, 50.828463],
              [92.32844, 50.829851],
              [92.328939, 50.831602],
              [92.328691, 50.832785],
              [92.327108, 50.834467],
              [92.327051, 50.835711],
              [92.326962713, 50.835938317],
              [92.326235, 50.837812],
              [92.326349, 50.839766],
              [92.326370624999981, 50.839856225],
              [92.32704, 50.842649],
              [92.326704, 50.84363],
              [92.325285, 50.846266],
              [92.319014, 50.858309],
              [92.316599, 50.865671],
              [92.31616, 50.86701],
              [92.312212, 50.879148],
              [92.322004, 50.879866],
              [92.330828, 50.879801],
              [92.343744, 50.879698],
              [92.345076, 50.880144],
              [92.346098, 50.8832],
              [92.352816, 50.883471],
              [92.360724, 50.884428],
              [92.364126, 50.882936],
              [92.365206, 50.882044],
              [92.372129, 50.88043],
              [92.382978, 50.872412],
              [92.383665, 50.871325],
              [92.384207, 50.87039],
              [92.386262, 50.86812],
              [92.390151392, 50.863819580999973],
              [92.393336128999977, 50.86029828400001],
              [92.393728, 50.859865],
              [92.393937, 50.85991],
              [92.397623, 50.860685],
              [92.399644712, 50.860609136999983],
              [92.401274, 50.860548],
              [92.404222, 50.857958],
              [92.404237382000019, 50.856827751000026],
              [92.404245, 50.856268],
              [92.407008506000011, 50.854547692999972],
              [92.40851, 50.853613],
              [92.408598, 50.85211],
              [92.407656, 50.846964],
              [92.406195, 50.844713],
              [92.405893, 50.843039],
              [92.407042, 50.839067],
              [92.405893, 50.835161],
              [92.404966, 50.833388],
              [92.403967, 50.831476],
              [92.404482, 50.829924],
              [92.405523, 50.828951],
              [92.40629, 50.828173],
              [92.406309046, 50.828119969],
              [92.406675, 50.827101],
              [92.411959, 50.824389],
              [92.41371, 50.822454],
              [92.415269, 50.821691],
              [92.417929, 50.820383],
              [92.419705842999974, 50.818968747999975],
              [92.42034, 50.818464],
              [92.420435269, 50.817808674999981],
              [92.420645, 50.816366],
              [92.422070521000023, 50.815576971999974],
              [92.424215, 50.81439],
              [92.424147, 50.813467],
              [92.423803, 50.813234],
              [92.421009833000028, 50.811339378000014],
              [92.42071, 50.811136],
              [92.431921, 50.803267],
              [92.44615, 50.79788],
              [92.460768, 50.792356],
              [92.469687, 50.788954],
              [92.476728, 50.786287],
              [92.489874, 50.785765],
              [92.499708, 50.785566],
              [92.505651, 50.785131],
              [92.516119, 50.787764],
              [92.533834, 50.792238],
              [92.546991, 50.795564],
              [92.561499, 50.799227],
              [92.586851, 50.791227],
              [92.588532043999976, 50.790161055],
              [92.597052118000022, 50.7847585],
              [92.600729, 50.782427],
              [92.607140361, 50.777059298999973],
              [92.609655, 50.774954],
              [92.615166183999975, 50.768939261000014],
              [92.615576, 50.768492],
              [92.617733828999974, 50.767607479999981],
              [92.619894, 50.766722],
              [92.619080666, 50.766578142000014],
              [92.6164, 50.766104],
              [92.612898, 50.763788],
              [92.612642, 50.762476],
              [92.612165, 50.761652],
              [92.612433733999978, 50.76102460200002],
              [92.612673, 50.760466],
              [92.613237, 50.759264],
              [92.612513, 50.757952],
              [92.613375, 50.75662],
              [92.612806, 50.755789],
              [92.611658, 50.754984],
              [92.609488, 50.75474],
              [92.608694, 50.754221],
              [92.608519, 50.753191],
              [92.607592, 50.752214],
              [92.607546, 50.749643],
              [92.606939, 50.747187],
              [92.607286, 50.744959],
              [92.607198004, 50.744806217000018],
              [92.606649, 50.743853],
              [92.607586057, 50.742842086999985],
              [92.607664, 50.742758],
              [92.607616458999985, 50.742576607],
              [92.607458, 50.741972],
              [92.607359, 50.740396],
              [92.606066, 50.739607],
              [92.605932, 50.73826],
              [92.606592375999981, 50.736705563999976],
              [92.60676, 50.736311],
              [92.608, 50.734934],
              [92.607927, 50.734613],
              [92.607488, 50.734278],
              [92.604770581000025, 50.732212733999972],
              [92.603567, 50.731298],
              [92.603563271999974, 50.730786358999978],
              [92.603559, 50.7302],
              [92.602884, 50.729391],
              [92.60253, 50.727949],
              [92.601553, 50.727045],
              [92.602076, 50.725801],
              [92.601679, 50.725256],
              [92.601881, 50.724367],
              [92.603552, 50.723063],
              [92.603666, 50.722757],
              [92.603373, 50.722353],
              [92.60248, 50.721704],
              [92.602320210000016, 50.721120129999974],
              [92.602217, 50.720743],
              [92.603575, 50.719698],
              [92.610018, 50.715403],
              [92.610821621000014, 50.714860640999973],
              [92.617965390999984, 50.710039352000024],
              [92.619944, 50.708704],
              [92.627729, 50.703386],
              [92.654528, 50.704992],
              [92.657675, 50.705339],
              [92.684893, 50.707094],
              [92.702394, 50.708071],
              [92.705263, 50.708296],
              [92.711512, 50.709791],
              [92.723623, 50.712812],
              [92.72872, 50.713839],
              [92.735567, 50.715719],
              [92.743635, 50.717749],
              [92.74972, 50.721903],
              [92.753344, 50.724188],
              [92.762377, 50.729734],
              [92.764925, 50.731287],
              [92.765508501, 50.734219113],
              [92.766882, 50.741121],
              [92.764265, 50.747183],
              [92.762552, 50.751558],
              [92.759462, 50.759451],
              [92.760681111999986, 50.763425921000021],
              [92.762437, 50.769151],
              [92.762887, 50.770613],
              [92.764692, 50.776506],
              [92.776972, 50.787687],
              [92.781446, 50.791849],
              [92.786181, 50.796343],
              [92.791451782000024, 50.803978325],
              [92.792311, 50.805223],
              [92.793494013999975, 50.804938468999978],
              [92.797529, 50.803968],
              [92.800894, 50.804537],
              [92.802385911999977, 50.806053651000013],
              [92.802462, 50.806131],
              [92.802634453999985, 50.806087024000021],
              [92.80596, 50.805239],
              [92.806925, 50.806921],
              [92.808008, 50.807894],
              [92.809317, 50.808207],
              [92.819426, 50.808691],
              [92.832678, 50.810122],
              [92.833426, 50.809996],
              [92.835268, 50.809935],
              [92.837553, 50.811171],
              [92.840334, 50.810888],
              [92.842547, 50.810934],
              [92.842623, 50.810934],
              [92.843428, 50.811087],
              [92.845957, 50.810812],
              [92.849527, 50.809767],
              [92.85013, 50.809984],
              [92.853571, 50.811228],
              [92.856924, 50.811514],
              [92.858179, 50.810598],
              [92.861998, 50.809298],
              [92.862959, 50.807467],
              [92.863297, 50.807169],
              [92.864672, 50.805952],
              [92.869945941000026, 50.803404387],
              [92.871843, 50.802488],
              [92.871803437999972, 50.801609298000017],
              [92.871786, 50.801222],
              [92.872885, 50.80028],
              [92.877001, 50.800749],
              [92.878252, 50.800634],
              [92.880323, 50.800955],
              [92.882434091999983, 50.801412801000026],
              [92.883242, 50.801588],
              [92.884291244999986, 50.801463257000023],
              [92.891485, 50.800608],
              [92.893857, 50.80066],
              [92.894636, 50.800676],
              [92.898924, 50.802706],
              [92.901175, 50.803041],
              [92.90449, 50.801851],
              [92.906717, 50.800943],
              [92.908747, 50.800955],
              [92.912006153999982, 50.800934378000022],
              [92.912382, 50.800932],
              [92.912520857, 50.800584551999975],
              [92.913065, 50.799223],
              [92.916071, 50.795973],
              [92.916166, 50.79587],
              [92.921103, 50.793966],
              [92.923068672, 50.793873362],
              [92.924498, 50.793806],
              [92.924388347999979, 50.792813685],
              [92.924337, 50.792349],
              [92.925367, 50.79077],
              [92.927576, 50.789694],
              [92.933146, 50.789621],
              [92.937868, 50.789091],
              [92.940638, 50.787649],
              [92.941824, 50.789289],
              [92.945257, 50.791609],
              [92.949919, 50.793028],
              [92.957403, 50.794279],
              [92.961264, 50.794859],
              [92.968512, 50.793592],
              [92.969694, 50.793878],
              [92.972303, 50.794508],
              [92.974646, 50.79418],
              [92.978201, 50.794249],
              [92.981836, 50.794863],
              [92.989466, 50.794127],
              [92.992628, 50.792292],
              [92.997042, 50.792322],
              [92.999643, 50.791929],
              [92.999895, 50.792303],
              [93.002302, 50.792566],
              [93.004315994000024, 50.79088791700002],
              [93.00503, 50.790293],
              [93.005281, 50.788244],
              [93.005716146, 50.787505298999974],
              [93.006445, 50.786268],
              [93.008356, 50.78583],
              [93.012117, 50.786982],
              [93.0142, 50.786692],
              [93.014921, 50.786043],
              [93.018980234000026, 50.782638927999983],
              [93.01932, 50.782354],
              [93.019339, 50.780279],
              [93.020555, 50.777849],
              [93.019156, 50.77709],
              [93.018793, 50.776056],
              [93.020929, 50.77038],
              [93.022562, 50.769243],
              [93.02389509, 50.768653696],
              [93.025496, 50.767946],
              [93.028795253, 50.767464650000022],
              [93.029444, 50.76737],
              [93.029589, 50.759371],
              [93.027609, 50.743967],
              [93.025019, 50.728823],
              [93.022924, 50.716288],
              [93.015615, 50.708933],
              [93.006792, 50.701399],
              [92.999685, 50.694719],
              [92.995035, 50.690451],
              [92.982569, 50.679091],
              [92.98203, 50.678586],
              [92.980212868000024, 50.676886167000021],
              [92.972921, 50.670065],
              [92.97011, 50.667421],
              [92.970233862999976, 50.667249162000019],
              [92.970536, 50.66683],
              [93.000062, 50.625753],
              [93.001484803999972, 50.623773070000027],
              [93.010010244, 50.611909331999982],
              [93.011069, 50.610436],
              [93.011164, 50.610304],
              [93.029741, 50.615408],
              [93.03304, 50.616326],
              [93.037151341000026, 50.617469402999973],
              [93.042921, 50.619074],
              [93.057324342000015, 50.61303043800001],
              [93.058405, 50.612577],
              [93.068213, 50.612669],
              [93.06949864500001, 50.611628499],
              [93.071989, 50.609613],
              [93.071711, 50.6065],
              [93.071474, 50.603849],
              [93.079356350000012, 50.599646929000016],
              [93.080568, 50.599001],
              [93.088319, 50.599111],
              [93.093786, 50.599188],
              [93.095148, 50.59601],
              [93.09585, 50.59437],
              [93.096105680999983, 50.594175598999982],
              [93.099989, 50.591223],
              [93.101317194999979, 50.590292717000011],
              [93.102419, 50.589521],
              [93.103109, 50.589449],
              [93.105097, 50.589502],
              [93.105506801999979, 50.589519530000018],
              [93.10671, 50.589571],
              [93.107592, 50.589609],
              [93.109373, 50.58809],
              [93.110488406, 50.587136913],
              [93.110926, 50.586763],
              [93.114396867999972, 50.587333193],
              [93.120232430999977, 50.588291857],
              [93.122656, 50.58869],
              [93.122572134999984, 50.589746982],
              [93.122419, 50.591677],
              [93.122377, 50.59218],
              [93.123895, 50.592298],
              [93.125608167, 50.592431439999984],
              [93.127233, 50.592558],
              [93.130823, 50.592772],
              [93.132109, 50.595461],
              [93.134859, 50.596643],
              [93.140467, 50.599051],
              [93.161158806, 50.599677611],
              [93.1723, 50.600015],
              [93.175174793, 50.600101463999977],
              [93.177653, 50.600176],
              [93.180906, 50.600275],
              [93.190081, 50.599478],
              [93.19373712700002, 50.599143658],
              [93.193799, 50.599138],
              [93.211831120999989, 50.597484200999986],
              [93.214014, 50.597284],
              [93.226003903, 50.59749726299998],
              [93.227732, 50.597528],
              [93.240181614999983, 50.599374279000017],
              [93.24991, 50.600817],
              [93.251394, 50.601049],
              [93.25234, 50.601198],
              [93.254282, 50.60145],
              [93.265062, 50.603086],
              [93.281431, 50.605543],
              [93.282221, 50.605593],
              [93.290803372000028, 50.606370894],
              [93.314568915999985, 50.608524971],
              [93.331968, 50.610102],
              [93.342649, 50.616022],
              [93.343866, 50.616892],
              [93.344812, 50.6172],
              [93.34713195, 50.617956317],
              [93.371920413999987, 50.626037499],
              [93.375063, 50.627062],
              [93.376497, 50.627543],
              [93.381705311000019, 50.629265456999974],
              [93.394483306999973, 50.633491309000021],
              [93.397234, 50.634401],
              [93.409242, 50.631723],
              [93.410341, 50.631475],
              [93.419012, 50.629534],
              [93.424616, 50.628309],
              [93.425922446000015, 50.628414765],
              [93.433721848, 50.629046174],
              [93.447752, 50.630182],
              [93.456564, 50.630896],
              [93.45855, 50.629991],
              [93.461184, 50.62879],
              [93.47447, 50.624899],
              [93.487394, 50.621302],
              [93.488931, 50.62089],
              [93.499846, 50.61796],
              [93.504766, 50.616617],
              [93.505159, 50.616438],
              [93.505869, 50.616747],
              [93.506495, 50.616846],
              [93.506807, 50.617037],
              [93.507147, 50.617071],
              [93.50738, 50.617189],
              [93.507318, 50.617453],
              [93.507502, 50.617563],
              [93.508245, 50.617521],
              [93.50844, 50.617533],
              [93.508814, 50.617556],
              [93.51005, 50.617262],
              [93.510714, 50.617239],
              [93.510802425, 50.617213567000022],
              [93.511538, 50.617002],
              [93.511843698, 50.61663015900001],
              [93.512259, 50.616125],
              [93.512285, 50.615957],
              [93.512674, 50.61595],
              [93.513193, 50.615549],
              [93.513727, 50.614462],
              [93.514013, 50.614141],
              [93.514795, 50.613844],
              [93.515296257999978, 50.613840354],
              [93.515345, 50.61384],
              [93.516405, 50.6136],
              [93.516649, 50.613314],
              [93.517847, 50.612627],
              [93.518075, 50.612146],
              [93.518145, 50.611994],
              [93.518105321, 50.611231276000012],
              [93.518091, 50.610956],
              [93.518412, 50.610201],
              [93.519052101999989, 50.609928851],
              [93.519167, 50.60988],
              [93.519231629999979, 50.609681885999976],
              [93.51932, 50.609411],
              [93.519464, 50.609102],
              [93.519464, 50.60861],
              [93.519712, 50.608248],
              [93.519098, 50.608118],
              [93.518675, 50.607828],
              [93.518629, 50.607374],
              [93.518873, 50.606947],
              [93.518515, 50.60668],
              [93.518435, 50.606226],
              [93.517973, 50.606062],
              [93.517202, 50.605341],
              [93.517237, 50.605032],
              [93.517981, 50.604979],
              [93.518164, 50.604433],
              [93.518797, 50.604292],
              [93.519213, 50.60401],
              [93.519674, 50.604052],
              [93.520006, 50.603796],
              [93.520319, 50.603781],
              [93.520983, 50.603483],
              [93.521349, 50.603632],
              [93.521688, 50.60367],
              [93.522154, 50.603868],
              [93.522779, 50.603964],
              [93.523561, 50.604456],
              [93.524427, 50.604658],
              [93.525545, 50.604898],
              [93.525839, 50.604822],
              [93.527094, 50.604799],
              [93.527517, 50.604925],
              [93.527914, 50.605913],
              [93.527136, 50.607584],
              [93.528013, 50.608519],
              [93.528673, 50.608557],
              [93.529226, 50.608812],
              [93.529734, 50.608912],
              [93.53071, 50.608877],
              [93.5315, 50.60853],
              [93.532244, 50.608599],
              [93.532927, 50.608225],
              [93.533056, 50.608019],
              [93.533766, 50.607698],
              [93.533762, 50.607286],
              [93.534018, 50.607004],
              [93.534029, 50.606703],
              [93.533117, 50.606359],
              [93.533091, 50.60573],
              [93.532972, 50.605639],
              [93.53219, 50.605558],
              [93.532068, 50.605322],
              [93.532133, 50.605013],
              [93.532358, 50.604757],
              [93.532469, 50.604307],
              [93.53285, 50.604017],
              [93.5329, 50.603579],
              [93.532995, 50.603407],
              [93.535322, 50.602766],
              [93.535467, 50.602518],
              [93.535334, 50.601889],
              [93.53554, 50.601564],
              [93.535597, 50.600904],
              [93.53694, 50.600405],
              [93.538409120999972, 50.600972012999989],
              [93.538492, 50.601004],
              [93.538527, 50.601145],
              [93.53771, 50.601412],
              [93.537272, 50.601709],
              [93.537191, 50.602549],
              [93.537344, 50.602686],
              [93.537508, 50.602999],
              [93.537745, 50.603186],
              [93.538069, 50.603228],
              [93.53842, 50.602987],
              [93.538942, 50.60288],
              [93.539289, 50.602472],
              [93.54022, 50.602488],
              [93.540773, 50.602243],
              [93.54117, 50.602377],
              [93.541513, 50.602972],
              [93.54151, 50.60354],
              [93.540983, 50.604078],
              [93.541471, 50.60467],
              [93.541483, 50.605001],
              [93.541807, 50.605318],
              [93.542124, 50.605757],
              [93.542963, 50.605833],
              [93.543921, 50.605543],
              [93.5445, 50.605055],
              [93.544439, 50.604773],
              [93.543657, 50.604391],
              [93.543482, 50.604155],
              [93.543238, 50.60412],
              [93.542879, 50.603853],
              [93.542887, 50.603437],
              [93.543444, 50.602785],
              [93.543943, 50.602434],
              [93.54479, 50.602182],
              [93.545603277999987, 50.60204897],
              [93.545652, 50.602041],
              [93.546503, 50.602137],
              [93.547003, 50.601892],
              [93.547636, 50.60216],
              [93.54793, 50.60214],
              [93.548700575999987, 50.602627558],
              [93.548853, 50.602724],
              [93.54962, 50.602797],
              [93.550559489000022, 50.602911629],
              [93.550833, 50.602945],
              [93.552591, 50.603025],
              [93.553026, 50.603148],
              [93.554724, 50.604834],
              [93.555277, 50.605413],
              [93.555262, 50.605597],
              [93.555137259999981, 50.605748655000014],
              [93.555021, 50.60589],
              [93.555197, 50.606073],
              [93.555132, 50.606222],
              [93.554934, 50.606413],
              [93.554945, 50.606562],
              [93.555262, 50.606966],
              [93.555403, 50.607683],
              [93.555597, 50.607874],
              [93.556096340000011, 50.607937022999977],
              [93.556112, 50.607939],
              [93.556114375999982, 50.60796224],
              [93.556135, 50.608164],
              [93.556361831, 50.608308220000026],
              [93.556459, 50.60837],
              [93.55642351, 50.608394455],
              [93.555983, 50.608698],
              [93.556127, 50.608984],
              [93.556173, 50.609076],
              [93.556124, 50.609213],
              [93.555891, 50.609426],
              [93.555929, 50.610327],
              [93.555677, 50.610567],
              [93.555887, 50.610823],
              [93.557928, 50.611975],
              [93.558432, 50.612059],
              [93.560678755000026, 50.611724596999977],
              [93.561638870000024, 50.611581694999984],
              [93.562994, 50.61138],
              [93.564325, 50.610479],
              [93.564531, 50.610128],
              [93.563363018000018, 50.608901546000027],
              [93.562933, 50.60845],
              [93.562773, 50.608282],
              [93.561892, 50.608152],
              [93.56003, 50.607088],
              [93.560003, 50.606512],
              [93.560404, 50.605997],
              [93.561327, 50.605658],
              [93.561205, 50.605246],
              [93.561411, 50.60491],
              [93.56143, 50.604406],
              [93.561941, 50.604078],
              [93.562243, 50.603636],
              [93.562723, 50.603395],
              [93.562643, 50.603186],
              [93.562365, 50.603067],
              [93.562445, 50.602987],
              [93.562967, 50.602877],
              [93.563421, 50.602823],
              [93.563906, 50.60285],
              [93.564886, 50.603445],
              [93.565382, 50.603487],
              [93.565958, 50.603842],
              [93.566832, 50.60388],
              [93.568113, 50.604479],
              [93.568644, 50.604521],
              [93.569651, 50.604326],
              [93.570696, 50.6043],
              [93.571508, 50.604643],
              [93.571566, 50.604826],
              [93.572054, 50.605116],
              [93.572611, 50.605841],
              [93.572573, 50.606066],
              [93.571707, 50.606409],
              [93.571241, 50.60631],
              [93.570826, 50.60647],
              [93.570478, 50.606997],
              [93.570478, 50.607439],
              [93.570887, 50.607733],
              [93.570825, 50.608022],
              [93.570803, 50.608126],
              [93.571051, 50.608343],
              [93.570799, 50.608667],
              [93.571527, 50.609102],
              [93.572138, 50.609087],
              [93.572699, 50.609457],
              [93.573328, 50.609468],
              [93.573778, 50.609655],
              [93.574244, 50.609629],
              [93.576307, 50.608076],
              [93.576353, 50.608004],
              [93.576529, 50.607718],
              [93.577223, 50.607481],
              [93.577097, 50.606955],
              [93.57786, 50.60671],
              [93.57778, 50.60605],
              [93.578066, 50.605753],
              [93.57815, 50.605371],
              [93.578566, 50.605204],
              [93.579184, 50.604868],
              [93.579672, 50.604849],
              [93.580679, 50.605047],
              [93.581186, 50.605032],
              [93.581442, 50.604891],
              [93.601519, 50.605539],
              [93.60961, 50.605879],
              [93.620638, 50.60639],
              [93.633695, 50.606959],
              [93.636049, 50.607061],
              [93.643286, 50.603193],
              [93.643864, 50.602884],
              [93.650843, 50.599134],
              [93.667151, 50.590384],
              [93.684637, 50.58843],
              [93.703154, 50.586302],
              [93.720385, 50.589682],
              [93.733328, 50.592176],
              [93.749578, 50.595224],
              [93.767771, 50.596498],
              [93.787619, 50.597807],
              [93.805021, 50.597849],
              [93.823114, 50.597925],
              [93.826666, 50.598066],
              [93.837965, 50.599386],
              [93.838373, 50.599432],
              [93.84749, 50.600328],
              [93.854840745, 50.601043874000027],
              [93.855951, 50.601152],
              [93.859574211999984, 50.600720347999982],
              [93.86437, 50.600149],
              [93.874937, 50.59889],
              [93.888159, 50.597296],
              [93.90185, 50.595675],
              [93.924654, 50.592421],
              [93.941851, 50.589949],
              [93.956953, 50.594107],
              [93.970694, 50.597902],
              [93.975156, 50.599257],
              [93.983091, 50.601667],
              [93.994242, 50.605238],
              [93.999979, 50.603991],
              [94.000074, 50.603968],
              [94.014666, 50.600458],
              [94.019602, 50.599298],
              [94.021368, 50.598871],
              [94.030993, 50.596632],
              [94.042124, 50.595472],
              [94.053511, 50.595209],
              [94.065737, 50.594515],
              [94.077044, 50.59384],
              [94.083643, 50.593824],
              [94.097239, 50.593813],
              [94.119024, 50.593878],
              [94.13328, 50.593271],
              [94.147287, 50.592821],
              [94.160872, 50.592291],
              [94.177858, 50.592222],
              [94.191072, 50.592169],
              [94.193895, 50.592138],
              [94.196798, 50.591836],
              [94.210585, 50.590395],
              [94.218309, 50.5897],
              [94.240377, 50.587713],
              [94.242071, 50.587126],
              [94.242643, 50.586928],
              [94.247946, 50.585089],
              [94.250093, 50.584063],
              [94.26623, 50.578337],
              [94.283759488999976, 50.571990442000015],
              [94.283827, 50.571966],
              [94.289511, 50.562826],
              [94.295816, 50.552793],
              [94.296613, 50.550249],
              [94.300428, 50.538046],
              [94.303469, 50.528631],
              [94.304401408999979, 50.525926147],
              [94.304438, 50.52582],
              [94.318903, 50.51618],
              [94.32284, 50.513556],
              [94.340705409, 50.501614323000013],
              [94.341234, 50.501261],
              [94.342947, 50.491907],
              [94.344824, 50.480936],
              [94.346785, 50.469572],
              [94.349501, 50.454062],
              [94.351328, 50.443075],
              [94.353159, 50.433023],
              [94.35578, 50.417448],
              [94.35697, 50.410349],
              [94.35808362, 50.404748774999973],
              [94.358114, 50.404596],
              [94.359934, 50.393496],
              [94.362452, 50.379366],
              [94.365252, 50.363241],
              [94.367685, 50.349253],
              [94.370306, 50.33362],
              [94.371695, 50.325945],
              [94.373747, 50.314096],
              [94.376139, 50.300428],
              [94.378706, 50.285418],
              [94.381804, 50.267481],
              [94.384279, 50.253443],
              [94.38368, 50.244135],
              [94.383402, 50.239805],
              [94.384562, 50.233484],
              [94.386641, 50.22019],
              [94.386641, 50.220098],
              [94.387545, 50.215677],
              [94.387854, 50.213804],
              [94.389067, 50.213644],
              [94.389753, 50.21253],
              [94.390917, 50.212507],
              [94.391623, 50.211229],
              [94.392401, 50.211305],
              [94.392843, 50.211348],
              [94.393961, 50.211042],
              [94.395853, 50.20986],
              [94.396497, 50.207899],
              [94.39678, 50.207033],
              [94.397806, 50.206167],
              [94.398649, 50.20648],
              [94.400369, 50.205835],
              [94.4009, 50.205633],
              [94.400945, 50.205526],
              [94.40135, 50.204554],
              [94.402143, 50.20389],
              [94.402819, 50.203867],
              [94.404657, 50.203546],
              [94.404806, 50.20352],
              [94.404947, 50.203393],
              [94.407122, 50.20141],
              [94.406641, 50.200739],
              [94.407232, 50.199877],
              [94.410372, 50.198534],
              [94.410135, 50.197966],
              [94.410406835, 50.197767743999975],
              [94.411066, 50.197287],
              [94.411619146000021, 50.197158151999986],
              [94.414934, 50.196386],
              [94.414953, 50.195807],
              [94.418539, 50.194269],
              [94.420061, 50.192739],
              [94.422804, 50.191877],
              [94.427839688, 50.191633556999989],
              [94.42872, 50.191591],
              [94.435198, 50.191248],
              [94.437448, 50.1901],
              [94.439367, 50.19013],
              [94.440454, 50.189753],
              [94.441380391999985, 50.190053278999983],
              [94.441759, 50.190176],
              [94.443087, 50.189928],
              [94.444433, 50.19026],
              [94.446731063000016, 50.189319271999977],
              [94.44734, 50.18907],
              [94.448431, 50.189386],
              [94.448655847, 50.189694659],
              [94.44882, 50.18992],
              [94.450591628999973, 50.190548342],
              [94.451101, 50.190729],
              [94.451285163000023, 50.19107206000001],
              [94.451429, 50.19134],
              [94.451532, 50.191538],
              [94.452009907, 50.191619345999982],
              [94.452425, 50.19169],
              [94.453165, 50.192301],
              [94.455, 50.192095],
              [94.455603, 50.192236],
              [94.455923, 50.191896],
              [94.45783, 50.191298],
              [94.458357, 50.190737],
              [94.458944, 50.191076],
              [94.459295, 50.191168],
              [94.459356, 50.190477],
              [94.459383, 50.190157],
              [94.460195, 50.190359],
              [94.460375, 50.190405],
              [94.460717, 50.190287],
              [94.461279, 50.190092],
              [94.461809, 50.190134],
              [94.461855, 50.190138],
              [94.46277, 50.190031],
              [94.463377, 50.190496],
              [94.46409, 50.190508],
              [94.464253188999976, 50.190574314],
              [94.464907, 50.19084],
              [94.466593, 50.190275],
              [94.466622148999988, 50.190238492],
              [94.467001, 50.189764],
              [94.467344, 50.190161],
              [94.467525264000017, 50.19017205],
              [94.468279, 50.190218],
              [94.468428, 50.190825],
              [94.46866, 50.191031],
              [94.468954, 50.19084],
              [94.469004, 50.190115],
              [94.470201, 50.190451],
              [94.472273, 50.190474],
              [94.473236789999987, 50.190233952000028],
              [94.473345, 50.190207],
              [94.473550382999974, 50.190427334],
              [94.473867, 50.190767],
              [94.472998, 50.191225],
              [94.473551, 50.191633],
              [94.47415, 50.19169],
              [94.475084, 50.192167],
              [94.475419483, 50.191582632],
              [94.475607, 50.191256],
              [94.476358, 50.190958],
              [94.47698, 50.190542],
              [94.477926, 50.190485],
              [94.47867, 50.190306],
              [94.4802, 50.190645],
              [94.480795, 50.190458],
              [94.480368, 50.189997],
              [94.480597, 50.189558],
              [94.48023, 50.18899],
              [94.480581, 50.188868],
              [94.480745, 50.18854],
              [94.481367, 50.188559],
              [94.481096, 50.188021],
              [94.481997, 50.187841],
              [94.482225, 50.18733],
              [94.482954, 50.187265],
              [94.483076, 50.187158],
              [94.483389, 50.18688],
              [94.484259, 50.186903],
              [94.484919, 50.186773],
              [94.48506, 50.186296],
              [94.485659, 50.18598],
              [94.485743, 50.185339],
              [94.486254, 50.185244],
              [94.486841, 50.184851],
              [94.487924, 50.185148],
              [94.488009, 50.185171],
              [94.488352, 50.185038],
              [94.488397, 50.184862],
              [94.488401, 50.184839],
              [94.487787, 50.18442],
              [94.488356, 50.184183],
              [94.48943, 50.184236],
              [94.490246795000019, 50.18442935600001],
              [94.490786, 50.184557],
              [94.490931, 50.184191],
              [94.49148, 50.184118],
              [94.491796, 50.183828],
              [94.492262, 50.183893],
              [94.492682, 50.183676],
              [94.493933, 50.183775],
              [94.494158, 50.183035],
              [94.494764, 50.182756],
              [94.493685, 50.181662],
              [94.493639, 50.181616],
              [94.493753, 50.181181],
              [94.49436, 50.181254],
              [94.494864, 50.181314],
              [94.49531, 50.181215],
              [94.495726, 50.181417],
              [94.496424, 50.18133],
              [94.496492, 50.180876],
              [94.496912, 50.180742],
              [94.497435, 50.180887],
              [94.497805, 50.181269],
              [94.498217, 50.181437],
              [94.498804, 50.181444],
              [94.49869, 50.180742],
              [94.499094, 50.180315],
              [94.498968, 50.179705],
              [94.500029, 50.179289],
              [94.501036, 50.179167],
              [94.50136, 50.179064],
              [94.501456631, 50.178860817999976],
              [94.501623, 50.178511],
              [94.502333, 50.178],
              [94.505476, 50.177748],
              [94.506556, 50.177088],
              [94.507322, 50.177031],
              [94.507578, 50.177328],
              [94.507708, 50.177496],
              [94.50778, 50.17811],
              [94.508169, 50.178194],
              [94.50873, 50.177912],
              [94.509806, 50.178167],
              [94.510263, 50.178106],
              [94.510675, 50.177897],
              [94.510504, 50.177542],
              [94.510939, 50.177088],
              [94.510729, 50.176737],
              [94.511057881, 50.176646545999972],
              [94.511438, 50.176542],
              [94.511415, 50.176085],
              [94.512487, 50.176001],
              [94.513716, 50.175447],
              [94.51465, 50.175875],
              [94.516802, 50.175993],
              [94.517126, 50.175406],
              [94.51846015000001, 50.174992734999989],
              [94.51895, 50.174841],
              [94.520895, 50.173712],
              [94.521761, 50.172628],
              [94.520891, 50.171511],
              [94.520647, 50.170469],
              [94.521173, 50.169569],
              [94.520353, 50.16947],
              [94.520281, 50.169188],
              [94.52183, 50.168013],
              [94.522604, 50.168249],
              [94.523619, 50.168268],
              [94.523779, 50.167692],
              [94.522974, 50.167044],
              [94.522936, 50.166071],
              [94.523993, 50.165804],
              [94.524164, 50.165541],
              [94.523649, 50.164427],
              [94.524507761, 50.163845950999985],
              [94.524889, 50.163588],
              [94.524969, 50.163126],
              [94.523577688999978, 50.163013480000018],
              [94.523275, 50.162989],
              [94.52194, 50.162565],
              [94.521509, 50.162107],
              [94.522069110000018, 50.161717329],
              [94.523954, 50.160406],
              [94.523603, 50.158342],
              [94.524309, 50.158171],
              [94.524427, 50.15774],
              [94.52492, 50.15682],
              [94.524427, 50.156561],
              [94.5244, 50.15656],
              [94.523653, 50.156527],
              [94.523302, 50.156885],
              [94.52289, 50.156916],
              [94.522676, 50.156565],
              [94.522592221000025, 50.15642429899998],
              [94.522467, 50.156214],
              [94.522459, 50.155832],
              [94.522829, 50.155806],
              [94.522919076999983, 50.155858755],
              [94.523401, 50.156141],
              [94.523962, 50.156096],
              [94.523951, 50.155569],
              [94.524248, 50.15526],
              [94.524439, 50.154959],
              [94.525259, 50.154612],
              [94.52558, 50.154549],
              [94.526007, 50.154463],
              [94.526014, 50.154173],
              [94.525846, 50.154096],
              [94.5249, 50.153666],
              [94.524828070000012, 50.153455098],
              [94.524797, 50.153364],
              [94.524937593, 50.153345145],
              [94.525908, 50.153215],
              [94.526961, 50.152189],
              [94.527662, 50.151506],
              [94.52841, 50.151358],
              [94.529268, 50.152018],
              [94.530436, 50.151922],
              [94.530848, 50.151503],
              [94.53063, 50.150785],
              [94.528708, 50.150145],
              [94.528677, 50.1499],
              [94.529497, 50.149603],
              [94.529566, 50.149267],
              [94.529245, 50.149069],
              [94.528794, 50.149065],
              [94.528025, 50.149057],
              [94.527697, 50.148565],
              [94.5277, 50.147882],
              [94.528658, 50.147684],
              [94.528849, 50.147226],
              [94.52865, 50.145037],
              [94.528357, 50.144697],
              [94.527861, 50.144785],
              [94.527464, 50.145212],
              [94.526934, 50.145197],
              [94.526605358999973, 50.14491922000002],
              [94.526514, 50.144842],
              [94.525892, 50.144873],
              [94.525572, 50.144678],
              [94.526022, 50.143717],
              [94.525858, 50.142801],
              [94.525431, 50.142244],
              [94.525019, 50.141977],
              [94.524549, 50.142073],
              [94.52416, 50.142542],
              [94.523821, 50.142618],
              [94.523413, 50.142149],
              [94.523066, 50.141047],
              [94.523413, 50.140661],
              [94.523947, 50.14039],
              [94.525785, 50.14057],
              [94.52603, 50.140326],
              [94.525534, 50.139334],
              [94.526064, 50.138517],
              [94.526045, 50.137953],
              [94.526384, 50.137728],
              [94.527178, 50.137674],
              [94.529787, 50.136637],
              [94.53034, 50.136229],
              [94.530203, 50.135927],
              [94.529886, 50.135771],
              [94.529165, 50.135721],
              [94.528719, 50.135447],
              [94.528803, 50.135183],
              [94.529299, 50.134996],
              [94.530172, 50.134985],
              [94.530764, 50.134817],
              [94.530878, 50.134535],
              [94.530828, 50.133951],
              [94.53145, 50.133802],
              [94.532843, 50.133402],
              [94.532991, 50.13312],
              [94.532854, 50.132677],
              [94.53248, 50.131819],
              [94.532732, 50.131659],
              [94.533278, 50.131578],
              [94.533659, 50.131075],
              [94.534613, 50.130964],
              [94.535322, 50.130716],
              [94.535501, 50.130392],
              [94.535135, 50.128786],
              [94.535955, 50.127993],
              [94.536043, 50.126902],
              [94.536901, 50.126333],
              [94.536268, 50.12602],
              [94.536192, 50.125673],
              [94.537333, 50.125139],
              [94.538336, 50.124849],
              [94.539717, 50.124807],
              [94.541491, 50.122084],
              [94.540552, 50.12203],
              [94.540651, 50.121317],
              [94.540297, 50.121195],
              [94.539202, 50.121046],
              [94.539034, 50.120634],
              [94.539274, 50.120203],
              [94.539797, 50.12002],
              [94.540266, 50.120077],
              [94.541201, 50.120905],
              [94.54196, 50.120863],
              [94.54207, 50.12052],
              [94.541494, 50.119333],
              [94.54167, 50.11899],
              [94.542715, 50.118456],
              [94.54262, 50.117723],
              [94.543177, 50.117281],
              [94.543894, 50.117174],
              [94.544888448999984, 50.117468922],
              [94.545118, 50.117537],
              [94.545721, 50.117552],
              [94.546171, 50.117323],
              [94.546186, 50.116766],
              [94.546926, 50.116213],
              [94.547541, 50.115797],
              [94.547949, 50.115873],
              [94.548254, 50.116438],
              [94.549402, 50.116159],
              [94.54928, 50.115522],
              [94.550127, 50.114996],
              [94.550035, 50.114412],
              [94.550304628999982, 50.114161586000023],
              [94.55047, 50.114008],
              [94.550295, 50.113562],
              [94.552057, 50.113302],
              [94.552828, 50.113561],
              [94.553465, 50.113775],
              [94.554602, 50.113607],
              [94.555223, 50.112772],
              [94.555777, 50.113024],
              [94.556213823, 50.112886761000027],
              [94.556299, 50.11286],
              [94.556719, 50.112268],
              [94.556555971000023, 50.112071155000024],
              [94.556261, 50.111715],
              [94.55673, 50.110197],
              [94.557703, 50.110071],
              [94.558031, 50.109804],
              [94.557905, 50.109587],
              [94.557326, 50.1094],
              [94.556852, 50.109247],
              [94.556822, 50.108999],
              [94.5571, 50.108873],
              [94.557706, 50.109049],
              [94.558516, 50.109285],
              [94.558657257, 50.109152720999987],
              [94.558752, 50.109064],
              [94.558732205000013, 50.108988389999979],
              [94.558691, 50.108831],
              [94.558084, 50.108701],
              [94.558027, 50.108686],
              [94.557711, 50.10821],
              [94.559397, 50.106829],
              [94.559309, 50.106615],
              [94.558474, 50.106607],
              [94.558413, 50.105719],
              [94.558119, 50.104963],
              [94.560144, 50.103411],
              [94.561514, 50.103907],
              [94.561934, 50.103724],
              [94.561892, 50.103479],
              [94.56119, 50.102705],
              [94.563322, 50.102388],
              [94.563668705, 50.102281047000019],
              [94.5641, 50.102148],
              [94.564665, 50.101534],
              [94.564974, 50.101088],
              [94.565588, 50.100718],
              [94.565756, 50.100195],
              [94.566648, 50.099653],
              [94.567945, 50.099241],
              [94.568315, 50.099237],
              [94.568663, 50.09923],
              [94.568735, 50.099012],
              [94.568635, 50.09894],
              [94.568144, 50.098593],
              [94.568129, 50.098127],
              [94.569841, 50.097239],
              [94.569857, 50.096521],
              [94.56962, 50.096003],
              [94.56983, 50.095732],
              [94.570631, 50.095366],
              [94.570654, 50.095144],
              [94.570402, 50.095026],
              [94.570395, 50.094683],
              [94.571566, 50.093401],
              [94.572012, 50.093252],
              [94.573751, 50.093225],
              [94.574598, 50.092676],
              [94.575182, 50.09263],
              [94.575663, 50.092439],
              [94.576197, 50.092226],
              [94.57662, 50.092752],
              [94.577078, 50.092844],
              [94.577513, 50.092699],
              [94.577387, 50.091795],
              [94.577745, 50.091562],
              [94.578287, 50.09152],
              [94.579668, 50.091703],
              [94.579992, 50.091532],
              [94.579831750999972, 50.090637922999974],
              [94.579702, 50.089914],
              [94.580137, 50.089808],
              [94.580793, 50.090208],
              [94.581019769000022, 50.090239381],
              [94.5814, 50.090292],
              [94.582144, 50.090082],
              [94.582381638000015, 50.089413235999984],
              [94.58251, 50.089052],
              [94.58324152900002, 50.088763730999972],
              [94.583487, 50.088667],
              [94.583649735999984, 50.088428815999976],
              [94.584188, 50.087641],
              [94.584528439999985, 50.087610197],
              [94.585249, 50.087545],
              [94.586004, 50.087271],
              [94.586191, 50.086729],
              [94.585622004000015, 50.086182568000027],
              [94.585611, 50.086172],
              [94.585344, 50.085775],
              [94.585585, 50.085409],
              [94.586205254, 50.08528378699998],
              [94.586546, 50.085215],
              [94.58658, 50.08497],
              [94.586486533000027, 50.084850341],
              [94.586241, 50.084536],
              [94.58613, 50.083998],
              [94.586451, 50.083288],
              [94.587404, 50.082693],
              [94.587564, 50.081945],
              [94.587912, 50.081774],
              [94.588896, 50.081648],
              [94.588938, 50.080961],
              [94.589201, 50.080458],
              [94.590029, 50.079962],
              [94.591173, 50.079706],
              [94.591635, 50.079477],
              [94.591497, 50.078394],
              [94.591864, 50.077887],
              [94.592962, 50.077394],
              [94.59358, 50.07688],
              [94.593954, 50.076822],
              [94.594536027, 50.076815603999989],
              [94.594591, 50.076815],
              [94.595354, 50.076674],
              [94.59622, 50.075888],
              [94.597075, 50.075804],
              [94.597815, 50.075453],
              [94.598009, 50.074785],
              [94.599451, 50.073961],
              [94.599176, 50.07279],
              [94.599962, 50.071482],
              [94.600821, 50.071371],
              [94.601412, 50.070921],
              [94.601149, 50.069635],
              [94.601250923, 50.069336206],
              [94.601339, 50.069078],
              [94.60151369, 50.069019649999973],
              [94.6028, 50.06859],
              [94.603666, 50.067568],
              [94.604757, 50.067335],
              [94.605162, 50.067019],
              [94.605257, 50.066343],
              [94.605711, 50.065996],
              [94.605825, 50.065691],
              [94.60557, 50.065355],
              [94.604554802, 50.065558383],
              [94.604387, 50.065592],
              [94.604094, 50.065573],
              [94.604082, 50.065557],
              [94.603971, 50.065397],
              [94.604139, 50.064764],
              [94.603865, 50.064196],
              [94.604128, 50.063486],
              [94.604677, 50.063055],
              [94.605673, 50.062941],
              [94.605909, 50.062574],
              [94.60599, 50.062562],
              [94.606668, 50.062441],
              [94.606886, 50.061857],
              [94.607561, 50.061487],
              [94.607698, 50.061056],
              [94.608114, 50.060251],
              [94.608786, 50.059843],
              [94.6089, 50.059381],
              [94.609385, 50.058443],
              [94.609106, 50.058249],
              [94.608297, 50.058279],
              [94.608187, 50.05818],
              [94.608103, 50.058104],
              [94.608061, 50.05776],
              [94.608488, 50.05657],
              [94.607965, 50.055361],
              [94.608374, 50.054983],
              [94.609549, 50.054686],
              [94.610006, 50.054316],
              [94.610273, 50.05393],
              [94.610006, 50.053411],
              [94.610209, 50.052908],
              [94.610037, 50.052485],
              [94.609751, 50.052248],
              [94.609835, 50.052008],
              [94.611490122000021, 50.050516282],
              [94.611719, 50.05031],
              [94.611727, 50.049707],
              [94.611429, 50.04925],
              [94.6113289, 50.049158063999982],
              [94.610914, 50.048777],
              [94.610777, 50.048414],
              [94.611031836, 50.047982429],
              [94.61141, 50.047342],
              [94.611162, 50.046492],
              [94.61199, 50.045462],
              [94.612108, 50.044874],
              [94.612165, 50.044256],
              [94.611776, 50.043768],
              [94.611296, 50.043421],
              [94.610685, 50.043402],
              [94.610117, 50.0436],
              [94.609826025000018, 50.043951290999985],
              [94.609678, 50.04413],
              [94.609087, 50.04458],
              [94.60837, 50.04455],
              [94.608076, 50.044271],
              [94.60808, 50.043955],
              [94.608198, 50.043612],
              [94.608362, 50.043127],
              [94.607828, 50.041452],
              [94.608544232999975, 50.040738654999984],
              [94.60882, 50.040464],
              [94.608965, 50.039701],
              [94.609438, 50.039186],
              [94.610006, 50.038973],
              [94.609823, 50.038538],
              [94.609843776, 50.038349826],
              [94.609858, 50.038221],
              [94.610586, 50.037783],
              [94.610857, 50.037188],
              [94.611085, 50.037059],
              [94.611757, 50.03668],
              [94.612619, 50.036509],
              [94.612673140000027, 50.036489019999976],
              [94.613478, 50.036192],
              [94.614172855, 50.036145581000028],
              [94.613584517999982, 50.035654067999985],
              [94.614173424, 50.036145302000023],
              [94.614725, 50.035875],
              [94.615004, 50.035341],
              [94.620314, 50.035719],
              [94.644781, 50.036463],
              [94.675077, 50.037416],
              [94.696684, 50.041857],
              [94.717779, 50.046179],
              [94.740675, 50.050859],
              [94.749754, 50.052828],
              [94.760969, 50.055014],
              [94.779928, 50.054781],
              [94.796221, 50.054583],
              [94.806524, 50.054491],
              [94.830885, 50.053522],
              [94.847109, 50.052973],
              [94.870184, 50.052099],
              [94.882692, 50.051626],
              [94.9009, 50.050951],
              [94.910025, 50.05002],
              [94.919035, 50.048929],
              [94.941557, 50.046389],
              [94.961191, 50.04421],
              [94.97135, 50.043589],
              [94.978799, 50.044942],
              [94.979898, 50.045141],
              [94.986399, 50.047613],
              [94.989374, 50.047823],
              [94.998086393, 50.044795423999972],
              [94.998102, 50.04479],
              [94.998655, 50.043531],
              [94.999235, 50.041784],
              [94.999365107000017, 50.040604729],
              [94.999376, 50.040506],
              [94.999297033, 50.040305396],
              [94.99893, 50.039373],
              [94.998411353999984, 50.038723672],
              [94.998041, 50.03826],
              [94.997953693999989, 50.037906341999985],
              [94.997667, 50.036745],
              [94.997633, 50.035418],
              [94.998434, 50.034491],
              [94.998575, 50.033655],
              [94.998152, 50.032663],
              [94.998053, 50.031656],
              [94.99901, 50.028215],
              [94.999197, 50.026598],
              [94.998293, 50.024889],
              [94.998732, 50.023565],
              [94.998327, 50.022581],
              [94.998758, 50.021307],
              [94.99756, 50.020205],
              [94.997366, 50.019739],
              [94.996595, 50.017889],
              [94.997923, 50.016703],
              [94.997717, 50.015444],
              [94.998518, 50.014708],
              [94.998655, 50.013502],
              [95.000612, 50.010534],
              [95.001572661000012, 50.008693171],
              [95.005362, 50.001432],
              [95.007036, 49.998629],
              [95.011698, 49.989992],
              [95.01676, 49.980646],
              [95.065245, 49.96752],
              [95.081968, 49.963018],
              [95.149176, 49.964525],
              [95.167582, 49.964788],
              [95.198881, 49.965445],
              [95.209753, 49.964613],
              [95.222109, 49.963812],
              [95.250349, 49.961748],
              [95.259134, 49.960913],
              [95.29357, 49.958685],
              [95.302618, 49.958094],
              [95.328779, 49.958498],
              [95.345438, 49.958765],
              [95.360632, 49.958319],
              [95.384184, 49.957895],
              [95.426401, 49.957689],
              [95.466055, 49.931589],
              [95.491507, 49.914835],
              [95.493985805000023, 49.913199170999974],
              [95.49574241, 49.91203994],
              [95.499964, 49.909254],
              [95.501661, 49.908159],
              [95.505857337, 49.907354912000017],
              [95.510679, 49.906431],
              [95.513509435, 49.905816973000015],
              [95.521212, 49.904146],
              [95.524118, 49.903288],
              [95.524389, 49.90309],
              [95.525353247, 49.902382650999982],
              [95.531723764, 49.897709389],
              [95.53224228, 49.897329017],
              [95.532335, 49.897261],
              [95.534537629, 49.900421488],
              [95.534807, 49.900808],
              [95.536389543999974, 49.901706702000013],
              [95.537024, 49.902067],
              [95.537519, 49.903078],
              [95.537298754, 49.904336984999986],
              [95.53723, 49.90473],
              [95.539259, 49.905493],
              [95.543219, 49.907122],
              [95.545145, 49.910872],
              [95.545660612, 49.911382302999982],
              [95.545720730000028, 49.911441802000013],
              [95.546019, 49.911737],
              [95.551168, 49.90962],
              [95.552446, 49.90999],
              [95.556589980000012, 49.915537339000025],
              [95.556772, 49.915781],
              [95.558089517999974, 49.919971385999986],
              [95.558168, 49.920221],
              [95.559370897, 49.921626690999972],
              [95.561377, 49.923971],
              [95.561682, 49.925145],
              [95.561953, 49.926184],
              [95.562574, 49.927809],
              [95.563164154999981, 49.928794147000019],
              [95.564219, 49.930555],
              [95.564306, 49.933802],
              [95.56563, 49.935705],
              [95.567309427999987, 49.936416275],
              [95.568827, 49.937059],
              [95.56951, 49.93899],
              [95.57226, 49.943136],
              [95.572208612999987, 49.944059391],
              [95.572195, 49.944304],
              [95.572421792, 49.944354273999977],
              [95.579679, 49.945963],
              [95.581175, 49.946295],
              [95.584871, 49.94711],
              [95.593693571000017, 49.949052314000028],
              [95.598616, 49.950136],
              [95.602507259999982, 49.950920248999978],
              [95.628053379999983, 49.956068846999983],
              [95.62924, 49.956308],
              [95.629394817, 49.956302644],
              [95.634298, 49.956133],
              [95.635363, 49.956095],
              [95.653013, 49.956251],
              [95.653125128999989, 49.956262993999985],
              [95.653562165999972, 49.95630974300002],
              [95.656687, 49.956644],
              [95.659056, 49.958422],
              [95.659651243999974, 49.959780588],
              [95.659704, 49.959901],
              [95.659895, 49.960341],
              [95.66053778600002, 49.960904332999974],
              [95.662767, 49.962858],
              [95.665592210999989, 49.964350546999981],
              [95.66593, 49.964529],
              [95.66696235, 49.964389309000012],
              [95.67182, 49.963732],
              [95.675486, 49.962465],
              [95.683811702000014, 49.962646489],
              [95.684248, 49.962656],
              [95.686333, 49.961649],
              [95.687199342999975, 49.961229283000023],
              [95.68849, 49.960604],
              [95.691687, 49.961027],
              [95.696032, 49.95957],
              [95.700544760000014, 49.960594378999986],
              [95.701292, 49.960764],
              [95.702879, 49.960543],
              [95.703634851, 49.960144593],
              [95.70537, 49.95923],
              [95.706194630000027, 49.959251643000016],
              [95.706717848999972, 49.959265374999973],
              [95.708723, 49.959318],
              [95.711615, 49.960226],
              [95.714682, 49.960413],
              [95.717699, 49.961019],
              [95.719652644, 49.961410980999972],
              [95.720819, 49.961645],
              [95.721624635000012, 49.961506453000027],
              [95.721843637, 49.961468791000016],
              [95.723238, 49.961229],
              [95.724283, 49.96105],
              [95.725553, 49.961466],
              [95.726946, 49.961924],
              [95.728121, 49.961729],
              [95.729654553999978, 49.961476966000021],
              [95.729938319999974, 49.961430329999985],
              [95.731066, 49.961245],
              [95.733301673000028, 49.959829172000013],
              [95.733343, 49.959803],
              [95.733732533000023, 49.960704987999975],
              [95.734262, 49.961931],
              [95.735124, 49.962449],
              [95.735558251999976, 49.962709398000015],
              [95.73683, 49.963472],
              [95.740255, 49.966967],
              [95.740540608, 49.967021332],
              [95.743982, 49.967676],
              [95.745504, 49.966433],
              [95.745606160000023, 49.966355513999986],
              [95.748895, 49.963861],
              [95.749918, 49.963083],
              [95.751750394, 49.963341505000017],
              [95.754568, 49.963739],
              [95.756087375, 49.96343312800002],
              [95.757082270000012, 49.963232840999979],
              [95.757788920999985, 49.963090582],
              [95.759893, 49.962667],
              [95.760541129999979, 49.962747842999988],
              [95.762446232, 49.962985471000025],
              [95.765497, 49.963366],
              [95.768888, 49.962275],
              [95.769279950999987, 49.962275],
              [95.770158773, 49.962275],
              [95.772058, 49.962275],
              [95.773754282000027, 49.961467003],
              [95.774382, 49.961168],
              [95.77553, 49.963274],
              [95.77817, 49.964464],
              [95.780886, 49.963778],
              [95.784468, 49.964434],
              [95.788572, 49.963911],
              [95.789967647000026, 49.964024595000012],
              [95.792135, 49.964201],
              [95.795992, 49.964025],
              [95.795978718000015, 49.964096598000026],
              [95.795967017, 49.964159677],
              [95.795626, 49.965998],
              [95.794256, 49.968172],
              [95.792295, 49.971174],
              [95.791962932, 49.972502271],
              [95.790419, 49.978678],
              [95.79006, 49.979422],
              [95.790907, 49.980219],
              [95.789621, 49.983408],
              [95.787951124000017, 49.984833526999978],
              [95.787851, 49.984919],
              [95.78063, 49.988306],
              [95.779447683, 49.988969456],
              [95.773737, 49.992174],
              [95.763788, 49.997759],
              [95.763724755, 49.997858639000015],
              [95.761873, 50.000776],
              [95.762789, 50.004606],
              [95.761045, 50.007025],
              [95.760908329000017, 50.009224820999975],
              [95.760836, 50.010389],
              [95.761267, 50.01227],
              [95.764791, 50.016653],
              [95.765045989999976, 50.016750289000015],
              [95.769706811999981, 50.018528592],
              [95.772051, 50.019423],
              [95.773294, 50.022306],
              [95.777141368, 50.023332939999989],
              [95.777239, 50.023359],
              [95.777279389, 50.023388394999984],
              [95.780909, 50.02603],
              [95.782665904999988, 50.026138950000018],
              [95.783602, 50.026197],
              [95.783992082, 50.026952298000026],
              [95.784857, 50.028627],
              [95.787821, 50.031851],
              [95.789011, 50.033537],
              [95.790926, 50.035528],
              [95.790968740999972, 50.035490880999987],
              [95.796324, 50.03084],
              [95.799601, 50.031221],
              [95.803505834000021, 50.033387205999986],
              [95.805117, 50.034281],
              [95.80531484, 50.034228410000026],
              [95.805433, 50.034197],
              [95.809126, 50.033205],
              [95.810562796999989, 50.03409084499998],
              [95.812318, 50.035173],
              [95.814951, 50.036798],
              [95.81576944699998, 50.036693484000011],
              [95.818052, 50.036402],
              [95.818658, 50.03605],
              [95.819468, 50.035574],
              [95.822366, 50.036561],
              [95.826139, 50.037844],
              [95.829671, 50.037568],
              [95.832356315000027, 50.037357175000011],
              [95.833887, 50.037237],
              [95.83523, 50.038335],
              [95.836616820000017, 50.03946807],
              [95.841027316, 50.043071563000012],
              [95.841291, 50.043287],
              [95.841395924999972, 50.043278738000026],
              [95.846231, 50.042898],
              [95.851206, 50.043242],
              [95.854544, 50.042105],
              [95.85892224700001, 50.043748076999975],
              [95.859423, 50.043936],
              [95.861383, 50.043879],
              [95.862251927999978, 50.043656380000016],
              [95.868116, 50.042154],
              [95.868299912, 50.042155736999973],
              [95.874258, 50.042212],
              [95.876055, 50.041887],
              [95.877825, 50.040979],
              [95.878801634000013, 50.039556273000017],
              [95.880404, 50.037222],
              [95.885326185, 50.034952122999982],
              [95.889967, 50.032812],
              [95.891237, 50.032557],
              [95.895601, 50.03227],
              [95.900347, 50.028292],
              [95.909391, 50.025362],
              [95.914968, 50.023066],
              [95.915689982, 50.022295340000028],
              [95.91601814500001, 50.021945051999978],
              [95.916555, 50.021372],
              [95.91469, 50.017809],
              [95.913786, 50.01716],
              [95.911291224000024, 50.016326017999972],
              [95.910307, 50.015997],
              [95.910229782999977, 50.015582859],
              [95.909948680000014, 50.014075204999983],
              [95.909674, 50.012602],
              [95.90992085, 50.012438466],
              [95.911108, 50.011652],
              [95.909928, 50.011007],
              [95.906737967000026, 50.009265511000024],
              [95.906378, 50.009069],
              [95.90752462, 50.007275060999973],
              [95.910135, 50.003191],
              [95.910249202999978, 50.001390774000015],
              [95.910566, 49.996397],
              [95.910722252000028, 49.996530907000022],
              [95.912489, 49.998045],
              [95.919683, 49.99795],
              [95.926497, 49.997091],
              [95.930418, 49.99727],
              [95.932776, 49.997377],
              [95.93560499900002, 49.996632476],
              [95.935661864999986, 49.996617510000021],
              [95.935717, 49.996603],
              [95.938288, 49.992846],
              [95.93926, 49.991396],
              [95.94066, 49.989302],
              [95.944352, 49.988427],
              [95.949034, 49.987314],
              [95.953821, 49.984922],
              [95.957747, 49.984331],
              [95.958677, 49.980928],
              [95.95999565, 49.979725402999975],
              [95.961279, 49.978555],
              [95.961988, 49.977907],
              [95.963712405000024, 49.976831764],
              [95.964129, 49.976572],
              [95.965761, 49.974955],
              [95.967863996, 49.971469314999979],
              [95.968012, 49.971224],
              [95.975664360999986, 49.971628184999986],
              [95.979845, 49.971849],
              [95.98942, 49.974031],
              [95.996480326999972, 49.975672891999977],
              [95.996756, 49.975737],
              [95.998712150000017, 49.979230647],
              [95.998896, 49.979559],
              [95.999449428, 49.9821384],
              [95.999857, 49.984038],
              [95.999987, 49.98464],
              [96.002737, 49.988955],
              [96.006975, 49.990587],
              [96.008008282999981, 49.992998592],
              [96.009275, 49.995955],
              [96.013254, 49.999304],
              [96.015206848999981, 50.001633825999988],
              [96.015409, 50.001875],
              [96.018812, 50.003798],
              [96.021929, 50.004885],
              [96.025122, 50.004465],
              [96.025956, 50.004007],
              [96.026541, 50.003683],
              [96.026570787000026, 50.003694958999972],
              [96.027018052000017, 50.003874532],
              [96.028688, 50.004545],
              [96.028715, 50.004583],
              [96.02968, 50.00601],
              [96.030285165, 50.006080955000016],
              [96.031599, 50.006235],
              [96.032689090000019, 50.006011568000019],
              [96.034136, 50.005715],
              [96.036238, 50.005281],
              [96.03961, 50.006857],
              [96.042395, 50.008158],
              [96.050613801999987, 50.010601880000024],
              [96.051233, 50.010786],
              [96.051452198, 50.010773587000017],
              [96.055471, 50.010546],
              [96.056936, 50.010508],
              [96.057024, 50.010492],
              [96.059652, 50.010023],
              [96.060316, 50.009905],
              [96.061015645999987, 50.009954745000016],
              [96.061703777, 50.010003671],
              [96.064226, 50.010183],
              [96.065932401, 50.012520060999975],
              [96.066488, 50.013281],
              [96.068964, 50.011801],
              [96.071046142, 50.011044673000015],
              [96.071516, 50.010874],
              [96.076588405, 50.01100034000001],
              [96.077177, 50.011015],
              [96.079129298999987, 50.010645472000022],
              [96.082941, 50.009924],
              [96.083622441999978, 50.008847392],
              [96.084105, 50.008085],
              [96.085517002000017, 50.006594104999976],
              [96.08568, 50.006422],
              [96.087507, 50.005079],
              [96.090031768000017, 50.003560634999985],
              [96.090101, 50.003519],
              [96.09026200400001, 50.003329447999988],
              [96.091009, 50.00245],
              [96.09152, 50.001844],
              [96.093, 49.997599],
              [96.095728, 49.996172],
              [96.097754, 49.99457],
              [96.09847013000001, 49.994323813],
              [96.10034, 49.993681],
              [96.102408594, 49.99224596],
              [96.107004, 49.989058],
              [96.110582167000018, 49.989113055000018],
              [96.115648, 49.989191],
              [96.117441011999972, 49.988400361],
              [96.120043, 49.987253],
              [96.126051, 49.986307],
              [96.126806, 49.986261],
              [96.129095, 49.986563],
              [96.132196, 49.986406],
              [96.133045525999989, 49.98702276],
              [96.134634, 49.988176],
              [96.139952, 49.988512],
              [96.140451, 49.988652],
              [96.140936, 49.988787],
              [96.144754, 49.988825],
              [96.148298, 49.990122],
              [96.153505, 49.99],
              [96.15616, 49.98934],
              [96.157541383000023, 49.989138393000019],
              [96.156747817999985, 49.989252089999979],
              [96.157541275000028, 49.989137649999975],
              [96.15912, 49.988908],
              [96.159659522000027, 49.988829088999978],
              [96.162278453, 49.988446040999975],
              [96.164282, 49.988153],
              [96.16498474399998, 49.988284179],
              [96.166082, 49.988489],
              [96.169867, 49.989199],
              [96.172847246, 49.98927139],
              [96.173723960000018, 49.989292685],
              [96.177401, 49.989382],
              [96.178790795, 49.988747499999988],
              [96.179541, 49.988405],
              [96.180515803999981, 49.988455212000019],
              [96.182356, 49.98855],
              [96.184249642999987, 49.988334242],
              [96.185068, 49.988241],
              [96.188692010000011, 49.988104992],
              [96.189675083, 49.988068097999985],
              [96.190557, 49.988035],
              [96.191721, 49.987978],
              [96.197603943, 49.98843807999998],
              [96.197718, 49.988447],
              [96.197847915000011, 49.988402867],
              [96.199018529, 49.988005204999979],
              [96.201433, 49.987185],
              [96.202052993999985, 49.98654538],
              [96.204592, 49.983926],
              [96.206171, 49.982294],
              [96.20833, 49.98184],
              [96.211111164999977, 49.981976804],
              [96.211908, 49.982016],
              [96.214537, 49.98068],
              [96.216013, 49.980593],
              [96.217049600999985, 49.980011973999979],
              [96.221731, 49.977388],
              [96.223944545, 49.977952077999987],
              [96.230219, 49.979551],
              [96.231092, 49.979773],
              [96.234797, 49.980242],
              [96.238080989000025, 49.980154218999985],
              [96.240072, 49.980101],
              [96.242643591, 49.980211911000026],
              [96.243063, 49.98023],
              [96.244538967999972, 49.98000370699998],
              [96.248457, 49.979403],
              [96.248510360000012, 49.979401728000028],
              [96.250093, 49.979364],
              [96.254050321000022, 49.97845709500001],
              [96.259047, 49.977312],
              [96.261904, 49.976091],
              [96.264967, 49.973482],
              [96.263765827999975, 49.971026250000023],
              [96.263758289, 49.971010837],
              [96.263685, 49.970861],
              [96.26605, 49.96911],
              [96.268484, 49.966104],
              [96.26865839200002, 49.965887883999983],
              [96.268811589, 49.965698034000013],
              [96.269182, 49.965239],
              [96.272950993999984, 49.962950697999986],
              [96.277727, 49.960051],
              [96.278162754, 49.95926324200002],
              [96.279829, 49.956251],
              [96.280668, 49.95542],
              [96.281901264999988, 49.955619373],
              [96.283703498000023, 49.955910727],
              [96.284132, 49.95598],
              [96.286882, 49.95616],
              [96.294534081, 49.956659297999977],
              [96.294882, 49.956682],
              [96.299738, 49.954458],
              [96.299908228999982, 49.954334744],
              [96.299913405999973, 49.954332352],
              [96.302572, 49.952406],
              [96.302976, 49.95141],
              [96.303709621, 49.949594062000017],
              [96.30411, 49.948603],
              [96.302481116000024, 49.9473438],
              [96.301278726000021, 49.946414300000015],
              [96.300762922, 49.946015559999978],
              [96.299955, 49.945391],
              [96.300464292000015, 49.945221311000012],
              [96.301574844000015, 49.944851288999985],
              [96.302233, 49.944632],
              [96.303437670999983, 49.94460995999998],
              [96.306223, 49.944559],
              [96.312286959, 49.944962786000019],
              [96.313671122000017, 49.945054954999989],
              [96.313837, 49.945066],
              [96.313898305, 49.945060045999981],
              [96.317842, 49.944677],
              [96.319407, 49.945673],
              [96.321719444999985, 49.948331664000023],
              [96.321905, 49.948545],
              [96.321953109999981, 49.948553144000016],
              [96.323435, 49.948804],
              [96.323988869, 49.948897069999987],
              [96.32453, 49.948988],
              [96.325751077, 49.948120943999982],
              [96.326803, 49.947374],
              [96.331137, 49.945013],
              [96.334291, 49.944178],
              [96.337765205999972, 49.941582391999987],
              [96.338095, 49.941336],
              [96.339147, 49.93448],
              [96.339266, 49.933702],
              [96.338498107000021, 49.932551407],
              [96.338034, 49.931856],
              [96.338626293, 49.931649021],
              [96.342149, 49.930418],
              [96.345835, 49.929129],
              [96.34775, 49.926519],
              [96.345495, 49.92412],
              [96.345201219999979, 49.923807735000025],
              [96.344748, 49.923326],
              [96.344698175000019, 49.923078809],
              [96.344156, 49.920389],
              [96.340342, 49.915289],
              [96.341014658, 49.914645104999977],
              [96.345665617, 49.910193019000019],
              [96.346937, 49.908976],
              [96.347433, 49.908033],
              [96.348951, 49.90663],
              [96.348567259, 49.905353493],
              [96.348562, 49.905336],
              [96.34863967299998, 49.905339624000021],
              [96.351027, 49.905451],
              [96.360697295000023, 49.902963038],
              [96.366998, 49.901342],
              [96.368285134000018, 49.901010633],
              [96.368509, 49.900953],
              [96.36897921000002, 49.900633905],
              [96.368936539, 49.900655745999984],
              [96.368978500000026, 49.900632858],
              [96.369931, 49.899988],
              [96.371721, 49.898767],
              [96.373659, 49.898264],
              [96.3743, 49.898096],
              [96.377001, 49.897947],
              [96.379503, 49.897085],
              [96.382811, 49.897169],
              [96.386114, 49.893869],
              [96.386746851, 49.893437928000026],
              [96.38846, 49.892271],
              [96.38881, 49.89126],
              [96.388914218000025, 49.890957238999988],
              [96.389284, 49.889883],
              [96.39057, 49.889372],
              [96.394102, 49.888814],
              [96.395100277999973, 49.888655670999981],
              [96.39559, 49.888578],
              [96.396295, 49.8878],
              [96.39757, 49.886393],
              [96.397631, 49.884478],
              [96.401388, 49.883093],
              [96.407213, 49.8808],
              [96.414161830000012, 49.878137434],
              [96.414224624999974, 49.878114700000026],
              [96.414271032999977, 49.878095590999976],
              [96.417239633, 49.876958119999983],
              [96.417467, 49.876871],
              [96.420237, 49.877836],
              [96.421446, 49.877741],
              [96.423630477000017, 49.876507124],
              [96.424314519, 49.87612075200002],
              [96.424654, 49.875929],
              [96.426985511, 49.876398214],
              [96.431059, 49.877218],
              [96.432677478000016, 49.877106266],
              [96.433985, 49.877016],
              [96.435667, 49.878725],
              [96.437265, 49.882723],
              [96.444704, 49.884375],
              [96.449877, 49.88777],
              [96.454302, 49.888998],
              [96.455317, 49.890718],
              [96.462385515999983, 49.895708140000011],
              [96.462893854000015, 49.896067011000014],
              [96.462942, 49.896101],
              [96.462850321000019, 49.896401722],
              [96.462221, 49.898466],
              [96.462469, 49.899092],
              [96.46255629, 49.899446685999976],
              [96.462927, 49.900953],
              [96.463663, 49.90283],
              [96.463209, 49.904494],
              [96.463152, 49.904707],
              [96.461599, 49.906321],
              [96.459901961000014, 49.907118285000024],
              [96.459181, 49.907457],
              [96.459256509, 49.907507667],
              [96.465105, 49.911432],
              [96.466857125, 49.912363439999979],
              [96.467035, 49.912458],
              [96.468502968999985, 49.912874430999977],
              [96.470613, 49.913473],
              [96.470974580000018, 49.913854904],
              [96.471795623999981, 49.914722101],
              [96.474936, 49.918039],
              [96.480646, 49.919466],
              [96.486770948000014, 49.921821822000027],
              [96.487112, 49.921953],
              [96.487365673, 49.921985844],
              [96.487699, 49.922029],
              [96.492201, 49.922609],
              [96.494799, 49.923662],
              [96.498832414999981, 49.924714511],
              [96.4998, 49.924967],
              [96.500013, 49.925097],
              [96.500202398999988, 49.925173686],
              [96.501322, 49.925627],
              [96.501744106999979, 49.926561092999975],
              [96.503008, 49.929358],
              [96.504626, 49.931628],
              [96.50699, 49.934946],
              [96.50704817899998, 49.93500708],
              [96.514791, 49.943136],
              [96.517653, 49.942476],
              [96.519064, 49.942461],
              [96.523932, 49.94409],
              [96.527082, 49.944036],
              [96.530001, 49.943792],
              [96.531037647, 49.943886930000019],
              [96.533419, 49.944105],
              [96.533583555, 49.944065177000027],
              [96.535452, 49.943613],
              [96.537188, 49.943518],
              [96.539541, 49.944056],
              [96.544001, 49.943853],
              [96.546946, 49.943853],
              [96.549246, 49.943628],
              [96.55018, 49.943346],
              [96.550913, 49.942396],
              [96.552446, 49.94116],
              [96.552609623000023, 49.94111565999998],
              [96.553911, 49.940763],
              [96.554823, 49.940134],
              [96.555849, 49.939375],
              [96.556025, 49.938688],
              [96.556271767, 49.938502221000022],
              [96.556551, 49.938292],
              [96.557539, 49.937513],
              [96.557878, 49.936918],
              [96.558344, 49.936659],
              [96.559855, 49.935316],
              [96.559969, 49.935297],
              [96.560587, 49.931643],
              [96.560758, 49.930777],
              [96.560953988, 49.929777148000028],
              [96.561112173000026, 49.928970149],
              [96.561132, 49.928869],
              [96.561141255999985, 49.928856586999984],
              [96.562551, 49.926966],
              [96.564379, 49.92584],
              [96.565467, 49.924916],
              [96.566122, 49.924356],
              [96.566205, 49.923998],
              [96.566462, 49.922857],
              [96.56798, 49.921788],
              [96.568521, 49.921404],
              [96.568594, 49.921022],
              [96.568796, 49.91995],
              [96.570204, 49.917952],
              [96.571825, 49.916998],
              [96.573759, 49.915861],
              [96.574499, 49.915144],
              [96.574968, 49.914316],
              [96.577089, 49.912111],
              [96.578321, 49.909636],
              [96.578350004000015, 49.909500109000021],
              [96.578699, 49.907865],
              [96.57873, 49.907724],
              [96.578817, 49.906195],
              [96.579996, 49.904203],
              [96.579931, 49.903543],
              [96.581202, 49.902456],
              [96.581556, 49.901663],
              [96.582209, 49.901075],
              [96.58322, 49.900202],
              [96.583815, 49.899115],
              [96.584314, 49.898024],
              [96.584772, 49.897577],
              [96.584913, 49.897108],
              [96.585546471999976, 49.896409272000028],
              [96.585608, 49.896341],
              [96.585535086, 49.896042654999974],
              [96.58539, 49.895449],
              [96.585510983, 49.895266548999984],
              [96.585886, 49.894701],
              [96.585272, 49.89327],
              [96.58592, 49.892019],
              [96.586081, 49.891317],
              [96.586336, 49.890894],
              [96.586279, 49.889521],
              [96.586885, 49.888998],
              [96.587233, 49.887339],
              [96.588678, 49.885893],
              [96.588705, 49.885363],
              [96.589281, 49.884256],
              [96.590498, 49.883501],
              [96.590891, 49.882769],
              [96.591734, 49.882261],
              [96.593016, 49.882139],
              [96.593733, 49.881479],
              [96.594793, 49.881163],
              [96.595278, 49.880625],
              [96.596243, 49.880304],
              [96.597425, 49.879465],
              [96.597456, 49.878946],
              [96.598039471, 49.878327620999983],
              [96.598158, 49.878202],
              [96.599061388999985, 49.877947921999976],
              [96.599566, 49.877806],
              [96.599667081, 49.877709712000012],
              [96.600283, 49.877123],
              [96.601591, 49.876375],
              [96.602125, 49.87546],
              [96.603308, 49.874266],
              [96.603720224000028, 49.874695194000026],
              [96.60581, 49.876871],
              [96.609255, 49.878222],
              [96.610254, 49.878866],
              [96.610941, 49.879789],
              [96.611761, 49.880552],
              [96.612402, 49.880854],
              [96.613691, 49.881327],
              [96.617331, 49.881849],
              [96.618628, 49.882212],
              [96.621336, 49.883661],
              [96.622965, 49.883684],
              [96.624193, 49.883287],
              [96.626314, 49.883444],
              [96.62681, 49.883921],
              [96.626814, 49.884825],
              [96.626917, 49.886236],
              [96.632757, 49.888708],
              [96.63405, 49.888716],
              [96.635508, 49.889284],
              [96.63886706400001, 49.88919888700002],
              [96.640165, 49.889166],
              [96.641096, 49.88965],
              [96.641027, 49.891703],
              [96.641016, 49.891993],
              [96.64176, 49.892809],
              [96.641527, 49.894197],
              [96.641924, 49.894442],
              [96.643327665000015, 49.894589210999982],
              [96.644098, 49.89467],
              [96.64588, 49.89678],
              [96.647425, 49.896597],
              [96.652739, 49.898932],
              [96.653673, 49.898924],
              [96.654833, 49.898588],
              [96.655603, 49.898512],
              [96.656134635, 49.898458399999981],
              [96.657309, 49.89834],
              [96.658014, 49.898611],
              [96.66017, 49.899771],
              [96.662485, 49.900534],
              [96.665094, 49.900942],
              [96.66577, 49.901323],
              [96.665625, 49.902437],
              [96.665873, 49.902788],
              [96.666868, 49.902922],
              [96.667429, 49.903898],
              [96.670832, 49.905153],
              [96.673964, 49.906462],
              [96.6747, 49.907118],
              [96.675444, 49.907316],
              [96.676271, 49.907354],
              [96.676718, 49.907766],
              [96.676832, 49.909353],
              [96.678156, 49.910215],
              [96.68207, 49.911161],
              [96.682203, 49.912321],
              [96.682611, 49.913607],
              [96.683779, 49.914362],
              [96.686148, 49.914907],
              [96.686975, 49.915545],
              [96.688203, 49.917596],
              [96.688234, 49.91765],
              [96.689204, 49.918226],
              [96.689216, 49.918232],
              [96.690866, 49.918997],
              [96.691172, 49.919378],
              [96.691172, 49.919462],
              [96.691172, 49.919874],
              [96.690218, 49.921122],
              [96.690512, 49.921858],
              [96.691637, 49.922491],
              [96.694166, 49.923151],
              [96.694370772000013, 49.923179783000023],
              [96.696905, 49.923536],
              [96.697657, 49.923265],
              [96.698183, 49.923052],
              [96.698629, 49.923174],
              [96.698893, 49.923468],
              [96.699217, 49.924147],
              [96.700758, 49.924982],
              [96.701719, 49.925089],
              [96.702539, 49.924887],
              [96.703257, 49.924807],
              [96.70365, 49.925024],
              [96.704821, 49.926157],
              [96.705538, 49.926371],
              [96.70648, 49.926168],
              [96.706911, 49.926306],
              [96.707098, 49.927343],
              [96.707521, 49.928358],
              [96.708624, 49.929461],
              [96.709501, 49.929602],
              [96.710028, 49.92943],
              [96.711172, 49.927958],
              [96.712103, 49.927259],
              [96.713686, 49.92708],
              [96.71454, 49.925837],
              [96.715246, 49.925512],
              [96.716139, 49.924616],
              [96.716848, 49.924509],
              [96.717962, 49.923922],
              [96.719843, 49.923361],
              [96.720667, 49.922544],
              [96.723093, 49.921629],
              [96.724024, 49.920267],
              [96.725554, 49.919786],
              [96.725969, 49.919027],
              [96.726435, 49.91884],
              [96.726774, 49.918421],
              [96.727766, 49.917833],
              [96.727884, 49.916815],
              [96.728804, 49.915827],
              [96.729441, 49.913317],
              [96.730219, 49.912665],
              [96.730986, 49.912024],
              [96.730856, 49.911287],
              [96.731382, 49.910501],
              [96.732023, 49.910143],
              [96.732531, 49.909388],
              [96.733854, 49.909109],
              [96.735132, 49.908461],
              [96.736013, 49.908525],
              [96.73646143000002, 49.908352702],
              [96.737978, 49.90777],
              [96.740759, 49.907618],
              [96.741522, 49.907419],
              [96.742456, 49.907457],
              [96.744566, 49.907267],
              [96.747419, 49.907259],
              [96.747849659999986, 49.907455589],
              [96.750326, 49.908586],
              [96.751856, 49.909101],
              [96.753084, 49.909311],
              [96.754656, 49.909742],
              [96.755621, 49.909693],
              [96.755979170999979, 49.909512829],
              [96.756281, 49.909361],
              [96.757185, 49.909288],
              [96.759165, 49.909346],
              [96.760286, 49.909437],
              [96.761045, 49.909922],
              [96.761105613999973, 49.909958124000013],
              [96.762785, 49.910959],
              [96.764643, 49.911074],
              [96.766860409, 49.911283771],
              [96.768385, 49.911428],
              [96.771517, 49.911722],
              [96.774015, 49.911348],
              [96.778372, 49.910696],
              [96.781332, 49.910913],
              [96.785456, 49.910784],
              [96.785917, 49.910867],
              [96.787203, 49.911093],
              [96.791155, 49.911512],
              [96.819266729999981, 49.910893955],
              [96.819765, 49.910883],
              [96.818345, 49.909139],
              [96.817911, 49.908606],
              [96.819096308999974, 49.908323415999973],
              [96.82052, 49.907984],
              [96.821665, 49.907823],
              [96.826887, 49.90708],
              [96.832570034000014, 49.904932149],
              [96.836153, 49.903578],
              [96.836742442, 49.903059401],
              [96.838308, 49.901682],
              [96.839451171, 49.901476597999988],
              [96.839922, 49.901392],
              [96.840704, 49.900277],
              [96.84216762, 49.898186668],
              [96.842215, 49.898119],
              [96.846735, 49.897284],
              [96.848372, 49.896334],
              [96.849252794, 49.896238902],
              [96.853406123000013, 49.895790474000023],
              [96.855337, 49.895582],
              [96.860178, 49.896013],
              [96.862036, 49.895803],
              [96.868093620000025, 49.895672102999981],
              [96.871199, 49.895605],
              [96.872529333999978, 49.895246456],
              [96.873915, 49.894873],
              [96.874433, 49.895361],
              [96.876226, 49.897058],
              [96.87829, 49.898069],
              [96.88032, 49.898241],
              [96.882672094999975, 49.897701231999974],
              [96.883013, 49.897623],
              [96.883844023, 49.897291490999976],
              [96.885412, 49.896666],
              [96.887249726999983, 49.897141455999986],
              [96.888021, 49.897341],
              [96.890657, 49.896544],
              [96.891371310000011, 49.895934378],
              [96.892008, 49.895391],
              [96.892279, 49.895159],
              [96.899462, 49.894972],
              [96.900911, 49.895406],
              [96.902353, 49.895838],
              [96.902660759000014, 49.895792218],
              [96.905378, 49.895388],
              [96.905412, 49.895361],
              [96.906305611999983, 49.894644073999984],
              [96.907167, 49.893953],
              [96.908109, 49.89528],
              [96.908163759, 49.895357562000015],
              [96.908438, 49.895746],
              [96.91144, 49.896246],
              [96.914209, 49.895979],
              [96.916956, 49.896112],
              [96.923891, 49.895792],
              [96.926468629, 49.895182778],
              [96.927847, 49.894857],
              [96.928834111000015, 49.894990783000026],
              [96.931337, 49.89533],
              [96.932060853999985, 49.895208649999972],
              [96.934312545000012, 49.894831168],
              [96.936795, 49.894415],
              [96.937044, 49.894373],
              [96.939592, 49.893404],
              [96.940554392000024, 49.892619828000022],
              [96.940969, 49.892282],
              [96.941599, 49.891981],
              [96.942212924999978, 49.891939831],
              [96.944759992, 49.891769029999978],
              [96.946028, 49.891684],
              [96.949330261999989, 49.892830604999972],
              [96.949389, 49.892851],
              [96.949682930999984, 49.892897426],
              [96.950022268999987, 49.892951025],
              [96.952238, 49.893301],
              [96.955248, 49.892672],
              [96.957010755, 49.891801666999982],
              [96.957243, 49.891687],
              [96.958689, 49.891584],
              [96.960542, 49.892275],
              [96.967107492000025, 49.894722366],
              [96.967356, 49.894815],
              [96.972227, 49.894812],
              [96.976912, 49.894217],
              [96.985106, 49.893106],
              [96.991152, 49.892118],
              [96.991190281, 49.892122799],
              [96.993744398999979, 49.892442956000025],
              [96.995085, 49.892611],
              [96.995527, 49.891615],
              [96.99563, 49.890825],
              [96.996439, 49.890047],
              [96.998835, 49.889071],
              [96.99885, 49.888643],
              [96.998090429, 49.888030227],
              [96.997484, 49.887541],
              [96.997866, 49.886816],
              [96.999166, 49.886332],
              [96.999186185999974, 49.886274206],
              [96.999334, 49.885851],
              [96.999206546999972, 49.88577196],
              [96.998381, 49.88526],
              [96.997858, 49.884539],
              [96.998814987, 49.883469586],
              [96.999317587, 49.882907940999985],
              [96.99962, 49.88257],
              [97.000463, 49.87752],
              [96.999495, 49.875982],
              [96.999353, 49.874273],
              [96.998285, 49.872995],
              [96.998232, 49.872931],
              [96.998121, 49.870966],
              [96.997734809, 49.870243276999986],
              [96.996099, 49.867182],
              [96.99422602300001, 49.865454156],
              [96.993647, 49.86492],
              [96.995327065000026, 49.864643296999986],
              [96.998049, 49.864195],
              [96.997759, 49.863375],
              [96.997801085, 49.862873203],
              [96.997927598999979, 49.861364713],
              [96.997942, 49.861193],
              [96.997795145999987, 49.860697494000021],
              [96.997648, 49.860201],
              [96.997675038000011, 49.860102625000025],
              [96.997908, 49.859255],
              [96.997797, 49.857176],
              [96.998545, 49.856184],
              [96.998121, 49.855646],
              [96.998213, 49.854582],
              [96.99888, 49.853224],
              [96.999369, 49.852182],
              [96.99996, 49.852007],
              [97.0007, 49.851294],
              [97.00088593800001, 49.850481166],
              [97.001276, 49.848776],
              [97.00205, 49.847712],
              [97.002005, 49.8459],
              [97.002373746999979, 49.845455402000027],
              [97.003935, 49.843573],
              [97.005518, 49.842276],
              [97.007505, 49.840319],
              [97.009432, 49.839819],
              [97.010134, 49.839373],
              [97.008887432999984, 49.838065116999985],
              [97.008101, 49.83724],
              [97.007189, 49.834158],
              [97.007405576, 49.834090203000017],
              [97.014696, 49.831808],
              [97.01615, 49.831629],
              [97.017916, 49.831808],
              [97.022692, 49.833639],
              [97.025511, 49.833315],
              [97.028048, 49.833345],
              [97.031015, 49.833754],
              [97.036432, 49.833131],
              [97.040251, 49.832689],
              [97.043398, 49.833368],
              [97.04495, 49.832979],
              [97.045948651, 49.832589177999978],
              [97.046534848000022, 49.832360357000027],
              [97.050089, 49.830973],
              [97.052423, 49.82926],
              [97.05406, 49.829081],
              [97.062329, 49.826529],
              [97.065058, 49.825686],
              [97.069483, 49.823736],
              [97.070063, 49.823164],
              [97.079263, 49.82248],
              [97.084412788, 49.822096649],
              [97.088774, 49.821772],
              [97.093037939999988, 49.821518374999982],
              [97.116228, 49.820139],
              [97.118151, 49.819921],
              [97.118542061000028, 49.81963206],
              [97.119116, 49.819208],
              [97.119558257, 49.819052305000014],
              [97.128325, 49.815966],
              [97.129869, 49.814955],
              [97.130153842000027, 49.814052769999989],
              [97.130281, 49.81365],
              [97.129572, 49.811983],
              [97.130487, 49.807486],
              [97.126501, 49.80485],
              [97.123816, 49.801893],
              [97.123068, 49.797743],
              [97.120382, 49.793982],
              [97.120164, 49.793283],
              [97.119783, 49.792082],
              [97.11902934699998, 49.791139511999972],
              [97.077657699999975, 49.768178939999984],
              [97.077619552999977, 49.768152236999981],
              [97.126676558999975, 49.732625961],
              [97.126626967999982, 49.732587814],
              [97.064256667999985, 49.684724808],
              [97.064188004000016, 49.684671402],
              [97.044054030999973, 49.661745070999984],
              [97.030855179000014, 49.649751663000018],
              [97.006490707000012, 49.628023148000011],
              [97.006444930999976, 49.627996445],
              [97.000352858999975, 49.623979567999982],
              [96.986497879000012, 49.609800339],
              [96.97445869400002, 49.597455978000028],
              [96.960161208999978, 49.580530167],
              [96.928682327, 49.570882797000024],
              [96.83526039100002, 49.47028923],
              [96.856036343000028, 49.386203699000021],
              [96.856088638000017, 49.385992050000027],
              [96.855798720999985, 49.385236739999982],
              [96.976182938000022, 49.307600020999985],
              [97.02471351600002, 49.279356002999975],
              [97.065912247000028, 49.255331039],
              [97.08275032, 49.24550437900001],
              [97.08369636499998, 49.243341445999988],
              [97.087160110000013, 49.241479874],
              [97.090234755999973, 49.239484786999981],
              [97.091882705999978, 49.238248825000028],
              [97.092119217, 49.237249373999987],
              [97.092218398999989, 49.236291885000014],
              [97.092760086, 49.234472274999973],
              [97.094545364, 49.232889175000025],
              [97.097055435000016, 49.231794357000012],
              [97.099542617999987, 49.231054305999976],
              [97.101114273, 49.229990005],
              [97.102571486999977, 49.228357314999982],
              [97.103899002, 49.226808548],
              [97.105829239, 49.225053786999979],
              [97.10846138, 49.222352982000018],
              [97.110559464, 49.21959877],
              [97.112726211999984, 49.216974258],
              [97.117456436, 49.21330452],
              [97.123781204000011, 49.209657669000023],
              [97.128870010000014, 49.206823349],
              [97.136217117, 49.204282761],
              [97.141321182000013, 49.203042983999978],
              [97.141561508, 49.202981949],
              [97.223180770999988, 49.201581955],
              [97.223291397000025, 49.201593398999989],
              [97.306817857, 49.209669109],
              [97.306936264, 49.209680557000013],
              [97.306959152, 49.209684372000027],
              [97.344636917, 49.200208664],
              [97.344717026000012, 49.200185776000012],
              [97.373304367, 49.192975998],
              [97.373407364, 49.193006516000025],
              [97.40646553, 49.202589035000017],
              [97.406694411999979, 49.202653885000018],
              [97.446939467999982, 49.21670723],
              [97.446985245, 49.216688155999975],
              [97.503942489999986, 49.192350388000023],
              [97.504564285000015, 49.192087173],
              [97.631742476999989, 49.162626266000018],
              [97.631807327, 49.162611008],
              [97.658891677999975, 49.145746230999976],
              [97.659128189, 49.145593642999984],
              [97.692827224999974, 49.130083083999978],
              [97.692975998, 49.130010605],
              [97.764642714999979, 49.096406936999983],
              [97.764722823999989, 49.096368789999985],
              [97.792009354000015, 49.08028602600001],
              [97.792284011999982, 49.080041885000014],
              [97.822629929000016, 49.052991867],
              [97.82267952, 49.052946091000024],
              [97.869737625000027, 49.03371238699998],
              [97.869989395, 49.033590317],
              [97.912145614999986, 49.013540267999986],
              [97.912160873, 49.013536452999972],
              [97.93708686399998, 49.007355995000012],
              [97.937776566000025, 49.007184982000012],
              [97.937810898, 49.007173538000018],
              [98.02182578999998, 49.01693153399998],
              [98.021894455, 49.016942977999975],
              [98.090322495, 49.006582260000016],
              [98.090421677, 49.006567001],
              [98.159166336, 49.038419724],
              [98.15934181199998, 49.038469314999986],
              [98.22316551199998, 49.057111739999982],
              [98.22332572900001, 49.057024002],
              [98.26137352, 49.035898208999981],
              [98.261453629000016, 49.035905838000019],
              [98.33949852, 49.044660567999983],
              [98.339651108, 49.044675827],
              [98.399072647000025, 49.050161361999983],
              [98.440496445, 49.040044785000021],
              [98.440511703000027, 49.039995192999982],
              [98.45158577, 49.007406235000019],
              [98.451601028000027, 49.007360458],
              [98.568685532000018, 48.974214554000014],
              [98.569093704000011, 48.97410011300002],
              [98.642381667999985, 49.004266739],
              [98.642518997000025, 49.004320145],
              [98.710496901999988, 49.02372551000002],
              [98.710622786999977, 49.023759842],
              [98.71065712, 49.023817061999978],
              [98.757966995, 49.109861374],
              [98.758148088999974, 49.110221646000014],
              [98.758195310000019, 49.110390505],
              [98.868246078000027, 49.125059127999975],
              [98.869836807000013, 49.12471962],
              [98.871610641000018, 49.124864577999972],
              [98.872987747000025, 49.124399185000016],
              [98.874845505, 49.12428093],
              [98.875818252999977, 49.12389183],
              [98.876932144000023, 49.123846054000012],
              [98.878084183, 49.123052597000026],
              [98.879053116000023, 49.122339249],
              [98.880025864, 49.122140883999975],
              [98.880521773999988, 49.121648788000016],
              [98.881731033, 49.121595383],
              [98.883436202999974, 49.120714188000022],
              [98.88428688, 49.120576858999982],
              [98.884950638000021, 49.120576858999982],
              [98.885194778000027, 49.120740891000025],
              [98.88561058, 49.120851517],
              [98.886091232000012, 49.120874405],
              [98.886571883999977, 49.120576858999982],
              [98.887205124, 49.120492935000016],
              [98.887590408, 49.120630264],
              [98.888277054000014, 49.120687485000019],
              [98.88835334800001, 49.120103836],
              [98.888643264999985, 49.119768142999988],
              [98.888856888000021, 49.119409561],
              [98.889268875000027, 49.11918067900001],
              [98.889795303000028, 49.119169235000015],
              [98.890008926, 49.11926078800002],
              [98.890161514, 49.119401932000017],
              [98.890176773, 49.119768142999988],
              [98.89008522, 49.120027542],
              [98.89011573800002, 49.120237350000025],
              [98.89030647300001, 49.120325089],
              [98.890657424999972, 49.120294570999988],
              [98.890932083, 49.120256424],
              [98.891283035000015, 49.120096207000017],
              [98.891595839999979, 49.119798660000015],
              [98.891870499, 49.119272232000014],
              [98.891992569000024, 49.119054794000022],
              [98.892114639, 49.118925095],
              [98.892221451000012, 49.118795395],
              [98.892465591000018, 49.118734360000019],
              [98.892816544000027, 49.11872673],
              [98.893190383999979, 49.11872673],
              [98.893373489, 49.118627548],
              [98.893480301000011, 49.118360519000021],
              [98.893602370999986, 49.118028641000024],
              [98.893739700000026, 49.117929458999981],
              [98.894075394000026, 49.117921829000011],
              [98.894372939999982, 49.11797142],
              [98.89487648, 49.118089676000011],
              [98.895212173, 49.118032455],
              [98.895410538000021, 49.117902755999978],
              [98.895502089999979, 49.117635727],
              [98.895547867, 49.117406845],
              [98.895441055, 49.116968155],
              [98.895502089999979, 49.116807938000022],
              [98.895715714, 49.116670608999982],
              [98.896043776999988, 49.116628647000027],
              [98.896257401000014, 49.116720199999975],
              [98.896409988000016, 49.116880417],
              [98.896516799999972, 49.117029189999982],
              [98.896669388000021, 49.117288589],
              [98.89686012300001, 49.117444992],
              [98.897241592, 49.117456436],
              [98.897455214999979, 49.117376327999978],
              [98.897638320999988, 49.117147446],
              [98.897714614999984, 49.116849898999988],
              [98.897684097000024, 49.11640358],
              [98.897775650000028, 49.116281508999975],
              [98.898050308, 49.116224289],
              [98.898347855, 49.116224289],
              [98.898637771999972, 49.116312027],
              [98.898927689, 49.116544724],
              [98.899187088000019, 49.116823195999984],
              [98.899515152, 49.117021561],
              [98.899896622000028, 49.117010117],
              [98.90004921000002, 49.116960526000014],
              [98.900217055999974, 49.116781235000019],
              [98.90017128, 49.116445541000019],
              [98.900064467999982, 49.115987777999976],
              [98.899988173999986, 49.115480423],
              [98.899850845, 49.115072250000026],
              [98.89988136300002, 49.114583969000023],
              [98.900156020999987, 49.114225388000023],
              [98.900751114, 49.113718033],
              [98.901102066000021, 49.113458633],
              [98.901193619000026, 49.113290786999983],
              [98.901117324999973, 49.112913132000017],
              [98.901147842, 49.112535477],
              [98.901315689, 49.112356186],
              [98.901590347000024, 49.112306595],
              [98.901857376, 49.112375258999975],
              [98.902070998999989, 49.112516402999972],
              [98.902658463000023, 49.112855911],
              [98.902994155999977, 49.112974167],
              [98.903238296999973, 49.11299323999998],
              [98.903421402, 49.112916945999984],
              [98.903589249, 49.112714767],
              [98.903848648, 49.112428664999982],
              [98.903963089, 49.112386703000027],
              [98.904344558999981, 49.112310410000021],
              [98.904756545999987, 49.112230301000011],
              [98.905031204000011, 49.112089157000014],
              [98.905298233, 49.112062454000011],
              [98.905786514, 49.112161636],
              [98.906030655, 49.112241745],
              [98.906709670999987, 49.112409592],
              [98.907136917, 49.112421036],
              [98.907297133999975, 49.112340927],
              [98.907632827999976, 49.111883163000016],
              [98.908197402999974, 49.111524582000015],
              [98.908830642999988, 49.111387252999975],
              [98.90924263, 49.111188889],
              [98.909761429000014, 49.110841751],
              [98.910593033, 49.110445023000011],
              [98.911188126000013, 49.11022377],
              [98.911439896, 49.110006332000012],
              [98.911623001, 49.109647751000011],
              [98.912233352999976, 49.109262466000018],
              [98.913049698, 49.108903885000018],
              [98.913644791000024, 49.108606339],
              [98.914339066000025, 49.108037949],
              [98.914964676000011, 49.107522964],
              [98.915979385000014, 49.106985092],
              [98.917238235000013, 49.106527328000027],
              [98.91881752, 49.106061935000014],
              [98.919939041000021, 49.105882645],
              [98.920816421999973, 49.10584449800001],
              [98.921770095999989, 49.105913161999979],
              [98.922784805, 49.10611534100002],
              [98.923814774, 49.106313705],
              [98.924829483, 49.106615067],
              [98.925504683999975, 49.106443405],
              [98.926412582000012, 49.106649399],
              [98.927099227999975, 49.106664658],
              [98.927408217999982, 49.106752396],
              [98.927682877, 49.106664658],
              [98.928232192999985, 49.10651207],
              [98.928712845, 49.106492995999986],
              [98.929636002, 49.107248305999974],
              [98.930116653000027, 49.107744217],
              [98.930410385000016, 49.108190536],
              [98.930822372000023, 49.10896492],
              [98.93148994400002, 49.109357833999979],
              [98.931985855, 49.109651566000025],
              [98.93280983, 49.109651566000025],
              [98.93327522300001, 49.109632492],
              [98.933927536, 49.10972023],
              [98.934526442999982, 49.10972023],
              [98.93522834800001, 49.110063552999975],
              [98.936052322000023, 49.110540389999983],
              [98.936620711999979, 49.111055373999989],
              [98.937475204, 49.111330032000012],
              [98.93850517300001, 49.112119674999974],
              [98.939706801999989, 49.11306572],
              [98.940374373999987, 49.11388588],
              [98.94128608699998, 49.114797592],
              [98.942193985000017, 49.115415573],
              [98.943292617999987, 49.116529464999985],
              [98.944013596, 49.117471695],
              [98.944906235000019, 49.118005752999977],
              [98.94591713, 49.118707657000016],
              [98.947015761999978, 49.119340896999972],
              [98.947889327999974, 49.119821548],
              [98.949331283999982, 49.120061873999987],
              [98.950960158999976, 49.120252608999976],
              [98.952024460000018, 49.120611191000023],
              [98.952699661, 49.120985030999975],
              [98.953878402999976, 49.121007919000022],
              [98.955213547000028, 49.121332169000027],
              [98.955953598, 49.121828079000011],
              [98.956537247000028, 49.122446060000016],
              [98.956876755, 49.122911452999972],
              [98.958028792999983, 49.123750686999983],
              [98.958559036, 49.124269485000013],
              [98.959848404000013, 49.124959946],
              [98.960466385000018, 49.125310898],
              [98.961168289, 49.125429153000027],
              [98.961778641000024, 49.12537574800001],
              [98.962099075000026, 49.125284195],
              [98.96254158, 49.125192642],
              [98.963220595999985, 49.124914169000022],
              [98.964151382000011, 49.124742508],
              [98.964715958, 49.124757767],
              [98.965600967, 49.124692917],
              [98.966524123999989, 49.124452591000022],
              [98.967485427999975, 49.124258041000019],
              [98.967927933, 49.124258041000019],
              [98.968736649, 49.12432289100002],
              [98.969865799, 49.124403],
              [98.970308304000014, 49.124349594000023],
              [98.971010208, 49.124166489],
              [98.971857070999988, 49.124124527],
              [98.972459792999985, 49.124269485000013],
              [98.972940445, 49.124456405999979],
              [98.973787308, 49.124837875000026],
              [98.97464942900001, 49.125116348],
              [98.975290298, 49.12520790100001],
              [98.976175308, 49.125181198],
              [98.976678848, 49.125131607000014],
              [98.977487564, 49.125089645],
              [98.978509902999974, 49.125024796],
              [98.979173660000015, 49.125104904000011],
              [98.979600905999973, 49.125223160000019],
              [98.980302811, 49.125528336],
              [98.981164932000013, 49.125684738000018],
              [98.981752396, 49.125726699999973],
              [98.982294083, 49.125711441000021],
              [98.982698441000025, 49.125631332000012],
              [98.983240127999977, 49.12528801000002],
              [98.984483719000025, 49.12465477],
              [98.985330582000017, 49.124444961999984],
              [98.986032486, 49.124498367],
              [98.986658095999985, 49.124799728000028],
              [98.986963272000025, 49.125131607000014],
              [98.987321854000015, 49.125619888000017],
              [98.987863541000024, 49.126028061],
              [98.988451004000012, 49.126279830999977],
              [98.989076614, 49.126386642],
              [98.989679336999984, 49.126478195],
              [98.990785599, 49.126531601000011],
              [98.991525650000028, 49.12666511499998],
              [98.992311477999976, 49.12699317900001],
              [98.992837905999977, 49.127138138000021],
              [98.993059158, 49.127126694000026],
              [98.993356705, 49.126955032000012],
              [98.993738173999986, 49.126703261999978],
              [98.994447708, 49.126321792999988],
              [98.995271683, 49.126096725000025],
              [98.995851517, 49.126096725000025],
              [98.996377945, 49.126188277999972],
              [98.996957779000013, 49.126451492],
              [98.997362136999982, 49.126848220999989],
              [98.99792671199998, 49.127336502],
              [98.998430252, 49.127576827999974],
              [98.998933792, 49.127534866000019],
              [98.999391555999978, 49.127298355],
              [98.99965858500002, 49.126848220999989],
              [98.99987983699998, 49.126741408999976],
              [99.000299454000015, 49.126768111999979],
              [99.001260757000011, 49.127046585000016],
              [99.001825333, 49.127099991000023],
              [99.002649307000013, 49.127363205],
              [99.00299263, 49.127614974999972],
              [99.003236771, 49.128038405999973],
              [99.003458023, 49.128274917999988],
              [99.003717422000022, 49.12843132],
              [99.003938674999972, 49.128484726000011],
              [99.004503250000027, 49.128355026],
              [99.005144119000022, 49.128038405999973],
              [99.00576973, 49.127679824999973],
              [99.006135941000025, 49.127416611],
              [99.006395339999983, 49.127325058],
              [99.00699806199998, 49.127336502],
              [99.00766181900002, 49.127298355],
              [99.008142470999985, 49.127298355],
              [99.008409500000027, 49.127244948999987],
              [99.008707046999973, 49.127008438000018],
              [99.009134292999988, 49.126836777],
              [99.009492873999989, 49.126848220999989],
              [99.009996414, 49.126966476],
              [99.010576248, 49.127180098999986],
              [99.011140823, 49.127283095999985],
              [99.011667252, 49.127256392999982],
              [99.012170792, 49.127153396999972],
              [99.012552261, 49.126966476],
              [99.013093948, 49.126913071],
              [99.013696671, 49.127004623],
              [99.014017105, 49.127046585000016],
              [99.014299392999988, 49.127031326],
              [99.014825820999988, 49.127004623],
              [99.015169144000026, 49.127058029000011],
              [99.015489577999972, 49.127202988000022],
              [99.015871048, 49.127256392999982],
              [99.016275405999977, 49.127283095999985],
              [99.016756058, 49.127244948999987],
              [99.01725959800001, 49.127309798999988],
              [99.017419814999982, 49.127508163000016],
              [99.017496108999978, 49.127691269000024],
              [99.017740249999974, 49.12779808],
              [99.018106461, 49.127744674999974],
              [99.018869400000028, 49.127851486],
              [99.019388199, 49.128049850000025],
              [99.019891739, 49.128232955999977],
              [99.020112991000019, 49.12849617],
              [99.020257949999973, 49.128881454],
              [99.020235061999983, 49.129354477],
              [99.020296097000028, 49.129541397000025],
              [99.020555495999986, 49.129644394000024],
              [99.020998001, 49.129686355999979],
              [99.021501541000021, 49.129671097000028],
              [99.021928786999979, 49.129590988000018],
              [99.022249222000028, 49.129472733],
              [99.022546767999984, 49.129171370999984],
              [99.022989273, 49.129011154000011],
              [99.023294449, 49.129037857000014],
              [99.02347755400001, 49.129102707000015],
              [99.023820877, 49.129327773999989],
              [99.024301529000013, 49.129713058],
              [99.024583817, 49.129922867],
              [99.024942398, 49.130052567],
              [99.025308608999978, 49.130132675000027],
              [99.02576637300001, 49.130132675000027],
              [99.026048660000015, 49.130105972000024],
              [99.026330948, 49.130041122000023],
              [99.026552200000026, 49.12994957],
              [99.027139664, 49.129789351999989],
              [99.027658463000023, 49.129735946999972],
              [99.028024673, 49.129842758],
              [99.028383255, 49.129987717],
              [99.028749466000022, 49.130052567],
              [99.029031754000016, 49.130025864],
              [99.02967262300001, 49.130105972000024],
              [99.030031204000011, 49.130304336999984],
              [99.030557632000011, 49.130620955999973],
              [99.030755997000028, 49.130846024],
              [99.03109931900002, 49.130990982000014],
              [99.031419754000012, 49.131055832000015],
              [99.031847, 49.131017685000018],
              [99.032350539999982, 49.131109238000022],
              [99.032609939999986, 49.131227492999983],
              [99.03285408, 49.131437302],
              [99.033014297000022, 49.131753921999973],
              [99.033296585000016, 49.132005692],
              [99.03361702, 49.132242202999976],
              [99.034055710000018, 49.132295608999982],
              [99.034673691000023, 49.132329941000023],
              [99.03553199800001, 49.132310867],
              [99.036088942999982, 49.132482529000015],
              [99.036272049, 49.13253212],
              [99.036493301, 49.132677077999972],
              [99.037080764999985, 49.133073807000017],
              [99.038064957000017, 49.13362693800002],
              [99.038530349999974, 49.133932114],
              [99.03865242, 49.134157180999978],
              [99.038705826000012, 49.134607314999982],
              [99.03891181900002, 49.13497352600001],
              [99.039194107000014, 49.135213852],
              [99.039735794000023, 49.135396957000012],
              [99.039979935000019, 49.135557174999974],
              [99.040018082000017, 49.135728836],
              [99.040018082000017, 49.136056900000028],
              [99.039880752999977, 49.136480330999973],
              [99.039941788000021, 49.136705399],
              [99.040163039999982, 49.136995316000025],
              [99.040422439999986, 49.137220383],
              [99.040948867999987, 49.137468338000019],
              [99.041528702, 49.137800217],
              [99.042451858999982, 49.138261795],
              [99.043161392, 49.138605117999987],
              [99.043542861999981, 49.13895988500002],
              [99.043664932000013, 49.139368057000013],
              [99.043542861999981, 49.139764786],
              [99.043016433999981, 49.140241623],
              [99.042474747000028, 49.140718460000016],
              [99.041650772000025, 49.14109993],
              [99.041269301999989, 49.141363144000024],
              [99.040948867999987, 49.141721725000025],
              [99.040826797000022, 49.142076492],
              [99.040887833, 49.14248848],
              [99.040788651000014, 49.143003464],
              [99.040590286, 49.143518448],
              [99.040468216000022, 49.143739700000026],
              [99.039964676000011, 49.144033432000015],
              [99.039499283, 49.144426345999989],
              [99.039239883, 49.144968033],
              [99.039117813000018, 49.145235061999983],
              [99.038675308, 49.145643233999976],
              [99.038034439, 49.146024704000013],
              [99.037446976000012, 49.14632988],
              [99.037172317999989, 49.146684646999972],
              [99.037172317999989, 49.146856308],
              [99.037508011, 49.147279739],
              [99.037958145, 49.147611617999985],
              [99.038301467999986, 49.147745132000011],
              [99.046770095999989, 49.14941597],
              [99.053857803000028, 49.151056289999985],
              [99.059259414999985, 49.152166367],
              [99.068086623999989, 49.152647017999982],
              [99.078264236, 49.153131485000017],
              [99.098592758, 49.157125473],
              [99.099420547000022, 49.157720566000023],
              [99.100175858, 49.157785416000024],
              [99.100900650000028, 49.157766342],
              [99.101289748999989, 49.157655716000022],
              [99.101572036999983, 49.157457352],
              [99.101915358999975, 49.157148361],
              [99.102045058999977, 49.15703392],
              [99.102533339999979, 49.156648636],
              [99.103502274, 49.156202316000019],
              [99.103845595999985, 49.155992508],
              [99.103960036999979, 49.155721664],
              [99.103746414, 49.15497398399998],
              [99.103837967, 49.154367447000027],
              [99.104036330999975, 49.154096603000028],
              [99.104516983, 49.153806686],
              [99.105028151999988, 49.153249741000025],
              [99.105218886999978, 49.152643204000015],
              [99.105340958, 49.151968002],
              [99.105287552, 49.151128769000024],
              [99.105272292999985, 49.150400161999983],
              [99.105295180999974, 49.149637222000024],
              [99.105401992999987, 49.149068832000012],
              [99.10550880400001, 49.14891243],
              [99.105821608999975, 49.148710251000011],
              [99.106134414999985, 49.148511886999984],
              [99.106454848999988, 49.148225783999976],
              [99.106454848999988, 49.148111342999982],
              [99.106111526, 49.147874832000014],
              [99.10594368, 49.147665024],
              [99.106035233, 49.147363663000021],
              [99.106378555, 49.147043227999973],
              [99.106500626000013, 49.146883011],
              [99.106302261, 49.146677017],
              [99.106111526, 49.146471024],
              [99.105958939, 49.146039963000021],
              [99.106126785000015, 49.145734786999981],
              [99.106470108, 49.145433426000011],
              [99.106836319000024, 49.14536857600001],
              [99.10720253, 49.145479202],
              [99.107446671, 49.145685195999988],
              [99.107904433999977, 49.145765305],
              [99.108827591000022, 49.145559311],
              [99.109895705999975, 49.144933701000014],
              [99.109872817999985, 49.144487380999976],
              [99.109651566000025, 49.144090651999988],
              [99.109483719000025, 49.143514633],
              [99.109628676999989, 49.143053055],
              [99.110185623, 49.142671585000016],
              [99.110841751, 49.142431258999977],
              [99.111352921, 49.142156601000011],
              [99.111566544000027, 49.141138077],
              [99.111955642999988, 49.140768051],
              [99.113046645999987, 49.140195846999973],
              [99.113145827999972, 49.139955521],
              [99.113313674999972, 49.139398574999973],
              [99.113157272000024, 49.138902664],
              [99.11065101600002, 49.137945175000027],
              [99.108819961999984, 49.136022567999987],
              [99.107774733999975, 49.134527205999973],
              [99.106859207000014, 49.133546829000011],
              [99.106599808, 49.132432938000022],
              [99.106592178000028, 49.131708145],
              [99.106660842999986, 49.130895614999986],
              [99.106264114, 49.129953383999975],
              [99.105745316000025, 49.129270554000016],
              [99.105157852, 49.128503798999986],
              [99.10495948800002, 49.127519608],
              [99.105020523, 49.126707077],
              [99.105020523, 49.126321792999988],
              [99.103776932000017, 49.125169754000012],
              [99.103059769000026, 49.124357224],
              [99.103059769000026, 49.122945786],
              [99.103250504000016, 49.122476577999976],
              [99.103578567999989, 49.121664047000024],
              [99.103311539, 49.120210648000011],
              [99.102464676000011, 49.119142532000012],
              [99.101549149, 49.118288039999982],
              [99.101419449, 49.117605208999976],
              [99.101549149, 49.117136002],
              [99.101160048999986, 49.116407394000021],
              [99.100114822000023, 49.11508369400002],
              [99.09945869400002, 49.112134933],
              [99.09964942900001, 49.109827042],
              [99.099840164, 49.107645035000019],
              [99.100290298, 49.105379105],
              [99.100542067999982, 49.103200911999977],
              [99.100603104000015, 49.101446152],
              [99.100343704000011, 49.099611282000012],
              [99.100664139, 49.098413467],
              [99.101381302, 49.096960067999987],
              [99.101961136, 49.095716476],
              [99.102937698, 49.09396553],
              [99.103586197000027, 49.092939377],
              [99.103776932000017, 49.090929030999973],
              [99.103769301999989, 49.089006424],
              [99.103372574, 49.087080002],
              [99.102396011, 49.085756302],
              [99.097703933999981, 49.082342148],
              [99.093530655, 49.079610824999975],
              [99.089792252, 49.077077866000025],
              [99.089750289999984, 49.077051163000021],
              [99.111566544000027, 49.053743361999977],
              [99.111597061, 49.053712845],
              [99.115530014, 49.006666183],
              [99.115549088000023, 49.006437302],
              [99.119283676, 48.978460311999982],
              [99.119356155, 48.977853775000028],
              [99.120866776000014, 48.928346633999979],
              [99.120969772000024, 48.928262711],
              [99.194581985000013, 48.869852066000021],
              [99.194631577, 48.869813919000023],
              [99.207345963000023, 48.842920303000028],
              [99.192552567, 48.805295944000022],
              [99.185564041000021, 48.803529739],
              [99.180627823, 48.798410416000024],
              [99.175180435000016, 48.792268752999973],
              [99.173089980999976, 48.786977767999986],
              [99.172304153000027, 48.783903122000027],
              [99.170732498, 48.77775383],
              [99.167085648000011, 48.768362045],
              [99.165246964, 48.760507583999981],
              [99.163949966000018, 48.757261276],
              [99.161874770999987, 48.75606727600001],
              [99.158250808999981, 48.754705429000012],
              [99.156175613000016, 48.752317429000016],
              [99.152032852, 48.747198105],
              [99.145296097000028, 48.741567611999983],
              [99.139352798, 48.739866257000017],
              [99.135728836, 48.736967086999982],
              [99.134943008, 48.732866286999979],
              [99.135957717999986, 48.726373672000022],
              [99.135156630999973, 48.718687057000011],
              [99.130136489999984, 48.712118149],
              [99.130010605, 48.711954117],
              [99.090528488000018, 48.685388564999982],
              [99.088247298999988, 48.680654526000012],
              [99.085859299, 48.676923752],
              [99.083452224999974, 48.672693252999977],
              [99.083013535000021, 48.670721054000012],
              [99.082876205, 48.66901207],
              [99.082574844000021, 48.66685295100001],
              [99.082136154000011, 48.664590836],
              [99.082509995, 48.659574508999981],
              [99.081701279000015, 48.655176163000021],
              [99.080606461, 48.651308060000019],
              [99.081262589, 48.648756027],
              [99.081190108999976, 48.645910263000019],
              [99.081918716000018, 48.642770767],
              [99.080530167, 48.637517929000012],
              [99.080312729000013, 48.635255814],
              [99.079217911, 48.633577347000028],
              [99.079984664999984, 48.625951767],
              [99.079874039, 48.62591362],
              [99.072481155, 48.572626114],
              [99.073816298999986, 48.512651442999982],
              [99.073789596999973, 48.512628555],
              [99.063135147000025, 48.503847122000025],
              [99.062997817999985, 48.503683089999981],
              [99.060804367, 48.501054764],
              [99.060804367, 48.498571395999988],
              [99.063581467, 48.494623183999977],
              [99.065919876, 48.489656448],
              [99.067380905, 48.483224869000026],
              [99.069547652999972, 48.478528976],
              [99.074979782000014, 48.476503372000025],
              [99.080091476, 48.475919724],
              [99.085790633999977, 48.476797104000013],
              [99.090616226, 48.478258133],
              [99.092367172000024, 48.477235794000023],
              [99.091489792, 48.474752426],
              [99.090177536, 48.469781876000013],
              [99.090761185000019, 48.463354111],
              [99.093538283999976, 48.458822250000026],
              [99.098386764999987, 48.453039169000022],
              [99.102159500000027, 48.448740005],
              [99.102598189999981, 48.444356917999983],
              [99.102888107000012, 48.440263748],
              [99.099382401000014, 48.435441970999989],
              [99.096635817999982, 48.431127548],
              [99.096685410000021, 48.431024551],
              [99.11409568800002, 48.396875380999973],
              [99.114164351999989, 48.396738051999989],
              [99.090608597000028, 48.338571548],
              [99.090539932000013, 48.338411330999975],
              [99.080896377999977, 48.311346054000012],
              [99.01825523399998, 48.304708480999977],
              [99.017137526999988, 48.304590225000027],
              [98.989934920999985, 48.305433273],
              [98.956842422000022, 48.290266036999981],
              [98.941198349, 48.277093886999978],
              [98.907674789, 48.261075974],
              [98.868997574, 48.247667313000022],
              [98.868879317999983, 48.247625351000011],
              [98.804216385000018, 48.224966048999988],
              [98.705903020999983, 48.232089212],
              [98.705889078999974, 48.232090222000011],
              [98.705865860000017, 48.232091904000015],
              [98.692842483999982, 48.197389602999976],
              [98.681463242, 48.16702079800001],
              [98.665037155, 48.164224624999974],
              [98.664564133, 48.164144516000022],
              [98.656717300000025, 48.162809372000027],
              [98.649656295999989, 48.161607742],
              [98.649370192999982, 48.161558151],
              [98.648973464999983, 48.161489486999983],
              [98.618291855, 48.156259536999983],
              [98.595411301000013, 48.140691757000013],
              [98.581602096999973, 48.131288528000027],
              [98.57242012, 48.12386131300002],
              [98.552503586, 48.107740402],
              [98.551218033, 48.107145308999975],
              [98.549364089999983, 48.10628318800002],
              [98.496103286999983, 48.081495285000017],
              [98.473295211999982, 48.090227127],
              [98.453958511, 48.097620010000014],
              [98.45363426199998, 48.097745895],
              [98.409238814999981, 48.114698410000017],
              [98.380109786999981, 48.110567092999986],
              [98.313699722000024, 48.101118088000021],
              [98.309019089, 48.100450516000024],
              [98.305952072000025, 48.100011826000014],
              [98.298234939999986, 48.098909377999973],
              [98.267374039, 48.094499588000019],
              [98.238649367999983, 48.072515488000022],
              [98.22902488699998, 48.029981613000018],
              [98.224081039, 48.008108139],
              [98.219171523999989, 47.997423172000026],
              [98.215471267999988, 47.989370345999987],
              [98.206415176, 47.983953476000011],
              [98.188905716000022, 47.976095199999975],
              [98.181058883999981, 47.963361739999982],
              [98.175188064999986, 47.950960158999976],
              [98.175210952999976, 47.950937270999987],
              [98.183206558, 47.942686080999977],
              [98.188074111999981, 47.938550948999989],
              [98.193410873, 47.934179305999976],
              [98.194154739, 47.931589127],
              [98.193864822000023, 47.929315567],
              [98.188055038000016, 47.915079117],
              [98.189878464, 47.912904739],
              [98.190137863000018, 47.911329269000021],
              [98.188554764, 47.907777786],
              [98.188020705999975, 47.904546738000022],
              [98.189718245999984, 47.900857925000025],
              [98.19208335899998, 47.899145126],
              [98.193853377999972, 47.898214339999981],
              [98.197099686, 47.892789841000024],
              [98.20052528399998, 47.890623092999988],
              [98.204656601000011, 47.888368607000018],
              [98.212171555, 47.886690139999985],
              [98.217134476000012, 47.88341713],
              [98.220350266000025, 47.879663467],
              [98.220491408999976, 47.878087997000023],
              [98.219350814999984, 47.876111983999976],
              [98.217420577999974, 47.872243880999974],
              [98.217809677, 47.869806289999985],
              [98.220117569000024, 47.864076614],
              [98.21912574800001, 47.859895705999975],
              [98.216253280999979, 47.856492995999986],
              [98.21160697900001, 47.854337692],
              [98.204694748, 47.855234145999987],
              [98.196435928000028, 47.856988907000016],
              [98.201810836999982, 47.852773666000019],
              [98.205160141000022, 47.847681046],
              [98.205312729000013, 47.845476151000014],
              [98.202066421999973, 47.843564986999979],
              [98.200563430999978, 47.84261131300002],
              [98.199914932000013, 47.839143752999973],
              [98.198797226000011, 47.835672379000016],
              [98.19629097, 47.831403732000012],
              [98.194681167999988, 47.822183608999978],
              [98.194738388000019, 47.818563461],
              [98.190961838000021, 47.813421248999987],
              [98.190671920999989, 47.812433242999987],
              [98.192502975000025, 47.804300308],
              [98.196905136, 47.799215317],
              [98.200254439999981, 47.794198989999984],
              [98.200666427999977, 47.790109633999975],
              [98.198957442999983, 47.787343979000013],
              [98.18658638, 47.786626816000023],
              [98.18040657, 47.786188126000013],
              [98.178319930999976, 47.784944533999976],
              [98.177412033, 47.78341102600001],
              [98.181310654000015, 47.780607224],
              [98.185808182000017, 47.77662468],
              [98.190294266000024, 47.773508072000027],
              [98.191293716000018, 47.769498825000028],
              [98.190408707000017, 47.766187667999986],
              [98.191740036, 47.763204574999975],
              [98.191568374999974, 47.760957717999986],
              [98.188764572000025, 47.759248733999982],
              [98.184221267999988, 47.758825302],
              [98.17909812900001, 47.757921219000025],
              [98.173513411999977, 47.756700516000024],
              [98.172475814999984, 47.755826950000028],
              [98.174718857000016, 47.754346848000012],
              [98.178590774999975, 47.753114700000026],
              [98.180246352999973, 47.75163459800001],
              [98.179681777999974, 47.750368117999983],
              [98.17691993699998, 47.747987747000025],
              [98.174493789999985, 47.746316910000019],
              [98.174875258999975, 47.744352341000024],
              [98.179841995, 47.740373611],
              [98.183137894000026, 47.738428116000023],
              [98.187253952, 47.736413955999978],
              [98.188093185000014, 47.735078811999983],
              [98.188234329000011, 47.733270645],
              [98.18569755599998, 47.731363296999973],
              [98.179712296, 47.726205826000012],
              [98.177438736, 47.722410202],
              [98.180311202999974, 47.717866898000011],
              [98.185743332000015, 47.713575363000018],
              [98.190443039, 47.711248398],
              [98.196996689, 47.709955214999979],
              [98.200742721999973, 47.709035873],
              [98.202638626, 47.706922530999975],
              [98.202695846999973, 47.703145980999977],
              [98.201791763000017, 47.701406479000013],
              [98.20253562900001, 47.69849968],
              [98.206552505, 47.695066452],
              [98.20913505599998, 47.693902969000021],
              [98.211954117, 47.693094254000016],
              [98.24524498, 47.676008223999986],
              [98.241033554000012, 47.651685714999985],
              [98.268953323, 47.648706436],
              [98.344347, 47.656885147000025],
              [98.409429550000027, 47.642885208],
              [98.422563552999975, 47.657682419000025],
              [98.44993782, 47.664770126],
              [98.492292404000011, 47.680242538000016],
              [98.54424476600002, 47.699934005999978],
              [98.591268539, 47.712167739999984],
              [98.603841782000018, 47.712915421],
              [98.608880997000028, 47.71141243],
              [98.614179611, 47.711030960000016],
              [98.621355057000017, 47.711252213000023],
              [98.624753952, 47.711809158],
              [98.627706527999976, 47.713830948],
              [98.628808975000027, 47.716367721999973],
              [98.631402969000021, 47.722631454],
              [98.633127213000023, 47.725168227999973],
              [98.634634017999986, 47.726613998],
              [98.642362595, 47.727693558],
              [98.646718979000013, 47.728269577],
              [98.651346207000017, 47.728616714],
              [98.662477492999983, 47.729757308999979],
              [98.672742844000027, 47.730779648],
              [98.684221267999988, 47.729951858999982],
              [98.696027755999978, 47.726144791000024],
              [98.707120895, 47.723497391000024],
              [98.713079452999978, 47.72344017],
              [98.723798752, 47.729303360000017],
              [98.752153396999972, 47.738451004000012],
              [98.754594802999975, 47.735677719000023],
              [98.757959366000023, 47.732767105],
              [98.76130867, 47.730649948],
              [98.763227463000021, 47.729028702],
              [98.765851973999986, 47.727964401],
              [98.767892838000023, 47.728017807000015],
              [98.772813797000026, 47.727693558],
              [98.782632827999976, 47.727449417],
              [98.786050796999973, 47.727437973],
              [98.789148330999978, 47.727819442999987],
              [98.785600661999979, 47.72313118],
              [98.783395767, 47.719865799],
              [98.781976699999973, 47.716596603000028],
              [98.781976699999973, 47.713472366000019],
              [98.782258986999977, 47.711839676000011],
              [98.78368187, 47.710641861],
              [98.784830092999982, 47.709947586],
              [98.786611557000015, 47.709089279000011],
              [98.78714942900001, 47.708845139],
              [98.78973960899998, 47.707689285000015],
              [98.792852402, 47.707098007000013],
              [98.795396805, 47.705869674999974],
              [98.797174454000015, 47.705163955999978],
              [98.798170089999985, 47.703813552999975],
              [98.798524857000018, 47.701894760000016],
              [98.79778862, 47.700548172000026],
              [98.797487258999979, 47.698942183999975],
              [98.796846389999985, 47.696821213000021],
              [98.796369552999977, 47.693445205999978],
              [98.797319411999979, 47.689893723000012],
              [98.798597336, 47.686483383],
              [98.799379349, 47.684495926000011],
              [98.799875258999975, 47.682008742999983],
              [98.806222916000024, 47.678274155],
              [98.808668136999984, 47.677453995],
              [98.811220169000023, 47.676137923999988],
              [98.81377601600002, 47.674150467],
              [98.816034317, 47.671304702999976],
              [98.817914963000021, 47.667795180999974],
              [98.818243027, 47.667387008999981],
              [98.823106766000024, 47.617925644000024],
              [98.825361252, 47.585515976000011],
              [98.834550858, 47.569749832000014],
              [98.853136063000022, 47.53550148],
              [98.876001358, 47.530488967999986],
              [98.877874373999987, 47.528680801],
              [98.880186080999977, 47.527082442999983],
              [98.882291794000025, 47.524984360000019],
              [98.883428574, 47.524126052999975],
              [98.885450363000018, 47.523412704],
              [98.886812210000016, 47.523355483999978],
              [98.887380599999972, 47.523248672000022],
              [98.888269423999986, 47.522924423],
              [98.891477585000018, 47.520940780999979],
              [98.895780563000017, 47.518205642999988],
              [98.898267745999988, 47.516714095999987],
              [98.901048660000015, 47.515401839999981],
              [98.904047011999978, 47.514760970999987],
              [98.909978867, 47.513555527],
              [98.917867661, 47.512174605999974],
              [98.923791885000014, 47.511285782000016],
              [98.928922652999972, 47.510766983],
              [98.934984207000014, 47.51004982],
              [98.935682297000028, 47.509988785000019],
              [98.940244674999974, 47.509576797000022],
              [98.945322036999983, 47.508642196999972],
              [98.953119277999974, 47.507364273],
              [98.964021683, 47.506475449],
              [99.079076767, 47.48031806900002],
              [99.171388626, 47.479005814],
              [99.244894027999976, 47.459936142],
              [99.259862899999973, 47.487680435000016],
              [99.367284774999973, 47.522211074999973],
              [99.391805649, 47.577985764],
              [99.395360946999972, 47.580869674999974],
              [99.396516799999972, 47.581445694000024],
              [99.397958755, 47.581350327],
              [99.399209976, 47.580484389999981],
              [99.400796889999981, 47.579633713000021],
              [99.400907516000018, 47.57956886300002],
              [99.401353836, 47.579381942999987],
              [99.401819229000012, 47.57926368699998],
              [99.402513504000012, 47.57923317],
              [99.403356552, 47.579317092999986],
              [99.405054092, 47.57985878],
              [99.406839371, 47.581075667999983],
              [99.409284592, 47.583818436],
              [99.411710739, 47.587697983],
              [99.413824080999973, 47.591157913000018],
              [99.415750504000016, 47.593851089],
              [99.417383194000024, 47.596929550000027],
              [99.419691086, 47.600103377999972],
              [99.42122840899998, 47.603082657000016],
              [99.422674179000012, 47.604333877999977],
              [99.424016952999978, 47.605485916000021],
              [99.426038742, 47.605871201000014],
              [99.427865982000014, 47.605680466000024],
              [99.43105125400001, 47.604486464999979],
              [99.433549880999976, 47.604013442999985],
              [99.436845779, 47.603063583],
              [99.439020157000016, 47.603277205999973],
              [99.441713333, 47.603563308999981],
              [99.444211960000018, 47.604043961],
              [99.445848464999983, 47.604238510000016],
              [99.447290421, 47.604429245],
              [99.449598311999978, 47.604719161999981],
              [99.451906204000011, 47.604814529],
              [99.455667496, 47.603738785000019],
              [99.462224960000015, 47.602128983],
              [99.464704514, 47.601549149],
              [99.466138839999985, 47.60058403],
              [99.46796608, 47.598852158],
              [99.469118117999983, 47.596735001000013],
              [99.470560074, 47.59442710899998],
              [99.473348617999989, 47.589910507000013],
              [99.476453780999975, 47.586248398],
              [99.480386733999978, 47.583311080999977],
              [99.483121872000027, 47.581323624],
              [99.486646652, 47.579450607000012],
              [99.490659714, 47.576349258],
              [99.493928908999976, 47.57442665100001],
              [99.497037888000023, 47.573686599999974],
              [99.498048782000012, 47.573423386],
              [99.498075485000015, 47.573423386],
              [99.50998497, 47.574537277],
              [99.556627274, 47.593370438000022],
              [99.569799423, 47.61885261499998],
              [99.63971138, 47.630872726],
              [99.655576705999977, 47.629240036],
              [99.669099808, 47.639265060000014],
              [99.669969558999981, 47.639875411999981],
              [99.673818588000017, 47.642614364999986],
              [99.674707413000021, 47.643301010000016],
              [99.677911758, 47.645811080999977],
              [99.681806564, 47.648885727],
              [99.685060501, 47.651453017999984],
              [99.686998367, 47.652845383],
              [99.689531326, 47.654649733999975],
              [99.690999985000019, 47.655649185000016],
              [99.693693161, 47.657461166000019],
              [99.697992324999973, 47.659833908],
              [99.703657150000026, 47.660600661999979],
              [99.713083267, 47.662614822000023],
              [99.718843460000016, 47.663190842],
              [99.731786727999975, 47.653646469000023],
              [99.736028670999985, 47.651380539],
              [99.744791030999977, 47.650728226000012],
              [99.681234360000019, 47.615926742999989],
              [99.707551955999975, 47.582838058],
              [99.711309433, 47.539255142],
              [99.754640579000011, 47.492334366000023],
              [99.817674636999982, 47.446496964],
              [99.829137802, 47.436765670999989],
              [99.87776756300002, 47.427923202999978],
              [99.887109755999973, 47.39235878],
              [99.883291245, 47.377084732000014],
              [99.889623642, 47.357793808],
              [99.853052139, 47.246671677],
              [99.910421370999984, 47.216829299999972],
              [99.891431808, 47.146600723],
              [99.923967361, 47.103212357000018],
              [99.92506218, 47.100164413000016],
              [99.927431107000018, 47.096815108999976],
              [99.928937911999981, 47.095010757000011],
              [99.931119919000025, 47.093130111999983],
              [99.932474136, 47.093278885000018],
              [99.936086655, 47.094709395999985],
              [99.940076827999974, 47.095537186],
              [99.945947647000025, 47.097269058],
              [99.949201583999979, 47.098943710000015],
              [99.95181846600002, 47.099374770999987],
              [99.955583572000023, 47.099752426],
              [99.95889473, 47.100355148],
              [99.962732314999982, 47.102460861],
              [99.965517044000023, 47.103590011999984],
              [99.968225479000012, 47.10389137300001],
              [99.971311569000022, 47.103441238000016],
              [99.974248886, 47.102685928000028],
              [99.977033614999982, 47.102235794000023],
              [99.978990555, 47.101556777999974],
              [99.982076645, 47.099901198999987],
              [99.98591423, 47.098173141000018],
              [99.988473892, 47.097494125000026],
              [99.989980698000011, 47.09787178],
              [100.000894546999973, 47.107503891000022],
              [100.003828049, 47.107881545999987],
              [100.006837845, 47.108633041000019],
              [100.011732101, 47.10878562900001],
              [100.017450333, 47.108934401999988],
              [100.019334792999985, 47.109312057000011],
              [100.02053642300001, 47.110891342],
              [100.021585464, 47.114641189999986],
              [100.02377891499998, 47.11797142],
              [100.026594161999981, 47.121686935000014],
              [100.030550002999973, 47.12504005400001],
              [100.035066605, 47.126245499],
              [100.04086113, 47.12571907],
              [100.043870926000011, 47.125192642],
              [100.048009872000023, 47.125116348],
              [100.053506851, 47.12534141499998],
              [100.056516647000024, 47.126699448000011],
              [100.061708450000026, 47.128126144000021],
              [100.063966751, 47.128881454],
              [100.066484451, 47.131917953000027],
              [100.069162369000026, 47.135126114],
              [100.071794510000018, 47.138364792],
              [100.075181961, 47.141527176000011],
              [100.083387374999973, 47.144613266000022],
              [100.137880325000026, 47.129331589],
              [100.174310683999977, 47.154169083],
              [100.18974113500002, 47.171407699999975],
              [100.227975845, 47.166513442999985],
              [100.257104874, 47.161924361999979],
              [100.293672561999983, 47.187665939],
              [100.323225020999985, 47.184911727999975],
              [100.358957291000024, 47.19598197900001],
              [100.37584877, 47.17128562900001],
              [100.388303757000017, 47.115022658999976],
              [100.373971939, 47.098627089999979],
              [100.427793502999975, 47.08028602600001],
              [100.429609299, 47.002996445],
              [100.427793502999975, 46.997861861999979],
              [100.429735183999981, 46.992418289],
              [100.431047439999986, 46.990350723],
              [100.442087173, 46.985570908],
              [100.445379257000013, 46.983217239],
              [100.450014114, 46.980089188000022],
              [100.453641891000018, 46.97902488699998],
              [100.458772658999976, 46.977708817],
              [100.464658736999979, 46.976522446],
              [100.47035408, 46.975831985000013],
              [100.47836494400002, 46.97558403],
              [100.484182358, 46.976083755],
              [100.489252089999979, 46.977083205999975],
              [100.492822647000025, 46.978086471999973],
              [100.499204636, 46.978399277],
              [100.510534286, 46.978899002],
              [100.517854691000025, 46.979589461999979],
              [100.524866104000012, 46.980024338000021],
              [100.528367995999986, 46.980024338000021],
              [100.531309127999975, 46.979337692],
              [100.537508011, 46.976957320999986],
              [100.542387008999981, 46.97551918],
              [100.545705795, 46.975019455],
              [100.551527023, 46.974767685000018],
              [100.55390358, 46.97489357],
              [100.556844711, 46.974706649999973],
              [100.562292099, 46.973955154],
              [100.566045761, 46.973642348999988],
              [100.571241379000014, 46.972452164],
              [100.575181961, 46.971578598],
              [100.578714371, 46.969671248999987],
              [100.58075523399998, 46.96631813],
              [100.58231926000002, 46.964941024999973],
              [100.586572647000025, 46.963628769000024],
              [100.589078902999972, 46.963315964],
              [100.591768264999985, 46.964128494000022],
              [100.595022202, 46.967008591000024],
              [100.598089217999984, 46.969137192],
              [100.602594376000013, 46.970136642],
              [100.630891799999972, 46.944940567],
              [100.613866805999976, 46.917612076000012],
              [100.628412247000028, 46.890996933],
              [100.644849777, 46.868078232000016],
              [100.663656235000019, 46.861886977999973],
              [100.708234786999981, 46.851129532000016],
              [100.717176436999978, 46.853715896999972],
              [100.719762802, 46.853445052999973],
              [100.721670151000012, 46.852853775000028],
              [100.724439620999988, 46.851991653000027],
              [100.726663589, 46.85044670100001],
              [100.728116989, 46.848585129000014],
              [100.72902488699998, 46.845907211],
              [100.729341507000015, 46.844457626],
              [100.729932785000017, 46.843458176000013],
              [100.731519698999989, 46.842683792],
              [100.732473373, 46.84200477600001],
              [100.732973099, 46.841005325000026],
              [100.733110427999975, 46.839235305999978],
              [100.73342704800001, 46.837240219000023],
              [100.734426498, 46.835149764999983],
              [100.735834122000028, 46.833471298],
              [100.737829208, 46.832288742],
              [100.740011214999981, 46.831834792999985],
              [100.742097855, 46.832063674999972],
              [100.746953964, 46.833379745],
              [100.755487442, 46.836965561],
              [100.773508072000027, 46.843637466000018],
              [100.780454636, 46.84604453999998],
              [100.788763045999985, 46.848722458],
              [100.794164658, 46.851083755],
              [100.795084, 46.851579666000021],
              [100.795797348, 46.851537704],
              [100.795934677, 46.850492476999989],
              [100.797204970999985, 46.848905563000017],
              [100.799291611, 46.848176955999975],
              [100.803743361999977, 46.849039077999976],
              [100.808191298999986, 46.849721908999982],
              [100.809640883999975, 46.849451064999982],
              [100.81182289100002, 46.848630905],
              [100.814863205, 46.846681595],
              [100.816316605, 46.845499039],
              [100.817995070999984, 46.844865799],
              [100.820581436, 46.844366074],
              [100.822896957000012, 46.844545364],
              [100.824850082000012, 46.845590591000018],
              [100.827165604000015, 46.846681595],
              [100.829660416000024, 46.846952438000017],
              [100.832021713000017, 46.847089767],
              [100.833791733, 46.847406386999978],
              [100.836015701, 46.848176955999975],
              [100.83856010400001, 46.849405289],
              [100.840600967, 46.850675583],
              [100.842161179000016, 46.852987289],
              [100.844316483, 46.855638504000012],
              [100.845640182000011, 46.856214523],
              [100.847093582000014, 46.856031417999986],
              [100.850950241000021, 46.859071732000018],
              [100.881048202999978, 46.845182419000025],
              [100.92040062, 46.840734482000016],
              [100.925077438000017, 46.839551926000013],
              [100.928117752, 46.837694167999985],
              [100.92934608500002, 46.837556839],
              [100.93179512, 46.838056564],
              [100.934064864999982, 46.838964461999979],
              [100.936925888000019, 46.839735030999975],
              [100.938650130999974, 46.840143204000015],
              [100.940511703000027, 46.839872360000015],
              [100.943418502999975, 46.839235305999978],
              [100.94582176199998, 46.839281082000014],
              [100.947542191000025, 46.84056282],
              [100.950540542999988, 46.841527939],
              [100.952676773, 46.842187880999973],
              [100.95413017300001, 46.841505051000013],
              [100.956037520999985, 46.840505599999972],
              [100.957986832000017, 46.840280533],
              [100.960531235000019, 46.839918136999984],
              [100.964117050000027, 46.840097426999989],
              [100.96688652, 46.839010239],
              [100.969610214, 46.838418961],
              [100.971319199, 46.838914870999986],
              [100.972589492999987, 46.838754654000013],
              [100.97489357, 46.839170455999977],
              [100.978643417, 46.840372086],
              [100.981229782000014, 46.840688705],
              [100.983137130999978, 46.840280533],
              [100.985494614, 46.839509964],
              [100.98767662, 46.839235305999978],
              [100.989400864, 46.839372635000018],
              [100.991533279, 46.839826583999979],
              [100.993730545, 46.841154099],
              [100.998029708999979, 46.842607498],
              [101.000028610000015, 46.843564986999979],
              [101.00050926199998, 46.843797683999981],
              [101.002130508, 46.844579696999972],
              [101.003225327, 46.84502601600002],
              [101.003664017, 46.84511375400001],
              [101.008226395, 46.844781876000013],
              [101.017145157000016, 46.842248917],
              [101.02031517, 46.841218948],
              [101.024362564, 46.839715958],
              [101.029783249, 46.836977005],
              [101.032106399999975, 46.835687636999978],
              [101.033308029000011, 46.835012436],
              [101.036260605, 46.833734511999978],
              [101.036638260000018, 46.833589554000014],
              [101.037710189999984, 46.833654404000015],
              [101.038408279, 46.833795547000022],
              [101.038537979000012, 46.833814620999988],
              [101.04232215899998, 46.836545944000022],
              [101.044340133999981, 46.837617873999989],
              [101.046018600000025, 46.838338852],
              [101.050153732000012, 46.839868546],
              [101.050992966000024, 46.839849472000026],
              [101.056257248, 46.838518142999988],
              [101.058591842999988, 46.838144301999989],
              [101.059785842999986, 46.837953567999989],
              [101.062475204, 46.837762833],
              [101.064466476, 46.838499069000022],
              [101.066820145, 46.839662552],
              [101.070062636999978, 46.841142654],
              [101.074556351000012, 46.842504501],
              [101.073469161999981, 46.859300613000016],
              [101.125352858999975, 46.870149611999977],
              [101.169431686, 46.852128983],
              [101.187177658, 46.833879470999989],
              [101.209238051999989, 46.827207564999981],
              [101.246191024999973, 46.817445755],
              [101.266752242999985, 46.804693222000026],
              [101.298490523999988, 46.781023026000014],
              [101.298711777, 46.780858994000027],
              [101.331190108999976, 46.765130997000028],
              [101.362394333, 46.729040145999988],
              [101.45536232, 46.68294715899998],
              [101.542562485000019, 46.613355636999984],
              [101.50475502, 46.597024917999988],
              [101.490285873, 46.582361220999985],
              [101.489206314, 46.546098708999978],
              [101.507104874, 46.529039383],
              [101.520780563000017, 46.496198654000011],
              [101.555391311999983, 46.45324516300002],
              [101.534196854000015, 46.435720444000026],
              [101.502069473, 46.423360824999975],
              [101.500047683999981, 46.417341232000012],
              [101.499361038000018, 46.411092758],
              [101.498380661, 46.405858994000027],
              [101.495351791000019, 46.40222358699998],
              [101.489137649999975, 46.398756027],
              [101.485734939999986, 46.397363663000021],
              [101.481485367, 46.395891189999986],
              [101.475767136, 46.394319533999976],
              [101.472032547000026, 46.393293380999978],
              [101.468961716000024, 46.392766952999978],
              [101.466215133999981, 46.392091751],
              [101.465101242, 46.382879257000013],
              [101.470796585000016, 46.366418839],
              [101.493455886999982, 46.323640823],
              [101.47332572900001, 46.293798446999972],
              [101.507265091000022, 46.265382767],
              [101.493535995, 46.23975563],
              [101.487531661999981, 46.205602645999988],
              [101.494859695, 46.188947677999977],
              [101.458841324, 46.151258469000027],
              [101.434774399, 46.117147446],
              [101.355360030999975, 46.104726791000019],
              [101.341741561999982, 46.09261131300002],
              [101.318906783999978, 46.080293655],
              [101.310194016000025, 46.065374373999987],
              [101.289266586, 46.048048019000021],
              [101.260324477999973, 46.014299392999988],
              [101.271738051999989, 45.973642348999988],
              [101.281251907000012, 45.967733383],
              [101.272890091000022, 45.951482773],
              [101.26192665100001, 45.936788558999979],
              [101.25041008, 45.926172255999973],
              [101.251008986999977, 45.922769546999973],
              [101.252912520999985, 45.92076683],
              [101.255617142, 45.919363022000027],
              [101.258821486999977, 45.918363570999986],
              [101.260725020999985, 45.917360305999978],
              [101.261827469000025, 45.915758133],
              [101.263727188000018, 45.914556502999972],
              [101.265729904000011, 45.914255142],
              [101.267835617, 45.913255692],
              [101.269838333, 45.912454605],
              [101.271841048999988, 45.911352158],
              [101.273443222000026, 45.910852432000013],
              [101.275346755999976, 45.909849167],
              [101.277349472000026, 45.909349442],
              [101.278749466000022, 45.90804863],
              [101.279951096, 45.906747817999985],
              [101.281652451000014, 45.905145645],
              [101.282957077, 45.903841019000026],
              [101.284257889, 45.902841567999985],
              [101.284856795999985, 45.901437758999975],
              [101.28616142300001, 45.90023613],
              [101.287363051999989, 45.899335861],
              [101.287805557000013, 45.898309708],
              [101.288244247000023, 45.896802902],
              [101.289163589, 45.895231247000027],
              [101.290365219000023, 45.894227982000018],
              [101.290098189999981, 45.893163680999976],
              [101.289613724, 45.892133713000021],
              [101.289621352999973, 45.890844345],
              [101.29004097, 45.889871597000024],
              [101.291238785000019, 45.888402939],
              [101.292657852, 45.887132645],
              [101.293863296999973, 45.886732101],
              [101.296075820999988, 45.886117935000016],
              [101.310094833, 45.80049323999998],
              [101.312105179000014, 45.743375777999972],
              [101.237985611, 45.635026932000017],
              [101.245340347000024, 45.594820023000011],
              [101.222173691000023, 45.543771744000026],
              [101.175081252999973, 45.519475936999982],
              [101.174016952999978, 45.487192154000013],
              [101.144517899, 45.470060349],
              [101.10991478, 45.450456619000022],
              [101.10122108500002, 45.428674698],
              [101.112066269000024, 45.386724472000026],
              [101.115751266000018, 45.370157242],
              [101.119058608999978, 45.347822189],
              [101.109827042, 45.33661460899998],
              [101.09062767, 45.321992873999989],
              [101.099607467999988, 45.294668198000011],
              [101.122106552, 45.126955032000012],
              [101.144964217999984, 45.047449111999981],
              [101.202600479000012, 44.984972],
              [101.222581863000016, 44.979310989],
              [101.311330795, 44.976366042999985],
              [101.328001022000024, 44.958082198999989],
              [101.384473801000013, 44.956827164],
              [101.385995864999984, 44.953420639],
              [101.387521744000026, 44.950105667],
              [101.389940261999982, 44.94616127],
              [101.392129898, 44.943304061999982],
              [101.395898819000024, 44.940008163000016],
              [101.40060997, 44.936120986999981],
              [101.402730942, 44.933179855],
              [101.404497146999972, 44.931409836],
              [101.406732558999977, 44.928937911999981],
              [101.409326553000028, 44.925992966000024],
              [101.409677505, 44.924226761],
              [101.411272049, 44.921957016000022],
              [101.410734177, 44.919897079],
              [101.410375595, 44.917924880999976],
              [101.411722183, 44.916936873999987],
              [101.414499283, 44.916131973],
              [101.416292191000025, 44.915594101000011],
              [101.417638779000015, 44.914609908999978],
              [101.419073105, 44.913534164],
              [101.420236588000023, 44.912099838000017],
              [101.42265892, 44.910844802999975],
              [101.424898148000011, 44.910486220999985],
              [101.426603317, 44.909589767],
              [101.427679061999982, 44.907976151000014],
              [101.428575516000024, 44.907079696999972],
              [101.430635452, 44.906450271999972],
              [101.432157516000018, 44.905195236],
              [101.433233261, 44.903760910000017],
              [101.435564041000021, 44.90268516499998],
              [101.437536239999986, 44.901521683],
              [101.439508438000018, 44.899549483999976],
              [101.443811417, 44.898473739999986],
              [101.447130202999972, 44.897756577],
              [101.449907302999975, 44.896680832000015],
              [101.452684401999988, 44.895158767999988],
              [101.455553055, 44.89193153399998],
              [101.459947586, 44.889959335000015],
              [101.462186813000017, 44.888704299999972],
              [101.465772629000014, 44.887090683],
              [101.469984055, 44.885744095],
              [101.475004195999986, 44.884309769000026],
              [101.479578017999984, 44.883863448999989],
              [101.483251571999972, 44.883234023999989],
              [101.486032486, 44.882696152],
              [101.488988876, 44.882787704],
              [101.491498947000025, 44.882966995],
              [101.493471146, 44.883413314999984],
              [101.495531082000014, 44.883863448999989],
              [101.497323989999984, 44.884489058999975],
              [101.499475479000012, 44.885477066000021],
              [101.501985549999972, 44.886640549],
              [101.504228592, 44.887628555],
              [101.507005692, 44.88879203800002],
              [101.509874344000025, 44.889329910000015],
              [101.512922286999981, 44.889242172000024],
              [101.515699386999984, 44.88915062],
              [101.519018173, 44.888704299999972],
              [101.523408889999985, 44.887987136999982],
              [101.528516769000021, 44.887449264999987],
              [101.532194138000023, 44.887269974],
              [101.534433364999984, 44.88637352],
              [101.536676407000016, 44.885206223000012],
              [101.540349960000015, 44.882787704],
              [101.544023514, 44.879919052],
              [101.547700882000015, 44.87776756300002],
              [101.550569533999976, 44.875257492],
              [101.552637100000027, 44.873067855999977],
              [101.553518295, 44.870996475000027],
              [101.553789139, 44.869245529000011],
              [101.553510666000022, 44.86558342],
              [101.551607132000015, 44.861566544000027],
              [101.550119400000028, 44.857408524],
              [101.556276320999984, 44.819417953000027],
              [101.542936325000028, 44.787023544000022],
              [101.510862350000025, 44.707941055],
              [101.498521805, 44.67288017300001],
              [101.525587082000015, 44.651647567999987],
              [101.546941757000013, 44.630701064999982],
              [101.580442429000016, 44.547636032000014],
              [101.584081649999973, 44.518903732000012],
              [101.620031357000016, 44.488664627],
              [101.648889542, 44.377618789999985],
              [101.688161849999972, 44.313001633],
              [101.688791275000028, 44.302587508999977],
              [101.687223433999975, 44.300264358999982],
              [101.682531357000016, 44.277379989999986],
              [101.712945938000018, 44.125791549999974],
              [101.742315292, 44.041868210000018],
              [101.742216110000015, 44.041837692],
              [101.355287552, 43.902704239],
              [101.225267410000015, 43.853937148999989],
              [101.023702620999984, 43.850564957000017],
              [100.839250564999986, 43.845453261999978],
              [100.286153792999983, 43.829515457000014],
              [100.07532692, 43.989591599],
              [99.990762711, 44.059080124],
              [99.762071608999975, 44.163137436],
              [99.668058395, 44.142435074],
              [99.483407973999988, 44.124296188000017],
              [99.426031113000022, 44.118371964],
              [99.495107651000012, 43.235803604000012],
              [99.576395035000019, 42.915502548],
              [99.590803145999985, 42.755430221999973],
              [99.598497391000024, 42.665239333999978],
              [99.631883271999982, 42.58924840200001],
              [99.631881, 42.589248],
              [99.560806, 42.576611],
              [99.503194, 42.566333],
              [99.484833, 42.567694],
              [99.416611, 42.572806],
              [99.347111, 42.577972],
              [99.297327, 42.581616],
              [99.289417, 42.582194],
              [99.194972, 42.589111],
              [99.171139, 42.590833],
              [99.104583, 42.595611],
              [99.078856265000013, 42.597457127999974],
              [99.050778, 42.599472],
              [99.020528, 42.601639],
              [98.9485, 42.606722],
              [98.880389, 42.612028],
              [98.808306, 42.617583],
              [98.797692808000022, 42.618395283999973],
              [98.725194, 42.623944],
              [98.651389, 42.6295],
              [98.641670006000027, 42.630231644999981],
              [98.595305, 42.633722],
              [98.587252, 42.634322],
              [98.544611, 42.6375],
              [98.480556, 42.640417],
              [98.443555, 42.642083],
              [98.407861, 42.643694],
              [98.373722, 42.645194],
              [98.298833, 42.648472],
              [98.258528, 42.650222],
              [98.195889, 42.652917],
              [98.151861, 42.659139],
              [98.093083, 42.6675],
              [98.049944, 42.673639],
              [97.963028, 42.685917],
              [97.887111, 42.696611],
              [97.864684, 42.699754],
              [97.864681936000011, 42.699754289],
              [97.846278, 42.702333],
              [97.779333, 42.711695],
              [97.710722, 42.721222],
              [97.665722, 42.727444],
              [97.59175, 42.737611],
              [97.523694, 42.746944],
              [97.4645, 42.755028],
              [97.390444, 42.765111],
              [97.336361, 42.772417],
              [97.269444, 42.781445],
              [97.224972, 42.787389],
              [97.1715, 42.794556],
              [97.170509728000013, 42.794350916999974],
              [97.157152705999977, 42.79158471400001],
              [97.10725, 42.78125],
              [97.058778, 42.771194],
              [97.022528, 42.763667],
              [96.996919, 42.758329],
              [96.97775, 42.754333],
              [96.967653, 42.754368],
              [96.8725, 42.754694],
              [96.813583, 42.754833],
              [96.748555, 42.754972],
              [96.748226009, 42.754944583999986],
              [96.748063, 42.754931],
              [96.641444, 42.746111],
              [96.5865, 42.7415],
              [96.532917, 42.736972],
              [96.475056, 42.732083],
              [96.430556, 42.728306],
              [96.423471, 42.727702],
              [96.387893151000014, 42.724672478],
              [96.3875, 42.724639],
              [96.382528, 42.760167],
              [96.378629976000013, 42.787835249000011],
              [96.37859, 42.788119],
              [96.377194, 42.798028],
              [96.375611, 42.809389],
              [96.372722, 42.830139],
              [96.368583, 42.859583],
              [96.363056, 42.898722],
              [96.362775956, 42.898933660000012],
              [96.361119, 42.900186],
              [96.325056, 42.927444],
              [96.304639, 42.942861],
              [96.282361, 42.959639],
              [96.260472, 42.975861],
              [96.231333, 42.997417],
              [96.188333, 43.029222],
              [96.162611, 43.048306],
              [96.127806, 43.074417],
              [96.107306, 43.089778],
              [96.073417, 43.114778],
              [96.038972, 43.140167],
              [96.000472, 43.168556],
              [95.989528, 43.176611],
              [95.951389, 43.204667],
              [95.909194, 43.235639],
              [95.901149, 43.246042],
              [95.877056, 43.277194],
              [95.873439, 43.300833],
              [95.871667, 43.312417],
              [95.866361, 43.354139],
              [95.863861, 43.371361],
              [95.857639, 43.413667],
              [95.839611, 43.4405],
              [95.826442679000024, 43.460084114999972],
              [95.817323865, 43.473645745999988],
              [95.814583, 43.477722],
              [95.796667, 43.504361],
              [95.788806, 43.516],
              [95.780339798, 43.528554686],
              [95.777361, 43.532972],
              [95.772957737000013, 43.539507639000021],
              [95.77237, 43.54038],
              [95.768488472, 43.546140548999972],
              [95.7625, 43.555028],
              [95.759784067, 43.559045205000018],
              [95.756426783999984, 43.564011047],
              [95.742197875999977, 43.585057383],
              [95.736851963, 43.592964656999982],
              [95.735889, 43.594389],
              [95.731222446, 43.605673981],
              [95.727722, 43.614139],
              [95.727681, 43.61424],
              [95.726038449999976, 43.618220025000028],
              [95.725630158, 43.619209348000027],
              [95.711639, 43.653111],
              [95.696889, 43.6815],
              [95.688694, 43.697306],
              [95.679278, 43.715417],
              [95.671555, 43.730222],
              [95.667422871999975, 43.738153841999974],
              [95.666898724000021, 43.739159971999982],
              [95.666446, 43.740029],
              [95.653462672999979, 43.764946668],
              [95.647472, 43.776444],
              [95.638722, 43.803389],
              [95.632778, 43.821639],
              [95.624859, 43.846069],
              [95.623027708, 43.851717181000026],
              [95.622972, 43.851889],
              [95.618383117, 43.858711357],
              [95.616545030999987, 43.861444066],
              [95.612926661000017, 43.866823547000024],
              [95.609333317999983, 43.872165820000021],
              [95.608644261, 43.873190251999972],
              [95.608483, 43.87343],
              [95.601056, 43.884472],
              [95.5855, 43.907556],
              [95.573139, 43.925889],
              [95.562222, 43.943167],
              [95.558886116999986, 43.948414093999986],
              [95.558595, 43.948872],
              [95.548889, 43.964139],
              [95.522806, 44.005056],
              [95.466361, 44.005583],
              [95.45438, 44.005109],
              [95.446028, 44.004778],
              [95.440736, 44.005597],
              [95.432766, 44.00683],
              [95.423056, 44.008333],
              [95.417807, 44.01001],
              [95.372639, 44.024444],
              [95.355958, 44.024941],
              [95.323167, 44.025917],
              [95.331086616, 44.044652085],
              [95.335862, 44.055949],
              [95.336033792000023, 44.056355565999979],
              [95.338055, 44.061139],
              [95.338763, 44.065758],
              [95.339639, 44.071472],
              [95.341706300999988, 44.076065616],
              [95.342017, 44.076756],
              [95.344409272, 44.082072444],
              [95.347639, 44.08925],
              [95.348188424, 44.099525817000028],
              [95.348436764999974, 44.104170507999982],
              [95.349194, 44.118333],
              [95.350889, 44.143056],
              [95.351956, 44.15891],
              [95.352472, 44.166583],
              [95.353414, 44.169301],
              [95.359841098, 44.187838536000015],
              [95.363994387, 44.199817775999975],
              [95.365944, 44.205441],
              [95.366167, 44.206083],
              [95.366212744999984, 44.206215319000023],
              [95.371601606000013, 44.221802981],
              [95.372951740000019, 44.225708337000015],
              [95.373139, 44.22625],
              [95.382729063, 44.230616172],
              [95.388345, 44.233173],
              [95.405722, 44.241083],
              [95.407506872999988, 44.243594272],
              [95.42068753, 44.262139121000018],
              [95.422583, 44.264806],
              [95.423347026999977, 44.268237697000018],
              [95.424945701000013, 44.275418284000011],
              [95.425972, 44.280028],
              [95.409806, 44.293917],
              [95.403778, 44.295111],
              [95.367333, 44.288556],
              [95.312556, 44.284278],
              [95.309360019, 44.283952273000011],
              [95.286535, 44.281626],
              [95.27572332699998, 44.280524561],
              [95.274108, 44.28036],
              [95.2515, 44.278056],
              [95.188444, 44.27],
              [95.156722, 44.268528],
              [95.123528, 44.266945],
              [95.113333, 44.265722],
              [95.087111, 44.262556],
              [95.052639, 44.258389],
              [95.023972, 44.254417],
              [95.019512, 44.253796],
              [94.999461746, 44.251003584999978],
              [94.998639, 44.250889],
              [94.989879552, 44.256506431999981],
              [94.986944, 44.258389],
              [94.981667, 44.259083],
              [94.977778, 44.259417],
              [94.976090008000028, 44.261300682000012],
              [94.972775, 44.265],
              [94.970361, 44.267694],
              [94.970284161, 44.267746616000011],
              [94.961111, 44.274028],
              [94.949472, 44.281972],
              [94.943861, 44.289167],
              [94.937361, 44.292195],
              [94.934896443000014, 44.292969056],
              [94.913038332999975, 44.299834147000013],
              [94.909944, 44.300806],
              [94.902979, 44.299922],
              [94.898556, 44.299361],
              [94.891681, 44.303519],
              [94.890170346, 44.304432675999976],
              [94.88470361100002, 44.307739073999983],
              [94.882389, 44.309139],
              [94.868583, 44.309528],
              [94.841472, 44.314611],
              [94.835351, 44.315764],
              [94.823778, 44.317945],
              [94.810800371000028, 44.322783026000025],
              [94.80925, 44.323361],
              [94.80689750099998, 44.324134248],
              [94.795389, 44.327917],
              [94.794611, 44.328541],
              [94.790811510000026, 44.331588158999978],
              [94.784950196000011, 44.336288884],
              [94.784167, 44.336917],
              [94.783290635000014, 44.337063476000026],
              [94.765889, 44.339972],
              [94.75948, 44.339833],
              [94.743219657, 44.339478840000027],
              [94.723806, 44.339056],
              [94.713573645999986, 44.344611238000027],
              [94.712806, 44.345028],
              [94.690650824999977, 44.371362840000018],
              [94.690278, 44.371806],
              [94.687232, 44.375415],
              [94.681219101000011, 44.382543564],
              [94.671694, 44.393833],
              [94.664158317999977, 44.398291863],
              [94.661694, 44.39975],
              [94.659969, 44.401132],
              [94.654363435999983, 44.405622204999986],
              [94.634056, 44.421889],
              [94.627811984, 44.42688453],
              [94.626179, 44.428191],
              [94.602917, 44.446806],
              [94.597313983, 44.448381647000019],
              [94.574564580000015, 44.454779095999982],
              [94.571883661000015, 44.455533007999975],
              [94.560444, 44.45875],
              [94.5603, 44.45876],
              [94.555861, 44.459056],
              [94.533071, 44.47049],
              [94.531667, 44.471195],
              [94.518166, 44.478645],
              [94.504333, 44.486278],
              [94.499629629000026, 44.490445341999987],
              [94.49698, 44.492793],
              [94.490444, 44.498583],
              [94.47970155500002, 44.50310228],
              [94.463895, 44.509752],
              [94.463493358, 44.509921202999976],
              [94.46225, 44.510445],
              [94.460559819000025, 44.510639959],
              [94.451900272999978, 44.511638818],
              [94.443472, 44.512611],
              [94.433611, 44.516],
              [94.414139, 44.516833],
              [94.390472, 44.5225],
              [94.378583, 44.520667],
              [94.373697, 44.519058],
              [94.371310446, 44.518272519],
              [94.367299076, 44.516952265999976],
              [94.360778, 44.514806],
              [94.348, 44.516722],
              [94.343478174999973, 44.522297284],
              [94.343111, 44.52275],
              [94.343172399000025, 44.523018295999975],
              [94.344512018999978, 44.528872073],
              [94.34617, 44.536117],
              [94.347389, 44.541445],
              [94.343833, 44.549195],
              [94.339833, 44.563556],
              [94.334192, 44.570036],
              [94.332556, 44.571917],
              [94.330964, 44.574582],
              [94.326333, 44.582333],
              [94.303778, 44.593417],
              [94.297225, 44.595479],
              [94.295228495, 44.596107048000022],
              [94.293163344, 44.59675669],
              [94.289389, 44.597944],
              [94.276194, 44.604917],
              [94.275499814999989, 44.605467718],
              [94.264678, 44.614053],
              [94.250940230000026, 44.62495168800001],
              [94.250389, 44.625389],
              [94.243494, 44.630846],
              [94.23288254900001, 44.639244677000022],
              [94.226278, 44.644472],
              [94.221389, 44.647528],
              [94.220505947999982, 44.651706156999978],
              [94.220119, 44.653537],
              [94.219778592000011, 44.655149009000013],
              [94.219722, 44.655417],
              [94.219499251, 44.655744821999974],
              [94.211847101999979, 44.667006597000011],
              [94.211361, 44.667722],
              [94.183944, 44.676778],
              [94.164063, 44.680777],
              [94.149972, 44.683611],
              [94.145559, 44.686065],
              [94.102556, 44.709972],
              [94.078476059000025, 44.723325946999978],
              [94.068666043, 44.728766259999986],
              [94.062083, 44.732417],
              [94.032189604, 44.744365725000023],
              [94.023305, 44.747917],
              [94.022545450999985, 44.748220505],
              [93.982778, 44.764111],
              [93.981077851, 44.764778283],
              [93.977698552, 44.766104606],
              [93.946611, 44.778306],
              [93.899861, 44.796611],
              [93.856605, 44.813481],
              [93.855107885999985, 44.814064594],
              [93.853778, 44.814583],
              [93.851875872999983, 44.815324781000015],
              [93.851424, 44.815501],
              [93.824833, 44.825861],
              [93.794083, 44.837833],
              [93.751265397999987, 44.854481736000025],
              [93.741911, 44.858119],
              [93.731161199999974, 44.862298329],
              [93.731, 44.862361],
              [93.73021, 44.862313],
              [93.72973, 44.862248],
              [93.729121, 44.86195],
              [93.728840503000015, 44.861654675000011],
              [93.728667, 44.861472],
              [93.72825057, 44.861819137],
              [93.723378824, 44.865880238999978],
              [93.711972, 44.875389],
              [93.712083765999978, 44.876156487],
              [93.712717085, 44.880505415000016],
              [93.713159, 44.88354],
              [93.71390935300002, 44.888687905999973],
              [93.714056, 44.889694],
              [93.71361162, 44.890044960000012],
              [93.710222, 44.892722],
              [93.709892137999987, 44.896739778999972],
              [93.709889, 44.896778],
              [93.709885536, 44.896777615000019],
              [93.69492, 44.895115],
              [93.694139, 44.895028],
              [93.69341, 44.895344],
              [93.692743, 44.895706],
              [93.692132, 44.896275],
              [93.691479, 44.896942],
              [93.691414447999989, 44.896990709000022],
              [93.691096, 44.897231],
              [93.690799, 44.897455],
              [93.690201, 44.897775],
              [93.690046, 44.897812],
              [93.689563, 44.897928],
              [93.689153748000024, 44.897984802999986],
              [93.688965, 44.898011],
              [93.688285, 44.898233],
              [93.686965, 44.898511],
              [93.686132, 44.898705],
              [93.685424, 44.898719],
              [93.68466, 44.899011],
              [93.684021, 44.89933],
              [93.683507, 44.899664],
              [93.682396, 44.900108],
              [93.681216, 44.900497],
              [93.680368, 44.900719],
              [93.679924, 44.900886],
              [93.679556, 44.901167],
              [93.67966665199998, 44.901409367999975],
              [93.680449, 44.903123],
              [93.681028, 44.904389],
              [93.680856, 44.904288],
              [93.680419977999975, 44.904130663999979],
              [93.680335, 44.9041],
              [93.679799, 44.904028],
              [93.679314, 44.904064],
              [93.678677, 44.904274],
              [93.678329, 44.904426],
              [93.67803, 44.904462],
              [93.677967, 44.904469],
              [93.677685, 44.904621],
              [93.677178, 44.904911],
              [93.677162, 44.904942],
              [93.677098, 44.905063],
              [93.677091, 44.905476],
              [93.677105, 44.905859],
              [93.677236, 44.906279],
              [93.677496, 44.906663],
              [93.677757, 44.906917],
              [93.677799624999977, 44.907105907000016],
              [93.677801, 44.907112],
              [93.677649, 44.907416],
              [93.677352, 44.907742],
              [93.677344, 44.908053],
              [93.67743, 44.90823],
              [93.67744, 44.908284],
              [93.677415, 44.908307],
              [93.676615, 44.908481],
              [93.675308, 44.908747],
              [93.67366, 44.909258],
              [93.671765, 44.909637],
              [93.670234615000027, 44.910064804],
              [93.669937, 44.910148],
              [93.669773720000023, 44.910245633999978],
              [93.66935, 44.910499],
              [93.668687, 44.910906],
              [93.668138, 44.911105],
              [93.667484, 44.911342],
              [93.666812, 44.911503],
              [93.666206, 44.911692],
              [93.665514432, 44.911811033999982],
              [93.665381, 44.911834],
              [93.665186703000018, 44.911931290999973],
              [93.664860475000012, 44.912094645000025],
              [93.6647, 44.912175],
              [93.66449719000002, 44.91230740200001],
              [93.663061, 44.913245],
              [93.662640823, 44.913394579999988],
              [93.662502, 44.913444],
              [93.661924, 44.913568],
              [93.660939, 44.913691],
              [93.658581, 44.913975],
              [93.657511, 44.914183],
              [93.656952, 44.914221],
              [93.655957, 44.914231],
              [93.655398, 44.914268],
              [93.655048, 44.914392],
              [93.654811, 44.914572],
              [93.654726, 44.915017],
              [93.654641, 44.9155],
              [93.654366499, 44.915875371000027],
              [93.654309, 44.915954],
              [93.65393, 44.916324],
              [93.653485, 44.916646],
              [93.652944, 44.916899],
              [93.651707, 44.917112],
              [93.651035112999978, 44.917267238000022],
              [93.650599, 44.917368],
              [93.650209855000014, 44.917549195999982],
              [93.649959, 44.917666],
              [93.648829, 44.918263],
              [93.647784, 44.918647],
              [93.646996, 44.918754],
              [93.646476993000022, 44.918784067],
              [93.646271, 44.918796],
              [93.645503, 44.918775],
              [93.64416, 44.918754],
              [93.643798, 44.918775],
              [93.643115, 44.919052],
              [93.642476, 44.919415],
              [93.641538, 44.919948],
              [93.640451, 44.920374],
              [93.639406, 44.920566],
              [93.638382, 44.92063],
              [93.636762, 44.920672],
              [93.635867, 44.920779],
              [93.634861, 44.921139],
              [93.633132623, 44.921627281999974],
              [93.622472, 44.924639],
              [93.621994, 44.92477],
              [93.615066911999975, 44.926671923000015],
              [93.59659, 44.931745],
              [93.595775, 44.932013],
              [93.594527, 44.932356],
              [93.592592, 44.933057],
              [93.591293, 44.933655],
              [93.590680867, 44.934235893],
              [93.590568, 44.934343],
              [93.590262, 44.934674],
              [93.590186, 44.935285],
              [93.590107, 44.935514],
              [93.590033, 44.935731],
              [93.589816, 44.935922],
              [93.589498, 44.935985],
              [93.58888, 44.935928],
              [93.588543, 44.935896],
              [93.587937308999983, 44.935823734999985],
              [93.587906, 44.93582],
              [93.587563, 44.93596],
              [93.587219, 44.936444],
              [93.587191, 44.936497],
              [93.587163227000019, 44.936549537000019],
              [93.586748, 44.937335],
              [93.586111, 44.938112],
              [93.585487, 44.938723],
              [93.584774, 44.939372],
              [93.584341, 44.939639],
              [93.58387, 44.939843],
              [93.583386, 44.940009],
              [93.582979, 44.940085],
              [93.58196, 44.940161],
              [93.580827, 44.940238],
              [93.580579758, 44.940263748],
              [93.580564354999979, 44.940266485],
              [93.579656, 44.940365],
              [93.579096, 44.940505],
              [93.578128, 44.940671],
              [93.577638528000023, 44.940786375000016],
              [93.577428, 44.940836],
              [93.577376174999984, 44.940832993000015],
              [93.576549, 44.940785],
              [93.575569, 44.940849],
              [93.575008, 44.940925],
              [93.574005281999973, 44.941408454],
              [93.573608, 44.9416],
              [93.573137, 44.941957],
              [93.572258, 44.942351],
              [93.571787, 44.942441],
              [93.57152, 44.942593],
              [93.571265, 44.94295],
              [93.570705, 44.943243],
              [93.569724, 44.943548],
              [93.56877, 44.943612],
              [93.568319761999987, 44.943586175],
              [93.567445, 44.943536],
              [93.566898, 44.943497],
              [93.566376, 44.943663],
              [93.564746, 44.944249],
              [93.564186, 44.944363],
              [93.563829, 44.944329],
              [93.563651, 44.944312],
              [93.56332, 44.944312],
              [93.562811, 44.944669],
              [93.562662821, 44.944755859],
              [93.561639, 44.945356],
              [93.560684, 44.945675],
              [93.559844, 44.945687],
              [93.559798, 44.945675],
              [93.558774, 44.945407],
              [93.55862749, 44.945330178],
              [93.55824, 44.945127],
              [93.557756, 44.944987],
              [93.55731, 44.945],
              [93.55689, 44.945102],
              [93.55661, 44.945407],
              [93.556558882, 44.945783656],
              [93.556534, 44.945967],
              [93.556444, 44.946668],
              [93.556356, 44.946825],
              [93.556215, 44.947075],
              [93.555757, 44.947508],
              [93.555273, 44.947839],
              [93.554776, 44.948081],
              [93.554089, 44.948374],
              [93.553478, 44.948374],
              [93.552981, 44.948234],
              [93.552445, 44.948131],
              [93.551186, 44.94789],
              [93.550206, 44.947712],
              [93.5499, 44.947572],
              [93.549543, 44.947534],
              [93.549225, 44.947597],
              [93.54855, 44.947763],
              [93.54799, 44.948094],
              [93.546921, 44.948705],
              [93.545902, 44.948947],
              [93.545418, 44.948947],
              [93.545197906, 44.948903119000022],
              [93.544781, 44.94882],
              [93.544259, 44.94868],
              [93.543852, 44.94868],
              [93.543177, 44.948781],
              [93.542337, 44.949112],
              [93.541789, 44.94938],
              [93.541458, 44.949584],
              [93.54086, 44.949876],
              [93.5403, 44.950538],
              [93.539536, 44.951583],
              [93.538988, 44.952397],
              [93.538965, 44.952634],
              [93.53895, 44.952792],
              [93.538975058, 44.952892229999975],
              [93.539052, 44.9532],
              [93.539281, 44.953683],
              [93.539383, 44.954065],
              [93.539319, 44.954371],
              [93.538937, 44.954702],
              [93.538402, 44.954893],
              [93.537613, 44.954931],
              [93.535538, 44.955186],
              [93.534392, 44.955339],
              [93.534048, 44.955453],
              [93.533717, 44.955657],
              [93.53322, 44.955937],
              [93.532775, 44.956064],
              [93.531412, 44.956306],
              [93.531293372, 44.956326327999989],
              [93.53129005400001, 44.956327438000017],
              [93.529047011999978, 44.956777573000011],
              [93.531289964, 44.956326912],
              [93.529031, 44.956714],
              [93.527249, 44.95693],
              [93.526536, 44.956917],
              [93.525403, 44.956803],
              [93.524715, 44.956816],
              [93.524193, 44.956879],
              [93.523327, 44.957121],
              [93.523195475000023, 44.957155027999988],
              [93.522983, 44.95721],
              [93.522556, 44.957472],
              [93.521978, 44.958127],
              [93.521405, 44.958725],
              [93.520832, 44.959107],
              [93.520255178000014, 44.959347846000014],
              [93.520068, 44.959426],
              [93.519087, 44.959833],
              [93.517801, 44.960317],
              [93.516617, 44.960839],
              [93.515395, 44.961285],
              [93.51514, 44.961578],
              [93.515127, 44.961819],
              [93.515548, 44.962507],
              [93.515775916, 44.962858064999978],
              [93.516044, 44.963271],
              [93.516019, 44.963538],
              [93.515509, 44.963984],
              [93.514987, 44.964417],
              [93.514173, 44.964761],
              [93.512479, 44.965461],
              [93.510837, 44.966123],
              [93.510458973000027, 44.966253632000019],
              [93.509474, 44.966594],
              [93.508443, 44.966951],
              [93.507501, 44.967129],
              [93.506482, 44.967434],
              [93.5054, 44.96774],
              [93.504894905000015, 44.967937144000018],
              [93.504306, 44.968167],
              [93.504189402, 44.967942247],
              [93.502, 44.963722],
              [93.501889, 44.95852],
              [93.50186, 44.957137],
              [93.501889, 44.956556],
              [93.501643, 44.956113],
              [93.501185, 44.955453],
              [93.500899, 44.955222],
              [93.500417, 44.955098],
              [93.499973, 44.955084],
              [93.499914360999981, 44.955100674999983],
              [93.4987, 44.955446],
              [93.497963, 44.955588],
              [93.497571734000019, 44.955602568000018],
              [93.497211, 44.955616],
              [93.496857, 44.955716],
              [93.496701, 44.955942],
              [93.496687, 44.956311],
              [93.496693869000012, 44.956390969999973],
              [93.496715, 44.956637],
              [93.496673, 44.956935],
              [93.496715, 44.957346],
              [93.496857, 44.957587],
              [93.496701, 44.957814],
              [93.496276, 44.958041],
              [93.495411, 44.95814],
              [93.494773, 44.958424],
              [93.494177, 44.95882],
              [93.493242, 44.959473],
              [93.493081, 44.959555],
              [93.492689, 44.959756],
              [93.492036, 44.95987],
              [93.491242, 44.959926],
              [93.490363, 44.959926],
              [93.489711, 44.960097],
              [93.489002, 44.960366],
              [93.488396, 44.960686],
              [93.487335, 44.961282],
              [93.487028045999978, 44.961409473],
              [93.486733, 44.961532],
              [93.486566, 44.961601],
              [93.486392670999976, 44.961693622999974],
              [93.485548, 44.962145],
              [93.484892, 44.962577],
              [93.484331, 44.963146],
              [93.484158, 44.963388],
              [93.48415135800002, 44.963430066],
              [93.484098, 44.963768],
              [93.484003, 44.96451],
              [93.483794, 44.965117],
              [93.483735, 44.965287],
              [93.483576271, 44.965604755000015],
              [93.4832, 44.966358],
              [93.482863, 44.966971],
              [93.482639, 44.967083],
              [93.482360007000011, 44.967083],
              [93.482259, 44.967083],
              [93.482193, 44.967069],
              [93.481439, 44.96691],
              [93.4808, 44.966703],
              [93.479695, 44.966211],
              [93.478528, 44.965778],
              [93.465979, 44.959271],
              [93.464897141, 44.958709961000011],
              [93.462778, 44.957611],
              [93.46183607, 44.958183244999987],
              [93.460997, 44.958693],
              [93.460459, 44.959044],
              [93.459719, 44.959527],
              [93.459274, 44.959712],
              [93.458938, 44.959722],
              [93.457941, 44.959365],
              [93.457486, 44.959213],
              [93.457117, 44.959094],
              [93.456932, 44.958899],
              [93.45689, 44.958855],
              [93.456792, 44.958682],
              [93.456823682999982, 44.958525743999985],
              [93.456836, 44.958465],
              [93.45702, 44.958303],
              [93.457193, 44.957977],
              [93.457291, 44.95788],
              [93.457779, 44.957576],
              [93.457854, 44.957446],
              [93.45767, 44.957175],
              [93.457237, 44.956872],
              [93.456801, 44.956663],
              [93.456534, 44.956534],
              [93.456185, 44.956569],
              [93.455698, 44.956774],
              [93.455286, 44.956926],
              [93.454766, 44.957165],
              [93.454202, 44.957403],
              [93.453931, 44.957652],
              [93.45366, 44.958259],
              [93.453376, 44.958753],
              [93.453367, 44.958769],
              [93.453172, 44.958899],
              [93.452869, 44.958931],
              [93.452381, 44.958931],
              [93.451677, 44.958704],
              [93.451567, 44.958679],
              [93.450766, 44.958498],
              [93.450127, 44.958422],
              [93.449693, 44.958574],
              [93.449649, 44.9586],
              [93.449314, 44.958801],
              [93.448946, 44.959191],
              [93.448512, 44.959657],
              [93.448187, 44.959939],
              [93.447862, 44.960058],
              [93.446876, 44.960199],
              [93.446052, 44.960264],
              [93.444828643, 44.960327568000025],
              [93.444166, 44.960362],
              [93.44279, 44.960243],
              [93.441326, 44.959885],
              [93.440072, 44.959523],
              [93.439863, 44.959462],
              [93.438476, 44.958747],
              [93.43814, 44.958433],
              [93.437837, 44.95827],
              [93.437739, 44.957988],
              [93.437729697, 44.957548232000022],
              [93.437728, 44.957468],
              [93.437728, 44.95711],
              [93.437652, 44.956894],
              [93.43711, 44.956601],
              [93.436352, 44.956298],
              [93.435636, 44.956113],
              [93.434564, 44.955951],
              [93.432363, 44.956016],
              [93.430402, 44.956113],
              [93.428982, 44.956157],
              [93.428364, 44.956254],
              [93.427757, 44.956493],
              [93.426554, 44.957035],
              [93.42534, 44.957696],
              [93.423606, 44.958552],
              [93.422472, 44.959222],
              [93.421829, 44.95969],
              [93.420963988999972, 44.96027680200001],
              [93.420918, 44.960308],
              [93.420149, 44.96086],
              [93.419553, 44.961446],
              [93.419228, 44.961717],
              [93.418805, 44.961857],
              [93.418274, 44.962128],
              [93.418014, 44.962464],
              [93.417808, 44.96279],
              [93.417635, 44.962952],
              [93.41706, 44.963191],
              [93.416551, 44.963299],
              [93.416041, 44.963472],
              [93.415478, 44.963787],
              [93.415415570999983, 44.963824610000017],
              [93.414741, 44.964231],
              [93.414145, 44.964589],
              [93.413375, 44.965033],
              [93.412952, 44.965391],
              [93.412801, 44.965727],
              [93.412801, 44.965998],
              [93.41292, 44.966366],
              [93.412921547, 44.966380169],
              [93.412952, 44.966659],
              [93.412833, 44.966875],
              [93.412595, 44.966984],
              [93.412319559000025, 44.967000599000016],
              [93.412064, 44.967016],
              [93.411814, 44.967027],
              [93.411587, 44.967103],
              [93.411413, 44.967374],
              [93.411273, 44.967797],
              [93.411247945000014, 44.968105636000018],
              [93.411229, 44.968339],
              [93.410817, 44.968913],
              [93.410384, 44.969336],
              [93.409712, 44.969628],
              [93.408357, 44.970008],
              [93.406352, 44.970322],
              [93.404705, 44.97043],
              [93.403578, 44.970539],
              [93.402873, 44.970756],
              [93.402071, 44.971016],
              [93.401316748999989, 44.971584034999978],
              [93.401107, 44.971742],
              [93.400879, 44.972013],
              [93.400803, 44.972425],
              [93.400803, 44.972608015999981],
              [93.400803, 44.972706],
              [93.400792, 44.972738],
              [93.400695, 44.97301],
              [93.400575, 44.973313],
              [93.40038, 44.973465],
              [93.400371482000025, 44.973468095999976],
              [93.399904, 44.973638],
              [93.399372, 44.973779],
              [93.399112, 44.973931],
              [93.398982, 44.97418],
              [93.399004, 44.974614],
              [93.399123, 44.975307],
              [93.39908, 44.975665],
              [93.398842097999989, 44.976152269000011],
              [93.398831, 44.976175],
              [93.398354, 44.976781],
              [93.397974, 44.977313],
              [93.397497, 44.9778],
              [93.39688, 44.978201],
              [93.396132, 44.978418],
              [93.395319, 44.978526],
              [93.394105, 44.978505],
              [93.392944, 44.978611],
              [93.39261, 44.978591],
              [93.390225, 44.978635],
              [93.388697665, 44.978652753],
              [93.387472, 44.978667],
              [93.385987, 44.978808],
              [93.384925, 44.978971],
              [93.384134, 44.979166],
              [93.383451, 44.979393],
              [93.38253, 44.979892],
              [93.381332938000014, 44.980465476],
              [93.38124, 44.98051],
              [93.380568, 44.980857],
              [93.380189, 44.980965],
              [93.379528, 44.980954],
              [93.378841, 44.980948],
              [93.378206, 44.980943],
              [93.378181945999984, 44.980943],
              [93.378011, 44.980943],
              [93.377913, 44.981062],
              [93.377826, 44.981214],
              [93.377729, 44.981323],
              [93.377714, 44.98137],
              [93.377675, 44.981496],
              [93.377688184000021, 44.981596593],
              [93.377729, 44.981908],
              [93.377859, 44.982829],
              [93.378043, 44.983512],
              [93.37826, 44.984834],
              [93.378173, 44.985268],
              [93.378065, 44.985474],
              [93.377881, 44.985614],
              [93.377523, 44.985701],
              [93.376905, 44.985961],
              [93.376548, 44.986156],
              [93.376309, 44.986406],
              [93.376071, 44.986449],
              [93.375182, 44.9862],
              [93.37451, 44.985885],
              [93.374249234999979, 44.985779654],
              [93.374109, 44.985723],
              [93.373741, 44.985777],
              [93.373459, 44.985885],
              [93.37339154, 44.985940680999988],
              [93.373144, 44.986145],
              [93.37283, 44.986438],
              [93.372646, 44.986547],
              [93.372104, 44.986612],
              [93.371291, 44.986687],
              [93.370912, 44.986785],
              [93.370673, 44.986937],
              [93.370294, 44.987229],
              [93.369806, 44.987533],
              [93.368246, 44.988064],
              [93.367097, 44.988291],
              [93.366316, 44.988259],
              [93.365731, 44.988064],
              [93.365146, 44.987988],
              [93.364572, 44.987999],
              [93.363986, 44.987847],
              [93.363509, 44.987544],
              [93.362946, 44.986937],
              [93.362252, 44.986048],
              [93.362025, 44.985799],
              [93.361665, 44.985651],
              [93.361656, 44.985647],
              [93.361646, 44.985652],
              [93.361038, 44.98595],
              [93.360095, 44.986492],
              [93.359066, 44.987045],
              [93.358448, 44.987153],
              [93.357733, 44.987034],
              [93.357343, 44.986915],
              [93.356497, 44.98685],
              [93.35589, 44.986709],
              [93.354618984000012, 44.986414880999973],
              [93.354438, 44.986373],
              [93.353747, 44.98614],
              [93.353636, 44.986102],
              [93.353072, 44.986037],
              [93.352357, 44.986225],
              [93.352249, 44.986254],
              [93.351555, 44.986438],
              [93.350699, 44.986547],
              [93.349539, 44.986644],
              [93.348434, 44.986817],
              [93.347502, 44.987132],
              [93.346432785, 44.987490891999983],
              [93.346212, 44.987565],
              [93.345063, 44.987869],
              [93.344369, 44.987966],
              [93.343492, 44.987955],
              [93.342787, 44.987901],
              [93.342289, 44.987717],
              [93.341736, 44.98737],
              [93.341129, 44.987067],
              [93.340705, 44.986945],
              [93.340338, 44.986839],
              [93.339792413999987, 44.986781392000012],
              [93.339211, 44.98672],
              [93.338701, 44.986872],
              [93.3385, 44.987081],
              [93.33843, 44.987153],
              [93.338354, 44.987479],
              [93.337975, 44.987912],
              [93.337151, 44.988573],
              [93.336664, 44.988931],
              [93.336344747, 44.989518197999985],
              [93.336328, 44.989549],
              [93.335797, 44.990665],
              [93.335688, 44.990828],
              [93.335309, 44.990979],
              [93.334135, 44.991299],
              [93.331801, 44.991796],
              [93.330369, 44.992142],
              [93.329974100000015, 44.992231554],
              [93.329271, 44.992391],
              [93.328979886000013, 44.992515438999988],
              [93.32863, 44.992665],
              [93.328075, 44.992822],
              [93.327513, 44.992947],
              [93.327342180000016, 44.992959811],
              [93.326473, 44.993025],
              [93.325787, 44.993143],
              [93.324917, 44.99328],
              [93.324283, 44.993541],
              [93.323554796, 44.994077571999981],
              [93.323466, 44.994143],
              [93.323198, 44.994483],
              [93.322972, 44.994667],
              [93.322806, 44.994182],
              [93.322655, 44.9936],
              [93.322518, 44.993018],
              [93.322381, 44.992561],
              [93.322048, 44.992129],
              [93.321616, 44.991704],
              [93.321328, 44.991208],
              [93.321244, 44.990861],
              [93.321028, 44.99058],
              [93.320537, 44.990221],
              [93.319831, 44.989907],
              [93.319341, 44.989691],
              [93.319204, 44.989488],
              [93.319112, 44.988972],
              [93.31908, 44.988148],
              [93.31908, 44.987508],
              [93.319105, 44.987397],
              [93.319184, 44.98705],
              [93.31928270100002, 44.986742483],
              [93.319295, 44.986396],
              [93.319034, 44.986043],
              [93.318828134, 44.985954709],
              [93.318563, 44.985841],
              [93.317648, 44.985684],
              [93.316844, 44.98554],
              [93.3167, 44.98537],
              [93.3167, 44.985082],
              [93.316733, 44.984775],
              [93.316962, 44.984219],
              [93.317047, 44.983991],
              [93.316955, 44.983677],
              [93.316609, 44.983449],
              [93.31599, 44.983132],
              [93.31497, 44.982362],
              [93.314066, 44.981743],
              [93.313916, 44.981559],
              [93.313907, 44.981325],
              [93.313807, 44.980881],
              [93.313782581, 44.980758578],
              [93.313732, 44.980505],
              [93.313556, 44.98025],
              [93.313464, 44.980045],
              [93.312887, 44.980095],
              [93.312009, 44.980338],
              [93.310955, 44.980681],
              [93.31021, 44.981099],
              [93.309131, 44.981509],
              [93.308537, 44.981634],
              [93.30781, 44.981852],
              [93.307325, 44.981869],
              [93.306229, 44.98222],
              [93.305384, 44.982688],
              [93.30474, 44.983048],
              [93.303611, 44.983625],
              [93.302507, 44.984077],
              [93.301854, 44.984219],
              [93.301352, 44.984236],
              [93.300876, 44.984127],
              [93.300541, 44.984185],
              [93.30029, 44.984328],
              [93.299989, 44.984462],
              [93.299537, 44.984512],
              [93.299144, 44.984587],
              [93.298760329, 44.984810935999974],
              [93.298642, 44.98488],
              [93.298458, 44.985173],
              [93.298199, 44.985239],
              [93.297747, 44.985239],
              [93.297329, 44.985398],
              [93.296852, 44.985566],
              [93.29666, 44.985633],
              [93.296543, 44.985599],
              [93.296492, 44.98544],
              [93.296536, 44.985348],
              [93.296744, 44.985123],
              [93.296899, 44.984811],
              [93.296813, 44.984431],
              [93.296605, 44.984084],
              [93.296561594000025, 44.984038740000017],
              [93.296207, 44.983669],
              [93.295653, 44.983374],
              [93.295358, 44.983253],
              [93.294889, 44.983278],
              [93.292688668999972, 44.983108786],
              [93.286994605000018, 44.982670891999987],
              [93.286944, 44.982667],
              [93.286915889999989, 44.982674671999973],
              [93.279175553000016, 44.984787327],
              [93.277583, 44.985222],
              [93.256136, 44.98995],
              [93.25545398600002, 44.990100335000022],
              [93.232972, 44.995056],
              [93.221444, 44.998083],
              [93.206728344999988, 45.001930711],
              [93.205476256, 45.002258095],
              [93.204444, 45.002528],
              [93.202290961000017, 45.003155761000016],
              [93.201004, 45.003531],
              [93.183583, 45.008611],
              [93.168222, 45.013389],
              [93.156667, 45.010889],
              [93.132306, 45.014639],
              [93.126111, 45.009695],
              [93.093806, 45.007583],
              [93.080889, 45.00825],
              [93.080279, 45.008624],
              [93.079726, 45.009082],
              [93.079063, 45.009335],
              [93.077643, 45.009708],
              [93.076343, 45.010117],
              [93.074658, 45.011116],
              [93.073935, 45.011622],
              [93.073598, 45.012019],
              [93.073285, 45.012248],
              [93.072599, 45.012525],
              [93.071829, 45.012729],
              [93.071155, 45.012789],
              [93.069939, 45.012777],
              [93.068542, 45.012994],
              [93.067279, 45.013355],
              [93.066376, 45.013849],
              [93.06575, 45.014234],
              [93.065413, 45.014366],
              [93.0651, 45.014439],
              [93.064751, 45.014463],
              [93.063198, 45.014559],
              [93.06215, 45.014764],
              [93.061573, 45.014944],
              [93.061175, 45.015221],
              [93.060766, 45.015474],
              [93.060224, 45.015594],
              [93.059574, 45.015606],
              [93.05872, 45.015739],
              [93.058383, 45.015739],
              [93.05807, 45.015666],
              [93.057347, 45.01569],
              [93.055879, 45.015799],
              [93.054856, 45.016003],
              [93.054109, 45.016365],
              [93.053784, 45.016641],
              [93.053387, 45.016906],
              [93.052881, 45.017075],
              [93.052147, 45.017159],
              [93.050919, 45.017159],
              [93.0498, 45.017243],
              [93.048801, 45.01758],
              [93.048452, 45.017725],
              [93.048126, 45.017749],
              [93.047862, 45.017689],
              [93.04738, 45.017352],
              [93.046935, 45.017039],
              [93.046465, 45.01687],
              [93.045599, 45.016714],
              [93.043973, 45.01681],
              [93.042433, 45.016894],
              [93.040603, 45.017051],
              [93.040242, 45.016991],
              [93.039664, 45.01669],
              [93.03905, 45.01616],
              [93.038617, 45.015763],
              [93.038231, 45.015546],
              [93.03787, 45.015389],
              [93.037064, 45.014956],
              [93.036197, 45.014643],
              [93.035972983000022, 45.014573568],
              [93.035342, 45.014378],
              [93.034777, 45.014306],
              [93.033356, 45.01418],
              [93.032712, 45.014065],
              [93.032393, 45.013909],
              [93.032008, 45.013524],
              [93.031526, 45.013096],
              [93.031238, 45.012838],
              [93.030858, 45.012759],
              [93.030118, 45.012765],
              [93.0293, 45.012886],
              [93.027711, 45.013036],
              [93.026056, 45.013111],
              [93.025574, 45.01312],
              [93.024641, 45.01312],
              [93.02366, 45.013042],
              [93.022697, 45.012639],
              [93.021981, 45.01232],
              [93.021264, 45.012151],
              [93.020295, 45.012007],
              [93.019459, 45.01185],
              [93.018568, 45.01161],
              [93.017719, 45.011345],
              [93.017045, 45.011297],
              [93.016389, 45.011357],
              [93.015691, 45.011465],
              [93.014722, 45.011447],
              [93.013494, 45.011303],
              [93.012512, 45.011155],
              [93.010956, 45.011132],
              [93.010246, 45.011041],
              [93.009514, 45.010766],
              [93.008599, 45.010492],
              [93.008072, 45.010423],
              [93.007918, 45.010338],
              [93.007306, 45.01],
              [93.004278492000026, 45.010011802],
              [93.001406, 45.010023],
              [93.000083, 45.010028],
              [92.999949, 45.009964],
              [92.990806, 45.005611],
              [92.982134351000013, 45.001457400999982],
              [92.980194, 45.000528],
              [92.979265823999981, 45.003019032999987],
              [92.977917, 45.006639],
              [92.977079791, 45.00766847],
              [92.976001, 45.008995],
              [92.971389, 45.014667],
              [92.970732, 45.014862],
              [92.970113, 45.015141],
              [92.969106, 45.015636],
              [92.968564, 45.015853],
              [92.967867, 45.015884],
              [92.967232, 45.016008],
              [92.966287, 45.016318],
              [92.965498, 45.016535],
              [92.965002, 45.01655],
              [92.964506, 45.016426],
              [92.964212, 45.016333],
              [92.963825, 45.016426],
              [92.963174, 45.016597],
              [92.962725, 45.01655],
              [92.962338, 45.016287],
              [92.962075, 45.015915],
              [92.961595, 45.015698],
              [92.961161, 45.015745],
              [92.960619, 45.016039],
              [92.960077, 45.016178],
              [92.959566, 45.016163],
              [92.959028, 45.016195],
              [92.958404, 45.016488],
              [92.957754, 45.01655],
              [92.95701, 45.016597],
              [92.956174, 45.01686],
              [92.955291, 45.016875],
              [92.955212, 45.01687],
              [92.95461, 45.016829],
              [92.954161, 45.016829],
              [92.953758, 45.017015],
              [92.95272, 45.017154],
              [92.951342, 45.017216],
              [92.949886, 45.017139],
              [92.948461, 45.016999],
              [92.947556, 45.016917],
              [92.940055, 45.016528],
              [92.929556, 45.015417],
              [92.927731530000017, 45.017730412999981],
              [92.927694, 45.017778],
              [92.923278, 45.029333],
              [92.923328, 45.029531],
              [92.924201, 45.032963],
              [92.924667, 45.034389],
              [92.924193, 45.034271],
              [92.923029, 45.034196],
              [92.921988888999977, 45.034267345999979],
              [92.921819, 45.034279],
              [92.921169, 45.034392],
              [92.921047306, 45.034448657999974],
              [92.920617, 45.034649],
              [92.919808, 45.034907],
              [92.918976, 45.035398],
              [92.918583, 45.0357],
              [92.918348, 45.036177],
              [92.918361, 45.036667],
              [92.911736696999981, 45.036520853000013],
              [92.903222, 45.036333],
              [92.902292, 45.036547],
              [92.901322, 45.037101],
              [92.901023, 45.0374],
              [92.900985199, 45.037482325999974],
              [92.900815, 45.037853],
              [92.900661, 45.038361],
              [92.900561, 45.039757],
              [92.900461, 45.040283],
              [92.900325, 45.040428],
              [92.900017, 45.04041],
              [92.899083, 45.040038],
              [92.89895360700001, 45.039991236],
              [92.89843, 45.039802],
              [92.897886, 45.039693],
              [92.897651, 45.03973],
              [92.897025, 45.040147],
              [92.896227, 45.040809],
              [92.895384, 45.041443],
              [92.895266, 45.041588],
              [92.895239, 45.041724],
              [92.89533, 45.04206],
              [92.895378984999979, 45.042191753999987],
              [92.895475, 45.04245],
              [92.895411, 45.042731],
              [92.895139, 45.043021],
              [92.894931, 45.043229],
              [92.894568, 45.043247],
              [92.894142, 45.043329],
              [92.893589, 45.043637],
              [92.892583, 45.04429],
              [92.891585, 45.044698],
              [92.89106, 45.044979],
              [92.890924, 45.045242],
              [92.890851, 45.045478],
              [92.890561, 45.045614],
              [92.890044, 45.045614],
              [92.889219, 45.045441],
              [92.888702, 45.045414],
              [92.888195, 45.045604],
              [92.887877, 45.045623],
              [92.887506, 45.045423],
              [92.887283369999977, 45.045293859000026],
              [92.887225, 45.04526],
              [92.886771, 45.045233],
              [92.886363, 45.045333],
              [92.886001, 45.045496],
              [92.885266, 45.045623],
              [92.884858, 45.045786],
              [92.884351, 45.045904],
              [92.884121004, 45.045893093000018],
              [92.883381, 45.045858],
              [92.882474, 45.045913],
              [92.881722, 45.045813],
              [92.881422, 45.045704],
              [92.881123, 45.045659],
              [92.880897, 45.045777],
              [92.880643, 45.046022],
              [92.880217, 45.046266],
              [92.8796, 45.04652],
              [92.879248, 45.047178],
              [92.87656623700002, 45.044668032],
              [92.874081, 45.042342],
              [92.869917, 45.038445],
              [92.862361, 45.041639],
              [92.850139, 45.03725],
              [92.849501, 45.036614],
              [92.849246, 45.036408],
              [92.848906, 45.036444],
              [92.848638, 45.036699],
              [92.848383, 45.036772],
              [92.847897, 45.036772],
              [92.847471, 45.036845],
              [92.846803, 45.036869],
              [92.845879, 45.03676],
              [92.844845, 45.036639],
              [92.844116, 45.036687],
              [92.843496, 45.0371],
              [92.843253, 45.037429],
              [92.843143, 45.037489],
              [92.842888, 45.037489],
              [92.842013, 45.03755],
              [92.841454, 45.037647],
              [92.840822, 45.037842],
              [92.840139, 45.038167],
              [92.825417, 45.04025],
              [92.818155882999974, 45.041263470999979],
              [92.805743, 45.042996],
              [92.804849470000022, 45.043120790999978],
              [92.801139, 45.043639],
              [92.799207293, 45.044152795],
              [92.776389, 45.050222],
              [92.774412139, 45.046328448999986],
              [92.773695, 45.044916],
              [92.773611, 45.04475],
              [92.769762005000018, 45.044403058],
              [92.763349, 45.043825],
              [92.745371417, 45.04220362],
              [92.739111, 45.041639],
              [92.735954, 45.039816],
              [92.7305, 45.036667],
              [92.723306, 45.034167],
              [92.715983387999984, 45.032784654000011],
              [92.713914, 45.032394],
              [92.701083, 45.029972],
              [92.69147, 45.027938],
              [92.689213388999974, 45.027460463000011],
              [92.683361, 45.026222],
              [92.677841, 45.025728],
              [92.677397225, 45.025688232999983],
              [92.656694, 45.023833],
              [92.62575, 45.020639],
              [92.624743, 45.020863],
              [92.62407, 45.020869],
              [92.62295, 45.020903],
              [92.622147, 45.02101],
              [92.621796, 45.021033],
              [92.621451, 45.021089],
              [92.62088, 45.021333],
              [92.620388, 45.021401],
              [92.619703, 45.021384],
              [92.61881, 45.021287],
              [92.618148196999982, 45.021112725000023],
              [92.61791, 45.02105],
              [92.617509, 45.020727],
              [92.617254, 45.020569],
              [92.616971, 45.020558],
              [92.616723, 45.020614],
              [92.616468, 45.020773],
              [92.615959, 45.021061],
              [92.615314, 45.021321],
              [92.614837233, 45.021446975],
              [92.614822, 45.021451],
              [92.614770869999973, 45.021453673999986],
              [92.614172, 45.021485],
              [92.613708, 45.02148],
              [92.613498, 45.021446],
              [92.613329, 45.021485],
              [92.613189364999982, 45.021613331000026],
              [92.613119, 45.021678],
              [92.612916, 45.021813],
              [92.612633, 45.021955],
              [92.611915, 45.022226],
              [92.611049, 45.022458],
              [92.610116, 45.022634],
              [92.609692, 45.022724],
              [92.60916, 45.022758],
              [92.608538, 45.02269],
              [92.607955, 45.022554],
              [92.607514, 45.022283],
              [92.607305, 45.022045],
              [92.607016, 45.021915],
              [92.606716, 45.021757],
              [92.606315, 45.021729],
              [92.605925, 45.021632],
              [92.605483, 45.021457],
              [92.605048, 45.021293],
              [92.604333, 45.02125],
              [92.596417, 45.019945],
              [92.586717, 45.018298],
              [92.585155, 45.018033],
              [92.583995, 45.017847],
              [92.5823, 45.01758],
              [92.58075, 45.017305],
              [92.579974, 45.017168],
              [92.57852, 45.016969],
              [92.577889, 45.016942],
              [92.577621213999976, 45.016950426999983],
              [92.577031, 45.016969],
              [92.576763, 45.016976],
              [92.576599, 45.017072],
              [92.576443687, 45.017242392000014],
              [92.576393, 45.017298],
              [92.576242, 45.017458],
              [92.575933, 45.017786],
              [92.575398, 45.018163],
              [92.574643, 45.01852],
              [92.573696, 45.018842],
              [92.572674, 45.019082],
              [92.571583, 45.019316],
              [92.570753, 45.019453],
              [92.570224, 45.019515],
              [92.569621, 45.019556],
              [92.569243, 45.019508],
              [92.568619, 45.019316],
              [92.567638, 45.018993],
              [92.567466, 45.018911],
              [92.567322, 45.018918],
              [92.567096, 45.019021],
              [92.566945, 45.019062],
              [92.566753, 45.019069],
              [92.566396, 45.01911],
              [92.566005, 45.01911],
              [92.565607, 45.019117],
              [92.565092, 45.019233],
              [92.564392, 45.019226],
              [92.56385, 45.019069],
              [92.563425, 45.018849],
              [92.562746, 45.018629],
              [92.561861, 45.018451],
              [92.560989, 45.018321],
              [92.560234, 45.018273],
              [92.559514, 45.018396],
              [92.558457, 45.018712],
              [92.558162, 45.018787],
              [92.557867, 45.018794],
              [92.557366, 45.018883],
              [92.556776, 45.019027],
              [92.556351, 45.01911],
              [92.556083, 45.019055],
              [92.555802, 45.018732],
              [92.555644, 45.018451],
              [92.55537, 45.018307],
              [92.555088, 45.018197],
              [92.554594, 45.018033],
              [92.55421, 45.018012],
              [92.553709, 45.018074],
              [92.553353, 45.018163],
              [92.553051, 45.018177],
              [92.552214, 45.018142],
              [92.551109, 45.018135],
              [92.549105, 45.018232],
              [92.547493, 45.018328],
              [92.545716, 45.018444],
              [92.54444, 45.018472],
              [92.543767, 45.018575],
              [92.543177, 45.018705],
              [92.542724, 45.018945],
              [92.54256, 45.019048],
              [92.542361, 45.019075],
              [92.541833, 45.019083],
              [92.524111, 45.010333],
              [92.519833, 45.008222],
              [92.49372, 45.002162],
              [92.489902, 45.001276],
              [92.488496, 45.000999],
              [92.487694, 45.000778],
              [92.486713, 45.000336],
              [92.485531, 44.999951],
              [92.484545, 44.999807],
              [92.483784, 44.999834],
              [92.483471, 44.999977],
              [92.483148, 45.00013],
              [92.482973, 45.00034],
              [92.48279, 45.00056],
              [92.482611, 45.000873],
              [92.482405, 45.001106],
              [92.481867, 45.001518],
              [92.481249, 45.001867],
              [92.480586, 45.002118],
              [92.479834, 45.002262],
              [92.478428, 45.002548],
              [92.477192, 45.002781],
              [92.476475, 45.002817],
              [92.475472, 45.002727],
              [92.474737, 45.002476],
              [92.474334, 45.002369],
              [92.4736, 45.002342],
              [92.472641, 45.002324],
              [92.47162, 45.002253],
              [92.470877, 45.002324],
              [92.470411, 45.002414],
              [92.469972, 45.002521],
              [92.46965, 45.002557],
              [92.468647, 45.00262],
              [92.467706, 45.0027],
              [92.466927, 45.002871],
              [92.46621, 45.002889],
              [92.465796, 45.002817],
              [92.465386, 45.002745],
              [92.464347, 45.002665],
              [92.463694, 45.002722],
              [92.463362, 45.002665],
              [92.462618, 45.002853],
              [92.461633, 45.003327],
              [92.460935, 45.003901],
              [92.460816, 45.004126],
              [92.460675, 45.004393],
              [92.460549, 45.004814],
              [92.46046, 45.005128],
              [92.460146, 45.005343],
              [92.459636, 45.005495],
              [92.458874, 45.005638],
              [92.457629, 45.00571],
              [92.456787, 45.005728],
              [92.456653, 45.006015],
              [92.456366, 45.006731],
              [92.456026, 45.007394],
              [92.455757, 45.007627],
              [92.455202, 45.007815],
              [92.454396, 45.007976],
              [92.453563, 45.008137],
              [92.452793, 45.008218],
              [92.452157, 45.008173],
              [92.451386, 45.007958],
              [92.450723, 45.007976],
              [92.449684, 45.008182],
              [92.44869, 45.00854],
              [92.447938, 45.008836],
              [92.447436, 45.008926],
              [92.44654, 45.009042],
              [92.445931, 45.009105],
              [92.445063, 45.009364],
              [92.443934, 45.009732],
              [92.442752, 45.010287],
              [92.441963, 45.010708],
              [92.441372, 45.010878],
              [92.441005, 45.010914],
              [92.440136, 45.010842],
              [92.439694, 45.010722],
              [92.439402, 45.010744],
              [92.43856, 45.010959],
              [92.437583, 45.011084],
              [92.436383, 45.011335],
              [92.435568, 45.011622],
              [92.434663, 45.012016],
              [92.433696, 45.012419],
              [92.432567, 45.01292],
              [92.431251, 45.013404],
              [92.430651, 45.013601],
              [92.430095, 45.013736],
              [92.4298, 45.01378],
              [92.429477, 45.01387],
              [92.429128, 45.014013],
              [92.42868, 45.014076],
              [92.428232, 45.01404],
              [92.427695, 45.014076],
              [92.427354, 45.014192],
              [92.426933, 45.014363],
              [92.426405, 45.014604],
              [92.425832, 45.014721],
              [92.425061, 45.014739],
              [92.42482, 45.014721],
              [92.424622, 45.014757],
              [92.424372, 45.014873],
              [92.423897, 45.015151],
              [92.4231, 45.015527],
              [92.42215, 45.015858],
              [92.42129, 45.016136],
              [92.420574, 45.016288],
              [92.419938, 45.016333],
              [92.419544, 45.016324],
              [92.41898, 45.016297],
              [92.418648, 45.016342],
              [92.41812, 45.016485],
              [92.417412, 45.016781],
              [92.416731, 45.016978],
              [92.416364, 45.017032],
              [92.415531, 45.017032],
              [92.414806, 45.017085],
              [92.414349, 45.017184],
              [92.41391, 45.017345],
              [92.413238, 45.017569],
              [92.412674, 45.017704],
              [92.412083, 45.017917],
              [92.389667, 45.016139],
              [92.343139, 45.012389],
              [92.312361, 45.027],
              [92.265056, 45.018639],
              [92.24825, 45.021695],
              [92.241774039, 45.017654059],
              [92.23933, 45.016129],
              [92.234583, 45.013167],
              [92.233856987000024, 45.013563448000014],
              [92.219169, 45.021584],
              [92.195667, 45.034417],
              [92.177056, 45.042194],
              [92.124917, 45.063944],
              [92.121861, 45.065333],
              [92.110972, 45.070222],
              [92.095111, 45.077389],
              [92.069667, 45.080472],
              [92.051944, 45.082639],
              [92.029823, 45.082046],
              [92.027994697, 45.081996947999983],
              [91.984611, 45.080833],
              [91.96375, 45.080306],
              [91.937694, 45.079667],
              [91.913375, 45.07903],
              [91.90960960000001, 45.078931553000018],
              [91.891, 45.078445],
              [91.8725, 45.079306],
              [91.864150928000015, 45.079700426999977],
              [91.86126, 45.079837],
              [91.841389, 45.080778],
              [91.801139, 45.082639],
              [91.790611, 45.080972],
              [91.754056, 45.075194],
              [91.712333, 45.068583],
              [91.704, 45.065694],
              [91.683844, 45.064144],
              [91.680889, 45.063917],
              [91.680201, 45.06405],
              [91.669972, 45.066028],
              [91.636111, 45.067861],
              [91.626705, 45.06781],
              [91.615861, 45.06775],
              [91.611065, 45.070593],
              [91.608972, 45.071833],
              [91.581389, 45.079972],
              [91.568028, 45.082528],
              [91.564953, 45.077987],
              [91.560084292, 45.070798272],
              [91.559694, 45.070222],
              [91.539751, 45.084479],
              [91.53555465, 45.087479401],
              [91.533972, 45.088611],
              [91.5164, 45.092324],
              [91.516222, 45.092361],
              [91.516056, 45.092439],
              [91.514881, 45.092991],
              [91.499472, 45.100222],
              [91.492694, 45.106083],
              [91.491943, 45.113579],
              [91.491611, 45.116889],
              [91.49116994000002, 45.117477869000027],
              [91.487538754000013, 45.12232594],
              [91.486389, 45.123861],
              [91.483379160000027, 45.126707959999976],
              [91.479703831999984, 45.130184392999979],
              [91.477667, 45.132111],
              [91.469862, 45.136453],
              [91.46882778600002, 45.137028536],
              [91.466083, 45.138556],
              [91.465509297999972, 45.139415484999972],
              [91.465349737999986, 45.139654528999984],
              [91.461783, 45.144998],
              [91.459675289000018, 45.148155401999986],
              [91.459, 45.149167],
              [91.454889, 45.153028],
              [91.451919002000011, 45.153623997000011],
              [91.438833, 45.15625],
              [91.435023, 45.156743],
              [91.434093, 45.156864],
              [91.432611, 45.157056],
              [91.427555, 45.156389],
              [91.406001, 45.13999],
              [91.400611, 45.135889],
              [91.395074, 45.131473],
              [91.38675, 45.124833],
              [91.386578, 45.123741],
              [91.385556, 45.11725],
              [91.385304852, 45.115685897],
              [91.38509241700001, 45.11436289],
              [91.384722, 45.112056],
              [91.379306, 45.110361],
              [91.374444, 45.110472],
              [91.373438797, 45.110790548000011],
              [91.357, 45.116],
              [91.354623558000014, 45.116879803000018],
              [91.339667, 45.122417],
              [91.338240627, 45.123250557],
              [91.335247219999985, 45.124999871999989],
              [91.334222, 45.125599],
              [91.327833, 45.129333],
              [91.323375687, 45.129287159],
              [91.31704, 45.129222],
              [91.312431167999989, 45.129174334000027],
              [91.311962497000025, 45.129169487000013],
              [91.311722, 45.129167],
              [91.297111, 45.128722],
              [91.272417, 45.131917],
              [91.249417, 45.134889],
              [91.246354145999987, 45.134051192000015],
              [91.245688336, 45.133869066999978],
              [91.242917, 45.133111],
              [91.237694, 45.136806],
              [91.236816396, 45.137890832999972],
              [91.233335849000014, 45.142193238],
              [91.232341, 45.143423],
              [91.227873088000024, 45.148946379999984],
              [91.226639, 45.150472],
              [91.220638931999986, 45.15276464599998],
              [91.218861, 45.153444],
              [91.20975, 45.153352],
              [91.207917, 45.153333],
              [91.201598569, 45.15499687800002],
              [91.191778, 45.157583],
              [91.185976644999982, 45.166205729000012],
              [91.184865, 45.167858],
              [91.184726443999978, 45.168062999000028],
              [91.184694, 45.168111],
              [91.18465, 45.168113],
              [91.179028, 45.168306],
              [91.175514517000011, 45.171202560999973],
              [91.170639, 45.175222],
              [91.17041092, 45.175896895],
              [91.167222, 45.185333],
              [91.167159, 45.188873],
              [91.167028, 45.19625],
              [91.165149843999984, 45.197859581999978],
              [91.161972, 45.200583],
              [91.147667, 45.203528],
              [91.123722, 45.214195],
              [91.114806, 45.212292],
              [91.110056, 45.211278],
              [91.105237396, 45.212369667000019],
              [91.100198884, 45.213511155],
              [91.097432, 45.214138],
              [91.09375, 45.214972],
              [91.087919, 45.214816],
              [91.086352318000024, 45.214773744000013],
              [91.085596292, 45.214753352],
              [91.085472, 45.21475],
              [91.083143, 45.21483],
              [91.079778, 45.214945],
              [91.069575, 45.212127],
              [91.068498208, 45.211829707999982],
              [91.05390382500002, 45.207800338000027],
              [91.049194, 45.2065],
              [91.0105, 45.213417],
              [91.00324, 45.214095],
              [91.002492478000022, 45.214164830000016],
              [90.996528, 45.214722],
              [90.996187878, 45.214577011000017],
              [90.984278, 45.2095],
              [90.977319, 45.206534],
              [90.972417, 45.204444],
              [90.959056, 45.19875],
              [90.934111, 45.193389],
              [90.907778, 45.191472],
              [90.879528, 45.189389],
              [90.880058812000016, 45.189913123],
              [90.88175, 45.191583],
              [90.880767406000018, 45.192298701000027],
              [90.865389, 45.2035],
              [90.865557734, 45.203730931],
              [90.880611, 45.224333],
              [90.891828, 45.242805],
              [90.892722, 45.244278],
              [90.896694, 45.250833],
              [90.884389, 45.265056],
              [90.872944, 45.278278],
              [90.872875, 45.27846],
              [90.872943, 45.278635],
              [90.87309, 45.278846],
              [90.873327, 45.279312],
              [90.873348, 45.279577],
              [90.873299, 45.280147],
              [90.873254, 45.280592],
              [90.873611, 45.281],
              [90.873306, 45.280833],
              [90.870962234, 45.281366909999974],
              [90.868306, 45.281972],
              [90.860535, 45.285836],
              [90.853333, 45.289417],
              [90.852014483, 45.290069062999976],
              [90.847616818, 45.292243895000013],
              [90.847103, 45.292498],
              [90.837944, 45.297028],
              [90.837844761999975, 45.297088828000028],
              [90.8345, 45.299139],
              [90.833689298000024, 45.298890179000011],
              [90.833604, 45.298864],
              [90.804028, 45.289778],
              [90.804132, 45.290286],
              [90.804133243000024, 45.29029205400002],
              [90.807056, 45.304528],
              [90.811111, 45.324472],
              [90.807987179, 45.329853523],
              [90.807984298, 45.329859151999983],
              [90.78005360200001, 45.384423308],
              [90.776917, 45.391945],
              [90.771694, 45.404417],
              [90.770278, 45.428333],
              [90.76943336, 45.429113819],
              [90.759611, 45.438194],
              [90.756583, 45.440394],
              [90.754043, 45.442239],
              [90.74875, 45.446083],
              [90.744417, 45.448806],
              [90.733966834, 45.454505596],
              [90.730972, 45.456139],
              [90.729158338, 45.456884536000018],
              [90.723472, 45.459222],
              [90.715659892000019, 45.461966795000023],
              [90.714222, 45.462472],
              [90.710944, 45.463972],
              [90.705587, 45.465877],
              [90.699306, 45.468111],
              [90.688639, 45.473139],
              [90.674328, 45.483845],
              [90.670222, 45.486917],
              [90.669028, 45.514222],
              [90.667722, 45.543583],
              [90.672667, 45.572167],
              [90.678444, 45.605361],
              [90.687306, 45.635139],
              [90.695667, 45.66325],
              [90.706111, 45.69825],
              [90.714806, 45.727472],
              [90.740333, 45.760583],
              [90.773028, 45.802944],
              [90.8125, 45.847694],
              [90.847167, 45.886972],
              [90.886472, 45.917639],
              [90.904333, 45.931583],
              [90.936, 45.95625],
              [90.968917, 45.981861],
              [90.988556, 45.997111],
              [91.021472, 46.022639],
              [91.0195, 46.047528],
              [91.019256, 46.050719],
              [91.019321, 46.056654],
              [91.019095, 46.057346],
              [91.018822, 46.057925],
              [91.018725, 46.05844],
              [91.018741, 46.059003],
              [91.018565, 46.059727],
              [91.018146, 46.060628],
              [91.017712, 46.060982],
              [91.017516226, 46.06107967600002],
              [91.017247, 46.061214],
              [91.017229, 46.061223],
              [91.016699, 46.061834],
              [91.016184, 46.062542],
              [91.015991, 46.063378],
              [91.015975, 46.064022],
              [91.016119, 46.064746],
              [91.016119, 46.0651],
              [91.015943, 46.065309],
              [91.015766, 46.065405],
              [91.015396, 46.065405],
              [91.014881, 46.065405],
              [91.014173, 46.06555],
              [91.013932, 46.066226],
              [91.01369, 46.067239],
              [91.013497, 46.067593],
              [91.013015, 46.067931],
              [91.012597, 46.068397],
              [91.012146, 46.069234],
              [91.011953, 46.070247],
              [91.011712, 46.070778],
              [91.011294, 46.071357],
              [91.010908, 46.071663],
              [91.010843, 46.072177],
              [91.011036, 46.072885],
              [91.011085, 46.073657],
              [91.010795, 46.074349],
              [91.010216, 46.074896],
              [91.009476, 46.075314],
              [91.009219, 46.07562],
              [91.009058, 46.076408],
              [91.008849, 46.076939],
              [91.008125, 46.077647],
              [91.007755, 46.078306],
              [91.00761, 46.079062],
              [91.007658, 46.080397],
              [91.007835, 46.081797],
              [91.008028, 46.082102],
              [91.008865, 46.082183],
              [91.010103, 46.082408],
              [91.011036, 46.082424],
              [91.012162, 46.082376],
              [91.013095, 46.082456],
              [91.013287, 46.082563],
              [91.01353, 46.082698],
              [91.013787, 46.082907],
              [91.013996, 46.083454],
              [91.014366, 46.084499],
              [91.014643868, 46.084823659],
              [91.014752, 46.08495],
              [91.015203, 46.085159],
              [91.015556, 46.085336],
              [91.015862, 46.085432],
              [91.015637, 46.085754],
              [91.015138, 46.086333],
              [91.014463, 46.087266],
              [91.01398, 46.088102],
              [91.013497, 46.08873],
              [91.013192, 46.089003],
              [91.012841531999982, 46.089204965000022],
              [91.012661, 46.089309],
              [91.011933, 46.089858],
              [91.011744, 46.090001],
              [91.011551, 46.090403],
              [91.011262, 46.091143],
              [91.011036, 46.091818],
              [91.011117, 46.092188],
              [91.011236527999984, 46.092464727],
              [91.011374, 46.092783],
              [91.011386, 46.092806],
              [91.011567, 46.093137],
              [91.011567, 46.093298],
              [91.011519, 46.093411],
              [91.011406, 46.093684],
              [91.011326, 46.09407],
              [91.011422, 46.09436],
              [91.011471, 46.094826],
              [91.011519, 46.095373],
              [91.011406, 46.09592],
              [91.01139, 46.096338],
              [91.011438, 46.096515],
              [91.011599, 46.096789],
              [91.011889, 46.097127],
              [91.012162, 46.097545],
              [91.012292, 46.097904],
              [91.012207, 46.098074],
              [91.011675, 46.098563],
              [91.010739, 46.09946],
              [91.009702, 46.100453],
              [91.009318, 46.104417],
              [91.009603, 46.109012],
              [91.009726, 46.110746],
              [91.009942390999981, 46.114960130999975],
              [91.009962, 46.115342],
              [91.010272, 46.120198],
              [91.010309, 46.121635],
              [91.010457, 46.123939],
              [91.009157, 46.125363],
              [91.007683, 46.126973],
              [91.006763418, 46.127938013],
              [91.005416, 46.129352],
              [91.005222, 46.129566],
              [91.003818, 46.131123],
              [91.001762, 46.133315],
              [90.998838, 46.136548],
              [90.997463, 46.137973],
              [90.996002, 46.139558],
              [90.99459, 46.141094],
              [90.993128, 46.142655],
              [90.991753, 46.144142],
              [90.989313, 46.14678],
              [90.985238, 46.151425],
              [90.980716, 46.156281],
              [90.978586, 46.158486],
              [90.978449, 46.158634],
              [90.975254, 46.162103],
              [90.972615, 46.166983],
              [90.971104, 46.169869],
              [90.968825, 46.174106],
              [90.967834, 46.176013],
              [90.965641, 46.180113],
              [90.964811, 46.181835],
              [90.962557, 46.18596],
              [90.961541, 46.187868],
              [90.959113, 46.192414],
              [90.957565, 46.195312],
              [90.955311, 46.199734],
              [90.95396, 46.202199],
              [90.951991, 46.204999],
              [90.951359, 46.206039],
              [90.950096, 46.207885],
              [90.9483, 46.210573],
              [90.946813, 46.21274],
              [90.945624, 46.214487],
              [90.945215, 46.216779],
              [90.944992, 46.218661],
              [90.944509, 46.221808],
              [90.9442, 46.22405],
              [90.943989, 46.225573],
              [90.944187, 46.225788],
              [90.945191, 46.226874],
              [90.945562, 46.227233],
              [90.946181, 46.227828],
              [90.946739, 46.228137],
              [90.947507, 46.228398],
              [90.948808, 46.228782],
              [90.949662, 46.229091],
              [90.948961462999989, 46.230078162999973],
              [90.948176, 46.231185],
              [90.947259, 46.23251],
              [90.94612, 46.234207],
              [90.944881, 46.235929],
              [90.943419, 46.238072],
              [90.941995, 46.240103],
              [90.940954, 46.24159],
              [90.939852, 46.2432],
              [90.939592, 46.243572],
              [90.938564, 46.244922],
              [90.937461, 46.246557],
              [90.93507, 46.249951],
              [90.933051, 46.252911],
              [90.930289, 46.256888],
              [90.928629, 46.259291],
              [90.927291, 46.261235],
              [90.925582, 46.263676],
              [90.923633, 46.266479],
              [90.923154, 46.267132],
              [90.922375, 46.268114],
              [90.920547, 46.270633],
              [90.918511, 46.273525],
              [90.918119, 46.274168],
              [90.916324, 46.276756],
              [90.916262, 46.276846],
              [90.915119, 46.278512],
              [90.913715, 46.280523],
              [90.911453, 46.283761],
              [90.910216, 46.285594],
              [90.907883, 46.288902],
              [90.9073, 46.289795],
              [90.905603053999982, 46.292265720999978],
              [90.904324, 46.294128],
              [90.903289, 46.295591],
              [90.902562, 46.296627],
              [90.89973, 46.300698],
              [90.898897, 46.301793],
              [90.896231, 46.305708],
              [90.894993, 46.307494],
              [90.89291, 46.310517],
              [90.891862, 46.31204],
              [90.894076, 46.312969],
              [90.894778, 46.312945],
              [90.896207, 46.3131],
              [90.896438, 46.313132],
              [90.897814, 46.313326],
              [90.899325, 46.313504],
              [90.902051, 46.313838],
              [90.903967, 46.314111],
              [90.905609, 46.314302],
              [90.907288, 46.316349],
              [90.909371, 46.31892],
              [90.911906, 46.322002],
              [90.912953, 46.323288],
              [90.913667, 46.324085],
              [90.914619, 46.324669],
              [90.918642, 46.326942],
              [90.920651785000018, 46.328008486999977],
              [90.920975, 46.32818],
              [90.923368, 46.329525],
              [90.926569, 46.331298],
              [90.927843, 46.331988],
              [90.930271, 46.333381],
              [90.930565541000021, 46.333526346999975],
              [90.932032, 46.33425],
              [90.933615, 46.335714],
              [90.935782, 46.337428],
              [90.937555, 46.339011],
              [90.941078, 46.34195],
              [90.942494, 46.343129],
              [90.943827, 46.344236],
              [90.945053, 46.345259],
              [90.946993, 46.346461],
              [90.949279, 46.347925],
              [90.951415527999984, 46.349222972],
              [90.953218, 46.350318],
              [90.956510719999983, 46.352396718000023],
              [90.956706, 46.35252],
              [90.959681, 46.354364],
              [90.965704, 46.358149],
              [90.968191, 46.359649],
              [90.969786, 46.360851],
              [90.969863352, 46.360985722],
              [90.971679, 46.364148],
              [90.973059, 46.36616],
              [90.973713794999981, 46.367133879999983],
              [90.974083, 46.367683],
              [90.976166, 46.373301],
              [90.976701, 46.374634],
              [90.978915, 46.38043],
              [90.98095, 46.385751],
              [90.981569, 46.387512],
              [90.982593, 46.390166],
              [90.984319, 46.39488],
              [90.984866, 46.396284],
              [90.986247, 46.39995],
              [90.987806, 46.404223],
              [90.989199, 46.407901],
              [90.990948, 46.412388],
              [90.991603, 46.414375],
              [90.992504, 46.416796],
              [90.992626, 46.417125],
              [90.993471, 46.419529],
              [90.99384, 46.420553],
              [90.994495, 46.422385],
              [90.99702, 46.425069],
              [90.999803, 46.428027],
              [91.001434, 46.429717],
              [91.002779, 46.431098],
              [91.00458, 46.43305],
              [91.007184, 46.435732],
              [91.006477, 46.439715],
              [91.006292106999979, 46.441027268000028],
              [91.006241, 46.44139],
              [91.006576, 46.44211],
              [91.006651, 46.442607],
              [91.006899, 46.445101],
              [91.006957758999988, 46.445291785999984],
              [91.00698, 46.445364],
              [91.00778, 46.447955],
              [91.008591, 46.449332],
              [91.008686, 46.449494],
              [91.008701, 46.449604],
              [91.00876, 46.45004],
              [91.008909, 46.452001],
              [91.009046, 46.453664],
              [91.00922, 46.455413],
              [91.009418, 46.456034],
              [91.009865, 46.457089],
              [91.009952, 46.457399],
              [91.009865, 46.458814],
              [91.009828, 46.459546],
              [91.00984, 46.459918],
              [91.009853, 46.461097],
              [91.010138, 46.461445],
              [91.010672, 46.462028],
              [91.010907, 46.462375],
              [91.011081, 46.462487],
              [91.011379, 46.462574],
              [91.011844, 46.4628],
              [91.012111, 46.463045],
              [91.012459, 46.463529],
              [91.012794, 46.463802],
              [91.013116, 46.464348],
              [91.013563, 46.464684],
              [91.013724, 46.464969],
              [91.013749, 46.465316],
              [91.0137, 46.46585],
              [91.0137, 46.466272],
              [91.013786, 46.466483],
              [91.014072, 46.46652],
              [91.014432, 46.466607],
              [91.015052, 46.467091],
              [91.015648, 46.467687],
              [91.016132, 46.468071],
              [91.016258, 46.468225],
              [91.016591, 46.46863],
              [91.016703, 46.468853],
              [91.016726, 46.46922],
              [91.016728, 46.469238],
              [91.01683497099998, 46.469483210000021],
              [91.016988, 46.469834],
              [91.01736, 46.470479],
              [91.017784, 46.471012],
              [91.017795, 46.471025],
              [91.018192, 46.471285],
              [91.018502, 46.471534],
              [91.018862, 46.472129],
              [91.019197, 46.47275],
              [91.019445, 46.473519],
              [91.019541, 46.473988],
              [91.019557, 46.474065],
              [91.019616, 46.474114],
              [91.019855, 46.474313],
              [91.020351, 46.474711],
              [91.020947, 46.475008],
              [91.021592, 46.475108],
              [91.02225, 46.475219],
              [91.023019, 46.475406],
              [91.023665, 46.475803],
              [91.024024, 46.476063],
              [91.024397, 46.476473],
              [91.024558, 46.476758],
              [91.02457, 46.477006],
              [91.024533, 46.477205],
              [91.024409, 46.477466],
              [91.024223, 46.477701],
              [91.024136, 46.478086],
              [91.024186, 46.478396],
              [91.024309575000018, 46.478665782],
              [91.024459, 46.478992],
              [91.024508, 46.479364],
              [91.024434, 46.47965],
              [91.024198, 46.479823],
              [91.023725994000017, 46.480133516000024],
              [91.023327, 46.480396],
              [91.022883, 46.480717],
              [91.022783, 46.481027],
              [91.022808, 46.481313],
              [91.022932, 46.481586],
              [91.02328, 46.482231],
              [91.023405014, 46.482474299999978],
              [91.023503, 46.482665],
              [91.02359, 46.483038],
              [91.023565, 46.483323],
              [91.023416, 46.483708],
              [91.023379, 46.484005],
              [91.023553, 46.484254],
              [91.024, 46.484688],
              [91.024434, 46.485122],
              [91.024806, 46.485433],
              [91.02493, 46.485817],
              [91.025067, 46.48609],
              [91.02529, 46.486202],
              [91.025687, 46.486376],
              [91.02632, 46.486649],
              [91.02709, 46.486947],
              [91.027244, 46.487036],
              [91.027623, 46.487257],
              [91.027983, 46.487443],
              [91.028467, 46.487927],
              [91.028765, 46.488212],
              [91.0291, 46.488361],
              [91.029572, 46.488411],
              [91.03018, 46.488696],
              [91.030788, 46.488994],
              [91.031123, 46.489218],
              [91.031222, 46.489391],
              [91.031222, 46.489677],
              [91.031222, 46.490099],
              [91.031224, 46.49063],
              [91.031266688000017, 46.490754036],
              [91.03133, 46.490938],
              [91.031755, 46.491384],
              [91.032211, 46.491596],
              [91.032679, 46.491925],
              [91.032944, 46.492361],
              [91.033167, 46.492807],
              [91.033103, 46.493157],
              [91.032944, 46.493487],
              [91.032753, 46.493911],
              [91.032615, 46.494517],
              [91.032583, 46.495058],
              [91.032721, 46.495653],
              [91.032912, 46.496089],
              [91.033071, 46.496386],
              [91.033337, 46.496407],
              [91.033985, 46.496535],
              [91.034384015, 46.496648565999976],
              [91.034505, 46.496683],
              [91.034962, 46.496843],
              [91.035217, 46.497044],
              [91.03527, 46.497267],
              [91.035249, 46.497448],
              [91.035111, 46.497586],
              [91.034739, 46.497703],
              [91.034470331000023, 46.497836913000015],
              [91.03442, 46.497862],
              [91.034197, 46.498149],
              [91.034171, 46.498289],
              [91.034102, 46.498659],
              [91.03425, 46.499009],
              [91.034558, 46.499349],
              [91.034596721000014, 46.499543335],
              [91.034611, 46.499615],
              [91.034739, 46.500252],
              [91.035058, 46.500634],
              [91.035684, 46.500985],
              [91.036086, 46.501199],
              [91.03664, 46.501494],
              [91.037267, 46.501802],
              [91.037851, 46.501898],
              [91.038148, 46.50194],
              [91.038244, 46.502089],
              [91.038212, 46.502248],
              [91.038106, 46.502323],
              [91.037989, 46.502631],
              [91.03784, 46.503013],
              [91.037936, 46.503332],
              [91.038435, 46.503597],
              [91.039051, 46.503905],
              [91.039688, 46.504171],
              [91.040092, 46.504319],
              [91.04024, 46.5045],
              [91.040262, 46.504914],
              [91.040368, 46.505456],
              [91.04057, 46.505944],
              [91.040665, 46.506507],
              [91.040612, 46.506847],
              [91.040718, 46.507091],
              [91.040888, 46.507304],
              [91.041207, 46.507665],
              [91.041653, 46.508235],
              [91.042032, 46.50843],
              [91.042637887000012, 46.508839405],
              [91.042769, 46.508928],
              [91.043054803000018, 46.509011542999986],
              [91.043289, 46.50908],
              [91.043657, 46.509156],
              [91.044102, 46.509296],
              [91.044567, 46.509416],
              [91.045337, 46.509556],
              [91.045943, 46.509546],
              [91.046387, 46.509491],
              [91.047493, 46.509535],
              [91.047904, 46.509654],
              [91.048294, 46.50986],
              [91.048803, 46.510044],
              [91.049518, 46.510271],
              [91.050244, 46.510488],
              [91.050548, 46.510683],
              [91.050829, 46.51103],
              [91.05136, 46.511485],
              [91.052021, 46.511994],
              [91.0524, 46.5122],
              [91.053083, 46.512904],
              [91.051935468000011, 46.513772824],
              [91.051609, 46.51402],
              [91.050786, 46.516912],
              [91.050807, 46.51766],
              [91.050921647, 46.518627773999981],
              [91.051165, 46.520682],
              [91.051317, 46.521939],
              [91.051598, 46.522329],
              [91.052238, 46.523131],
              [91.053581, 46.524853],
              [91.054816, 46.526381],
              [91.055368, 46.527161],
              [91.056051, 46.528092],
              [91.056766, 46.528937],
              [91.056116, 46.529739],
              [91.055228, 46.530692],
              [91.054958, 46.530998],
              [91.053884, 46.53222],
              [91.053473, 46.532566],
              [91.052638, 46.533195],
              [91.050992, 46.534581],
              [91.050417, 46.535004],
              [91.050298, 46.535199],
              [91.050385, 46.535795],
              [91.050602, 46.536791],
              [91.050959, 46.537268],
              [91.051555, 46.538146],
              [91.051667392000013, 46.538265192999972],
              [91.051902, 46.538514],
              [91.053386, 46.539316],
              [91.054924, 46.540117],
              [91.056473, 46.540962],
              [91.056658, 46.541255],
              [91.057243, 46.542977],
              [91.058358, 46.545567],
              [91.05916, 46.547343],
              [91.059199348999982, 46.547431486],
              [91.059767, 46.548708],
              [91.060352, 46.549824],
              [91.060457869, 46.550042776],
              [91.060698, 46.550539],
              [91.060944, 46.550833],
              [91.061175, 46.5512],
              [91.061673, 46.551525],
              [91.061977, 46.551709],
              [91.063168, 46.551839],
              [91.06361453, 46.551877123999986],
              [91.064187, 46.551926],
              [91.064472, 46.552167],
              [91.065183, 46.552782],
              [91.065889, 46.553333],
              [91.066417, 46.553556],
              [91.067339, 46.554558],
              [91.068484652, 46.555737621],
              [91.068823, 46.556086],
              [91.069584, 46.556864],
              [91.069733, 46.557017],
              [91.069993, 46.557223],
              [91.070795, 46.557537],
              [91.071835, 46.558068],
              [91.072225, 46.558967],
              [91.07281, 46.560083],
              [91.07281, 46.560322],
              [91.072799, 46.560755],
              [91.072745, 46.560972],
              [91.072474, 46.56134],
              [91.072095, 46.561979],
              [91.071835, 46.562412],
              [91.071792, 46.562965],
              [91.071889, 46.563832],
              [91.071954, 46.564406],
              [91.071976, 46.564655],
              [91.072016427, 46.564776656],
              [91.072084, 46.56498],
              [91.072333, 46.565392],
              [91.072442, 46.56563],
              [91.072388, 46.565825],
              [91.072258, 46.565944],
              [91.071878, 46.566226],
              [91.071434, 46.566562],
              [91.071199596999975, 46.566784426000027],
              [91.071023, 46.566952],
              [91.070936, 46.567071],
              [91.070828, 46.567298],
              [91.070589, 46.568143],
              [91.070448, 46.568555],
              [91.070209928999986, 46.569217034000019],
              [91.070156, 46.569367],
              [91.069918, 46.570223],
              [91.069807, 46.570504],
              [91.069658, 46.570884],
              [91.069235, 46.571697],
              [91.068953, 46.572292],
              [91.068466, 46.573062],
              [91.068228191, 46.573422661999984],
              [91.068195, 46.573473],
              [91.068135665, 46.573608904000025],
              [91.067892, 46.574167],
              [91.067718, 46.574524],
              [91.067632, 46.574762],
              [91.067437, 46.575109],
              [91.067079, 46.575467],
              [91.066733, 46.575867],
              [91.066386, 46.576106],
              [91.066083, 46.576539],
              [91.065736, 46.576832],
              [91.065248, 46.577211],
              [91.064685, 46.577655],
              [91.064284, 46.578164],
              [91.063992, 46.578446],
              [91.063775, 46.5785],
              [91.063363, 46.578478],
              [91.062378, 46.578229],
              [91.061868, 46.578088],
              [91.061598, 46.57811],
              [91.061175, 46.578272],
              [91.060969, 46.578348],
              [91.060698, 46.578305],
              [91.060308, 46.57824],
              [91.06007, 46.578186],
              [91.059778, 46.578218],
              [91.059561, 46.578327],
              [91.059355, 46.578424],
              [91.058998, 46.578457],
              [91.058662, 46.578337],
              [91.058445, 46.578251],
              [91.058055, 46.578251],
              [91.057459, 46.578381],
              [91.057058, 46.578381],
              [91.056896, 46.578218],
              [91.056506, 46.578056],
              [91.056029, 46.577991],
              [91.055238, 46.578012],
              [91.054448, 46.57811],
              [91.053689, 46.578316],
              [91.052866, 46.578511],
              [91.052454, 46.57876],
              [91.052238, 46.578814],
              [91.051923, 46.578814],
              [91.051685, 46.578792],
              [91.051252, 46.578847],
              [91.050818, 46.578879],
              [91.050309, 46.57889],
              [91.049768, 46.578684],
              [91.049334, 46.578543],
              [91.048749, 46.578478],
              [91.048272, 46.578511],
              [91.047677, 46.578597],
              [91.047265, 46.578489],
              [91.047037, 46.57824],
              [91.046756, 46.578099],
              [91.046236, 46.578067],
              [91.045532, 46.578023],
              [91.045261, 46.57811],
              [91.044957, 46.578305],
              [91.044632, 46.578435],
              [91.044437, 46.578446],
              [91.04421, 46.578402],
              [91.043972, 46.578489],
              [91.043885, 46.578652],
              [91.043755, 46.578673],
              [91.043625, 46.578608],
              [91.043441, 46.578597],
              [91.0433, 46.578717],
              [91.043159, 46.578814],
              [91.043007, 46.578977],
              [91.042715, 46.578998],
              [91.042444, 46.578955],
              [91.042217, 46.578944],
              [91.041978, 46.578977],
              [91.041805, 46.579161],
              [91.041794, 46.579486],
              [91.041805, 46.5798],
              [91.041762, 46.579897],
              [91.041588, 46.579941],
              [91.041274, 46.5798],
              [91.041101, 46.579713],
              [91.040895, 46.579746],
              [91.040722, 46.5798],
              [91.04057, 46.579767],
              [91.040256, 46.579724],
              [91.040126, 46.579778],
              [91.039833, 46.580017],
              [91.039682, 46.580114],
              [91.039584, 46.580114],
              [91.039443, 46.580017],
              [91.039313, 46.579854],
              [91.039064, 46.579681],
              [91.038587, 46.579627],
              [91.038035, 46.57954],
              [91.037764, 46.579572],
              [91.037526, 46.579681],
              [91.037417, 46.579843],
              [91.037071, 46.580006],
              [91.036724, 46.580082],
              [91.036399, 46.580038],
              [91.036193, 46.579995],
              [91.03602, 46.579995],
              [91.035814, 46.580082],
              [91.035565, 46.580136],
              [91.035446, 46.580136],
              [91.035218, 46.580038],
              [91.034969, 46.579627],
              [91.034861, 46.579497],
              [91.034731, 46.579475],
              [91.034557, 46.579497],
              [91.034352, 46.57954],
              [91.034178, 46.579497],
              [91.034147506000011, 46.579473108],
              [91.034081, 46.579421],
              [91.033951, 46.579432],
              [91.033844774999977, 46.579485111999986],
              [91.033821, 46.579497],
              [91.033767, 46.579594],
              [91.033669, 46.579746],
              [91.033507, 46.579832],
              [91.033247, 46.579865],
              [91.033008, 46.579811],
              [91.032716, 46.579648],
              [91.032412, 46.579529],
              [91.032302360000017, 46.579507727000021],
              [91.032077, 46.579464],
              [91.031719, 46.579334],
              [91.031437, 46.579226],
              [91.031091, 46.579258],
              [91.030668, 46.57928],
              [91.030441, 46.579302],
              [91.030246, 46.579377],
              [91.030117039, 46.579539767000028],
              [91.03004, 46.579637],
              [91.029834, 46.579789],
              [91.029487, 46.579897],
              [91.029162, 46.579897],
              [91.028827, 46.579843],
              [91.028697, 46.579887],
              [91.028577, 46.580017],
              [91.028404, 46.580168],
              [91.028209, 46.580233],
              [91.027949, 46.580233],
              [91.027364, 46.580071],
              [91.026996, 46.579897],
              [91.026746, 46.579883],
              [91.026432, 46.579865],
              [91.025988, 46.579973],
              [91.025696, 46.580017],
              [91.02536, 46.579973],
              [91.025078, 46.579919],
              [91.02484, 46.580006],
              [91.024742, 46.580136],
              [91.024602, 46.580266],
              [91.024493, 46.580309],
              [91.024233, 46.580233],
              [91.02393, 46.580266],
              [91.023822, 46.580352],
              [91.023735, 46.58058],
              [91.023594, 46.580732],
              [91.023432, 46.580862],
              [91.023247, 46.580927],
              [91.023052, 46.580927],
              [91.022717, 46.58084],
              [91.022446, 46.580775],
              [91.022283, 46.580786],
              [91.022012, 46.580883],
              [91.021817, 46.580894],
              [91.021568, 46.580656],
              [91.02133, 46.580331],
              [91.021081, 46.580147],
              [91.020691, 46.580049],
              [91.020257, 46.579941],
              [91.019748, 46.579789],
              [91.019001, 46.579605],
              [91.018437, 46.579507],
              [91.017951, 46.579376],
              [91.017434, 46.579272],
              [91.016911, 46.579239],
              [91.01617, 46.579261],
              [91.015614, 46.579294],
              [91.015211, 46.579408],
              [91.014939, 46.579642],
              [91.014786, 46.579691],
              [91.014568, 46.579708],
              [91.014198, 46.579626],
              [91.013958, 46.579599],
              [91.013833, 46.579722],
              [91.014167, 46.58],
              [91.013861, 46.580111],
              [91.013649, 46.580296],
              [91.013649, 46.583712],
              [91.013727738, 46.587996675999989],
              [91.013793, 46.591548],
              [91.014017, 46.599822],
              [91.014195, 46.606674],
              [91.014249, 46.610856],
              [91.016064, 46.616461],
              [91.018057, 46.62269],
              [91.019178, 46.626302],
              [91.019872, 46.628118],
              [91.020086, 46.629025],
              [91.022737, 46.637265],
              [91.025229, 46.644988],
              [91.026492, 46.648956],
              [91.026807, 46.649922],
              [91.028521, 46.655185],
              [91.030746, 46.662232],
              [91.032935, 46.66919],
              [91.033198567, 46.670015702],
              [91.034554, 46.674262],
              [91.036654, 46.68074],
              [91.037259, 46.682715],
              [91.039145, 46.688499],
              [91.04274, 46.699835],
              [91.044235, 46.705352],
              [91.044929, 46.710228],
              [91.046299, 46.720051],
              [91.046651338, 46.722181852],
              [91.046655, 46.722204],
              [91.04676, 46.723042],
              [91.04678, 46.723201],
              [91.04678, 46.723272],
              [91.046304, 46.723321],
              [91.04593, 46.723323],
              [91.045445, 46.723325],
              [91.044741434, 46.723503150999989],
              [91.044355, 46.723601],
              [91.043995, 46.723748],
              [91.043987, 46.723758],
              [91.043665, 46.724162],
              [91.043583608, 46.724304151000013],
              [91.043164, 46.725037],
              [91.042829, 46.725621],
              [91.04238, 46.726578],
              [91.041699, 46.727632],
              [91.040889, 46.728433],
              [91.03943, 46.730088],
              [91.03854, 46.731511],
              [91.037811, 46.732953],
              [91.037241, 46.734608],
              [91.036511, 46.735996],
              [91.035639, 46.737384],
              [91.035497, 46.737598],
              [91.034803, 46.738487],
              [91.033344, 46.740748],
              [91.032062, 46.742812],
              [91.031279, 46.743915],
              [91.030532, 46.744485],
              [91.029393, 46.745125],
              [91.027222, 46.746033],
              [91.024891, 46.746976],
              [91.023147, 46.747848],
              [91.021954, 46.748595],
              [91.02094, 46.749147],
              [91.020388, 46.749556],
              [91.019748, 46.74977],
              [91.01936, 46.74977],
              [91.019178, 46.74977],
              [91.017933, 46.749521],
              [91.016844, 46.749327],
              [91.016473, 46.749321],
              [91.016295, 46.749432],
              [91.016171, 46.749717],
              [91.016117, 46.75009],
              [91.016278, 46.750517],
              [91.01658, 46.750998],
              [91.017007, 46.751425],
              [91.017126, 46.751534],
              [91.017826, 46.752172],
              [91.018342, 46.752866],
              [91.018591, 46.753703],
              [91.018662, 46.754272],
              [91.018751, 46.755216],
              [91.018609, 46.755838],
              [91.018395, 46.756354],
              [91.017986, 46.756853],
              [91.017648, 46.757654],
              [91.017399, 46.758472],
              [91.017292, 46.759184],
              [91.01731, 46.759807],
              [91.017256, 46.760501],
              [91.01715, 46.761053],
              [91.016758, 46.761836],
              [91.01642, 46.762369],
              [91.015957, 46.76317],
              [91.015744, 46.763562],
              [91.015103, 46.764078],
              [91.013911, 46.764754],
              [91.012149, 46.765484],
              [91.010796, 46.766],
              [91.010086, 46.766454],
              [91.00973, 46.766629],
              [91.008279, 46.767122],
              [91.007452, 46.767411],
              [91.007057, 46.767471],
              [91.006488, 46.767479],
              [91.005151, 46.767464],
              [91.004457, 46.767405],
              [91.003549, 46.767327],
              [91.002426, 46.767228],
              [91.001537, 46.767099],
              [90.999738, 46.76697],
              [90.998721, 46.766856],
              [90.997901, 46.766879],
              [90.996845, 46.767031],
              [90.995759, 46.767236],
              [90.994727, 46.767471],
              [90.993914, 46.767752],
              [90.993224, 46.768033],
              [90.992609, 46.768398],
              [90.991933, 46.768914],
              [90.991083, 46.769377],
              [90.990619, 46.769628],
              [90.98942, 46.770478],
              [90.988911, 46.770956],
              [90.988805, 46.771222],
              [90.988767, 46.771526],
              [90.988805, 46.771951],
              [90.989002, 46.77249],
              [90.989678, 46.773614],
              [90.990004, 46.7741],
              [90.990201, 46.774271],
              [90.990665, 46.774677],
              [90.99128, 46.775223],
              [90.991386, 46.775451],
              [90.991386, 46.775633],
              [90.991325, 46.775823],
              [90.991166, 46.776036],
              [90.990961, 46.77618],
              [90.990688, 46.776469],
              [90.99027, 46.777106],
              [90.990103, 46.777463],
              [90.990035, 46.777774],
              [90.98989, 46.778291],
              [90.989686, 46.778678],
              [90.989359, 46.778959],
              [90.989063, 46.779095],
              [90.988759, 46.779285],
              [90.988357, 46.779733],
              [90.988144, 46.780143],
              [90.987666, 46.780781],
              [90.987271, 46.78135],
              [90.987013, 46.781738],
              [90.986907, 46.782148],
              [90.986854, 46.782558],
              [90.986816, 46.783165],
              [90.986816, 46.783734],
              [90.986846, 46.784418],
              [90.98696, 46.785063],
              [90.986884, 46.78561],
              [90.986838, 46.786035],
              [90.986686, 46.786498],
              [90.986573, 46.78706],
              [90.98633, 46.787508],
              [90.986102, 46.787834],
              [90.985829, 46.788313],
              [90.98557, 46.788935],
              [90.985464, 46.789467],
              [90.985343, 46.790089],
              [90.98535, 46.790674],
              [90.985396, 46.79141],
              [90.98554, 46.792124],
              [90.985692, 46.792572],
              [90.985798, 46.792921],
              [90.985807, 46.793296],
              [90.985662, 46.794231],
              [90.985425, 46.795231],
              [90.985123, 46.796034],
              [90.985075746, 46.796137016999978],
              [90.984916333, 46.796484554000017],
              [90.984912, 46.796494],
              [90.984754, 46.796639],
              [90.984685174, 46.796669834],
              [90.984629, 46.796695],
              [90.984517, 46.796626],
              [90.984136, 46.796415],
              [90.983554814, 46.796241380000026],
              [90.983346, 46.796179],
              [90.98157, 46.795797],
              [90.980727, 46.795652],
              [90.979846, 46.795547],
              [90.979293, 46.795586],
              [90.978687, 46.795718],
              [90.978003, 46.795915],
              [90.977135, 46.795968],
              [90.975608, 46.796113],
              [90.974937, 46.796258],
              [90.97441, 46.796244],
              [90.973724, 46.796136],
              [90.973239, 46.79606],
              [90.971594, 46.795981],
              [90.970633, 46.796073],
              [90.969896, 46.796244],
              [90.968646, 46.796784],
              [90.967251, 46.797547],
              [90.966198, 46.798153],
              [90.965501, 46.798863],
              [90.965224, 46.799284],
              [90.965159, 46.799613],
              [90.965159, 46.800035],
              [90.965198, 46.800679],
              [90.965382, 46.801916],
              [90.965461, 46.80243],
              [90.965685, 46.80289],
              [90.965764, 46.803285],
              [90.965689, 46.803518],
              [90.965619, 46.803733],
              [90.965382, 46.804101],
              [90.96504, 46.804522],
              [90.964685, 46.805035],
              [90.964461, 46.805575],
              [90.964264, 46.806088],
              [90.964211, 46.806483],
              [90.964119, 46.806654],
              [90.963908, 46.806746],
              [90.963435, 46.806812],
              [90.962263, 46.807009],
              [90.961057, 46.807433],
              [90.960803, 46.807523],
              [90.959276, 46.808168],
              [90.957934, 46.808733],
              [90.956933, 46.809207],
              [90.956381, 46.80951],
              [90.956157, 46.80972],
              [90.955565, 46.810405],
              [90.955131, 46.811168],
              [90.954815, 46.812076],
              [90.954565, 46.812826],
              [90.954555, 46.81293],
              [90.954446, 46.81405],
              [90.954486, 46.814406],
              [90.954459, 46.814656],
              [90.954341, 46.814761],
              [90.954078, 46.8148],
              [90.953117, 46.8148],
              [90.952321, 46.814818],
              [90.95134, 46.81484],
              [90.949972, 46.815129],
              [90.947906, 46.815498],
              [90.946721, 46.815906],
              [90.945681, 46.816445],
              [90.944787, 46.81713],
              [90.944194, 46.81788],
              [90.943642, 46.818669],
              [90.943089, 46.819446],
              [90.942655, 46.820025],
              [90.942181, 46.820538],
              [90.941707, 46.821051],
              [90.941378, 46.821288],
              [90.94043, 46.822025],
              [90.939878, 46.822394],
              [90.938983, 46.822762],
              [90.938364, 46.823447],
              [90.937798, 46.824342],
              [90.93718, 46.825355],
              [90.936969, 46.825947],
              [90.93693, 46.826329],
              [90.937035, 46.826724],
              [90.937338, 46.827474],
              [90.937562, 46.828132],
              [90.937772, 46.828948],
              [90.938088, 46.829474],
              [90.938443, 46.830014],
              [90.938522, 46.830593],
              [90.938549, 46.83104],
              [90.938312, 46.831435],
              [90.937996, 46.831909],
              [90.937535, 46.83233],
              [90.937246, 46.832738],
              [90.937167, 46.833185],
              [90.937193, 46.833501],
              [90.937496, 46.834001],
              [90.93793, 46.834475],
              [90.938377, 46.834764],
              [90.938917, 46.835409],
              [90.939378, 46.836041],
              [90.939641, 46.836344],
              [90.940009, 46.836554],
              [90.940562, 46.83687],
              [90.941431, 46.837515],
              [90.942299, 46.838055],
              [90.942865, 46.838305],
              [90.943207, 46.838436],
              [90.943549, 46.838713],
              [90.943971, 46.8392],
              [90.944221, 46.839673],
              [90.944352, 46.840068],
              [90.944721, 46.841516],
              [90.9449, 46.841825],
              [90.94501, 46.842016],
              [90.945405, 46.842292],
              [90.945971, 46.842542],
              [90.946234, 46.842726],
              [90.946366, 46.842924],
              [90.946432, 46.843569],
              [90.946497, 46.844398],
              [90.946629, 46.844898],
              [90.947129, 46.845635],
              [90.947866, 46.846385],
              [90.948958, 46.84724],
              [90.949761, 46.847741],
              [90.950367, 46.848346],
              [90.950985, 46.848925],
              [90.95134, 46.849622],
              [90.95163, 46.850254],
              [90.952104, 46.850675],
              [90.952538, 46.851096],
              [90.952775, 46.851399],
              [90.952972, 46.851833],
              [90.953078, 46.852386],
              [90.953104, 46.853149],
              [90.953012, 46.8539],
              [90.952814, 46.854623],
              [90.952643, 46.855781],
              [90.952525, 46.857111],
              [90.952591, 46.85844],
              [90.952604, 46.859782],
              [90.952775, 46.86023],
              [90.953393, 46.861125],
              [90.954315, 46.862362],
              [90.954486, 46.86273],
              [90.954486, 46.863072],
              [90.954367, 46.863467],
              [90.954157, 46.863836],
              [90.95367, 46.864546],
              [90.953091, 46.865454],
              [90.95288, 46.866007],
              [90.952735, 46.86681],
              [90.952564, 46.867915],
              [90.952433, 46.868915],
              [90.952209, 46.870179],
              [90.952169, 46.870784],
              [90.952222, 46.871192],
              [90.952512, 46.871758],
              [90.952985, 46.87235],
              [90.954143, 46.873679],
              [90.954854, 46.874469],
              [90.955104, 46.874969],
              [90.95517, 46.875298],
              [90.95517, 46.875575],
              [90.955117, 46.876009],
              [90.955012, 46.876483],
              [90.955025, 46.876877],
              [90.95517, 46.877351],
              [90.955183, 46.878088],
              [90.955196, 46.87843],
              [90.954986, 46.87872],
              [90.954683, 46.87893],
              [90.95417, 46.879167],
              [90.953288, 46.879549],
              [90.952314, 46.879931],
              [90.951801, 46.880365],
              [90.951354, 46.880931],
              [90.950919, 46.881852],
              [90.950327, 46.883234],
              [90.949959, 46.884181],
              [90.949682, 46.884642],
              [90.949537, 46.884787],
              [90.949011, 46.884918],
              [90.948195, 46.885037],
              [90.946919, 46.885287],
              [90.945484, 46.885984],
              [90.944273, 46.886708],
              [90.943655, 46.8873],
              [90.943273, 46.887985],
              [90.94297, 46.888787],
              [90.942707, 46.889511],
              [90.942576, 46.889695],
              [90.942457, 46.889748],
              [90.942194, 46.889774],
              [90.941694, 46.889695],
              [90.94047, 46.88938],
              [90.93947, 46.889103],
              [90.938443, 46.888748],
              [90.93689, 46.888472],
              [90.93593, 46.888064],
              [90.935495, 46.887616],
              [90.935285, 46.887142],
              [90.935166, 46.886958],
              [90.934995, 46.886998],
              [90.934732, 46.887235],
              [90.934443, 46.88784],
              [90.933864, 46.888695],
              [90.933495, 46.889222],
              [90.932929, 46.889827],
              [90.932653, 46.890314],
              [90.932495, 46.890761],
              [90.932495, 46.891169],
              [90.932469, 46.891538],
              [90.93235, 46.892051],
              [90.93235, 46.892999],
              [90.932258, 46.894275],
              [90.932192, 46.89492],
              [90.932034, 46.895249],
              [90.931797, 46.89542],
              [90.931403, 46.895539],
              [90.930797, 46.895565],
              [90.929902, 46.895683],
              [90.92935, 46.895815],
              [90.928665, 46.89617],
              [90.928099, 46.896552],
              [90.927823, 46.896842],
              [90.927494, 46.897197],
              [90.926954, 46.897671],
              [90.926625, 46.898158],
              [90.926244, 46.898605],
              [90.925967, 46.899066],
              [90.925638, 46.8995],
              [90.925388, 46.899671],
              [90.924954, 46.899829],
              [90.924217, 46.900316],
              [90.923907, 46.900641],
              [90.923414, 46.901158],
              [90.922546, 46.902079],
              [90.922401, 46.902329],
              [90.922335, 46.902711],
              [90.922388, 46.902987],
              [90.922533, 46.903172],
              [90.922651, 46.903356],
              [90.922664, 46.903448],
              [90.922598, 46.90354],
              [90.922256, 46.903751],
              [90.92173, 46.904185],
              [90.92119, 46.904803],
              [90.920914, 46.905343],
              [90.920703, 46.906001],
              [90.920427, 46.906541],
              [90.920243, 46.907054],
              [90.919874, 46.907607],
              [90.919492, 46.908173],
              [90.919163, 46.908659],
              [90.918979, 46.90912],
              [90.918571, 46.909844],
              [90.918466, 46.910028],
              [90.918269, 46.91016],
              [90.9179, 46.910344],
              [90.917045, 46.910897],
              [90.916571, 46.911436],
              [90.916202, 46.912002],
              [90.916018, 46.912489],
              [90.915873, 46.913147],
              [90.915794, 46.913463],
              [90.915597, 46.913739],
              [90.915386, 46.914147],
              [90.9149, 46.914976],
              [90.914518, 46.9157],
              [90.913952, 46.916766],
              [90.913294, 46.917885],
              [90.913057, 46.918451],
              [90.912965, 46.918977],
              [90.91286, 46.919556],
              [90.91286, 46.920333],
              [90.912873, 46.921162],
              [90.912991, 46.922386],
              [90.913031, 46.923241],
              [90.913399, 46.923952],
              [90.913685, 46.924357],
              [90.913899, 46.924662],
              [90.91432, 46.925162],
              [90.914847, 46.925531],
              [90.91561, 46.926057],
              [90.916479, 46.926478],
              [90.916887, 46.926702],
              [90.916887, 46.926794],
              [90.916808, 46.926873],
              [90.916571, 46.927071],
              [90.915952, 46.927663],
              [90.915492, 46.928242],
              [90.915281, 46.928781],
              [90.915229, 46.929334],
              [90.91536, 46.929874],
              [90.915834, 46.930611],
              [90.916479, 46.931572],
              [90.916584, 46.931914],
              [90.916584, 46.932111],
              [90.916584, 46.932374],
              [90.916624, 46.932585],
              [90.916847, 46.932901],
              [90.917022, 46.933176],
              [90.917646, 46.934626],
              [90.918017, 46.935098],
              [90.918758, 46.935469],
              [90.920259, 46.93616],
              [90.921354, 46.936632],
              [90.921688, 46.936861],
              [90.921739, 46.937033],
              [90.921692, 46.937188],
              [90.92154, 46.93734],
              [90.921284, 46.937548],
              [90.920941, 46.937938],
              [90.920781, 46.938267],
              [90.920691, 46.938559],
              [90.920663, 46.93884],
              [90.920658, 46.93894],
              [90.920621, 46.939005],
              [90.920562, 46.939042],
              [90.920326, 46.939127],
              [90.919702, 46.939261],
              [90.918084, 46.939868],
              [90.917494, 46.94002],
              [90.91655, 46.94002],
              [90.915623, 46.940037],
              [90.914274, 46.940138],
              [90.912521, 46.940425],
              [90.911493, 46.940795],
              [90.910549, 46.941352],
              [90.909723, 46.941807],
              [90.908846, 46.942346],
              [90.908071, 46.943206],
              [90.907666, 46.943762],
              [90.907312, 46.94442],
              [90.907127, 46.944791],
              [90.906942, 46.944976],
              [90.906301, 46.945617],
              [90.905475, 46.946493],
              [90.905256, 46.946763],
              [90.905205, 46.947117],
              [90.905087, 46.948061],
              [90.904447, 46.949039],
              [90.903975, 46.949527],
              [90.903031, 46.950623],
              [90.90239, 46.951517],
              [90.902205, 46.951955],
              [90.902154, 46.952562],
              [90.902087, 46.953135],
              [90.902104, 46.953438],
              [90.902154, 46.953792],
              [90.902104, 46.954214],
              [90.901952, 46.954703],
              [90.901783, 46.955124],
              [90.901615, 46.955815],
              [90.901581, 46.956456],
              [90.901665, 46.956877],
              [90.90175, 46.95713],
              [90.901699, 46.957197],
              [90.901598, 46.957214],
              [90.901396, 46.957214],
              [90.901025, 46.957079],
              [90.900587, 46.957029],
              [90.899963, 46.957029],
              [90.899051062000012, 46.957142992],
              [90.899019, 46.957147],
              [90.898665, 46.956961],
              [90.897942323999985, 46.957242807],
              [90.89767, 46.957349],
              [90.896406, 46.957703],
              [90.895395, 46.958108],
              [90.894703, 46.958495],
              [90.893743, 46.959068],
              [90.893068, 46.959608],
              [90.892714, 46.960198],
              [90.892225, 46.960956],
              [90.891905, 46.961631],
              [90.891635, 46.96249],
              [90.891551, 46.962828],
              [90.891551, 46.962979],
              [90.891383, 46.963131],
              [90.890843, 46.963283],
              [90.890135, 46.963333],
              [90.888129, 46.963586],
              [90.887472, 46.963721],
              [90.886966, 46.964041],
              [90.886241, 46.964665],
              [90.885466, 46.965373],
              [90.884859, 46.965946],
              [90.884589, 46.966182],
              [90.884353, 46.966266],
              [90.883746, 46.966418],
              [90.882111, 46.966755],
              [90.880324, 46.967177],
              [90.877931, 46.967851],
              [90.876885, 46.968188],
              [90.876194, 46.968576],
              [90.875149, 46.969065],
              [90.873801, 46.96957],
              [90.871862, 46.970329],
              [90.870547, 46.971054],
              [90.868457, 46.972183],
              [90.86785, 46.972588],
              [90.867361, 46.97311],
              [90.866721, 46.973802],
              [90.866232, 46.97429],
              [90.865777, 46.974611],
              [90.865136, 46.974931],
              [90.864411, 46.97542],
              [90.863518, 46.975993],
              [90.862119, 46.976532],
              [90.860146, 46.977173],
              [90.857786, 46.977915],
              [90.856404, 46.978589],
              [90.854415, 46.979415],
              [90.85401, 46.979702],
              [90.853724, 46.980039],
              [90.853589, 46.980511],
              [90.853454, 46.981185],
              [90.85337, 46.982078],
              [90.853218, 46.982972],
              [90.853134, 46.983343],
              [90.852898, 46.983966],
              [90.852645, 46.984624],
              [90.852375, 46.985736],
              [90.852072, 46.98727],
              [90.852055, 46.987995],
              [90.85219, 46.988535],
              [90.852257, 46.988804],
              [90.852224, 46.988872],
              [90.851937, 46.988872],
              [90.851785, 46.988804],
              [90.85074, 46.98845],
              [90.84966684, 46.988200236000012],
              [90.848785, 46.987995],
              [90.847032, 46.98749],
              [90.844655, 46.987034],
              [90.84248, 46.986714],
              [90.8413, 46.986647],
              [90.841282830000011, 46.986650557000019],
              [90.840407, 46.986832],
              [90.839699, 46.987001],
              [90.839304, 46.987144],
              [90.838957, 46.98727],
              [90.837659, 46.987894],
              [90.836782, 46.98845],
              [90.836659, 46.98856],
              [90.836074, 46.989074],
              [90.835636, 46.989479],
              [90.835468, 46.989529],
              [90.835013, 46.989529],
              [90.833765, 46.989479],
              [90.832821817000024, 46.989432362],
              [90.832046, 46.989394],
              [90.831068, 46.98931],
              [90.830907, 46.989321],
              [90.829787, 46.989394],
              [90.829247, 46.98954],
              [90.829163, 46.989563],
              [90.828748709000024, 46.989715769999975],
              [90.828523, 46.989799],
              [90.827916, 46.990254],
              [90.827107, 46.990979],
              [90.826011, 46.992041],
              [90.825016, 46.993052],
              [90.824173, 46.993946],
              [90.823263, 46.994789],
              [90.822842, 46.995615],
              [90.821847, 46.997385],
              [90.821105, 46.998767],
              [90.820903, 46.998952],
              [90.820583, 46.999037],
              [90.819083, 46.998885],
              [90.816706, 46.998565],
              [90.813756, 46.997958],
              [90.810233, 46.997149],
              [90.807283, 46.996424],
              [90.803642, 46.995699],
              [90.801686, 46.995345],
              [90.801046, 46.995176],
              [90.80059, 46.995244],
              [90.799141, 46.99553],
              [90.797674, 46.995733],
              [90.796882, 46.995733],
              [90.796022, 46.995598],
              [90.794707, 46.995345],
              [90.792904, 46.99494],
              [90.791386, 46.994671],
              [90.789515, 46.99403],
              [90.78905, 46.993793],
              [90.788622, 46.993575],
              [90.787543, 46.993288],
              [90.786835, 46.99317],
              [90.785638, 46.992884],
              [90.784559, 46.992665],
              [90.783547, 46.992339],
              [90.782573, 46.992105],
              [90.781317, 46.991848],
              [90.780455, 46.991711],
              [90.779191, 46.991654],
              [90.776984, 46.99163],
              [90.77481, 46.99159],
              [90.772499, 46.991646],
              [90.770695, 46.991743],
              [90.769543, 46.991856],
              [90.767498, 46.991993],
              [90.766394, 46.991993],
              [90.765356, 46.992121],
              [90.764494, 46.992266],
              [90.763326, 46.992596],
              [90.76232, 46.992991],
              [90.761345, 46.993668],
              [90.760564, 46.99432],
              [90.760145, 46.994674],
              [90.760008, 46.99494],
              [90.75996, 46.995399],
              [90.759936, 46.996301],
              [90.759912, 46.996897],
              [90.760065, 46.997622],
              [90.760282, 46.998507],
              [90.760258, 46.998741],
              [90.760258, 46.998862],
              [90.760218, 46.99895],
              [90.760113, 46.999055],
              [90.759888, 46.999192],
              [90.759324, 46.99957],
              [90.759002, 46.999796],
              [90.758792, 47.000142],
              [90.758752, 47.000416],
              [90.758752, 47.000617],
              [90.758881, 47.000843],
              [90.758948, 47.000922],
              [90.759259, 47.001294],
              [90.759984, 47.001849],
              [90.761313, 47.002929],
              [90.762408, 47.003814],
              [90.763366, 47.004539],
              [90.763624, 47.004773],
              [90.763632, 47.004902],
              [90.763568, 47.004998],
              [90.763358, 47.005135],
              [90.763012, 47.005401],
              [90.762513, 47.005876],
              [90.761925, 47.006367],
              [90.761128, 47.006907],
              [90.760604, 47.007189],
              [90.760306, 47.007511],
              [90.760089, 47.008131],
              [90.759968, 47.00863],
              [90.759791, 47.009677],
              [90.759718, 47.010112],
              [90.759574, 47.010313],
              [90.759259, 47.0107],
              [90.7588, 47.011006],
              [90.75818, 47.011368],
              [90.756755, 47.011996],
              [90.755805, 47.012431],
              [90.755466, 47.012673],
              [90.755338, 47.012866],
              [90.755233, 47.01322],
              [90.754862, 47.013865],
              [90.754299, 47.014863],
              [90.753783, 47.015516],
              [90.753163, 47.016047],
              [90.752696, 47.016756],
              [90.752439, 47.017263],
              [90.751601, 47.018173],
              [90.750788, 47.018994],
              [90.750055, 47.01955],
              [90.748976, 47.020227],
              [90.748154, 47.020702],
              [90.747421, 47.021354],
              [90.747059, 47.021773],
              [90.746817, 47.022216],
              [90.746576, 47.022473],
              [90.746213, 47.022642],
              [90.745473, 47.022908],
              [90.744224, 47.023359],
              [90.743717, 47.023665],
              [90.743379, 47.024148],
              [90.742751, 47.024865],
              [90.741672, 47.026097],
              [90.741301, 47.02658],
              [90.741188, 47.026677],
              [90.740745, 47.026653],
              [90.740037, 47.026452],
              [90.739328, 47.026323],
              [90.738418, 47.026226],
              [90.737693966999984, 47.026072869000018],
              [90.737009, 47.025928],
              [90.735261, 47.02563],
              [90.734883, 47.025606],
              [90.734455, 47.025545],
              [90.733538, 47.025413],
              [90.732773, 47.025453],
              [90.732501623000019, 47.025482604999979],
              [90.732113, 47.025525],
              [90.731581, 47.025703],
              [90.731162, 47.026009],
              [90.730816, 47.026443],
              [90.730438, 47.027031],
              [90.729664, 47.027901],
              [90.729205, 47.028473],
              [90.728956, 47.028714],
              [90.728706, 47.028835],
              [90.728312, 47.028932],
              [90.727836, 47.029182],
              [90.72753, 47.029504],
              [90.727305, 47.029834],
              [90.7272, 47.030253],
              [90.727257, 47.030704],
              [90.727329, 47.031146],
              [90.727504, 47.031736],
              [90.727506, 47.031742],
              [90.727756, 47.032628],
              [90.728078, 47.033619],
              [90.728271, 47.03436],
              [90.728287, 47.034529],
              [90.728239, 47.034625],
              [90.728014, 47.034714],
              [90.727514, 47.034867],
              [90.726403, 47.035302],
              [90.72563, 47.035648],
              [90.724897, 47.036027],
              [90.724478, 47.036357],
              [90.723915, 47.036977],
              [90.723423, 47.037822],
              [90.723061, 47.038773],
              [90.72286, 47.039425],
              [90.722723, 47.039675],
              [90.722376, 47.039981],
              [90.721579, 47.040456],
              [90.720605, 47.040883],
              [90.720025, 47.041374],
              [90.719461, 47.042155],
              [90.718978, 47.043073],
              [90.718551, 47.043943],
              [90.718261, 47.04474],
              [90.718124, 47.045368],
              [90.718116, 47.045916],
              [90.718141, 47.046544],
              [90.718052, 47.047583],
              [90.718165, 47.048082],
              [90.718197, 47.048332],
              [90.718157, 47.048485],
              [90.718028, 47.048614],
              [90.717722, 47.048767],
              [90.717174, 47.048968],
              [90.716385, 47.049371],
              [90.715193, 47.049991],
              [90.713921, 47.050723],
              [90.713462, 47.051134],
              [90.713309, 47.051199],
              [90.712906, 47.051223],
              [90.712077, 47.051287],
              [90.71115, 47.05136],
              [90.709846, 47.051537],
              [90.708743, 47.051843],
              [90.708098, 47.052197],
              [90.707583, 47.052551],
              [90.707092, 47.05318],
              [90.706882, 47.053494],
              [90.706794, 47.053872],
              [90.706729, 47.054267],
              [90.706592, 47.054814],
              [90.70619, 47.055668],
              [90.705908, 47.056224],
              [90.70565, 47.05657],
              [90.705296, 47.056924],
              [90.704877, 47.057391],
              [90.704265, 47.0581],
              [90.704024, 47.058462],
              [90.703967, 47.058656],
              [90.703927, 47.059018],
              [90.703895, 47.059751],
              [90.70379, 47.060025],
              [90.70341, 47.060949],
              [90.702969, 47.061909],
              [90.702791, 47.062368],
              [90.702703, 47.062521],
              [90.70259, 47.062602],
              [90.702266, 47.062839],
              [90.701809, 47.063133],
              [90.700851, 47.063745],
              [90.699763, 47.064494],
              [90.698829, 47.06534],
              [90.698306, 47.065815],
              [90.697364, 47.066709],
              [90.696381, 47.067643],
              [90.69556, 47.068279],
              [90.694706, 47.069125],
              [90.694006, 47.069785],
              [90.693474, 47.070228],
              [90.693265, 47.070453],
              [90.693128, 47.070784],
              [90.692934, 47.071243],
              [90.692701, 47.071645],
              [90.692298, 47.072072],
              [90.691904, 47.072531],
              [90.691582, 47.072982],
              [90.69138, 47.073497],
              [90.691276, 47.0739],
              [90.691195, 47.074778],
              [90.691276, 47.075205],
              [90.691348, 47.075301],
              [90.691276, 47.075374],
              [90.691171, 47.075438],
              [90.690962, 47.075567],
              [90.690688, 47.07593],
              [90.690172, 47.07655],
              [90.689794, 47.077266],
              [90.689439, 47.078297],
              [90.68936, 47.078786],
              [90.689325, 47.079249],
              [90.689467, 47.079659],
              [90.689717, 47.07998],
              [90.690305, 47.080443],
              [90.690982, 47.080978],
              [90.691089, 47.081067],
              [90.691035, 47.081138],
              [90.690786, 47.081156],
              [90.690376, 47.081156],
              [90.689681, 47.081281],
              [90.688648, 47.081548],
              [90.68724, 47.082065],
              [90.685761, 47.082938],
              [90.683943, 47.084078],
              [90.683017, 47.084791],
              [90.682785, 47.085219],
              [90.682571, 47.085432],
              [90.682126, 47.085664],
              [90.681057, 47.086092],
              [90.679702, 47.08668],
              [90.678419, 47.087375],
              [90.677404, 47.087909],
              [90.676727, 47.088444],
              [90.676103, 47.088765],
              [90.674838, 47.089531],
              [90.673305, 47.090529],
              [90.671933, 47.091348],
              [90.671648, 47.09142],
              [90.671114, 47.091473],
              [90.670579, 47.091598],
              [90.66992, 47.091829],
              [90.669189, 47.09199],
              [90.667888, 47.092311],
              [90.666498, 47.092899],
              [90.665786, 47.093237],
              [90.665405, 47.093434],
              [90.665007, 47.093524],
              [90.664663, 47.09354],
              [90.664529, 47.093534],
              [90.664431, 47.093683],
              [90.664141, 47.09428],
              [90.66363, 47.095304],
              [90.663416, 47.095874],
              [90.663286, 47.09602],
              [90.663077, 47.09616],
              [90.662507, 47.096427],
              [90.661955, 47.096783],
              [90.661616, 47.097157],
              [90.661171, 47.097514],
              [90.660761, 47.097817],
              [90.660333, 47.098316],
              [90.659959, 47.09885],
              [90.659816, 47.099278],
              [90.65962, 47.099795],
              [90.659442, 47.099937],
              [90.659371, 47.10024],
              [90.659356, 47.100923],
              [90.659411, 47.101362],
              [90.659459, 47.101752],
              [90.65963, 47.102158],
              [90.659911, 47.102519],
              [90.660397, 47.102979],
              [90.66076, 47.103294],
              [90.660867, 47.103514],
              [90.660863, 47.103664],
              [90.66076, 47.10378],
              [90.660466, 47.104191],
              [90.659979, 47.104965],
              [90.659691, 47.105178],
              [90.659328, 47.105363],
              [90.658582, 47.105596],
              [90.657218, 47.106089],
              [90.656142, 47.106747],
              [90.654868, 47.107315],
              [90.653333, 47.10785],
              [90.652023, 47.108406],
              [90.651929, 47.108446],
              [90.650983, 47.108939],
              [90.649894, 47.109604],
              [90.649414, 47.110268],
              [90.648859, 47.111255],
              [90.648441, 47.112022],
              [90.648325, 47.112434],
              [90.648325, 47.11268],
              [90.648463, 47.112897],
              [90.648753, 47.113199],
              [90.649031, 47.113539],
              [90.649109, 47.11365],
              [90.649343, 47.113982],
              [90.649567, 47.114368],
              [90.649915, 47.114718],
              [90.650328, 47.11517],
              [90.650651, 47.115824],
              [90.65086, 47.116186],
              [90.65093, 47.11634],
              [90.650839, 47.116613],
              [90.650532, 47.117055],
              [90.650161, 47.118079],
              [90.650031, 47.118524],
              [90.649928, 47.118929],
              [90.649976, 47.119121],
              [90.650091, 47.119269],
              [90.650479, 47.119783],
              [90.651127, 47.120756],
              [90.65134, 47.121114],
              [90.651436, 47.121409],
              [90.651415, 47.121758],
              [90.651333, 47.122183],
              [90.651113, 47.123375],
              [90.650887, 47.12478],
              [90.65086, 47.12613],
              [90.650999, 47.126606],
              [90.651004, 47.127137],
              [90.651018, 47.127315],
              [90.651011, 47.128068],
              [90.651238, 47.128548],
              [90.651828, 47.12992],
              [90.652011, 47.130398],
              [90.652073, 47.13083],
              [90.65199, 47.131076],
              [90.651799, 47.131398],
              [90.651415, 47.131864],
              [90.651031, 47.13246],
              [90.650894, 47.132734],
              [90.650764, 47.132858],
              [90.650579, 47.132892],
              [90.650154, 47.132823],
              [90.649318, 47.132748],
              [90.648407, 47.132782],
              [90.647226484999976, 47.132915427],
              [90.647071, 47.132933],
              [90.646304, 47.132988],
              [90.645139, 47.132974],
              [90.644474, 47.132919],
              [90.644015, 47.133008],
              [90.643371, 47.133228],
              [90.64172, 47.133577],
              [90.639829, 47.133755],
              [90.638014, 47.133892],
              [90.636458, 47.133906],
              [90.634197, 47.133714],
              [90.633213, 47.133729],
              [90.632854, 47.133735],
              [90.631443, 47.133947],
              [90.630004, 47.134118],
              [90.629381, 47.134296],
              [90.62875, 47.134687],
              [90.628333261000023, 47.135100387000023],
              [90.628004, 47.135427],
              [90.627558, 47.136222],
              [90.627229, 47.137071],
              [90.627065, 47.137948],
              [90.62699, 47.138647],
              [90.627003, 47.139312],
              [90.627059, 47.139748],
              [90.627092, 47.140011],
              [90.627243, 47.140655],
              [90.627565, 47.141353],
              [90.627962, 47.141833],
              [90.628394, 47.142251],
              [90.628915, 47.142731],
              [90.629168, 47.142895],
              [90.629257, 47.142977],
              [90.629278, 47.143039],
              [90.629196, 47.143087],
              [90.62899, 47.143114],
              [90.628709, 47.143155],
              [90.628175, 47.14334],
              [90.626743, 47.143751],
              [90.625503, 47.144101],
              [90.624756, 47.14432],
              [90.624085, 47.14432],
              [90.623667, 47.144526],
              [90.623525937000011, 47.144650038],
              [90.623172571, 47.144960756999978],
              [90.623029, 47.145087],
              [90.62205, 47.145903],
              [90.621104, 47.14693],
              [90.620878, 47.147143],
              [90.620707, 47.147348],
              [90.620529, 47.147609],
              [90.62051, 47.147882],
              [90.620569, 47.148489],
              [90.620618, 47.149157],
              [90.620623, 47.149717],
              [90.620681, 47.150354],
              [90.620679, 47.150939],
              [90.620673, 47.151576],
              [90.620618, 47.151788],
              [90.620713, 47.152054],
              [90.620938, 47.152355],
              [90.621052, 47.152712],
              [90.621023, 47.153376],
              [90.621152, 47.153881],
              [90.621262, 47.154467],
              [90.621275, 47.15483],
              [90.621125, 47.155186],
              [90.620844, 47.155693],
              [90.620501, 47.156358],
              [90.620159, 47.156879],
              [90.619501, 47.157605],
              [90.61848, 47.15866],
              [90.617308, 47.159297],
              [90.616897, 47.159469],
              [90.616562, 47.15953],
              [90.615774, 47.15951],
              [90.614930947, 47.159549095999978],
              [90.614588, 47.159565],
              [90.613622, 47.159585],
              [90.613273, 47.159729],
              [90.613026, 47.15975],
              [90.612766, 47.15964],
              [90.612478, 47.159619],
              [90.612184, 47.159695],
              [90.611601, 47.159804],
              [90.610889, 47.159928],
              [90.610128, 47.160106],
              [90.609203, 47.1604],
              [90.608093, 47.16077],
              [90.606977, 47.161017],
              [90.606513, 47.161224],
              [90.60601, 47.161449],
              [90.605943188000026, 47.161478338],
              [90.605427, 47.161705],
              [90.604935, 47.161921],
              [90.604702, 47.1621],
              [90.604519, 47.162373],
              [90.604202, 47.162812],
              [90.604051, 47.163038],
              [90.603914, 47.163148],
              [90.603599, 47.163244],
              [90.602811, 47.163436],
              [90.601742, 47.163655],
              [90.600703776999978, 47.163870734999989],
              [90.600048, 47.164007],
              [90.599815, 47.164081],
              [90.598713, 47.164681],
              [90.598235362000025, 47.165003050999985],
              [90.597132, 47.165747],
              [90.596667, 47.166102],
              [90.595944, 47.16658],
              [90.59505, 47.166898],
              [90.59429, 47.167131],
              [90.594131, 47.167278],
              [90.594008, 47.167658],
              [90.593984, 47.168283],
              [90.593947, 47.169447],
              [90.593592, 47.170549],
              [90.593261, 47.171198],
              [90.592832, 47.172178],
              [90.592771, 47.172754],
              [90.59293, 47.173808],
              [90.593004, 47.174077],
              [90.593077, 47.174322],
              [90.592979, 47.174445],
              [90.592681, 47.17464],
              [90.592379, 47.175008],
              [90.591754, 47.175756],
              [90.591338, 47.176307],
              [90.591044, 47.176969],
              [90.590958, 47.177593],
              [90.590977, 47.177993],
              [90.590982, 47.17812],
              [90.591264, 47.178818],
              [90.591571, 47.179639],
              [90.591583, 47.18008],
              [90.591497, 47.18035],
              [90.591325, 47.180558],
              [90.591129, 47.180742],
              [90.590615, 47.181109],
              [90.589831, 47.181636],
              [90.589022, 47.182163],
              [90.588667, 47.182543],
              [90.588287, 47.182984],
              [90.587479, 47.183768],
              [90.58667, 47.184944],
              [90.586254, 47.185912],
              [90.586058, 47.186696],
              [90.585972, 47.186892],
              [90.585825, 47.187271],
              [90.585494, 47.187712],
              [90.585396, 47.187994],
              [90.585212, 47.188484],
              [90.585029, 47.189477],
              [90.584931, 47.190506],
              [90.584869, 47.191081],
              [90.584735, 47.191265],
              [90.584379, 47.191645],
              [90.583142, 47.192686],
              [90.582064, 47.193519],
              [90.581525, 47.194009],
              [90.581231, 47.194463],
              [90.581219, 47.194867],
              [90.581304, 47.195198],
              [90.581623, 47.195786],
              [90.58237, 47.196423],
              [90.583019, 47.196815],
              [90.583056, 47.196913],
              [90.58297, 47.196937],
              [90.582713, 47.196974],
              [90.581782, 47.196901],
              [90.57992, 47.19679],
              [90.579271, 47.196778],
              [90.578879, 47.197035],
              [90.57845, 47.197391],
              [90.576723, 47.19842],
              [90.575399, 47.199032],
              [90.575201452999977, 47.199081454],
              [90.574664, 47.199216],
              [90.57366, 47.199277],
              [90.573268, 47.199277],
              [90.572668, 47.199473],
              [90.572612, 47.199498],
              [90.571908, 47.199816],
              [90.57132, 47.200331],
              [90.570903, 47.20087],
              [90.570585, 47.201188],
              [90.570279, 47.201335],
              [90.569433, 47.201593],
              [90.567522, 47.202266],
              [90.566554, 47.202585],
              [90.565256, 47.203087],
              [90.564472, 47.203308],
              [90.563553, 47.203406],
              [90.562169, 47.203602],
              [90.560564, 47.204043],
              [90.559351, 47.204606],
              [90.55902, 47.204876],
              [90.559008, 47.205145],
              [90.55902, 47.205574],
              [90.559041176, 47.205875643000013],
              [90.559069, 47.206272],
              [90.559057, 47.207681],
              [90.559081, 47.208049],
              [90.55913, 47.208906],
              [90.559253, 47.209641],
              [90.55951, 47.210021],
              [90.559633, 47.210634],
              [90.559645, 47.211259],
              [90.559535, 47.211871],
              [90.559363, 47.212422],
              [90.559143, 47.2135],
              [90.559057, 47.214419],
              [90.558947, 47.215203],
              [90.559118, 47.216024],
              [90.559142, 47.216204],
              [90.559216, 47.216759],
              [90.559192, 47.21747],
              [90.55913, 47.218033],
              [90.558836, 47.218915],
              [90.55864, 47.220177],
              [90.55853, 47.22063],
              [90.558518, 47.221071],
              [90.558359, 47.222052],
              [90.558212, 47.222897],
              [90.55804, 47.223166],
              [90.557795, 47.223485],
              [90.557648, 47.224232],
              [90.557636, 47.224869],
              [90.557783, 47.225298],
              [90.557844, 47.225457],
              [90.557722, 47.225531],
              [90.557587, 47.225494],
              [90.557195, 47.225555],
              [90.556766, 47.225813],
              [90.55669615, 47.225851222000017],
              [90.555357, 47.226584],
              [90.553801, 47.22743],
              [90.552478, 47.228532],
              [90.551278, 47.229733],
              [90.550567, 47.230603],
              [90.550126, 47.231436],
              [90.549342, 47.232612],
              [90.548766, 47.233347],
              [90.548092, 47.23407],
              [90.54748, 47.235013],
              [90.547357, 47.235209],
              [90.547125, 47.235307],
              [90.54653, 47.235498],
              [90.545336, 47.235883],
              [90.543523, 47.236495],
              [90.541048, 47.237377],
              [90.539223, 47.23821],
              [90.537593, 47.239031],
              [90.536822, 47.239607],
              [90.53665, 47.240036],
              [90.53665, 47.240325918],
              [90.53665, 47.240697],
              [90.536564, 47.241445],
              [90.536662, 47.242351],
              [90.536871, 47.243037],
              [90.537177, 47.243564],
              [90.537422, 47.243956],
              [90.53763, 47.245279],
              [90.537667, 47.246161],
              [90.537642, 47.247374],
              [90.537765, 47.248232],
              [90.538071, 47.249261],
              [90.538385, 47.250134],
              [90.538524, 47.250522],
              [90.538524, 47.250743],
              [90.538377, 47.250902],
              [90.538194, 47.251025],
              [90.537985, 47.251306],
              [90.537802, 47.251564],
              [90.537557, 47.251784],
              [90.537439, 47.251834],
              [90.537005, 47.252017],
              [90.536700395000025, 47.25232160500002],
              [90.536307, 47.252715],
              [90.534212, 47.254038],
              [90.532583, 47.25481],
              [90.530806, 47.255705],
              [90.529324, 47.256709],
              [90.529165, 47.256966],
              [90.529116, 47.257371],
              [90.52912166599998, 47.25769491],
              [90.529128, 47.258057],
              [90.529067, 47.259331],
              [90.529079, 47.25998],
              [90.529202, 47.260139],
              [90.529753, 47.260409],
              [90.530672, 47.261095],
              [90.531085, 47.261336],
              [90.531113, 47.261352],
              [90.531168, 47.261649],
              [90.531073, 47.261996],
              [90.530884, 47.262974],
              [90.5306, 47.263857],
              [90.530632, 47.264457],
              [90.530537, 47.26534],
              [90.5306, 47.266129],
              [90.530736, 47.266516],
              [90.530901, 47.267012],
              [90.530901, 47.267492],
              [90.530752, 47.268038],
              [90.530603, 47.268385],
              [90.53019, 47.268832],
              [90.529528, 47.269262],
              [90.529210791000025, 47.269464087000017],
              [90.528255, 47.270073],
              [90.527461, 47.270552],
              [90.526997, 47.271098],
              [90.52686, 47.271247],
              [90.526402, 47.271743],
              [90.52574, 47.272124],
              [90.524334, 47.272752],
              [90.523292, 47.273265],
              [90.522333, 47.273463],
              [90.521936, 47.273695],
              [90.521704, 47.274241],
              [90.521638, 47.274621],
              [90.521578358, 47.274942204000013],
              [90.521555, 47.275068],
              [90.521241, 47.275514],
              [90.521059, 47.275911],
              [90.521059, 47.276226],
              [90.521241, 47.276755],
              [90.521283, 47.276978],
              [90.521373, 47.277334],
              [90.521506, 47.277549],
              [90.521638, 47.277946],
              [90.521754, 47.27826],
              [90.521853, 47.278757],
              [90.522032, 47.279439],
              [90.522184, 47.280146],
              [90.522449, 47.28089],
              [90.522912, 47.281701],
              [90.523176, 47.282462],
              [90.523276, 47.282991],
              [90.52321, 47.283405],
              [90.522978, 47.283768],
              [90.522692571, 47.283958526],
              [90.522581, 47.284033],
              [90.521704, 47.284612],
              [90.521125, 47.285042],
              [90.520331, 47.285935],
              [90.519306, 47.286994],
              [90.518859, 47.287507],
              [90.518181, 47.288036],
              [90.517486, 47.288747],
              [90.517122, 47.289277],
              [90.516891, 47.289425],
              [90.516295, 47.289459],
              [90.515336, 47.289492],
              [90.514625, 47.289558],
              [90.514029, 47.289822],
              [90.51345, 47.290286],
              [90.512772, 47.290848],
              [90.512028, 47.291609],
              [90.511515, 47.292304],
              [90.51087, 47.292949],
              [90.510655, 47.29318],
              [90.510556, 47.293478],
              [90.510556, 47.293825],
              [90.510556, 47.294107],
              [90.510556, 47.294233576000011],
              [90.510556, 47.294371],
              [90.510556, 47.294702],
              [90.510638, 47.295132],
              [90.510771, 47.296075],
              [90.511234, 47.296985],
              [90.511763, 47.297928],
              [90.511829, 47.298275],
              [90.511813, 47.298573],
              [90.511697, 47.298837],
              [90.511302167, 47.299048487],
              [90.511234, 47.299085],
              [90.510407, 47.299416],
              [90.508753, 47.300227],
              [90.506718, 47.30112],
              [90.505163, 47.301864],
              [90.504783, 47.302212],
              [90.504254, 47.302857],
              [90.503526, 47.303833],
              [90.502881, 47.304709],
              [90.502533, 47.305057],
              [90.502004, 47.305239],
              [90.501144, 47.305338],
              [90.499986, 47.305553],
              [90.498415, 47.305801],
              [90.49686, 47.305867],
              [90.495718, 47.3059],
              [90.494941, 47.305933],
              [90.49466, 47.305801],
              [90.494577, 47.305818],
              [90.494577, 47.305884],
              [90.49461, 47.306066],
              [90.494676, 47.30638],
              [90.494656422999981, 47.306595941000012],
              [90.494643, 47.306744],
              [90.49461, 47.307141],
              [90.494527, 47.307637],
              [90.494428, 47.30858],
              [90.494494, 47.309969],
              [90.494544, 47.311243],
              [90.494577, 47.312054],
              [90.494329, 47.312451],
              [90.493982, 47.312765],
              [90.493585, 47.312947],
              [90.49284, 47.313046],
              [90.492055060999974, 47.312986497999987],
              [90.491534, 47.312947],
              [90.489697, 47.312632],
              [90.487977, 47.312368],
              [90.486488, 47.312484],
              [90.485446, 47.312484],
              [90.48467, 47.312514],
              [90.484123, 47.312616],
              [90.483908, 47.312881],
              [90.483746, 47.313188],
              [90.483578073, 47.313542263999977],
              [90.483445, 47.313823],
              [90.482982, 47.31475],
              [90.482568, 47.31513],
              [90.481956, 47.31561],
              [90.480583, 47.31647],
              [90.479988, 47.316999],
              [90.479556, 47.317417],
              [90.479045, 47.317893],
              [90.478600491, 47.318782017999979],
              [90.478433, 47.319117],
              [90.477672, 47.321168],
              [90.477077, 47.322838],
              [90.476878, 47.323153],
              [90.476911, 47.323252],
              [90.477159, 47.323252],
              [90.47797, 47.323202],
              [90.478582, 47.323252],
              [90.479359, 47.323516],
              [90.480567, 47.323665],
              [90.481675, 47.323583],
              [90.482486, 47.323467],
              [90.48323, 47.323434],
              [90.483892, 47.323516],
              [90.484867, 47.323665],
              [90.485612, 47.323814],
              [90.486406, 47.324029],
              [90.487365, 47.324261],
              [90.48854, 47.324707],
              [90.489069, 47.324922],
              [90.489565, 47.325303],
              [90.490128, 47.325783],
              [90.490574, 47.326047],
              [90.490938, 47.326229],
              [90.491352, 47.326444],
              [90.491666, 47.326858],
              [90.49198, 47.327155],
              [90.492327, 47.327701],
              [90.492708, 47.328264],
              [90.493055, 47.328677],
              [90.493403, 47.329008],
              [90.494064, 47.329488],
              [90.494412, 47.329752],
              [90.495007, 47.330133],
              [90.496314, 47.330795],
              [90.496694, 47.331175],
              [90.496694, 47.33144],
              [90.496612, 47.331853],
              [90.496512, 47.332349],
              [90.496496, 47.332763],
              [90.49638, 47.333226],
              [90.49633, 47.333342],
              [90.496397, 47.333474],
              [90.496661, 47.333623],
              [90.497141, 47.334053],
              [90.497935, 47.334549],
              [90.498613, 47.335161],
              [90.499175, 47.335525],
              [90.499972, 47.336007],
              [90.500598, 47.336385],
              [90.501789, 47.336865],
              [90.503013, 47.337113],
              [90.504998, 47.337676],
              [90.50566, 47.337841],
              [90.505775, 47.338006],
              [90.505775, 47.338321],
              [90.505726, 47.3388],
              [90.505527, 47.33933],
              [90.504899, 47.340058],
              [90.504855142, 47.340164748],
              [90.504634, 47.340703],
              [90.504303, 47.341612],
              [90.503906, 47.342737],
              [90.50376961500001, 47.343455087],
              [90.503642, 47.344127],
              [90.503195, 47.345715],
              [90.503063, 47.346608],
              [90.50298, 47.346839],
              [90.502896, 47.346924],
              [90.502798, 47.347021],
              [90.502471293999974, 47.347161286000016],
              [90.502451, 47.34717],
              [90.502202, 47.347402],
              [90.501905, 47.347848],
              [90.501739, 47.348163],
              [90.501557, 47.348245],
              [90.501144, 47.348328],
              [90.49992, 47.348543],
              [90.499142, 47.34889],
              [90.497985, 47.349304],
              [90.49767, 47.349453],
              [90.497588, 47.349651],
              [90.497554, 47.350065],
              [90.497547543999985, 47.350525380000022],
              [90.497538, 47.351206],
              [90.497554, 47.352215],
              [90.497571, 47.352993],
              [90.497869, 47.353754],
              [90.4982, 47.354366],
              [90.498348, 47.354663],
              [90.498415, 47.355358],
              [90.498431, 47.356202],
              [90.49863, 47.356532],
              [90.49896, 47.356747],
              [90.499523, 47.357244],
              [90.5003, 47.357889],
              [90.500912, 47.358335],
              [90.501657, 47.359212],
              [90.502748, 47.359973],
              [90.503592, 47.360386],
              [90.504435, 47.360684],
              [90.505213, 47.361081],
              [90.505825, 47.361544],
              [90.506754, 47.361956],
              [90.507429, 47.362256],
              [90.508604, 47.362835],
              [90.509084, 47.363099],
              [90.509365, 47.363463],
              [90.509431, 47.363827],
              [90.509431, 47.364389],
              [90.509613, 47.364803],
              [90.510192, 47.365498],
              [90.511135, 47.36649],
              [90.512292, 47.367913],
              [90.514244, 47.369782],
              [90.515286, 47.370857],
              [90.51608, 47.371535],
              [90.516395, 47.372031],
              [90.517056, 47.372726],
              [90.517685, 47.373007],
              [90.51795, 47.37304],
              [90.51833, 47.373222],
              [90.518396, 47.373388],
              [90.518727, 47.374],
              [90.519091, 47.374645],
              [90.519736, 47.375257],
              [90.520232, 47.375836],
              [90.520331, 47.3762],
              [90.520331, 47.376464],
              [90.520183, 47.376663],
              [90.519389, 47.37749],
              [90.518677, 47.378333],
              [90.51785, 47.379425],
              [90.51747, 47.380203],
              [90.517238, 47.380418],
              [90.516808, 47.380467],
              [90.51613, 47.3806],
              [90.51522, 47.38093],
              [90.514974642000027, 47.381024718999981],
              [90.514575, 47.381179],
              [90.514244, 47.381542],
              [90.513583, 47.382766],
              [90.513146329, 47.383617574000027],
              [90.512921, 47.384057],
              [90.511945, 47.385727],
              [90.511085, 47.386968],
              [90.510142, 47.388208],
              [90.509249, 47.389664],
              [90.508108, 47.391153],
              [90.507512, 47.392145],
              [90.507049, 47.393419],
              [90.5069, 47.394229],
              [90.506784, 47.395073],
              [90.506702, 47.395652],
              [90.506536, 47.395966],
              [90.506288, 47.396264],
              [90.505989611000018, 47.396688777],
              [90.505974, 47.396711],
              [90.505888685, 47.396905532],
              [90.505742, 47.39724],
              [90.505518683999981, 47.397463316000028],
              [90.505329, 47.397653],
              [90.504684, 47.398117],
              [90.503509, 47.39901],
              [90.502517, 47.39987],
              [90.502302, 47.400234],
              [90.502236, 47.400548],
              [90.502153, 47.400879],
              [90.502103, 47.401375],
              [90.501971, 47.401524],
              [90.501524, 47.40164],
              [90.500879, 47.401772],
              [90.499539, 47.402268],
              [90.498563, 47.402731],
              [90.497753, 47.40288],
              [90.496694, 47.402798],
              [90.495206, 47.402368],
              [90.493618, 47.401656],
              [90.491964, 47.400747],
              [90.490591, 47.399919],
              [90.490581, 47.399913],
              [90.489648, 47.399291],
              [90.489003, 47.398762],
              [90.488473, 47.398332],
              [90.487795, 47.398017],
              [90.487018, 47.397637],
              [90.486224, 47.397356],
              [90.485628, 47.39681],
              [90.484884, 47.39638],
              [90.484255, 47.396198],
              [90.483577, 47.395999],
              [90.483048, 47.395801],
              [90.482585, 47.395917],
              [90.481923, 47.395966],
              [90.480931, 47.39585],
              [90.480219, 47.395768],
              [90.479674, 47.39585],
              [90.478681, 47.396148],
              [90.477242, 47.396529],
              [90.476217, 47.396677],
              [90.474579, 47.396727],
              [90.473553, 47.396942],
              [90.472478, 47.397339],
              [90.471767, 47.39762],
              [90.470444, 47.398117],
              [90.469898, 47.398547],
              [90.469286, 47.399208],
              [90.46831, 47.399969],
              [90.467996, 47.400151],
              [90.467863, 47.400399],
              [90.467863, 47.40068],
              [90.46788, 47.400978],
              [90.467913, 47.401805],
              [90.467913, 47.402401],
              [90.467913, 47.4025],
              [90.467731, 47.402649],
              [90.467334, 47.402798],
              [90.466821, 47.402864],
              [90.465002, 47.403112],
              [90.463066, 47.403625],
              [90.461875, 47.404121],
              [90.461082, 47.404816],
              [90.460073, 47.405775],
              [90.459423768000022, 47.406387920999975],
              [90.459179, 47.406619],
              [90.458667, 47.40728],
              [90.45827, 47.40771],
              [90.457823, 47.408124],
              [90.457161, 47.408736],
              [90.456649, 47.409712],
              [90.456218, 47.410307],
              [90.455838, 47.410886],
              [90.45564, 47.411399],
              [90.455507, 47.412226],
              [90.455491, 47.413119],
              [90.455491, 47.413516],
              [90.455606, 47.413632],
              [90.455904, 47.413731],
              [90.457178, 47.414211],
              [90.457972, 47.414476],
              [90.459394, 47.415253],
              [90.459609, 47.415435],
              [90.459692, 47.415633],
              [90.459692, 47.41595],
              [90.459692, 47.416064],
              [90.459659, 47.416659],
              [90.459516367999981, 47.417276432],
              [90.45951, 47.417304],
              [90.459411, 47.418098],
              [90.45942419, 47.418233499],
              [90.459477, 47.418776],
              [90.459626, 47.419322],
              [90.459626, 47.419868],
              [90.459626, 47.420298],
              [90.459543, 47.420761],
              [90.45946, 47.421274],
              [90.459361, 47.422382],
              [90.459394, 47.423209],
              [90.459245, 47.424053],
              [90.458964, 47.424814],
              [90.458831651000025, 47.42507451],
              [90.458648, 47.425436],
              [90.458469, 47.425842],
              [90.458393, 47.426124],
              [90.458338, 47.426379],
              [90.458397, 47.426775],
              [90.45838, 47.426936],
              [90.458335, 47.42707],
              [90.457919, 47.427321],
              [90.457507, 47.427587],
              [90.457175, 47.42798],
              [90.456844, 47.42827],
              [90.456513, 47.428436],
              [90.455913, 47.428705],
              [90.455429, 47.428903],
              [90.455043, 47.429151],
              [90.454691, 47.429554],
              [90.454658, 47.429588],
              [90.45407, 47.430196],
              [90.453509, 47.430678],
              [90.453221, 47.431065],
              [90.453179, 47.431201],
              [90.453221, 47.431355],
              [90.453387, 47.431562],
              [90.453635, 47.431831],
              [90.453713758, 47.431981607000012],
              [90.453749, 47.432049],
              [90.453884, 47.432307],
              [90.454383, 47.433152],
              [90.454396, 47.433551],
              [90.454464, 47.435719],
              [90.454448, 47.437178],
              [90.454367, 47.438285],
              [90.454239, 47.439424],
              [90.454255, 47.440146],
              [90.454335, 47.440403],
              [90.454929, 47.440563],
              [90.455731, 47.440932],
              [90.456677, 47.441526],
              [90.457688, 47.442103],
              [90.458458, 47.442681],
              [90.459404, 47.443178],
              [90.459476, 47.443202],
              [90.460206, 47.443451],
              [90.460848, 47.443675],
              [90.461923, 47.444205],
              [90.46319, 47.444991],
              [90.464538, 47.445777],
              [90.465163, 47.446402],
              [90.466061, 47.44698],
              [90.467233, 47.447413],
              [90.467457, 47.447589],
              [90.467553, 47.447766],
              [90.467553, 47.448135],
              [90.467441, 47.448712],
              [90.467216, 47.449418],
              [90.466992, 47.449995],
              [90.466832, 47.450461],
              [90.466815, 47.451054],
              [90.466815, 47.451776],
              [90.466815, 47.452466],
              [90.467104, 47.453043],
              [90.467377, 47.453781],
              [90.467666, 47.454808],
              [90.467778, 47.455562],
              [90.467778, 47.456139],
              [90.467746, 47.456444],
              [90.467569, 47.456941],
              [90.467265, 47.457952],
              [90.467072, 47.458578],
              [90.466799, 47.459444],
              [90.466623, 47.460005],
              [90.466607, 47.460487],
              [90.466751, 47.460904],
              [90.46696, 47.461337],
              [90.467152, 47.461609],
              [90.467377, 47.461882],
              [90.467906, 47.462444],
              [90.469125, 47.463342],
              [90.470425, 47.464064],
              [90.471227, 47.464593],
              [90.471548, 47.464946],
              [90.471868, 47.465363],
              [90.472045, 47.465732],
              [90.472125, 47.466101],
              [90.472093, 47.466358],
              [90.472045, 47.466711],
              [90.471804, 47.467048],
              [90.471339, 47.467497],
              [90.471262781, 47.467578401000026],
              [90.470633, 47.468251],
              [90.469398, 47.469277],
              [90.468516, 47.470192],
              [90.468259, 47.470448],
              [90.468211, 47.470801],
              [90.468179, 47.47125],
              [90.468182825999975, 47.471441758000026],
              [90.468195, 47.472052],
              [90.468195, 47.47247],
              [90.468051, 47.472694],
              [90.467569, 47.473143],
              [90.466623, 47.474042],
              [90.465997, 47.474699],
              [90.465757, 47.475084],
              [90.465709, 47.475437],
              [90.465709, 47.47571],
              [90.465885, 47.476095],
              [90.46627, 47.476544],
              [90.466751, 47.477057],
              [90.467361, 47.477843],
              [90.467682, 47.478357],
              [90.467954, 47.479111],
              [90.468051, 47.479977],
              [90.468115, 47.480619],
              [90.468227, 47.481485],
              [90.468484, 47.482447],
              [90.468869, 47.483378],
              [90.46943, 47.484436],
              [90.469623, 47.484886],
              [90.469831, 47.485607],
              [90.469944, 47.486185],
              [90.46996, 47.487516],
              [90.4702, 47.488639],
              [90.470649, 47.489297],
              [90.471291, 47.489794],
              [90.472189, 47.490276],
              [90.472526, 47.490356],
              [90.472526, 47.49042],
              [90.472382, 47.490452],
              [90.471997, 47.490484],
              [90.471253013000023, 47.490640706000022],
              [90.470473, 47.490805],
              [90.46943, 47.491254],
              [90.469297305, 47.491322482999976],
              [90.468436, 47.491767],
              [90.466944, 47.492473],
              [90.465356, 47.493564],
              [90.464185, 47.494751],
              [90.46319, 47.495922],
              [90.462773, 47.496676],
              [90.462452, 47.497494],
              [90.462147, 47.498409],
              [90.461955, 47.498858],
              [90.461393, 47.499644],
              [90.460912, 47.500077],
              [90.460559, 47.500253],
              [90.459645, 47.500301],
              [90.458586, 47.500189],
              [90.457351, 47.499949],
              [90.456680662, 47.499754955000014],
              [90.456629, 47.49974],
              [90.45618, 47.499596],
              [90.455667, 47.499531],
              [90.455164, 47.499582],
              [90.455025, 47.499596],
              [90.454143, 47.499724],
              [90.453500491, 47.500044920999983],
              [90.45318, 47.500205],
              [90.45241, 47.500735],
              [90.451624, 47.501521],
              [90.451127, 47.502098],
              [90.450565, 47.503028],
              [90.449876, 47.504777],
              [90.449619, 47.505964],
              [90.449592, 47.506274],
              [90.449491, 47.507456],
              [90.449234, 47.508964],
              [90.448961, 47.509477],
              [90.448833, 47.509846],
              [90.448673, 47.510151],
              [90.448544, 47.51052],
              [90.448352, 47.511001],
              [90.447999, 47.511482],
              [90.447999, 47.511514],
              [90.447758, 47.511899],
              [90.447614, 47.512349],
              [90.447373, 47.513279],
              [90.447133, 47.514514],
              [90.446988, 47.515172],
              [90.446716, 47.515477],
              [90.446331, 47.515813],
              [90.445978, 47.516102],
              [90.444839, 47.516856],
              [90.44309, 47.517899],
              [90.442047, 47.518637],
              [90.44078, 47.519439],
              [90.439721, 47.519968],
              [90.439112, 47.520417],
              [90.438647, 47.521011],
              [90.43823, 47.521925],
              [90.438149, 47.522374],
              [90.438021, 47.522567],
              [90.437716, 47.522792],
              [90.436353, 47.524155],
              [90.435615, 47.524941],
              [90.435134, 47.52523],
              [90.434203, 47.525567],
              [90.432792, 47.525968],
              [90.430995, 47.526465],
              [90.429327, 47.526914],
              [90.427979, 47.527331],
              [90.427049, 47.527732],
              [90.426519, 47.528053],
              [90.426022, 47.52855],
              [90.425557, 47.529176],
              [90.425332, 47.529369],
              [90.425092, 47.529465],
              [90.423889, 47.52993],
              [90.421915, 47.530796],
              [90.420055, 47.531662],
              [90.41829, 47.532898],
              [90.416718, 47.534021],
              [90.415435, 47.534887],
              [90.414905, 47.535384],
              [90.41444, 47.536202],
              [90.413847, 47.536812],
              [90.412644, 47.537277],
              [90.411713, 47.537742],
              [90.410783, 47.537822],
              [90.409082448999982, 47.537629277],
              [90.40878, 47.537595],
              [90.408665, 47.537582],
              [90.407382, 47.537245],
              [90.406708, 47.537117],
              [90.406179, 47.537229],
              [90.406065426999987, 47.537282318],
              [90.405393, 47.537598],
              [90.404655, 47.538015],
              [90.403644, 47.538191],
              [90.402457, 47.538304],
              [90.40135, 47.53856],
              [90.400115, 47.538849],
              [90.398816, 47.539587],
              [90.398158, 47.540132],
              [90.397099, 47.541063],
              [90.396249, 47.541913],
              [90.395816, 47.542378],
              [90.395784, 47.542859],
              [90.396105, 47.543549],
              [90.396394, 47.543982],
              [90.396779, 47.544351],
              [90.3975, 47.544961],
              [90.398142, 47.545827],
              [90.398431, 47.546533],
              [90.398463, 47.54703],
              [90.398302, 47.547415],
              [90.397934, 47.548458],
              [90.397597, 47.549372],
              [90.396955, 47.550688],
              [90.396506, 47.551586],
              [90.396105, 47.552645],
              [90.395896, 47.553832],
              [90.395886, 47.554038],
              [90.395832, 47.555115],
              [90.395768, 47.555436],
              [90.395511, 47.555725],
              [90.394821, 47.556077],
              [90.39453, 47.556166],
              [90.393923, 47.55635],
              [90.392736, 47.556896],
              [90.391501, 47.557922],
              [90.390875, 47.55858],
              [90.390715, 47.558917],
              [90.390426, 47.559831],
              [90.390121, 47.560617],
              [90.389768, 47.561403],
              [90.38956, 47.562189],
              [90.389624, 47.562767],
              [90.389928, 47.563388],
              [90.390009, 47.563553],
              [90.390779, 47.564467],
              [90.391629, 47.565157],
              [90.392544, 47.565702],
              [90.392624, 47.565847],
              [90.392624, 47.566023],
              [90.392512, 47.5662],
              [90.392223, 47.566585],
              [90.391774, 47.567306],
              [90.391116, 47.568285],
              [90.390651, 47.569328],
              [90.390298, 47.570322],
              [90.389977, 47.571509],
              [90.38972, 47.572119],
              [90.389432, 47.572456],
              [90.388806, 47.57321],
              [90.388196, 47.574076],
              [90.387507, 47.575552],
              [90.386961, 47.576482],
              [90.385501, 47.578439],
              [90.384459, 47.579915],
              [90.383432, 47.581118],
              [90.382534, 47.581984],
              [90.381684, 47.582594],
              [90.380577, 47.583396],
              [90.378924, 47.584744],
              [90.378635, 47.584998],
              [90.378138, 47.585433],
              [90.378074, 47.58561],
              [90.378074, 47.585963],
              [90.378122, 47.586078],
              [90.378235, 47.586348],
              [90.378491, 47.586861],
              [90.37886, 47.587358],
              [90.379406, 47.587807],
              [90.379839, 47.58816],
              [90.380144, 47.588626],
              [90.380737, 47.589251],
              [90.381218, 47.589732],
              [90.381571, 47.590294],
              [90.381523, 47.590807],
              [90.381395, 47.591786],
              [90.381202, 47.592315],
              [90.380753, 47.592604],
              [90.379839, 47.593278],
              [90.378973, 47.593663],
              [90.377802, 47.594272],
              [90.376679, 47.595267],
              [90.375748, 47.596598],
              [90.375203, 47.597705],
              [90.374978, 47.598202],
              [90.374946, 47.59886],
              [90.375007, 47.599343],
              [90.374966, 47.59985],
              [90.374966, 47.600065],
              [90.37493, 47.600113],
              [90.374751, 47.600185],
              [90.373795, 47.600424],
              [90.372062, 47.601272],
              [90.3707, 47.601846],
              [90.369625, 47.60224],
              [90.368465, 47.602539],
              [90.367514, 47.603068],
              [90.367067, 47.603316],
              [90.365442, 47.604188],
              [90.363781, 47.605395],
              [90.363064, 47.606136],
              [90.362025, 47.607343],
              [90.361308, 47.608406],
              [90.361033, 47.608908],
              [90.360973, 47.609111],
              [90.360937, 47.609446],
              [90.360937, 47.609613],
              [90.360841, 47.609781],
              [90.360614, 47.609912],
              [90.360292, 47.610139],
              [90.360113, 47.610378],
              [90.359993, 47.610665],
              [90.359957, 47.610988],
              [90.359945, 47.611274],
              [90.359826, 47.611466],
              [90.359682, 47.611573],
              [90.359539, 47.611788],
              [90.359443, 47.611979],
              [90.359384, 47.612123],
              [90.359372, 47.612505],
              [90.359372, 47.612816],
              [90.359312, 47.613091],
              [90.3593, 47.613318],
              [90.3593, 47.613652],
              [90.359422, 47.613805],
              [90.359587, 47.614011],
              [90.359826, 47.614262],
              [90.359874, 47.614405],
              [90.359742, 47.614596],
              [90.359276, 47.615039],
              [90.358714, 47.615684],
              [90.358033, 47.616317],
              [90.357507, 47.616628],
              [90.357102, 47.616885],
              [90.356922, 47.616998],
              [90.356432, 47.617572],
              [90.3555, 47.618373],
              [90.354281, 47.619615],
              [90.353552, 47.620536],
              [90.352955, 47.621312],
              [90.35262, 47.621742],
              [90.35219, 47.621969],
              [90.351664, 47.622101],
              [90.35072, 47.622161],
              [90.349919, 47.622101],
              [90.349178, 47.622125],
              [90.348844, 47.622197],
              [90.348593, 47.622376],
              [90.348151, 47.623009],
              [90.347721, 47.623619],
              [90.347075, 47.624192],
              [90.346167, 47.624694],
              [90.345044, 47.625244],
              [90.34398, 47.625674],
              [90.343204, 47.625865],
              [90.343048, 47.625949],
              [90.343048, 47.625985],
              [90.343048, 47.626164],
              [90.343275, 47.626367],
              [90.343586, 47.626522],
              [90.343753, 47.626809],
              [90.343873, 47.627419],
              [90.343944, 47.628148],
              [90.343861, 47.628757],
              [90.343909, 47.629199],
              [90.343921, 47.629474],
              [90.343932, 47.629821],
              [90.343705, 47.630526],
              [90.343682, 47.631231],
              [90.343753, 47.631864],
              [90.343825, 47.632449],
              [90.343729, 47.632975],
              [90.343431, 47.633537],
              [90.343144, 47.633979],
              [90.342749, 47.634565],
              [90.342498, 47.634995],
              [90.342379, 47.635509],
              [90.342379, 47.635891],
              [90.342451, 47.63613],
              [90.342618, 47.636273],
              [90.342833, 47.636393],
              [90.343204, 47.636536],
              [90.343944, 47.636907],
              [90.344399, 47.637265],
              [90.344876, 47.637719],
              [90.345629, 47.638389],
              [90.345988, 47.638926],
              [90.346514, 47.639703],
              [90.346992, 47.640838],
              [90.34735, 47.641436],
              [90.347816, 47.641878],
              [90.34845, 47.642368],
              [90.348868, 47.642679],
              [90.349585, 47.643097],
              [90.350051, 47.643407],
              [90.350278, 47.643575],
              [90.350385, 47.64379],
              [90.350541, 47.644328],
              [90.351067, 47.645941],
              [90.35121, 47.646502],
              [90.35121, 47.64652931400002],
              [90.35121, 47.646694],
              [90.35127, 47.646765],
              [90.351401, 47.646837],
              [90.351533, 47.646837],
              [90.352023, 47.646694],
              [90.352417, 47.646574],
              [90.353026, 47.646419],
              [90.353731, 47.646192],
              [90.354341, 47.645965],
              [90.354669, 47.645879],
              [90.355118, 47.645762],
              [90.356217, 47.645272],
              [90.357245, 47.644758],
              [90.35838, 47.644172],
              [90.359145, 47.643766],
              [90.359885, 47.643407],
              [90.36016, 47.643407],
              [90.360186477000013, 47.643406160999973],
              [90.360507, 47.643396],
              [90.361224, 47.643431],
              [90.361857, 47.643527],
              [90.362586, 47.643682],
              [90.363028, 47.643874],
              [90.363697, 47.644208],
              [90.363937706, 47.644333604999986],
              [90.364247, 47.644495],
              [90.364701, 47.644794],
              [90.364964, 47.644913],
              [90.365143, 47.644913],
              [90.36555, 47.644877],
              [90.36684, 47.64477],
              [90.368298, 47.644674],
              [90.370733724, 47.644550630000026],
              [90.37122, 47.644526],
              [90.371727, 47.644522],
              [90.3724, 47.64456],
              [90.372499, 47.644621],
              [90.372522, 47.644674],
              [90.372522, 47.644712],
              [90.372446, 47.644858],
              [90.372339, 47.644995],
              [90.372247, 47.645377],
              [90.372179, 47.645874],
              [90.371957, 47.646722],
              [90.371712, 47.647807],
              [90.371606, 47.648502],
              [90.371651, 47.650252],
              [90.371598, 47.65113],
              [90.371674, 47.652437],
              [90.371644, 47.65262],
              [90.371453, 47.652857],
              [90.371353, 47.653048],
              [90.371055, 47.653483],
              [90.370849, 47.653789],
              [90.370566, 47.654011],
              [90.369963, 47.654331],
              [90.3691, 47.655065],
              [90.368213, 47.656058],
              [90.367602, 47.656738],
              [90.367617, 47.65673],
              [90.367205, 47.657441],
              [90.367098, 47.657922],
              [90.367098, 47.658236],
              [90.36696, 47.658702],
              [90.366876, 47.659045],
              [90.366968, 47.659252],
              [90.367212, 47.659565],
              [90.367319, 47.659687],
              [90.367281, 47.659771],
              [90.367136, 47.659802],
              [90.36696, 47.659817],
              [90.366678, 47.659809],
              [90.365745, 47.659985],
              [90.365027, 47.660161],
              [90.364248, 47.660283],
              [90.363278, 47.660566],
              [90.362315, 47.660978],
              [90.361413, 47.661475],
              [90.361207, 47.661704],
              [90.360909, 47.66217],
              [90.360733, 47.662506],
              [90.360512, 47.662766],
              [90.360053, 47.66324],
              [90.359435, 47.663614],
              [90.35851, 47.664042],
              [90.357975, 47.664432],
              [90.357616, 47.664768],
              [90.357227, 47.665188],
              [90.35673, 47.665494],
              [90.356356, 47.665654],
              [90.355752, 47.665876],
              [90.355064, 47.666074],
              [90.354255, 47.666609],
              [90.353032, 47.667419],
              [90.352592586000014, 47.667593657],
              [90.352398, 47.667671],
              [90.351573, 47.668198],
              [90.350946, 47.668749],
              [90.350121, 47.669627],
              [90.349874, 47.670078],
              [90.349552, 47.670642],
              [90.349311, 47.671468],
              [90.349069, 47.672655],
              [90.348938991000011, 47.673078133999979],
              [90.348908, 47.673179],
              [90.348626, 47.673521],
              [90.348203, 47.673964],
              [90.347499, 47.674366],
              [90.346835, 47.674507],
              [90.346070038999983, 47.674343564000026],
              [90.345707, 47.674266],
              [90.3446, 47.673964],
              [90.343755, 47.673682],
              [90.343312, 47.673722],
              [90.34299, 47.673883],
              [90.342486, 47.674527],
              [90.342084, 47.675232],
              [90.341802, 47.675635],
              [90.341359, 47.675876],
              [90.340834621999988, 47.676199812999982],
              [90.340674, 47.676299],
              [90.339346, 47.677326],
              [90.337917, 47.678493],
              [90.337554, 47.678654],
              [90.33697, 47.678614],
              [90.33660069299998, 47.67853557799998],
              [90.336306, 47.678473],
              [90.33544, 47.678171],
              [90.334394, 47.677869],
              [90.333367, 47.677809],
              [90.33226, 47.677849],
              [90.331475, 47.67805],
              [90.330509249999977, 47.678469754],
              [90.329945, 47.678715],
              [90.328978, 47.679057],
              [90.328351, 47.679185],
              [90.328009536000025, 47.679253903000017],
              [90.327791, 47.679298],
              [90.327066, 47.67954],
              [90.326945, 47.679701],
              [90.326861715, 47.679950029],
              [90.326844, 47.680003],
              [90.326838, 47.680155],
              [90.326804, 47.680889],
              [90.326660601000015, 47.681620978000012],
              [90.326603, 47.681915],
              [90.326442, 47.682399],
              [90.326406323000015, 47.682457301],
              [90.326237, 47.682734],
              [90.325918, 47.683143],
              [90.325232, 47.683714],
              [90.32459, 47.68415],
              [90.323624, 47.684553],
              [90.322114, 47.685136],
              [90.321449, 47.685398],
              [90.321027, 47.685418],
              [90.320262, 47.685338],
              [90.319235, 47.685197],
              [90.318785532, 47.685161753999978],
              [90.317947, 47.685096],
              [90.31694, 47.685157],
              [90.315902478, 47.68518485300001],
              [90.31545, 47.685197],
              [90.313779, 47.685418],
              [90.313276541, 47.685445716],
              [90.311948, 47.685519],
              [90.311464, 47.68564],
              [90.31084, 47.685982],
              [90.310530404000019, 47.686204810999982],
              [90.310337, 47.686344],
              [90.309632, 47.686687],
              [90.308807, 47.687049],
              [90.307358, 47.687351],
              [90.306472, 47.687613],
              [90.305848, 47.687774],
              [90.305345, 47.687753],
              [90.305078518000016, 47.68776993900002],
              [90.3047, 47.687794],
              [90.304208, 47.687833],
              [90.303751, 47.687921],
              [90.303394, 47.688059],
              [90.303111, 47.688427],
              [90.303051627, 47.688500013],
              [90.302889, 47.6887],
              [90.302707, 47.68882],
              [90.30164, 47.689203],
              [90.300433, 47.689767],
              [90.299748, 47.690371],
              [90.299346, 47.691015],
              [90.298963, 47.691337],
              [90.297836, 47.692001],
              [90.29703, 47.692605],
              [90.295742, 47.692847],
              [90.294192, 47.69339],
              [90.293548, 47.693531],
              [90.292461, 47.693551],
              [90.290126, 47.693511],
              [90.288294, 47.693571],
              [90.286341, 47.693672],
              [90.284348, 47.693732],
              [90.283447909000017, 47.693698862000019],
              [90.283343, 47.693695],
              [90.282352, 47.693749],
              [90.281747, 47.693869],
              [90.281285081000021, 47.694027172],
              [90.281087, 47.694095],
              [90.28008, 47.694296],
              [90.279053, 47.694538],
              [90.277503, 47.695282],
              [90.276376, 47.695786],
              [90.27616, 47.695818],
              [90.275973, 47.695786],
              [90.275220721999972, 47.695362624999973],
              [90.275113, 47.695302],
              [90.275101, 47.695294],
              [90.274593, 47.694969],
              [90.274101, 47.694693],
              [90.273415, 47.694336],
              [90.272491, 47.693954],
              [90.271978, 47.693809],
              [90.271405, 47.693749],
              [90.270902, 47.693671],
              [90.27037160499998, 47.693607480000026],
              [90.270181983999976, 47.693584771000019],
              [90.269733, 47.693531],
              [90.268062, 47.69339],
              [90.266693, 47.69331],
              [90.265646, 47.69331],
              [90.264166, 47.693179],
              [90.262788, 47.693128],
              [90.261972432, 47.693227620000016],
              [90.261298, 47.69331],
              [90.259003, 47.69343],
              [90.258848125999975, 47.69343],
              [90.257815, 47.69343],
              [90.257461, 47.693621],
              [90.257270203000019, 47.693734042000017],
              [90.256212, 47.694361],
              [90.255578, 47.694785],
              [90.255168, 47.695128],
              [90.254545, 47.69555],
              [90.25395, 47.695746],
              [90.252521, 47.69643],
              [90.250689, 47.697497],
              [90.250105, 47.6979],
              [90.250006, 47.698051],
              [90.249765, 47.698704],
              [90.249609, 47.69915],
              [90.249494, 47.699477],
              [90.249384, 47.699819],
              [90.249062, 47.700261],
              [90.248821, 47.700451],
              [90.24858, 47.700642],
              [90.248008, 47.701084],
              [90.247425, 47.701566],
              [90.247015, 47.702172],
              [90.246983, 47.702219],
              [90.246806, 47.702556],
              [90.246471, 47.702701],
              [90.245968, 47.703013],
              [90.245105, 47.703595],
              [90.244874974000027, 47.703764531],
              [90.24447, 47.704063],
              [90.244057, 47.704561],
              [90.243739, 47.705032],
              [90.243337, 47.705574],
              [90.242855, 47.706277],
              [90.242433, 47.70693],
              [90.242272, 47.707372],
              [90.242302, 47.707724],
              [90.242222, 47.707874],
              [90.242121, 47.707925],
              [90.24192, 47.707874],
              [90.241529, 47.707701],
              [90.241147, 47.707613],
              [90.239953956000022, 47.707212428999981],
              [90.239771, 47.707151],
              [90.238325, 47.706689],
              [90.23724, 47.706257],
              [90.236637, 47.706046],
              [90.236225, 47.706036],
              [90.235763, 47.706056],
              [90.23515, 47.705886],
              [90.234256, 47.705494],
              [90.233594, 47.705283],
              [90.232921, 47.704841],
              [90.232719, 47.704741],
              [90.231424, 47.704098],
              [90.230028, 47.703475],
              [90.229335, 47.703184],
              [90.228702, 47.703073],
              [90.227557, 47.702942],
              [90.226653, 47.702932],
              [90.225709, 47.703103],
              [90.225206, 47.703324],
              [90.224714, 47.703756],
              [90.224061, 47.704228],
              [90.223358, 47.704429],
              [90.222695, 47.704509],
              [90.221419, 47.70453],
              [90.219722, 47.704329],
              [90.219099, 47.704288],
              [90.217954, 47.704007],
              [90.21707, 47.703917],
              [90.216257, 47.703756],
              [90.216017455999975, 47.703788061000012],
              [90.215734, 47.703826],
              [90.215132, 47.704017],
              [90.214734256999975, 47.704270173999987],
              [90.214731216000018, 47.704271317],
              [90.214579, 47.704369],
              [90.214077, 47.70472],
              [90.213454, 47.705012],
              [90.213121619999981, 47.70508894],
              [90.213022, 47.705112],
              [90.211646, 47.705896],
              [90.211276289000011, 47.706181508999975],
              [90.21032, 47.70692],
              [90.209425803999977, 47.707609079],
              [90.209095, 47.707864],
              [90.208261, 47.708437],
              [90.207879, 47.708638],
              [90.207699, 47.708859],
              [90.207658, 47.7091],
              [90.207618, 47.709371],
              [90.207468, 47.709652],
              [90.207276, 47.709784],
              [90.207146, 47.709873],
              [90.206604, 47.710436],
              [90.206011, 47.711159],
              [90.2057, 47.711711],
              [90.205559, 47.712153],
              [90.205546146000017, 47.712183978999974],
              [90.205459, 47.712394],
              [90.205207, 47.712475],
              [90.204675, 47.712515],
              [90.204042, 47.712525],
              [90.20358, 47.712555],
              [90.203068, 47.712746],
              [90.202516, 47.712746],
              [90.201863, 47.712776],
              [90.20128, 47.712867],
              [90.200878, 47.712826],
              [90.200416, 47.712816],
              [90.200270472999989, 47.712810821],
              [90.199854, 47.712796],
              [90.199109, 47.712826],
              [90.1991, 47.712826],
              [90.198297, 47.713017],
              [90.197393, 47.713258],
              [90.196931, 47.713479],
              [90.196692, 47.713726],
              [90.196629, 47.713791],
              [90.196238, 47.714263],
              [90.195715, 47.714534],
              [90.195324, 47.714654],
              [90.195012, 47.714865],
              [90.194902, 47.715207],
              [90.194711, 47.715508],
              [90.19443, 47.715679],
              [90.193927, 47.71589],
              [90.193455, 47.716031],
              [90.193013, 47.716342],
              [90.192903, 47.716513],
              [90.192903, 47.716694],
              [90.192993, 47.717035],
              [90.193154, 47.717377],
              [90.193472837, 47.717898412000011],
              [90.193516, 47.717969],
              [90.193646, 47.71821],
              [90.193636, 47.718301],
              [90.193506, 47.718361],
              [90.193375, 47.718381],
              [90.193023, 47.718371],
              [90.192712, 47.718461],
              [90.19235, 47.718712],
              [90.191868, 47.719004],
              [90.191386, 47.719114],
              [90.190914, 47.719044],
              [90.190663, 47.718783],
              [90.190502, 47.718672],
              [90.190211, 47.718662],
              [90.189648, 47.718813],
              [90.189056, 47.719034],
              [90.188353, 47.719124],
              [90.18777, 47.719034],
              [90.187167, 47.718903],
              [90.186434, 47.718893],
              [90.186375352000027, 47.718895780000025],
              [90.186012, 47.718913],
              [90.185711, 47.719054],
              [90.18539343499998, 47.719299934],
              [90.185179, 47.719466],
              [90.184616, 47.719737],
              [90.184144, 47.719918],
              [90.183858391, 47.719931753000026],
              [90.183521, 47.719948],
              [90.183089, 47.720069],
              [90.182768, 47.720279],
              [90.182396, 47.720631],
              [90.182095, 47.720842],
              [90.181452, 47.721043],
              [90.18103, 47.721404],
              [90.180568, 47.722087],
              [90.179775, 47.722821],
              [90.179242, 47.723574],
              [90.178881, 47.724096],
              [90.17864, 47.724619],
              [90.178509, 47.72497],
              [90.178458166999974, 47.725078876],
              [90.178368, 47.725272],
              [90.178147, 47.725513],
              [90.177766, 47.725623],
              [90.176922, 47.725583],
              [90.175661615000024, 47.725525221999987],
              [90.175534917999983, 47.725519414000019],
              [90.175395, 47.725513],
              [90.174109, 47.725583],
              [90.173055, 47.725563],
              [90.171759, 47.725312],
              [90.170152, 47.72494],
              [90.169630469000026, 47.724786715999983],
              [90.169298, 47.724689],
              [90.168675, 47.724488],
              [90.167972, 47.724438],
              [90.167038, 47.724458],
              [90.166154, 47.724649],
              [90.16522, 47.724719],
              [90.164919, 47.724709],
              [90.164517, 47.724538],
              [90.164045, 47.724498],
              [90.163744716999986, 47.724470866],
              [90.163713, 47.724468],
              [90.162696, 47.724037],
              [90.162598, 47.723996],
              [90.162056, 47.723725],
              [90.161825, 47.723725],
              [90.161584, 47.723765],
              [90.161152, 47.723644],
              [90.16065, 47.723413],
              [90.160077, 47.723182],
              [90.159173, 47.722891],
              [90.15846, 47.72272],
              [90.158377590999976, 47.722670601],
              [90.158108, 47.722509],
              [90.157807, 47.722489],
              [90.157558756000014, 47.72255922],
              [90.157556154000019, 47.722558866999975],
              [90.157094, 47.72268],
              [90.156351, 47.72263],
              [90.155969, 47.722539],
              [90.155963569, 47.72253608699998],
              [90.155708, 47.722399],
              [90.155346, 47.722349],
              [90.155095, 47.722439],
              [90.154772445999981, 47.72253608699998],
              [90.154693, 47.72256],
              [90.154201, 47.72261],
              [90.153689, 47.72261],
              [90.152307893, 47.722600649000015],
              [90.152212, 47.7226],
              [90.150816, 47.72266],
              [90.150183, 47.722781],
              [90.149611, 47.722971],
              [90.148948, 47.723433],
              [90.148521964, 47.723690766],
              [90.148034, 47.723986],
              [90.14724, 47.724257],
              [90.146879, 47.724287],
              [90.145492, 47.724096],
              [90.144006, 47.723805],
              [90.14265, 47.723423],
              [90.140832, 47.722881],
              [90.139446, 47.722258],
              [90.139230826000016, 47.722080408000011],
              [90.139154, 47.722017],
              [90.139024, 47.721937],
              [90.138923, 47.721937],
              [90.138803, 47.722158],
              [90.138712, 47.722419],
              [90.138511, 47.72276],
              [90.138039, 47.723443],
              [90.137487, 47.724006],
              [90.137045, 47.724388],
              [90.136081, 47.72488],
              [90.134765, 47.725583],
              [90.133851, 47.726156],
              [90.132806, 47.726678],
              [90.131721, 47.727491],
              [90.130707, 47.728154],
              [90.129652, 47.728948],
              [90.129566333000014, 47.72900278100002],
              [90.128537, 47.729661],
              [90.128085, 47.729762],
              [90.127091, 47.729762],
              [90.127003119999983, 47.729766767],
              [90.126538, 47.729792],
              [90.126056, 47.729932],
              [90.125413, 47.730053],
              [90.124449, 47.730143],
              [90.124027, 47.730143],
              [90.123736, 47.730404],
              [90.123354, 47.730987],
              [90.123053, 47.731308],
              [90.122741, 47.731479],
              [90.12252, 47.73162],
              [90.12241, 47.732032],
              [90.12241, 47.732323],
              [90.122641, 47.732795],
              [90.122851942000011, 47.733149652],
              [90.122892, 47.733217],
              [90.123003, 47.733528],
              [90.123013, 47.733759],
              [90.122993, 47.73402],
              [90.123003, 47.734362],
              [90.123133, 47.734894],
              [90.123143, 47.735417],
              [90.123203, 47.735788],
              [90.123133, 47.736019],
              [90.122932, 47.736301],
              [90.122149, 47.736803],
              [90.121054, 47.737606],
              [90.120918838000023, 47.737763219999977],
              [90.12019, 47.738611],
              [90.119316, 47.739897],
              [90.119025, 47.7406],
              [90.118754, 47.741288],
              [90.118693, 47.741443],
              [90.118633, 47.741715],
              [90.118533, 47.742498],
              [90.118513, 47.743312],
              [90.118633, 47.744256],
              [90.118754, 47.744869],
              [90.118774, 47.745501],
              [90.118744, 47.745692],
              [90.118503, 47.745923],
              [90.1179, 47.746205],
              [90.117398, 47.746275],
              [90.116383, 47.746225],
              [90.115429, 47.746355],
              [90.114947, 47.746486],
              [90.114455, 47.746837],
              [90.113762, 47.747279],
              [90.113388654, 47.747517663999986],
              [90.113008, 47.747761],
              [90.112265, 47.747982],
              [90.111502, 47.748053],
              [90.1112, 47.747992],
              [90.110869, 47.747928],
              [90.110813668999981, 47.747917070000028],
              [90.110788, 47.747912],
              [90.110457, 47.747902],
              [90.110105, 47.747852],
              [90.109382, 47.747721],
              [90.10894, 47.747591],
              [90.108508, 47.747721],
              [90.108207, 47.748003],
              [90.108003144, 47.74821341],
              [90.107896, 47.748324],
              [90.107865, 47.748706],
              [90.107765, 47.749117],
              [90.107594, 47.749369],
              [90.107233, 47.749539],
              [90.10664, 47.74968],
              [90.105887, 47.749871],
              [90.104902, 47.750273],
              [90.104219, 47.750735],
              [90.103998, 47.750986],
              [90.103797, 47.751377],
              [90.103506, 47.75185],
              [90.103094, 47.752432],
              [90.102642, 47.752844],
              [90.10224, 47.753045],
              [90.101889, 47.753135],
              [90.100724, 47.753145],
              [90.099849168999981, 47.753103539],
              [90.099669, 47.753095],
              [90.099468, 47.753186],
              [90.099396241000022, 47.753362208999988],
              [90.099378, 47.753407],
              [90.099227, 47.753617],
              [90.098855, 47.753969],
              [90.098283, 47.75429],
              [90.097757263, 47.754553277000014],
              [90.09764, 47.754612],
              [90.096374, 47.755506],
              [90.09534, 47.756329],
              [90.095089, 47.75654],
              [90.094697, 47.757043],
              [90.094446, 47.757655],
              [90.094134, 47.758318],
              [90.093612, 47.759303],
              [90.09321, 47.759825],
              [90.09309, 47.760116],
              [90.09306, 47.760267],
              [90.09306, 47.760488],
              [90.093002543000011, 47.760544648],
              [90.092989, 47.760558],
              [90.092698, 47.760639],
              [90.092387, 47.760639],
              [90.092146965999973, 47.760542827],
              [90.092085, 47.760518],
              [90.09193800700001, 47.760542382999972],
              [90.091663, 47.760588],
              [90.091312, 47.760669],
              [90.09084, 47.760649],
              [90.089916, 47.760689],
              [90.089092, 47.760598],
              [90.088791, 47.760448],
              [90.088489, 47.760347],
              [90.088412054, 47.760349019999978],
              [90.088108, 47.760357],
              [90.087535, 47.760468],
              [90.086953, 47.760719],
              [90.08639, 47.761151],
              [90.085898, 47.761533],
              [90.085335, 47.761924],
              [90.085074, 47.762246],
              [90.084924, 47.762718],
              [90.084934, 47.763029],
              [90.084883, 47.76327],
              [90.084809125, 47.763370786999985],
              [90.084743, 47.763461],
              [90.084391, 47.763642],
              [90.083979, 47.763762],
              [90.083568, 47.764074],
              [90.083176, 47.764385],
              [90.082684, 47.764586],
              [90.081778612999983, 47.764809227],
              [90.081378, 47.764908],
              [90.080645, 47.765018],
              [90.080484, 47.765098],
              [90.080464, 47.765149],
              [90.080504, 47.765279],
              [90.080635, 47.76543],
              [90.080735, 47.765601],
              [90.081036, 47.765872],
              [90.081318, 47.766143],
              [90.081498, 47.766444],
              [90.081619, 47.766866],
              [90.081637264, 47.767026720999979],
              [90.081659, 47.767218],
              [90.081629, 47.76761],
              [90.081539, 47.767901],
              [90.081436263, 47.768041389000018],
              [90.081348, 47.768162],
              [90.080936, 47.768584],
              [90.080715, 47.768976],
              [90.080203, 47.769598],
              [90.079791, 47.770151],
              [90.07954, 47.770442],
              [90.079469, 47.770784],
              [90.079419, 47.771125],
              [90.079319, 47.771406],
              [90.079168, 47.771607],
              [90.078756, 47.771889],
              [90.078374, 47.77213],
              [90.07735, 47.773014],
              [90.076356, 47.773837],
              [90.075914, 47.774199],
              [90.075642, 47.774349],
              [90.075291, 47.774621],
              [90.07512, 47.774852],
              [90.074849, 47.775043],
              [90.074407, 47.775274],
              [90.074095, 47.775444],
              [90.073955, 47.775605],
              [90.073841, 47.7758]
            ],
            [
              [90.07916832, 47.772123336999982],
              [90.074849599, 47.775043885],
              [90.074525833, 47.775262833],
              [90.074849, 47.775043],
              [90.07916832, 47.772123336999982]
            ]
          ]
        ]
      }
    }
